if ($('#planner-div').length) {
    var week_selected='';
    var broadcast_month_selected='';
    var broadcast_month_selected_number='';
    var camapaign_selected='';
    var deletedItemsDPTV = [];
    var deletedItemsLenTV = [];
    var deletedItemsDPRadio = [];
    var deletedItemsLenRadio = [];
    var deletedItemsPrint = [];
    var deletedItemsDigital = [];
    var deletedItemsOOH = [];
    var deletedItemsMail = [];
    var deletedItemsOther = [];
    var deletedItemsOTT = [];
    var weeks_array=[];
    var weeks_broadcast_month=[];
    var column_week='';
    var selected_row='';
    var selected_week='';
    var fligth_dates='';
    var saved_budget=true;
    var fd_camp_budget=[];
    var mouse_out=false;
    var MarketPlannerGrid;
    var MediaPlannerGrid;
    var media_report_request = '';
    var main_grid_type = 'current_quarter';
    var selected_cam_media_types = '';
    var cam_mark_count = true;
    var current_camp_fd;
    var current_camp_markets;
    var hidden_columns_main_grid={
        advertiser_name: 1,
        fd_start: 1,
        fd_end: 1,
        budget: 1,
        percent: 1,
    };
    var global_week_budget = 0;
    var global_week_media_types = [];

    var cost_other_market=0;
    var grp_other_market=0;
    var total_other_market=0;
    var camp_selected_week_budget = 0;
    var array_to_allocate = {
        tv: {total: 0, grp: 0},
        radio: {total: 0, grp: 0},
        print: {total: 0, grp: 0},
        digital: {total: 0, grp: 0},
        mail: {total: 0, grp: 0},
        ooh: {total: 0, grp: 0},
        other: {total: 0, grp: 0},
    };

    var saved_all=[ {tv_dp: 1, tv_len: 1, radio_dp: 1, radio_len: 1, print: 1, digital: 1, ooh: 1, mail: 1, other: 1}];
    var html_hide= '<li><a  data-col="advertiser_name">Advertiser</a></li>' +
        '                                        <li><a  data-col="fd_start">Start</a></li>' +
        '                                        <li><a  data-col="fd_end">End</a></li>' +
        '                                        <li><a  data-col="budget">Budget</a></li>' +
        '                                        <li><a  data-col="percent">Completed %</a></li>';
    for(var month in broadcast_week){
        for(var week in broadcast_week[month]) {
            var name= moment(broadcast_week[month][week]).format('MMMM')+'/';
            var str= name+ moment(broadcast_week[month][week]).format('DD');
            html_hide += '<li><a  data-col="week_'+broadcast_week[month][week]+'">'+str+'</a></li>'
        }
    }
    $('#hide_columns').html(html_hide);

    var mainColumnDef = [
        {
            headerName: '',
            headerTooltip: '',
            groupId: 'row_he',
            headerClass: 'campaign_header',
            children: [
                {
                    headerName: '',
                    headerTooltip: '',
                    groupId: 'row_he_he',
                    headerClass: 'campaign_header',
                    children: [
                        {
                            headerName: '',
                            headerTooltip: '',
                            field: 'row_select',
                            pinned: 'left',
                            width: 50,
                            editable: false,
                            cellRenderer: 'agGroupCellRenderer',
                            checkboxSelection: true,
                            cellRendererParams: {
                                //checkbox: true
                            },
                            suppressFilter: true,
                            suppressMovable: true,
                            suppressResize: true,
                            suppressNavigable: true,
                            suppressSorting: true,
                            required: true,
                            headerClass: 'weeks',
                           // cellClass:'cells',
                            cellStyle: changeRowColor,
                       }
                    ],
                },
            ]
        },
        {
        headerName: '',
        headerTooltip: '',
        groupId: 'campaign_data',
        headerClass: 'campaign_header',
        children: [
            {
                headerName: '',
                headerTooltip: '',
                groupId: 'campaign_data_data',
                headerClass: 'campaign_header',
                children: [

                    {
                    headerName: "Campaign",
                    field: 'campaign_name',
                    pinned: 'left',
                    suppressMovable: true,
                    minWidth: 50,
                    width:162,
                    editable: false,
                    filter: 'set',
                    required: true,
                  //  cellStyle: {'text-align': "left", 'font-size':'14px', 'border-right': "1px solid black", 'border-rop': "1px solid black"},
                    headerClass: 'weeks',
                    cellClass:'cells',
                    cellStyle: changeRowColor,
                    //cellRenderer:'agGroupCellRenderer'
                },
                    {
                        headerName: "Advertiser",
                        field: 'advertiser_name',
                        pinned: 'left',
                        suppressMovable: true,
                        minWidth: 50,
                        width:162,
                        filter: 'set',
                        cellStyle: changeRowColor,
                        //cellRenderer:'agGroupCellRenderer'
                        pinned: 'left',
                        headerClass: 'weeks',
                        allowSearch: true,

                    },
                    {
                        headerName: "",
                        field: 'campaign_id',
                        width: 100,
                        pinned: 'left',
                        cellStyle: {'text-align': "right"},
                        headerClass: 'weeks',
                        hide:true,
                        suppressMovable: true,
                        cellStyle: changeRowColor
                    },
                    {
                        headerName: "Start",
                        field: 'fd_start',
                        width: 100,
                        pinned: 'left',
                        suppressMovable: true,
                       cellStyle: changeRowColor,
                        headerClass: 'weeks',
                    },
                    {
                        headerName: "End",
                        field: 'fd_end',
                        width: 100,
                        cellStyle: {'text-align': "right"},
                        pinned: 'left',
                        headerClass: 'weeks',
                        suppressMovable: true,
                        cellStyle: changeRowColor
                    },
                    {
                        headerName: "Budget",
                        field: 'budget',
                        width: 100,
                        cellStyle: {'text-align': "right"},
                        pinned: 'left',
                        headerClass: 'weeks',
                        filter: 'number',
                        suppressMovable: true,
                        cellStyle: changeRowColor
                    },
                    {
                        headerName: "Completed %",
                        field: 'percent',
                        width: 100,
                        cellStyle: {'text-align': "right"},
                        pinned: 'left',
                        headerClass: 'weeks',
                        filter: 'number',
                        suppressMovable: true,
                        cellStyle: changeRowColor,

                    },
                ],
            },
           ],
        },
    ];
    var ws_global_column_definitions = {
        'week': {
            headerName: '',
            headerTooltip: '',
            field: 'week_',
            editable: false,
            minWidth: 35,
            width: 100,
            required: false
        },
        'group_months': {
            headerName: 'Months',
            headerTooltip: 'Months',
            groupId: 'month_',
            children: [],
            headerClass: 'quarters'
        }
    }
    var months_header = {
        headerName: 'Quarter',
        headerTooltip: 'Quarter',
        groupId: 'quarters',
        children: [],
        headerClass: 'quarters',
    }
    for (var month in broadcast_week) {
        var month_y = $.extend({}, ws_global_column_definitions.group_months);
        month_y.group_id = month;
        month_y.headerName = moment('2019-' + month + '-01').format('MMMM');
        month_y.headerTooltip += moment('2019-' + month + '-01').format('MMMM');
        if (broadcast_week[month].length == 4)
            month_y.width = '400';
        if (broadcast_week[month].length == 5)
            month_y.width = '500';
        month_y.headerClass= 'months';
        month_y.children=[];
        for (var xx in broadcast_week[month]) {
            var week_y = $.extend({}, ws_global_column_definitions.week);
            week_y.headerName = moment( broadcast_week[month][xx]).format('DD');
            week_y.headerTooltip += moment( broadcast_week[month][xx]).format('YYYY-MM-DD');
            week_y.field ='week_'+ moment( broadcast_week[month][xx]).format('YYYY-MM-DD');
            weeks_array.push('week_'+ moment( broadcast_week[month][xx]).format('YYYY-MM-DD'));
            weeks_broadcast_month['week_'+ moment( broadcast_week[month][xx]).format('YYYY-MM-DD')]=month;
            week_y.headerClass= 'weeks';
            week_y.suppressMovable= true;
            week_y.cellStyle= changeRowColor;
            week_y.cellClassRules= {
                'hover-week-change': function(params) {
                    if (params.node.rowPinned != 'top' && (typeof params.data.campaign_id !== 'undefined')) {
                        var camp = params.data.campaign_id;
                        var field = params.colDef.headerTooltip;
                        if (typeof campaigns_finally[camp] !== "undefined" && campaigns_finally[camp]['weeks'].length > 0) {
                            if (campaigns_finally[camp]['weeks'].indexOf(field) !== -1) {
                                return true;
                            }
                        }
                    }
                    return false;
                }
            },
            month_y.children.push(week_y);
        }
        months_header.children.push(month_y);
    }
    var mainColumnDefTotals=[{
         campaign_id: '',
         fd_start: '',
         fd_end: '',
         campaign_total: '',
     }];
    for (var s in weeks_array)
        mainColumnDefTotals[0][weeks_array[s]] = '';

    function changeRowColor(params) {
        if (params.node.rowPinned == 'top') {
            if(params.colDef.field=='campaign_total' )
                return  { 'text-align': 'right', 'font-size':'11px',  backgroundColor: '#BDBDBD', color: '#2E2E2E',};
            else {
                return {
                    backgroundColor: '#BDBDBD',
                    color: '#2E2E2E',
                    'text-align': 'right',
                    align: 'right',
                    textAlign: 'right',
                };
            }
        }
       else if(typeof params.data.campaign_id !== 'undefined') {
            var camp = params.data.campaign_id;
            var field = params.colDef.headerTooltip;
            if(params.colDef.field=='campaign_name')
                return  { 'text-align': 'left', 'font-size':'12px'};
            else if(params.colDef.field=='campaign_total' )
                return  { 'text-align': 'right', 'font-size':'11px', 'border-left': "1px solid black",};
            else if (camp != '') {
                if (campaigns_finally[camp]['weeks'].length > 0) {
                    if (campaigns_finally[camp]['weeks'].indexOf(field) !== -1) {
                        return {backgroundColor: '#D6EAF8', 'text-align': 'right'};
                    } else if (typeof campaign_hiatus[camp] !== 'undefined') {
                        if (campaign_hiatus[camp].indexOf(field) !== -1) {
                            return {
                                color: 'black',
                                backgroundColor: '#e0e0e0',
                                'text-align': 'center',
                                align: 'center'
                            };
                        }
                        else {return  { 'text-align': 'right', align: 'right', textAlign: 'right',};}
                    } else {return  { 'text-align': 'right', align: 'right', textAlign: 'right',};}
                }
                else {return  { 'text-align': 'right', align: 'right', textAlign: 'right',};}
            }
            else {return  { 'text-align': 'right', align: 'right', textAlign: 'right',};}
        }
       else return { 'text-align': 'right', align: 'right', textAlign: 'right'};
    }
    // function changeTopFloating(params) {
    //    // if (params.node.rowPinned == 'top') {
    //    //      return {
    //    //          backgroundColor: '#BDBDBD',
    //    //          color: '#2E2E2E',
    //    //          'text-align': 'right',
    //    //          align: 'right',
    //    //          'font-size':'12px',
    //    //      };
    //    //  }
    //    //  if(params.colDef.field== 'campaign_name'){
    //    //      return {
    //    //          'text-align': "left",
    //    //          'font-size':'12px',
    //    //          'border-right': "1px solid black",
    //    //          'border-rop': "1px solid black"
    //    //      };
    //    //  }
    //    //  if(params.colDef.field== 'campaign_total'){
    //    //      return {
    //    //          'text-align': "right",
    //    //          'font-size':'12px',
    //    //          'border-right': "1px solid black",
    //    //          'border-rop': "1px solid black"
    //    //      };
    //    //  }
    //    //  return  { 'text-align': 'right', align: 'right'};
    // }

    mainColumnDef.push(months_header);
    mainColumnDef.push(
        {
            headerName: '',
            headerTooltip: '',
            groupId: 'campaign_data_total',
            headerClass: 'campaign_header',
            children: [
                {
                    headerName: '',
                    headerTooltip: '',
                    groupId: 'campaign_data_data_total',
                    headerClass: 'campaign_header',
                    children: [

                        {
                            headerName: "Total",
                            field: 'campaign_total',
                            pinned: 'right',
                            suppressMovable: true,
                            minWidth: 50,
                            width: 100,
                            editable: false,
                            filter: 'set',
                            required: true,
                            //  cellStyle: {'text-align': "left", 'font-size':'14px', 'border-right': "1px solid black", 'border-rop': "1px solid black"},
                            headerClass: 'weeks',
                            cellClass:'cells',
                            cellStyle: changeRowColor,
                            valueGetter: function getTtotal(params) {
                                var tot = 0;
                                $.each(params.data, function (index, value) {
                                    if(typeof index !== 'undefined' && index.indexOf('week_') > -1){
                                        var val = (typeof value.split("$")[1] !== 'undefined') ? value.split("$")[1] : "0";
                                        tot += parseFloat(val.replace(",",""));
                                    }else{
                                    }
                                });
                                return parseFloat(tot).toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                    minimumFractionDigits: 2
                                });
                            },
                            //cellRenderer:'agGroupCellRenderer'
                        },
                    ],
                },
            ],
        }
    );
    var MainGrid = {
        enableFilter: true,
        enableSorting: true,
        columnDefs: mainColumnDef,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        pinnedTopRowData: mainColumnDefTotals,
        headerHeight: 24,
        rowHeight: 22,
        stopEditingWhenGridLosesFocus: true,
        suppressRowClickSelection: true,
        groupColumnDef: {
            cellRenderer: 'agGroupCellRenderer',
            headerName: 'Campaign',
            cellRendererParams: {
                suppressCount: true,
                suppressFilter: true,
            },
            width: 150,
            max_width: 300,
            pinned: 'left',
            suppressFilter: true,
        },
        enableColResize: true,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        rowSelection: 'single',
      //  suppressRowClickSelection: false,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        //  getContextMenuItems: getContextMenuItemsInvoice,
        onGridReady: function (e){
        },
        onSelectionChanged: function (e) {
        },
        onCellClicked: function (e) {
            if(e.node.rowPinned !== 'top') {
                 array_to_allocate = {
                    tv: {total: 0, grp: 0},
                    radio: {total: 0, grp: 0},
                    print: {total: 0, grp: 0},
                    digital: {total: 0, grp: 0},
                    mail: {total: 0, grp: 0},
                    ooh: {total: 0, grp: 0},
                    other: {total: 0, grp: 0},
                    ott: {total: 0, grp: 0},
                };
                $('#tv_dp_refresh_grp').hide();
                $('#radio_dp_refresh_grp').hide();
                $('#print_refresh_grp').hide();
                $('#digital_refresh_grp').hide();
                $('#mail_refresh_grp').hide();
                $('#ooh_refresh_grp').hide();
                $('#other_refresh_grp').hide();
                $('#ott_refresh_grp').hide();
                var w = e.colDef.field.split('week_');
                if (typeof w[1] !== 'undefined' && campaigns_finally[e.data.campaign_id]['weeks'].indexOf(e.colDef.headerTooltip) !== -1) {
                    show_loader();
                    showCampPlanner(e.data.campaign_id, e.colDef.headerTooltip, weeks_broadcast_month[e.colDef.field], e.colDef.field, e)
                }
            }
        },
        onCellValueChanged: function (e) {
            if(e.node.rowPinned !== 'top') {
                var floating_top_row = MainGrid.api.pinnedRowModel.pinnedTopRows[0];
                var xx = e.colDef.field;
                var total = 0;
                MainGrid.api.forEachNodeAfterFilterAndSort(function (node) {
                    var spl = node.data[xx].split('$');
                    if (typeof spl[1] !== 'undefined')
                        total += parseFloat(spl[1].replace(",", ""));
                    else {
                        if (typeof node.data[xx] !== 'undefined' && node.data[xx] !== '') {
                            if (!isNaN(node.data[xx]))
                                total += parseFloat(node.data[xx].replace(",", ""))
                        }
                    }
                });
                floating_top_row.data[xx] = parseFloat(total).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                var tot = 0;
                $.each(e.data, function (index, value) {
                    if (typeof index !== 'undefined' && index.indexOf('week_') > -1) {
                        var val = (typeof value.split("$")[1] !== 'undefined') ? value.split("$")[1] : "0";
                        tot += parseFloat(val.replace(",", ""));
                    }
                });
                e.data['campaign_total'] = parseFloat(tot).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                 //MainGrid.api.refreshCells([floating_top_row, e.node]);
                MainGrid.api.refreshCells({rowNodes: [floating_top_row, e.node], columns: [e.colDef.field, 'campaign_total' ], force: true});
               // MainGrid.api.pinnedRowModel.pinnedTopRows[0].setDataValue(xx, total);
            }
        },
        onFilterChanged: function () {
            if (this.api.isAnyFilterPresent())
                $('#reset_filters').show();
            else
                $('#reset_filters').hide();
            var floating_top_row = MainGrid.api.pinnedRowModel.pinnedTopRows[0];
            var total_maingrid={};

            for(var month in broadcast_week){
                for(var week in broadcast_week[month])
                    total_maingrid['week_'+broadcast_week[month][week]]=0;
            }
            var columns=[];
            for(var column in total_maingrid) {
                MainGrid.api.forEachNodeAfterFilterAndSort(function (node) {
                    var expl= node.data[column].split('$');
                    if(typeof(expl[1] !== 'undefined') && !isNaN(parseFloat(expl[1]))) {
                        var com= expl[1].replace(",","")
                        total_maingrid[column] += parseFloat((com));
                    }
                });
                floating_top_row.data[column]= parseFloat(total_maingrid[column]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                columns.push(column);
            }
            columns.push('campaign_total');
            //MainGrid.api.refreshCells([floating_top_row]);
            MainGrid.api.refreshCells({rowNodes: [floating_top_row], columns: columns, force: true});
        },
        onItemsAdded: function (e) {
        },
        onCellFocused: function (e) {
        },
        onCellEditingStarted: function (e) {
        },
        onRowSelected: function (e) {
        },
        onCellEditingStopped: function (e) {
        },
        onCellMouseOver: function (e) {
           // if(e.node.rowPinned !== 'top') {
           //     var w = e.colDef.field.split('week_');
           //     if (typeof w[1] !== 'undefined' && campaigns_finally[e.data.campaign_id]['weeks'].indexOf(e.colDef.headerTooltip) !== -1) {
           //         e.colDef.cellStyle = {backgroundColor: '#F0B27A', cursor: 'pointer'};
           //         MainGrid.api.refreshCells([e.node], [e.colDef.field]);
           //     }
           // }
        },
        onCellMouseOut: function (e) {
            // if(e.node.rowPinned !== 'top' ) {
            //     var w = e.colDef.field.split('week_');
            //    if (typeof w[1] !== 'undefined' && campaigns_finally[e.data.campaign_id]['weeks'].indexOf(e.colDef.headerTooltip) !== -1) {
            //         e.colDef.cellStyle =changeRowColor //{backgroundColor: '#D6EAF8'};
            //         MainGrid.api.refreshCells([e.node], [e.colDef.field]);
            //     }
            // }
        },
    };
    $(document).ready(function(){
        MainGrid.rowData = [];
        var totals_array=[];
        for (var m in weeks_array)
            totals_array[weeks_array[m]] = 0;
        for (var camp_id in campaigns_finally) {
            var bud= parseFloat(campaigns_finally[camp_id].budget).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            var values = {
                int_id: camp_id,
                campaign_id: camp_id,
                advertiser_name: campaigns_finally[camp_id].advertiser,
                campaign_name: campaigns_finally[camp_id].name.toUpperCase(),
                fd_start: moment(campaigns_finally[camp_id].start).format('MM/DD/YYYY'),
                fd_end: moment(campaigns_finally[camp_id].end).format('MM/DD/YYYY'),
                //   market_id: $('#campaign_market option:selected').val(),
                budget: bud ,
                percent: parseFloat(campaigns_finally[camp_id].percent).toFixed(1),
            };
            for (var y in weeks_array) {
                values[weeks_array[y]] = '';
                var ww = weeks_array[y].split('week_');
                if( typeof campaigns_finally[camp_id]['planner'][ww[1]] !== 'undefined') {
                    values[weeks_array[y]] = parseFloat(campaigns_finally[camp_id]['planner'][ww[1]]).toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                            minimumFractionDigits: 2
                                        });
                    totals_array[weeks_array[y]]+= campaigns_finally[camp_id]['planner'][ww[1]];
                }
                else if(campaigns_finally[camp_id]['weeks'].indexOf(ww[1]) !== -1) {
                    values[weeks_array[y]] =parseFloat(0).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                }
            }
            if(typeof campaign_hiatus[camp_id] !== 'undefined') {
                for (var i in weeks_array) {
                    var hiatus= weeks_array[i].split('week_');
                    if (campaign_hiatus[camp_id].indexOf(hiatus[1]) !== -1)
                        values[weeks_array[i]] = 'H';
                }
            }
            MainGrid.rowData.push(values);
        }
        $('#mainGrid').html("");
        var MainGridGrid = document.querySelector('#mainGrid');
        var g5 = new agGrid.Grid(MainGridGrid, MainGrid);
        var array=[{}];
        for(var x in totals_array) {
            array[0][x] = parseFloat(totals_array[x]).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
        }
        MainGrid.api.setPinnedTopRowData([array[0]]);
    });
    var tvDpColumnDef = [
        {
            headerName: '',
            headerTooltip: '',
            field: 'row_select',
            pinned: 'left',
            width: 50,
            editable: false,
            cellRenderer: 'agGroupCellRenderer',
            checkboxSelection: true,
            cellRendererParams: {
                //checkbox: true
            },
            suppressFilter: true,
            suppressMovable: true,
            suppressResize: true,
            suppressNavigable: true,
            suppressSorting: true,
            required: true,
            headerClass: 'fixedHeaderCellClass'
        },
        {
            headerName: "Daypart",
            field: 'daypart',
            pinned: 'left',
            suppressMovable: true,
            suppressResize: false,
            headerClass: 'fixedHeaderCellClass',
            minWidth: 50,
            width: 114.5,
            editable: true,
            cellEditor: DPCellEditor,
            cellEditorParams: {
                values: tv_dayparts,
            },
            cellRenderer: DPFormatRenderer,
            pinnedRowCellRenderer: FloatingDPFormatRenderer,
            filter: 'set',
            required: true
        },
        {
            headerName: "Campaign Id",
            field: 'campaign_id',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
            suppressMovable: true,
            suppressResize: false,
        },
        {
            headerName: "Market Id",
            field: 'market_id',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Type",
            field: 'type',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Media type",
            field: 'media_type',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },

        {
            headerName: "Broadcast Month",
            field: 'broadcast_month',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },

        {
            headerName: "PlannerID",
            field: 'planner_id',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Market Cost",
            field: 'market_cost',
            width: 140,
            cellStyle: {'text-align': "right"},
            editable: true,
            cellRenderer: CurrencyFormatRenderer,
            cellEditor: CurrencyCellEditor,
            pinnedRowCellRenderer: BlankFormatRenderer,
            suppressResize: false,
        },
        {
            headerName: "GRP Goal",
            field: 'grp',
            width: 145,
            cellStyle: {'text-align': "right"},
            editable: true,
            cellEditor: FloatCellEditor,
            cellRenderer: FloatFormatRenderer,
            suppressResize: false,
            suppressMovable: false,
        },
        {
            headerName: "GRP Percent",
            field: 'grp_percent',
            width: 145,
            cellStyle: {'text-align': "right"},
            editable: true,
            cellEditor: FloatCellEditor,
            cellRenderer: FloatPercentFormatRenderer,
            suppressResize: false,
            suppressMovable: false,
        },
        {
            headerName: "Total Cost",
            field: 'total_cost',
            // headerTooltip: 'Total Gross Cost',
            //    pinned: 'right',
            editable: false,
            cellStyle: {'text-align': "right"},
            minWidth: 50,
            width: 140,
            suppressNavigable: true,
            suppressMovable: false,
            suppressResize: false,
            // headerClass: 'fixedHeaderCellClass',
            required: false,
        },
        {
            headerName: "Budget Percent",
            field: 'percent',
            width: 120,
            cellStyle: {'text-align': "right"},
            suppressNavigable: true,
            required: false,
            //   pinned: 'right',
            editable: false,
            suppressMovable: false,
            suppressResize: false,
        },
        {
            headerName: "Broad.  Month",
            field: 'broadcast_month_name',
            width: 130,
            cellStyle: {'text-align': "right"},
            suppressNavigable: true,
            required: false,
            // pinned: 'right',
            editable: false,
            suppressMovable: false,
        },
        {
            headerName: "Week",
            field: 'week',
            width: 145,
            cellStyle: {'text-align': "right"},
            suppressNavigable: true,
            required: false,
            //  pinned: 'right',
            editable: false,
            hide:true,
            suppressMovable: false,
            suppressResize: false,
        },
];
    var tvLengthColumnDef = [
        {
            headerName: '',
            headerTooltip: '',
            field: 'row_select',
            pinned: 'left',
            width: 50,
            editable: false,
            cellRenderer: 'agGroupCellRenderer',
            checkboxSelection: true,
            cellRendererParams: {
                //checkbox: true
            },
            suppressFilter: true,
            suppressMovable: true,
            suppressResize: true,
            suppressNavigable: true,
            suppressSorting: true,
            required: true,
            headerClass: 'fixedHeaderCellClass'
        },
        {
            headerName: "Length",
            field: 'length',
            width: 114.5,
            pinned: 'left',
            cellStyle: {'text-align': "right"},
            required:true,
            editable: true,
            cellRenderer: LengthFormatRenderer,
            cellEditor: IntegerCellEditor,
            pinnedRowCellRenderer: FloatingLengthFormatRenderer,
        },
        {
            headerName: "Campaign Id",
            field: 'campaign_id',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Market Id",
            field: 'market_id',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Type",
            field: 'type',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Media type",
            field: 'media_type',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Broadcast Month",
            field: 'broadcast_month',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "PlannerID",
            field: 'planner_id',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Market Cost",
            field: 'market_cost',
            width: 140,
            cellStyle: {'text-align': "right"},
            editable: true,
            cellRenderer: CurrencyFormatRenderer,
            cellEditor: CurrencyCellEditor,
        },
        {
            headerName: "GRP Goal",
            field: 'grp',
            width: 145,
            cellStyle: {'text-align': "right"},
            editable: true,
            cellEditor: FloatCellEditor,
            cellRenderer: FloatFormatRenderer,
        },
        {
            headerName: "Total Cost",
            field: 'total_cost',
          //  headerTooltip: 'Total Gross Cost',
            pinned: 'right',
            editable: false,
            cellStyle: {'text-align': "right"},
            minWidth: 50,
            width: 140,
            suppressNavigable: true,
            suppressMovable: true,
            headerClass: 'fixedHeaderCellClass',
            required: false,
        },
        {
            headerName: "Broadcast Month",
            field: 'broadcast_month_name',
            width: 150,
            cellStyle: {'text-align': "right"},
            suppressNavigable: true,
            required: false,
            pinned: 'right',
            editable: false,
        },
        {
            headerName: "Week",
            field: 'week',
            width: 145,
            cellStyle: {'text-align': "right"},
            suppressNavigable: true,
            required: false,
            pinned: 'right',
            editable: false,
        },

    ];
    var tvDpColumnDefTotals = [{
        campaign_id: '',
        market_id: '',
        media_type: '',
        type: '',
        week: '',
        broadcast_month: '',
        planner_id: '',
        daypart: '',
        market_cost: '',
        grp: '',
    }];
    var tvDpColumnDefBottom = [{
        campaign_id: '',
        market_id: '',
        media_type: '',
        type: '',
        week: '',
        broadcast_month: '',
        planner_id: '',
        daypart: '',
        market_cost: '',
        grp: '',
    }];

    var TvDPGrid = {
        suppressDragLeaveHidesColumns: true,
        enableFilter: true,
        enableSorting: true,
        columnDefs: tvDpColumnDef,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        headerHeight: 20,
        rowHeight: 20,
        stopEditingWhenGridLosesFocus: true,
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        pinnedTopRowData: tvDpColumnDefTotals,
        pinnedBottomRowData: tvDpColumnDefBottom,
        defaultColDef: {
            suppressToolPanel: true
        },
        enableColResize: true,
        rowSelection: 'multiple',
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
      //  getContextMenuItems: getContextMenuItemsInvoice,
        onCellValueChanged: function (e) {
            $('#tv_apply_div').hide();
            saved_all[0]['tv_dp']=0;
            update_media_totals('television');
            update_market_totals('television');
            var cell_changed_refresh=[];
            var nodes_to_refresh = [];
            if(e.colDef.field === 'grp' && e.node.rowPinned === 'top'){
                $('#tv_dp_refresh_grp').show();
                array_to_allocate['tv']['total'] = 1;
                var top_line_grp = this.api.pinnedRowModel.pinnedTopRows[0].data.grp;
                swal({
                        title: "Warning",
                        text: "Would you like to refresh the GRP Goal Allocation based on the new GRP Total?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Yes, refresh.",
                        cancelButtonText: "No",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                       if(isConfirm){
                           TvDPGrid.api.forEachNode(function (node) {
                               var grp = (!isNaN(top_line_grp) && top_line_grp > 0 && !isNaN(parseFloat(node.data.grp_percent)) ) ? ((node.data.grp_percent * top_line_grp) / 100) : 0;
                               node.data.grp = grp;
                               cell_changed_refresh.push('grp');
                               nodes_to_refresh.push(node);
                           });
                           TvDPGrid.api.refreshCells({rowNodes: nodes_to_refresh, columns:  cell_changed_refresh, force: false});
                       }
                    });
            }
            if(e.colDef.field === 'grp_percent'){
                array_to_allocate['tv']['grp'] = 1;
                var top_percent = 0;
                e.api.forEachNode(function (node) {
                    console.log('perce ...',  node.data.grp_percent);
                    top_percent += (!isNaN(parseFloat(node.data.grp_percent))) ? parseFloat(node.data.grp_percent) : 0;
                });
                var top_row_data_invoice = {
                    market_cost: '',
                    grp: this.api.pinnedRowModel.pinnedTopRows[0].data.grp,
                    total_cost: this.api.pinnedRowModel.pinnedTopRows[0].data.total_cost,
                    grp_percent: parseFloat(top_percent).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    percent: this.api.pinnedRowModel.pinnedTopRows[0].data.percent
                };
                console.log('top_row_data_invoice  ****', top_row_data_invoice);
                this.api.setPinnedTopRowData([top_row_data_invoice]);
            }
            if((e.colDef.field === 'market_cost' || e.colDef.field === 'grp') && e.node.rowPinned !== 'top') {
                var grp = 0;
                var market_cost = 0;
                var total=0;
                if (!isNaN(parseFloat(e.node.data.grp)) && !isNaN(parseFloat(e.node.data.market_cost))) {
                    e.node.data.total_cost= parseFloat(e.node.data.grp * e.node.data.market_cost).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    var perc=0;
                    if(camp_selected_week_budget > 0)
                       perc=( e.node.data.grp * e.node.data.market_cost *100 )/ camp_selected_week_budget;

                    e.node.data.percent= parseFloat(perc).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    })+ '%';
                    cell_changed_refresh.push('total_cost');
                    cell_changed_refresh.push('percent');
                }
                else {
                    e.node.data.total_cost='$0.00';
                    e.node.data.percent='0%';
                    cell_changed_refresh.push('total_cost');
                    cell_changed_refresh.push('percent');
                }
                var total_budget_percent = 0;
                e.api.forEachNode(function (node) {
                    if (!isNaN(parseFloat(node.data.market_cost)))
                        market_cost += parseFloat(node.data.market_cost);
                    if (!isNaN(parseFloat(node.data.grp)))
                        grp += parseFloat(node.data.grp);
                    if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                        total+= parseFloat(node.data.grp) * parseFloat(node.data.market_cost);
                    if(camp_selected_week_budget > 0 && !isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                        total_budget_percent += parseFloat(( node.data.grp * node.data.market_cost *100 )/ camp_selected_week_budget);
                });
                total=parseFloat(total).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                var top_row_data_invoice = {
                    market_cost: '',
                    grp: grp,
                    total_cost: total,
                    percent: parseFloat(total_budget_percent).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                     }) + '%',
                    grp_percent:this.api.pinnedRowModel.pinnedTopRows[0].data.grp_percent,
                };
                this.api.setPinnedTopRowData([top_row_data_invoice]);
                if(e.colDef.field === 'grp'){
                    var top_line_grp_percent = 0;
                    var top_line_grp = this.api.pinnedRowModel.pinnedTopRows[0].data.grp;
                    e.api.forEachNode(function (node) {
                       var perc = (!isNaN(top_line_grp) && top_line_grp > 0 && !isNaN(parseFloat(node.data.grp)) ) ? ((node.data.grp * 100) / top_line_grp) : 0;
                        top_line_grp_percent += parseFloat(perc);
                        node.data.grp_percent = perc;
                        cell_changed_refresh.push('grp_percent');
                        nodes_to_refresh.push(node);
                    });
                    var top_row_data_invoice = {
                        market_cost: '',
                        grp: this.api.pinnedRowModel.pinnedTopRows[0].data.grp,
                        total_cost: this.api.pinnedRowModel.pinnedTopRows[0].data.total_cost,
                        grp_percent: parseFloat(top_line_grp_percent).toLocaleString("en-US", {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }) + '%',
                        percent:  this.api.pinnedRowModel.pinnedTopRows[0].data.percent,
                    };
                    console.log('top_row_data_invoice  ****', top_row_data_invoice);
                    this.api.setPinnedTopRowData([top_row_data_invoice]);
                }
            }
            if(e.colDef.field === 'daypart'){
                var vendor_value;
                $.each(e.colDef.cellEditorParams.values, function (index, value) {
                    if (e.node.data.daypart == value.id)
                        vendor_value = value;
                });
                if(vendor_value === undefined){
                    e.node.data.daypart = last_vndr;
                    cell_changed_refresh.push('daypart');
                }
              }
            if (cell_changed_refresh.length > 0) {
                try {
                    //e.api.refreshCells([e.node], cell_changed_refresh);
                    e.api.refreshCells({rowNodes: [e.node], columns:  cell_changed_refresh, force: false});
                    if(nodes_to_refresh.length > 0)
                        e.api.refreshCells({rowNodes: nodes_to_refresh, columns:  cell_changed_refresh, force: false});
                }
                catch(err) {
                    e.api.rowRenderer.startEditingCell(e.api.getFocusedCell(), null, null);
                }
            }
            if(e.colDef.field === 'market_cost'){
                this.api.setFocusedCell(e.rowIndex, 'grp');
            }
         },
        onItemsAdded: function (e) {
            if(this.api.getFocusedCell() !== null) {
                column = this.api.getFocusedCell().column.colId;
                this.api.setFocusedCell(e['rowNodes'][0].rowIndex, column);
                this.api.ensureNodeVisible(e['rowNodes'][0]);
                this.api.rowRenderer.startEditingCell(this.api.getFocusedCell(), null, null);
                this.api.tabToNextCell();
            }
        },
        onCellFocused: function (e) {
            if ((e.rowPinned == 'bottom') && (e.column.colId == 'daypart')) {
                this.api.rowRenderer.startEditingCell(this.api.getFocusedCell(), null, null);
            }
        },
        onCellEditingStarted: function (e) {
            if(e.colDef.field === 'daypart'){
                last_vndr = e.node.data.daypart;
            }
            if ((e.node.rowPinned == 'top' && e.column.colId != 'grp') || ((e.node.rowPinned == 'bottom') && (e.column.colId != 'daypart'))) {
                if (e.column.cellEditor !== undefined) {
                    if (e.column.cellEditor.prototype !== undefined) {
                        e.column.cellEditor.prototype.destroy();
                    }
                }
                c = this.api.gridCore.eGridDiv;
                $(c).find('.ag-popup-editor').hide();
                e.api.stopEditing(true);
                console.log("locking cell");
                // Do not allow editing of an exisiting line's vendor.
            } else {
                // Do not allow adding a vendor if there is a filter applied.
                // TODO -- update vendor select box on filter change
                if (((e.node.rowPinned == 'bottom') && (e.column.colId == 'daypart') && (e.api.isAnyFilterPresent()))) {
                    global_notification('warning', 'Sorry, you must reset any filters before adding a new line.', undefined, 'ws_reset_filter');
                    e.api.stopEditing(true);
                }
            }
        },
        onRowSelected: function (e) {
            if ((e.node.rowPinned == 'top') || (e.node.rowPinned == 'bottom')) {
                // Do not allow floating rows to be selected.
                e.node.setSelected(false);
            }
        },
        onCellEditingStopped: function (e) {
        },
        onSelectionChanged: function (e) {
            if (this.api.getSelectedNodes().length > 0)
                $('#tv_dp_remove_items').show();
            else
                $('#tv_dp_remove_items').hide();
        } ,

    };

    var radioDpColumnDef = [
        {
            headerName: '',
            headerTooltip: '',
            field: 'row_select',
            pinned: 'left',
            width: 50,
            editable: false,
            cellRenderer: 'agGroupCellRenderer',
            checkboxSelection: true,
            cellRendererParams: {
                //checkbox: true
            },
            suppressFilter: true,
            suppressMovable: true,
            suppressResize: true,
            suppressNavigable: true,
            suppressSorting: true,
            required: true,
            headerClass: 'fixedHeaderCellClass'
        },
        {
            headerName: "Daypart",
            field: 'daypart',
            pinned: 'left',
            suppressMovable: true,
            headerClass: 'fixedHeaderCellClass',
            minWidth: 50,
            width: 114.5,
            editable: true,
            cellEditor: DPRadioCellEditor,
            cellEditorParams: {
                values: radio_dayparts,
            },
            cellRenderer: DPFormatRenderer,
            pinnedRowCellRenderer: FloatingDPFormatRenderer,
            filter: 'set',
            required: true,
            suppressMovable: true,
            suppressResize: false,
        },
        {
            headerName: "Campaign Id",
            field: 'campaign_id',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
            suppressMovable: true,
            suppressResize: false,
        },
        {
            headerName: "Market Id",
            field: 'market_id',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Type",
            field: 'type',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Media type",
            field: 'media_type',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },

        {
            headerName: "Broadcast Month",
            field: 'broadcast_month',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },

        {
            headerName: "PlannerID",
            field: 'planner_id',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Market Cost",
            field: 'market_cost',
            width: 140,
            cellStyle: {'text-align': "right"},
            editable: true,
            cellRenderer: CurrencyFormatRenderer,
            cellEditor: CurrencyCellEditor,
            suppressMovable: false,
            suppressResize: false,
            pinnedRowCellRenderer: BlankFormatRenderer,
        },
        {
            headerName: "GRP Goal",
            field: 'grp',
            width: 145,
            cellStyle: {'text-align': "right"},
            editable: true,
            cellEditor: FloatCellEditor,
            cellRenderer: FloatFormatRenderer,
            suppressMovable: false,
            suppressResize: false,
        },
        {
            headerName: "GRP Percent",
            field: 'grp_percent',
            width: 145,
            cellStyle: {'text-align': "right"},
            editable: true,
            cellEditor: FloatCellEditor,
            cellRenderer: FloatPercentFormatRenderer,
            suppressResize: false,
            suppressMovable: false,
        },
        {
            headerName: "Total Cost",
            field: 'total_cost',
      //      headerTooltip: 'Total Gross Cost',
         //   pinned: 'right',
            editable: false,
            cellStyle: {'text-align': "right"},
            minWidth: 50,
            width: 140,
            suppressNavigable: true,
           // headerClass: 'fixedHeaderCellClass',
            required: false,
            suppressMovable: false,
            suppressResize: false,
        },
        {
            headerName: "Budget Percent",
            field: 'percent',
            width: 120,
            cellStyle: {'text-align': "right"},
            suppressNavigable: true,
            required: false,
            // pinned: 'right',
            editable: false,
            suppressMovable: false,
            suppressResize: false,
        },
        {
            headerName: "Broad. Month",
            field: 'broadcast_month_name',
            width: 130,
            cellStyle: {'text-align': "right"},
            suppressNavigable: true,
            required: false,
          //  pinned: 'right',
            editable: false,
            suppressMovable: false,
            suppressResize: false,
        },
        {
            headerName: "Week",
            field: 'week',
            width: 145,
            cellStyle: {'text-align': "right"},
            suppressNavigable: true,
            required: false,
          //  pinned: 'right',
            editable: false,
            hide:true,
            suppressMovable: false,
            suppressResize: false,
        },

    ];
    var radioLengthColumnDef = [
        {
            headerName: '',
            headerTooltip: '',
            field: 'row_select',
            pinned: 'left',
            width: 50,
            editable: false,
            cellRenderer: 'agGroupCellRenderer',
            checkboxSelection: true,
            cellRendererParams: {
                //checkbox: true
            },
            suppressFilter: true,
            suppressMovable: true,
            suppressResize: true,
            suppressNavigable: true,
            suppressSorting: true,
            required: true,
            headerClass: 'fixedHeaderCellClass'
        },
        {
            headerName: "Length",
            field: 'length',
            width: 114.5,
            pinned: 'left',
            cellStyle: {'text-align': "right"},
            required:true,
            editable: true,
            cellRenderer: LengthFormatRenderer,
            cellEditor: IntegerCellEditor,
            pinnedRowCellRenderer: FloatingLengthFormatRenderer,
        },
        {
            headerName: "Campaign Id",
            field: 'campaign_id',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Market Id",
            field: 'market_id',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Type",
            field: 'type',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Media type",
            field: 'media_type',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Broadcast Month",
            field: 'broadcast_month',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "PlannerID",
            field: 'planner_id',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Market Cost",
            field: 'market_cost',
            width: 140,
            cellStyle: {'text-align': "right"},
            editable: true,
            cellRenderer: CurrencyFormatRenderer,
            cellEditor: CurrencyCellEditor,
        },
        {
            headerName: "GRP Goal",
            field: 'grp',
            width: 145,
            cellStyle: {'text-align': "right"},
            editable: true,
            cellEditor: FloatCellEditor,
            cellRenderer: FloatFormatRenderer,
        },
        {
            headerName: "Total Cost",
            field: 'total_cost',
          //  headerTooltip: 'Total Gross Cost',
            pinned: 'right',
            editable: false,
            cellStyle: {'text-align': "right"},
            minWidth: 50,
            width: 140,
            suppressNavigable: true,
            suppressMovable: false,
          //  headerClass: 'fixedHeaderCellClass',
            required: false,
        },
        {
            headerName: "Broadcast Month",
            field: 'broadcast_month_name',
            width: 150,
            cellStyle: {'text-align': "right"},
            suppressNavigable: true,
            required: false,
            pinned: 'right',
            editable: false,
        },
        {
            headerName: "Week",
            field: 'week',
            width: 145,
            cellStyle: {'text-align': "right"},
            suppressNavigable: true,
            required: false,
            pinned: 'right',
            editable: false,
            hide:true,
        },
        {
            headerName: "Percent",
            field: 'percent',
            width: 120,
            cellStyle: {'text-align': "right"},
            suppressNavigable: true,
            required: false,
            pinned: 'right',
            editable: false,
        },

    ];
    var radioDpColumnDefTotals = [{
        campaign_id: '',
        market_id: '',
        media_type: '',
        ype: '',
        week: '',
        broadcast_month: '',
        planner_id: '',
        daypart: '',
        market_cost: '',
        grp: '',
    }];
    var radioDpColumnDefBottom = [{
        campaign_id: '',
        market_id: '',
        media_type: '',
        ype: '',
        week: '',
        broadcast_month: '',
        planner_id: '',
        daypart: '',
        market_cost: '',
        grp: '',
    }];
    var RadioDPGrid = {
        suppressDragLeaveHidesColumns: true,
        enableFilter: true,
        enableSorting: true,
        columnDefs: radioDpColumnDef,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        headerHeight: 20,
        rowHeight: 20,
        stopEditingWhenGridLosesFocus: true,
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        enableColResize: true,
        pinnedTopRowData: radioDpColumnDefTotals,
        pinnedBottomRowData: radioDpColumnDefBottom,
        defaultColDef: {
            suppressToolPanel: true
        },
        rowSelection: 'multiple',
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        //  getContextMenuItems: getContextMenuItemsInvoice,
        onCellValueChanged: function (e) {
            saved_all[0]['radio_dp']=0;
            $('#radio_apply_div').hide();
            update_media_totals('radio');
            update_market_totals('radio');
            var cell_changed_refresh=[];
            var nodes_to_refresh = [];
            if(e.colDef.field === 'grp' && e.node.rowPinned === 'top'){
                $('#radio_dp_refresh_grp').show();
                array_to_allocate['radio']['total'] = 1;
                var top_line_grp = this.api.pinnedRowModel.pinnedTopRows[0].data.grp;
                swal({
                        title: "Warning",
                        text: "Would you like to refresh the GRP Goal Allocation based on the new GRP Total?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Yes, refresh.",
                        cancelButtonText: "No",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if(isConfirm){
                            RadioDPGrid.api.forEachNode(function (node) {
                                var grp = (!isNaN(top_line_grp) && top_line_grp > 0 && !isNaN(parseFloat(node.data.grp_percent)) ) ? ((node.data.grp_percent * top_line_grp) / 100) : 0;
                                node.data.grp = grp;
                                cell_changed_refresh.push('grp');
                                nodes_to_refresh.push(node);
                            });
                            RadioDPGrid.api.refreshCells({rowNodes: nodes_to_refresh, columns:  cell_changed_refresh, force: false});
                        }
                    });
            }
            if(e.colDef.field === 'grp_percent'){
                array_to_allocate['radio']['grp'] = 1;
                var top_percent = 0;
                e.api.forEachNode(function (node) {
                    console.log('perce ...',  node.data.grp_percent);
                    top_percent += (!isNaN(parseFloat(node.data.grp_percent))) ? parseFloat(node.data.grp_percent) : 0;
                });
                var top_row_data_invoice = {
                    market_cost: '',
                    grp: this.api.pinnedRowModel.pinnedTopRows[0].data.grp,
                    total_cost: this.api.pinnedRowModel.pinnedTopRows[0].data.total_cost,
                    grp_percent: parseFloat(top_percent).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    percent: this.api.pinnedRowModel.pinnedTopRows[0].data.percent
                };
                console.log('top_row_data_invoice  ****', top_row_data_invoice);
                this.api.setPinnedTopRowData([top_row_data_invoice]);
            }
            if((e.colDef.field === 'market_cost' || e.colDef.field === 'grp') && e.node.rowPinned !== 'top') {
                var grp = 0;
                var market_cost = 0;
                var total=0;
                if (!isNaN(parseFloat(e.node.data.grp)) && !isNaN(parseFloat(e.node.data.market_cost))) {
                    e.node.data.total_cost= parseFloat(e.node.data.grp * e.node.data.market_cost).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    var perc=0;
                    if(camp_selected_week_budget > 0)
                        perc=( e.node.data.grp * e.node.data.market_cost *100 )/ camp_selected_week_budget;

                    e.node.data.percent= parseFloat(perc).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    })+ '%';
                    //e.api.refreshCells([e.node], ['total_cost', 'percent']);
                    //e.api.refreshCells({rowNodes: [e.node], columns:  ['total_cost', 'percent'], force: true});
                    cell_changed_refresh.push('total_cost');
                    cell_changed_refresh.push('percent');
                }
                else {
                    e.node.data.total_cost='$0.00';
                    e.node.data.total_cost='0.0%';
                   // e.api.refreshCells({rowNodes: [e.node], columns:  ['total_cost', 'percent'], force: true});
                    cell_changed_refresh.push('total_cost');
                    cell_changed_refresh.push('percent');
                }
                var total_budget_percent = 0;
                e.api.forEachNode(function (node) {
                    if (!isNaN(parseFloat(node.data.market_cost)))
                        market_cost += parseFloat(node.data.market_cost);
                    if (!isNaN(parseFloat(node.data.grp)))
                        grp += parseFloat(node.data.grp);
                    if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                        total+= parseFloat(node.data.grp) * parseFloat(node.data.market_cost);
                    if(camp_selected_week_budget > 0 && !isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                        total_budget_percent += parseFloat(( node.data.grp * node.data.market_cost *100 )/ camp_selected_week_budget);
                });
                total = parseFloat(total).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                var top_row_data_invoice = {
                    market_cost: '',
                    grp: grp,
                    total_cost: total,
                    percent: parseFloat(total_budget_percent).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    grp_percent: this.api.pinnedRowModel.pinnedTopRows[0].data.grp_percent,
                };
                this.api.setPinnedTopRowData([top_row_data_invoice]);
                if(e.colDef.field === 'grp'){
                    var top_line_grp_percent = 0;
                    var top_line_grp = this.api.pinnedRowModel.pinnedTopRows[0].data.grp;
                    e.api.forEachNode(function (node) {
                        var perc = (!isNaN(top_line_grp) && top_line_grp > 0 && !isNaN(parseFloat(node.data.grp)) ) ? ((node.data.grp * 100) / top_line_grp) : 0;
                        top_line_grp_percent += parseFloat(perc);
                        node.data.grp_percent = perc;
                        cell_changed_refresh.push('grp_percent');
                        nodes_to_refresh.push(node);
                    });
                    var top_row_data_invoice = {
                        market_cost: '',
                        grp: this.api.pinnedRowModel.pinnedTopRows[0].data.grp,
                        total_cost: this.api.pinnedRowModel.pinnedTopRows[0].data.total_cost,
                        grp_percent: parseFloat(top_line_grp_percent).toLocaleString("en-US", {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }) + '%',
                        percent: this.api.pinnedRowModel.pinnedTopRows[0].data.percent,
                    };
                    console.log('top_row_data_invoice  ****', top_row_data_invoice);
                    this.api.setPinnedTopRowData([top_row_data_invoice]);
                }
            }
            if(e.colDef.field === 'daypart'){
                var vendor_value;
                $.each(e.colDef.cellEditorParams.values, function (index, value) {
                    if (e.node.data.daypart == value.id)
                        vendor_value = value;
                });
                if(vendor_value === undefined){
                    e.node.data.daypart = last_vndr;
                }
            }
            if (cell_changed_refresh.length > 0) {
                try {
                    e.api.refreshCells({rowNodes: [e.node], columns:  cell_changed_refresh, force: false});
                    if(nodes_to_refresh.length > 0)
                        e.api.refreshCells({rowNodes: nodes_to_refresh, columns:  cell_changed_refresh, force: false});
                }
                catch(err) {
                    e.api.rowRenderer.startEditingCell(e.api.getFocusedCell(), null, null);
                }
            }
            if(e.colDef.field === 'market_cost') {
                this.api.setFocusedCell(e.rowIndex, 'grp');
            }
        },
        onItemsAdded: function (e) {
            if(this.api.getFocusedCell() !== null) {
                column = this.api.getFocusedCell().column.colId;
                this.api.setFocusedCell(e['rowNodes'][0].rowIndex, column);
                this.api.ensureNodeVisible(e['rowNodes'][0]);
                this.api.rowRenderer.startEditingCell(this.api.getFocusedCell(), null, null);
                this.api.tabToNextCell();
            }
        },
        onCellFocused: function (e) {
            if ((e.rowPinned == 'bottom') && (e.column.colId == 'daypart')) {
                this.api.rowRenderer.startEditingCell(this.api.getFocusedCell(), null, null);
            }
        },
        onCellEditingStarted: function (e) {
            if(e.colDef.field === 'daypart'){
                last_vndr = e.node.data.daypart;
            }
            if ((e.node.rowPinned == 'top' && e.column.colId != 'grp') || ((e.node.rowPinned == 'bottom') && (e.column.colId != 'daypart'))) {
                if (e.column.cellEditor !== undefined) {
                    if (e.column.cellEditor.prototype !== undefined) {
                        e.column.cellEditor.prototype.destroy();
                    }
                }
                c = this.api.gridCore.eGridDiv;
                $(c).find('.ag-popup-editor').hide();
                e.api.stopEditing(true);
                // Do not allow editing of an exisiting line's vendor.
            } else {
                // Do not allow adding a vendor if there is a filter applied.
                // TODO -- update vendor select box on filter change
                if (((e.node.rowPinned == 'bottom') && (e.column.colId == 'daypart') && (e.api.isAnyFilterPresent()))) {
                    global_notification('warning', 'Sorry, you must reset any filters before adding a new line.', undefined, 'ws_reset_filter');
                    e.api.stopEditing(true);
                }
            }
        },
        onRowSelected: function (e) {
            if ((e.node.rowPinned == 'top') || (e.node.rowPinned == 'bottom')) {
                // Do not allow floating rows to be selected.
                e.node.setSelected(false);
            }
        },
        onCellEditingStopped: function (e) {
        },
        onSelectionChanged: function (e) {
            if (this.api.getSelectedNodes().length > 0)
                $('#radio_dp_remove_items').show();
            else
                $('#radio_dp_remove_items').hide();
        } ,
    };
    var RadioLengthGrid = {
        columnDefs: radioLengthColumnDef,
        enableFilter: true,
        enableSorting: true,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        headerHeight: 20,
        rowHeight: 20,
        stopEditingWhenGridLosesFocus: true,
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        pinnedTopRowData: radioDpColumnDefTotals,
        pinnedBottomRowData: radioDpColumnDefBottom,
        defaultColDef: {
            suppressToolPanel: true
        },
        rowSelection: 'multiple',
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        onCellValueChanged: function (e) {
            $('#radio_len_apply').hide();
            saved_all[0]['radio_len']=0;
            update_media_totals('radio');
            update_market_totals('radio');
            var cell_changed_refresh=[];
            if(e.colDef.field === 'market_cost' || e.colDef.field === 'grp') {
                var grp = 0;
                var market_cost = 0;
                var total=0;
                if (!isNaN(parseFloat(e.node.data.grp)) && !isNaN(parseFloat(e.node.data.market_cost))) {
                    e.node.data.total_cost= parseFloat(e.node.data.grp * e.node.data.market_cost).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    //e.api.refreshCells([e.node], ['total_cost']);
                    e.api.refreshCells({rowNodes: [e.node], columns:  ['total_cost'], force: true});
                }
                else {
                    e.node.data.total_cost='$0.00';
                    e.api.refreshCells({rowNodes: [e.node], columns:  ['total_cost'], force: true});
                }
                e.api.forEachNode(function (node) {
                    if (!isNaN(parseFloat(node.data.market_cost)))
                        market_cost += parseFloat(node.data.market_cost);
                    if (!isNaN(parseFloat(node.data.grp)))
                        grp += parseFloat(node.data.grp);
                    if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                        total+= parseFloat(node.data.grp) * parseFloat(node.data.market_cost);
                });
                total=parseFloat(total).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                var top_row_data_invoice = {
                    market_cost: market_cost,
                    grp: grp,
                    total_cost: total,
                };
                this.api.setPinnedTopRowData([top_row_data_invoice]);
            }
            if (cell_changed_refresh.length > 0) {
                try {
                    //e.api.refreshCells([e.node], cell_changed_refresh);
                    e.api.refreshCells({rowNodes: [e.node], columns:  cell_changed_refresh, force: true});
                }
                catch(err) {
                    e.api.rowRenderer.startEditingCell(e.api.getFocusedCell(), null, null);
                }
            }
        },
        onItemsAdded: function (e) {
            if(this.api.getFocusedCell() !== null) {
                column = this.api.getFocusedCell().column.colId;
                this.api.setFocusedCell(e['rowNodes'][0].rowIndex, column);
                this.api.ensureNodeVisible(e['rowNodes'][0]);
                this.api.rowRenderer.startEditingCell(this.api.getFocusedCell(), null, null);
                this.api.tabToNextCell();
            }
        },
        onCellFocused: function (e) {
            if ((e.rowPinned == 'bottom') && (e.column.colId == 'length')) {
                this.api.rowRenderer.startEditingCell(this.api.getFocusedCell(), null, null);
            }
        },
        onCellEditingStarted: function (e) {
            /*if(e.colDef.field === 'daypart'){
                last_vndr = e.node.data.daypart;
            }*/
            if ((e.node.rowPinned == 'top') || ((e.node.rowPinned == 'bottom') && (e.column.colId != 'length'))) {
                if (e.column.cellEditor !== undefined) {
                    if (e.column.cellEditor.prototype !== undefined) {
                        e.column.cellEditor.prototype.destroy();
                    }
                }
                c = this.api.gridCore.eGridDiv;
                $(c).find('.ag-popup-editor').hide();
                e.api.stopEditing(true);
                // Do not allow editing of an exisiting line's vendor.
            } else {
                // Do not allow adding a vendor if there is a filter applied.
                // TODO -- update vendor select box on filter change
                if (((e.node.rowPinned == 'bottom') && (e.column.colId == 'length') && (e.api.isAnyFilterPresent()))) {
                    global_notification('warning', 'Sorry, you must reset any filters before adding a new line.', undefined, 'ws_reset_filter');
                    e.api.stopEditing(true);
                }
            }
            if ( e.node.rowPinned == 'bottom' && e.column.colId == 'length') {
                e.api.stopEditing(true);
            }
        },
        onRowSelected: function (e) {
            if ((e.node.rowPinned == 'top') || (e.node.rowPinned == 'bottom')) {
                // Do not allow floating rows to be selected.
                e.node.setSelected(false);
            }
        },
        onSelectionChanged: function (e) {
            if (this.api.getSelectedNodes().length > 0)
                $('#radio_len_remove_items').show();
            else
                $('#radio_len_remove_items').hide();
        } ,
    };

    var generalColumnDef = [
        {
            headerName: '',
            headerTooltip: '',
            field: 'row_select',
            pinned: 'left',
            width: 50,
            editable: false,
            cellRenderer: 'agGroupCellRenderer',
            checkboxSelection: true,
            cellRendererParams: {
                //checkbox: true
            },
            suppressFilter: true,
            suppressMovable: true,
            suppressResize: true,
            suppressNavigable: true,
            suppressSorting: true,
            required: true,
            headerClass: 'fixedHeaderCellClass'
        },
        {
            headerName: "",
            field: 'length',
            width: 114.5,
            pinned: 'left',
            cellStyle: {'text-align': "right"},
            required:true,
            editable: true,
            cellRenderer: LengthFormatRenderer,
            cellEditor: IntegerCellEditor,
            pinnedRowCellRenderer: FloatingLengthFormatRenderer,
            suppressMovable: true,
            suppressResize: false,
        },
        {
            headerName: "Campaign Id",
            field: 'campaign_id',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Market Id",
            field: 'market_id',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Type",
            field: 'type',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Media type",
            field: 'media_type',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Broadcast Month",
            field: 'broadcast_month',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "PlannerID",
            field: 'planner_id',
            width: 100,
            cellStyle: {'text-align': "right"},
            hide: true,
        },
        {
            headerName: "Market Cost",
            field: 'market_cost',
            width: 140,
            cellStyle: {'text-align': "right"},
            editable: true,
            cellRenderer: CurrencyFormatRenderer,
            cellEditor: CurrencyCellEditor,
            pinnedRowCellRenderer: BlankFormatRenderer,
            suppressMovable: false,
            suppressResize: false,
        },
        {
            headerName: "GRI Goal",
            field: 'grp',
            width: 145,
            cellStyle: {'text-align': "right"},
            editable: true,
            cellEditor: FloatCellEditor,
            cellRenderer: FloatFormatRenderer,
            suppressMovable: false,
            suppressResize: false,
        },
        {
            headerName: "GRI Percent",
            field: 'grp_percent',
            width: 145,
            cellStyle: {'text-align': "right"},
            editable: true,
            cellEditor: FloatCellEditor,
            cellRenderer: FloatPercentFormatRenderer,
            suppressResize: false,
            suppressMovable: false,
        },
        {
            headerName: "Total Cost",
            field: 'total_cost',
          //  headerTooltip: 'Total Gross Cost',
          //  pinned: 'right',
            editable: false,
            cellStyle: {'text-align': "right"},
            minWidth: 50,
            width: 140,
            suppressNavigable: true,
            suppressMovable: false,
          //  headerClass: 'fixedHeaderCellClass',
            required: false,
            suppressMovable: false,
            suppressResize: false,
        },
        {
            headerName: "Budget Percent",
            field: 'percent',
            width: 120,
            cellStyle: {'text-align': "right"},
            suppressNavigable: true,
            required: false,
            //pinned: 'right',
            editable: false,
            suppressMovable: false,
            suppressResize: false,
        },
        {
            headerName: "Broad.  Month",
            field: 'broadcast_month_name',
            width: 130,
            cellStyle: {'text-align': "right"},
            suppressNavigable: true,
            required: false,
           // pinned: 'right',
            editable: false,
            suppressMovable: false,
            suppressResize: false,
        },
        {
            headerName: "Week",
            field: 'week',
            width: 145,
            cellStyle: {'text-align': "right"},
            suppressNavigable: true,
            required: false,
            pinned: 'right',
            editable: false,
            hide:true,
        },

    ];
    var generalColumnDefTotals = [{
        campaign_id: '',
        market_id: '',
        media_type: '',
        week: '',
        broadcast_month: '',
        planner_id: '',
        name: '',
        market_cost: '',
        grp: '',
    }];
    var genaralColumnDefBottom = [{
        campaign_id: '',
        market_id: '',
        media_type: '',
        week: '',
        broadcast_month: '',
        planner_id: '',
        name: '',
        market_cost: '',
        grp: '',
    }];

    var DigitalGrid = {
        suppressDragLeaveHidesColumns: true,
        columnDefs: generalColumnDef,
        enableFilter: true,
        enableSorting: true,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        headerHeight: 20,
        rowHeight: 20,
        stopEditingWhenGridLosesFocus: true,
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        enableColResize: true,
        pinnedTopRowData: generalColumnDefTotals,
        pinnedBottomRowData: genaralColumnDefBottom,
        defaultColDef: {
            suppressToolPanel: true
        },
        rowSelection: 'multiple',
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        onCellValueChanged: function (e) {
            //    $('#digital_apply').hide();
            // $('#digital_apply_market').hide();
            $('#digital_apply_div').hide();
            update_market_totals('digital');
            saved_all[0]['digital'] = 0;
            var cell_changed_refresh = [];
            var nodes_to_refresh = [];
            if (e.colDef.field === 'grp' && e.node.rowPinned === 'top') {
                $('#digital_refresh_grp').show();
                array_to_allocate['digital']['total'] = 1;
                var top_line_grp = this.api.pinnedRowModel.pinnedTopRows[0].data.grp;
                swal({
                        title: "Warning",
                        text: "Would you like to refresh the GRI Goal Allocation based on the new GRI Total?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Yes, refresh.",
                        cancelButtonText: "No",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if(isConfirm){
                            DigitalGrid.api.forEachNode(function (node) {
                                var grp = (!isNaN(top_line_grp) && top_line_grp > 0 && !isNaN(parseFloat(node.data.grp_percent)) ) ? ((node.data.grp_percent * top_line_grp) / 100) : 0;
                                node.data.grp = grp;
                                cell_changed_refresh.push('grp');
                                nodes_to_refresh.push(node);
                            });
                            DigitalGrid.api.refreshCells({rowNodes: nodes_to_refresh, columns:  cell_changed_refresh, force: false});
                        }
                    });
            }
            if (e.colDef.field === 'grp_percent') {
                array_to_allocate['digital']['grp'] = 1;
                var top_percent = 0;
                e.api.forEachNode(function (node) {
                    console.log('perce ...', node.data.grp_percent);
                    top_percent += (!isNaN(parseFloat(node.data.grp_percent))) ? parseFloat(node.data.grp_percent) : 0;
                });
                var top_row_data_invoice = {
                    market_cost: '',
                    grp: this.api.pinnedRowModel.pinnedTopRows[0].data.grp,
                    total_cost: this.api.pinnedRowModel.pinnedTopRows[0].data.total_cost,
                    grp_percent: parseFloat(top_percent).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    percent: this.api.pinnedRowModel.pinnedTopRows[0].data.percent
                };
                console.log('top_row_data_invoice  ****', top_row_data_invoice);
                this.api.setPinnedTopRowData([top_row_data_invoice]);
            }
            if ((e.colDef.field === 'market_cost' || e.colDef.field === 'grp') && e.node.rowPinned !== 'top') {
                var cell_changed_refresh = [];
                var grp = 0;
                var market_cost = 0;
                var total = 0;
                if (!isNaN(parseFloat(e.node.data.grp)) && !isNaN(parseFloat(e.node.data.market_cost))) {
                    e.node.data.total_cost = parseFloat(e.node.data.grp * e.node.data.market_cost).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    var perc = 0;
                    if (camp_selected_week_budget > 0)
                        perc = (e.node.data.grp * e.node.data.market_cost * 100) / camp_selected_week_budget;

                    e.node.data.percent = parseFloat(perc).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%';

                    cell_changed_refresh.push('total_cost');
                    cell_changed_refresh.push('percent');
                    // e.api.refreshCells({rowNodes: [e.node], columns:  ['total_cost' , 'percent'], force: true});
                } else {
                    e.node.data.total_cost = '$0.00';
                    e.node.data.percent = '0%';
                    cell_changed_refresh.push('total_cost');
                    cell_changed_refresh.push('percent');
                }
                var total_budget_percent = 0;
                e.api.forEachNode(function (node) {
                    if (!isNaN(parseFloat(node.data.market_cost)))
                        market_cost += parseFloat(node.data.market_cost);
                    if (!isNaN(parseFloat(node.data.grp)))
                        grp += parseFloat(node.data.grp);
                    if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                        total += parseFloat(node.data.grp) * parseFloat(node.data.market_cost);
                    if (camp_selected_week_budget > 0 && !isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                        total_budget_percent += parseFloat((node.data.grp * node.data.market_cost * 100) / camp_selected_week_budget);
                });
                total = parseFloat(total).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                var top_row_data_invoice = {
                    market_cost: '',
                    grp: grp,
                    total_cost: total,
                    percent: parseFloat(total_budget_percent).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    grp_percent: this.api.pinnedRowModel.pinnedTopRows[0].data.grp_percent,
                };
                this.api.setPinnedTopRowData([top_row_data_invoice]);

                if(e.colDef.field === 'grp'){
                    var top_line_grp_percent = 0;
                    var top_line_grp = this.api.pinnedRowModel.pinnedTopRows[0].data.grp;
                    e.api.forEachNode(function (node) {
                        var perc = (!isNaN(top_line_grp) && top_line_grp > 0 && !isNaN(parseFloat(node.data.grp)) ) ? ((node.data.grp * 100) / top_line_grp) : 0;
                        top_line_grp_percent += parseFloat(perc);
                        node.data.grp_percent = perc;
                        cell_changed_refresh.push('grp_percent');
                        nodes_to_refresh.push(node);
                    });
                    var top_row_data_invoice = {
                        market_cost: '',
                        grp: this.api.pinnedRowModel.pinnedTopRows[0].data.grp,
                        total_cost: this.api.pinnedRowModel.pinnedTopRows[0].data.total_cost,
                        grp_percent: parseFloat(top_line_grp_percent).toLocaleString("en-US", {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }) + '%',
                        percent:  this.api.pinnedRowModel.pinnedTopRows[0].data.percent,
                    };
                    console.log('top_row_data_invoice  ****', top_row_data_invoice);
                    this.api.setPinnedTopRowData([top_row_data_invoice]);
                }
            }
            if (cell_changed_refresh.length > 0) {
                try {
                    //e.api.refreshCells([e.node], cell_changed_refresh);
                    //  e.api.refreshCells({rowNodes: [e.node], columns:  cell_changed_refresh, force: true});
                    e.api.refreshCells({rowNodes: [e.node], columns: cell_changed_refresh, force: false});
                    if (nodes_to_refresh.length > 0)
                        e.api.refreshCells({rowNodes: nodes_to_refresh, columns: cell_changed_refresh, force: false});
                } catch (err) {
                    e.api.rowRenderer.startEditingCell(e.api.getFocusedCell(), null, null);
                }
            }
            if (e.colDef.field === 'market_cost') {
                this.api.setFocusedCell(e.rowIndex, 'grp');
            }
        },
        onCellClicked: function (e) {
            if (e.node.rowPinned == 'bottom' )
                if (typeof DigitalGrid.api.pinnedRowModel.pinnedBottomRows[0] !== 'undefined')
                    createNewRowLength(DigitalGrid, DigitalGrid.api.pinnedRowModel.pinnedBottomRows[0].data, 'digital');
                else
                    createNewRowLength(DigitalGrid, DigitalGrid.api.pinnedRowModel.pinnedTopRows[0].data, 'digital');

        },
        onSelectionChanged: function (e) {
            if (this.api.getSelectedNodes().length > 0)
                $('#digital_remove_items').show();
            else
                $('#digital_remove_items').hide();
        },
        onCellEditingStarted: function (e) {
            if ((e.node.rowPinned == 'top' && e.column.colId != 'grp') || ((e.node.rowPinned == 'bottom'))) {
                if (e.column.cellEditor !== undefined) {
                    if (e.column.cellEditor.prototype !== undefined) {
                        e.column.cellEditor.prototype.destroy();
                    }
                }
                c = this.api.gridCore.eGridDiv;
                $(c).find('.ag-popup-editor').hide();
                e.api.stopEditing(true);
                console.log("locking cell");
                // Do not allow editing of an exisiting line's vendor.
            } else {
                // Do not allow adding a vendor if there is a filter applied.
                // TODO -- update vendor select box on filter change
                if (((e.node.rowPinned == 'bottom') && (e.column.colId == 'daypart') && (e.api.isAnyFilterPresent()))) {
                    global_notification('warning', 'Sorry, you must reset any filters before adding a new line.', undefined, 'ws_reset_filter');
                    e.api.stopEditing(true);
                }
            }
        },
    };
    var PrintGrid = {
        suppressDragLeaveHidesColumns: true,
        enableColResize: true,
        columnDefs: generalColumnDef,
        enableFilter: true,
        enableSorting: true,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        headerHeight: 20,
        rowHeight: 20,
        stopEditingWhenGridLosesFocus: true,
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        pinnedTopRowData: generalColumnDefTotals,
        pinnedBottomRowData: genaralColumnDefBottom,
        defaultColDef: {
            suppressToolPanel: true
        },
        rowSelection: 'multiple',
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        onCellValueChanged: function (e) {
            $('#print_apply_div').hide();
            saved_all[0]['print']=0;
            update_market_totals('print');
            var cell_changed_refresh = [];
            var nodes_to_refresh = [];
            if (e.colDef.field === 'grp' && e.node.rowPinned === 'top') {
                array_to_allocate['print']['total'] = 1;
                $('#print_refresh_grp').show();
                var top_line_grp = this.api.pinnedRowModel.pinnedTopRows[0].data.grp;
                swal({
                        title: "Warning",
                        text: "Would you like to refresh the GRI Goal Allocation based on the new GRI Total?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Yes, refresh.",
                        cancelButtonText: "No",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if(isConfirm){
                            PrintGrid.api.forEachNode(function (node) {
                                var grp = (!isNaN(top_line_grp) && top_line_grp > 0 && !isNaN(parseFloat(node.data.grp_percent)) ) ? ((node.data.grp_percent * top_line_grp) / 100) : 0;
                                node.data.grp = grp;
                                cell_changed_refresh.push('grp');
                                nodes_to_refresh.push(node);
                            });
                            PrintGrid.api.refreshCells({rowNodes: nodes_to_refresh, columns:  cell_changed_refresh, force: false});
                        }
                    });
            }
            if (e.colDef.field === 'grp_percent') {
                array_to_allocate['print']['grp'] = 1;
                var top_percent = 0;
                e.api.forEachNode(function (node) {
                    console.log('perce ...', node.data.grp_percent);
                    top_percent += (!isNaN(parseFloat(node.data.grp_percent))) ? parseFloat(node.data.grp_percent) : 0;
                });
                var top_row_data_invoice = {
                    market_cost: '',
                    grp: this.api.pinnedRowModel.pinnedTopRows[0].data.grp,
                    total_cost: this.api.pinnedRowModel.pinnedTopRows[0].data.total_cost,
                    grp_percent: parseFloat(top_percent).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    percent: this.api.pinnedRowModel.pinnedTopRows[0].data.percent
                };
                console.log('top_row_data_invoice  ****', top_row_data_invoice);
                this.api.setPinnedTopRowData([top_row_data_invoice]);
            }
            if ((e.colDef.field === 'market_cost' || e.colDef.field === 'grp') && e.node.rowPinned !== 'top') {
                var cell_changed_refresh = [];
                var grp = 0;
                var market_cost = 0;
                var total = 0;
                if (!isNaN(parseFloat(e.node.data.grp)) && !isNaN(parseFloat(e.node.data.market_cost))) {
                    e.node.data.total_cost = parseFloat(e.node.data.grp * e.node.data.market_cost).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    var perc = 0;
                    if (camp_selected_week_budget > 0)
                        perc = (e.node.data.grp * e.node.data.market_cost * 100) / camp_selected_week_budget;

                    e.node.data.percent = parseFloat(perc).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%';

                    cell_changed_refresh.push('total_cost');
                    cell_changed_refresh.push('percent');
                    // e.api.refreshCells({rowNodes: [e.node], columns:  ['total_cost' , 'percent'], force: true});
                } else {
                    e.node.data.total_cost = '$0.00';
                    e.node.data.percent = '0%';
                    cell_changed_refresh.push('total_cost');
                    cell_changed_refresh.push('percent');
                }
                var total_budget_percent = 0;
                e.api.forEachNode(function (node) {
                    if (!isNaN(parseFloat(node.data.market_cost)))
                        market_cost += parseFloat(node.data.market_cost);
                    if (!isNaN(parseFloat(node.data.grp)))
                        grp += parseFloat(node.data.grp);
                    if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                        total += parseFloat(node.data.grp) * parseFloat(node.data.market_cost);
                    if (camp_selected_week_budget > 0 && !isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                        total_budget_percent += parseFloat((node.data.grp * node.data.market_cost * 100) / camp_selected_week_budget);
                });
                total = parseFloat(total).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                var top_row_data_invoice = {
                    market_cost: '',
                    grp: grp,
                    total_cost: total,
                    percent: parseFloat(total_budget_percent).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    grp_percent: this.api.pinnedRowModel.pinnedTopRows[0].data.grp_percent,
                };
                this.api.setPinnedTopRowData([top_row_data_invoice]);

                if(e.colDef.field === 'grp'){
                    var top_line_grp_percent = 0;
                    var top_line_grp = this.api.pinnedRowModel.pinnedTopRows[0].data.grp;
                    e.api.forEachNode(function (node) {
                        var perc = (!isNaN(top_line_grp) && top_line_grp > 0 && !isNaN(parseFloat(node.data.grp)) ) ? ((node.data.grp * 100) / top_line_grp) : 0;
                        top_line_grp_percent += parseFloat(perc);
                        node.data.grp_percent = perc;
                        cell_changed_refresh.push('grp_percent');
                        nodes_to_refresh.push(node);
                    });
                    var top_row_data_invoice = {
                        market_cost: '',
                        grp: this.api.pinnedRowModel.pinnedTopRows[0].data.grp,
                        total_cost: this.api.pinnedRowModel.pinnedTopRows[0].data.total_cost,
                        grp_percent: parseFloat(top_line_grp_percent).toLocaleString("en-US", {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }) + '%',
                        percent:  this.api.pinnedRowModel.pinnedTopRows[0].data.percent,
                    };
                    console.log('top_row_data_invoice  ****', top_row_data_invoice);
                    this.api.setPinnedTopRowData([top_row_data_invoice]);
                }
            }
            if (cell_changed_refresh.length > 0) {
                try {
                   // e.api.refreshCells({rowNodes: [e.node], columns:  cell_changed_refresh, force: true});
                    e.api.refreshCells({rowNodes: [e.node], columns: cell_changed_refresh, force: false});
                    if (nodes_to_refresh.length > 0)
                        e.api.refreshCells({rowNodes: nodes_to_refresh, columns: cell_changed_refresh, force: false});
                }
                catch(err) {
                    e.api.rowRenderer.startEditingCell(e.api.getFocusedCell(), null, null);
                }
            }
            if(e.colDef.field === 'market_cost') {
                this.api.setFocusedCell(e.rowIndex, 'grp');
            }
        },
        onCellClicked: function (e) {
            if(e.node.rowPinned=='bottom' && e.colDef.field == 'length')
                if(typeof PrintGrid.api.pinnedRowModel.pinnedBottomRows[0] !== 'undefined')
                    createNewRowLength(PrintGrid, PrintGrid.api.pinnedRowModel.pinnedBottomRows[0].data, 'print');
                else
                    createNewRowLength(PrintGrid, PrintGrid.api.pinnedRowModel.pinnedTopRows[0].data, 'print');

        },
        onSelectionChanged: function (e) {
            if (this.api.getSelectedNodes().length > 0)
                $('#print_remove_items').show();
            else
                $('#print_remove_items').hide();
        } ,
        onCellEditingStarted: function (e) {
            if ((e.node.rowPinned == 'top' && e.column.colId != 'grp') || ((e.node.rowPinned == 'bottom'))) {
                if (e.column.cellEditor !== undefined) {
                    if (e.column.cellEditor.prototype !== undefined) {
                        e.column.cellEditor.prototype.destroy();
                    }
                }
                c = this.api.gridCore.eGridDiv;
                $(c).find('.ag-popup-editor').hide();
                e.api.stopEditing(true);
                console.log("locking cell");
                // Do not allow editing of an exisiting line's vendor.
            } else {
                // Do not allow adding a vendor if there is a filter applied.
                // TODO -- update vendor select box on filter change
                if (((e.node.rowPinned == 'bottom') && (e.column.colId == 'daypart') && (e.api.isAnyFilterPresent()))) {
                    global_notification('warning', 'Sorry, you must reset any filters before adding a new line.', undefined, 'ws_reset_filter');
                    e.api.stopEditing(true);
                }
            }
        },
    };
    var MailGrid = {
        suppressDragLeaveHidesColumns: true,
        columnDefs: generalColumnDef,
        enableFilter: true,
        enableSorting: true,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        headerHeight: 20,
        rowHeight: 20,
        stopEditingWhenGridLosesFocus: true,
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        pinnedTopRowData: generalColumnDefTotals,
        pinnedBottomRowData: genaralColumnDefBottom,
        defaultColDef: {
            suppressToolPanel: true
        },
        rowSelection: 'multiple',
        enableColResize: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        onCellValueChanged: function (e) {
          //  $('#mail_apply').hide();
          //  $('#mail_apply_market').hide();
            $('#mail_apply_div').hide();
            saved_all[0]['mail']=0;
            update_market_totals('mail');
            var cell_changed_refresh = [];
            var nodes_to_refresh = [];
            if (e.colDef.field === 'grp' && e.node.rowPinned === 'top') {
                $('#mail_refresh_grp').show();
                array_to_allocate['mail']['total'] = 1;
                var top_line_grp = this.api.pinnedRowModel.pinnedTopRows[0].data.grp;
                swal({
                        title: "Warning",
                        text: "Would you like to refresh the GRI Goal Allocation based on the new GRI Total?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Yes, refresh.",
                        cancelButtonText: "No",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if(isConfirm){
                            MailGrid.api.forEachNode(function (node) {
                                var grp = (!isNaN(top_line_grp) && top_line_grp > 0 && !isNaN(parseFloat(node.data.grp_percent)) ) ? ((node.data.grp_percent * top_line_grp) / 100) : 0;
                                node.data.grp = grp;
                                cell_changed_refresh.push('grp');
                                nodes_to_refresh.push(node);
                            });
                            MailGrid.api.refreshCells({rowNodes: nodes_to_refresh, columns:  cell_changed_refresh, force: false});
                        }
                    });
            }
            if (e.colDef.field === 'grp_percent') {
                array_to_allocate['mail']['grp'] = 1;
                var top_percent = 0;
                e.api.forEachNode(function (node) {
                    console.log('perce ...', node.data.grp_percent);
                    top_percent += (!isNaN(parseFloat(node.data.grp_percent))) ? parseFloat(node.data.grp_percent) : 0;
                });
                var top_row_data_invoice = {
                    market_cost: '',
                    grp: this.api.pinnedRowModel.pinnedTopRows[0].data.grp,
                    total_cost: this.api.pinnedRowModel.pinnedTopRows[0].data.total_cost,
                    grp_percent: parseFloat(top_percent).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    percent: this.api.pinnedRowModel.pinnedTopRows[0].data.percent
                };
                console.log('top_row_data_invoice  ****', top_row_data_invoice);
                this.api.setPinnedTopRowData([top_row_data_invoice]);
            }
            if ((e.colDef.field === 'market_cost' || e.colDef.field === 'grp') && e.node.rowPinned !== 'top') {
                var grp = 0;
                var market_cost = 0;
                var total = 0;
                if (!isNaN(parseFloat(e.node.data.grp)) && !isNaN(parseFloat(e.node.data.market_cost))) {
                    e.node.data.total_cost = parseFloat(e.node.data.grp * e.node.data.market_cost).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    var perc = 0;
                    if (camp_selected_week_budget > 0)
                        perc = (e.node.data.grp * e.node.data.market_cost * 100) / camp_selected_week_budget;

                    e.node.data.percent = parseFloat(perc).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%';

                    cell_changed_refresh.push('total_cost');
                    cell_changed_refresh.push('percent');
                    // e.api.refreshCells({rowNodes: [e.node], columns:  ['total_cost' , 'percent'], force: true});
                } else {
                    e.node.data.total_cost = '$0.00';
                    e.node.data.percent = '0%';
                    cell_changed_refresh.push('total_cost');
                    cell_changed_refresh.push('percent');
                }
                var total_budget_percent = 0;
                e.api.forEachNode(function (node) {
                    if (!isNaN(parseFloat(node.data.market_cost)))
                        market_cost += parseFloat(node.data.market_cost);
                    if (!isNaN(parseFloat(node.data.grp)))
                        grp += parseFloat(node.data.grp);
                    if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                        total += parseFloat(node.data.grp) * parseFloat(node.data.market_cost);
                    if (camp_selected_week_budget > 0 && !isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                        total_budget_percent += parseFloat((node.data.grp * node.data.market_cost * 100) / camp_selected_week_budget);
                });
                total = parseFloat(total).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                var top_row_data_invoice = {
                    market_cost: '',
                    grp: grp,
                    total_cost: total,
                    percent: parseFloat(total_budget_percent).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    grp_percent: this.api.pinnedRowModel.pinnedTopRows[0].data.grp_percent,
                };
                this.api.setPinnedTopRowData([top_row_data_invoice]);

                if(e.colDef.field === 'grp'){
                    var top_line_grp_percent = 0;
                    var top_line_grp = this.api.pinnedRowModel.pinnedTopRows[0].data.grp;
                    e.api.forEachNode(function (node) {
                        var perc = (!isNaN(top_line_grp) && top_line_grp > 0 && !isNaN(parseFloat(node.data.grp)) ) ? ((node.data.grp * 100) / top_line_grp) : 0;
                        top_line_grp_percent += parseFloat(perc);
                        node.data.grp_percent = perc;
                        cell_changed_refresh.push('grp_percent');
                        nodes_to_refresh.push(node);
                    });
                    var top_row_data_invoice = {
                        market_cost: '',
                        grp: this.api.pinnedRowModel.pinnedTopRows[0].data.grp,
                        total_cost: this.api.pinnedRowModel.pinnedTopRows[0].data.total_cost,
                        grp_percent: parseFloat(top_line_grp_percent).toLocaleString("en-US", {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }) + '%',
                        percent:  this.api.pinnedRowModel.pinnedTopRows[0].data.percent,
                    };
                    console.log('top_row_data_invoice  ****', top_row_data_invoice);
                    this.api.setPinnedTopRowData([top_row_data_invoice]);
                }
            }
            if (cell_changed_refresh.length > 0) {
                try {
                    // e.api.refreshCells({rowNodes: [e.node], columns:  cell_changed_refresh, force: true});
                    e.api.refreshCells({rowNodes: [e.node], columns: cell_changed_refresh, force: false});
                    if (nodes_to_refresh.length > 0)
                        e.api.refreshCells({rowNodes: nodes_to_refresh, columns: cell_changed_refresh, force: false});
                }
                catch(err) {
                    e.api.rowRenderer.startEditingCell(e.api.getFocusedCell(), null, null);
                }
            }
            if(e.colDef.field === 'market_cost') {
                this.api.setFocusedCell(e.rowIndex, 'grp');
            }
        },
        onSelectionChanged: function (e) {
            if (this.api.getSelectedNodes().length > 0)
                $('#mail_remove_items').show();
            else
                $('#mail_remove_items').hide();
        } ,
        onCellClicked: function (e) {
            if(e.node.rowPinned=='bottom' && e.colDef.field == 'length')
                if(typeof PrintGrid.api.pinnedRowModel.pinnedBottomRows[0] !== 'undefined')
                    createNewRowLength(MailGrid, PrintGrid.api.pinnedRowModel.pinnedBottomRows[0].data, 'mail');
                else
                    createNewRowLength(MailGrid, PrintGrid.api.pinnedRowModel.pinnedTopRows[0].data, 'mail');

        },
        onCellEditingStarted: function (e) {
            if ((e.node.rowPinned == 'top' && e.column.colId != 'grp') || ((e.node.rowPinned == 'bottom'))) {
                if (e.column.cellEditor !== undefined) {
                    if (e.column.cellEditor.prototype !== undefined) {
                        e.column.cellEditor.prototype.destroy();
                    }
                }
                c = this.api.gridCore.eGridDiv;
                $(c).find('.ag-popup-editor').hide();
                e.api.stopEditing(true);
                console.log("locking cell");
                // Do not allow editing of an exisiting line's vendor.
            } else {
                // Do not allow adding a vendor if there is a filter applied.
                // TODO -- update vendor select box on filter change
                if (((e.node.rowPinned == 'bottom') && (e.column.colId == 'daypart') && (e.api.isAnyFilterPresent()))) {
                    global_notification('warning', 'Sorry, you must reset any filters before adding a new line.', undefined, 'ws_reset_filter');
                    e.api.stopEditing(true);
                }
            }
        },
    };
    var OtherGrid = {
        suppressDragLeaveHidesColumns: true,
        columnDefs: generalColumnDef,
        enableFilter: true,
        enableSorting: true,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        headerHeight: 20,
        rowHeight: 20,
        stopEditingWhenGridLosesFocus: true,
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        pinnedTopRowData: generalColumnDefTotals,
        pinnedBottomRowData: genaralColumnDefBottom,
        defaultColDef: {
            suppressToolPanel: true
        },
        rowSelection: 'multiple',
        enableColResize: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        onCellValueChanged: function (e) {
            $('#other_apply_div').hide();
            saved_all[0]['other']=0;
            update_market_totals('other');
            var cell_changed_refresh = [];
            var nodes_to_refresh = [];
            if (e.colDef.field === 'grp' && e.node.rowPinned === 'top') {
                array_to_allocate['other']['total'] = 1;
                $('#other_refresh_grp').show();
                var top_line_grp = this.api.pinnedRowModel.pinnedTopRows[0].data.grp;
                swal({
                        title: "Warning",
                        text: "Would you like to refresh the GRI Goal Allocation based on the new GRI Total?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Yes, refresh.",
                        cancelButtonText: "No",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if(isConfirm){
                            OtherGrid.api.forEachNode(function (node) {
                                var grp = (!isNaN(top_line_grp) && top_line_grp > 0 && !isNaN(parseFloat(node.data.grp_percent)) ) ? ((node.data.grp_percent * top_line_grp) / 100) : 0;
                                node.data.grp = grp;
                                cell_changed_refresh.push('grp');
                                nodes_to_refresh.push(node);
                            });
                            OtherGrid.api.refreshCells({rowNodes: nodes_to_refresh, columns:  cell_changed_refresh, force: false});
                        }
                    });
            }
            if (e.colDef.field === 'grp_percent') {
                array_to_allocate['other']['grp'] = 1;
                var top_percent = 0;
                e.api.forEachNode(function (node) {
                    console.log('perce ...', node.data.grp_percent);
                    top_percent += (!isNaN(parseFloat(node.data.grp_percent))) ? parseFloat(node.data.grp_percent) : 0;
                });
                var top_row_data_invoice = {
                    market_cost: '',
                    grp: this.api.pinnedRowModel.pinnedTopRows[0].data.grp,
                    total_cost: this.api.pinnedRowModel.pinnedTopRows[0].data.total_cost,
                    grp_percent: parseFloat(top_percent).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    percent: this.api.pinnedRowModel.pinnedTopRows[0].data.percent
                };
                console.log('top_row_data_invoice  ****', top_row_data_invoice);
                this.api.setPinnedTopRowData([top_row_data_invoice]);
            }
            if ((e.colDef.field === 'market_cost' || e.colDef.field === 'grp') && e.node.rowPinned !== 'top') {
                var cell_changed_refresh = [];
                var grp = 0;
                var market_cost = 0;
                var total = 0;
                if (!isNaN(parseFloat(e.node.data.grp)) && !isNaN(parseFloat(e.node.data.market_cost))) {
                    e.node.data.total_cost = parseFloat(e.node.data.grp * e.node.data.market_cost).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    var perc = 0;
                    if (camp_selected_week_budget > 0)
                        perc = (e.node.data.grp * e.node.data.market_cost * 100) / camp_selected_week_budget;

                    e.node.data.percent = parseFloat(perc).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%';

                    cell_changed_refresh.push('total_cost');
                    cell_changed_refresh.push('percent');
                    // e.api.refreshCells({rowNodes: [e.node], columns:  ['total_cost' , 'percent'], force: true});
                } else {
                    e.node.data.total_cost = '$0.00';
                    e.node.data.percent = '0%';
                    cell_changed_refresh.push('total_cost');
                    cell_changed_refresh.push('percent');
                }
                var total_budget_percent = 0;
                e.api.forEachNode(function (node) {
                    if (!isNaN(parseFloat(node.data.market_cost)))
                        market_cost += parseFloat(node.data.market_cost);
                    if (!isNaN(parseFloat(node.data.grp)))
                        grp += parseFloat(node.data.grp);
                    if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                        total += parseFloat(node.data.grp) * parseFloat(node.data.market_cost);
                    if (camp_selected_week_budget > 0 && !isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                        total_budget_percent += parseFloat((node.data.grp * node.data.market_cost * 100) / camp_selected_week_budget);
                });
                total = parseFloat(total).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                var top_row_data_invoice = {
                    market_cost: '',
                    grp: grp,
                    total_cost: total,
                    percent: parseFloat(total_budget_percent).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    grp_percent: this.api.pinnedRowModel.pinnedTopRows[0].data.grp_percent,
                };
                this.api.setPinnedTopRowData([top_row_data_invoice]);

                if(e.colDef.field === 'grp'){
                    var top_line_grp_percent = 0;
                    var top_line_grp = this.api.pinnedRowModel.pinnedTopRows[0].data.grp;
                    e.api.forEachNode(function (node) {
                        var perc = (!isNaN(top_line_grp) && top_line_grp > 0 && !isNaN(parseFloat(node.data.grp)) ) ? ((node.data.grp * 100) / top_line_grp) : 0;
                        top_line_grp_percent += parseFloat(perc);
                        node.data.grp_percent = perc;
                        cell_changed_refresh.push('grp_percent');
                        nodes_to_refresh.push(node);
                    });
                    var top_row_data_invoice = {
                        market_cost: '',
                        grp: this.api.pinnedRowModel.pinnedTopRows[0].data.grp,
                        total_cost: this.api.pinnedRowModel.pinnedTopRows[0].data.total_cost,
                        grp_percent: parseFloat(top_line_grp_percent).toLocaleString("en-US", {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }) + '%',
                        percent:  this.api.pinnedRowModel.pinnedTopRows[0].data.percent,
                    };
                    console.log('top_row_data_invoice  ****', top_row_data_invoice);
                    this.api.setPinnedTopRowData([top_row_data_invoice]);
                }
            }
            if (cell_changed_refresh.length > 0) {
                try {
                    // e.api.refreshCells({rowNodes: [e.node], columns:  cell_changed_refresh, force: true});
                    e.api.refreshCells({rowNodes: [e.node], columns: cell_changed_refresh, force: false});
                    if (nodes_to_refresh.length > 0)
                        e.api.refreshCells({rowNodes: nodes_to_refresh, columns: cell_changed_refresh, force: false});
                }
                catch(err) {
                    e.api.rowRenderer.startEditingCell(e.api.getFocusedCell(), null, null);
                }
            }
            if(e.colDef.field === 'market_cost') {
                this.api.setFocusedCell(e.rowIndex, 'grp');
            }
        },
        onCellClicked: function (e) {
            if(e.node.rowPinned=='bottom' && e.colDef.field == 'length')
                if(typeof PrintGrid.api.pinnedRowModel.pinnedBottomRows[0] !== 'undefined')
                    createNewRowLength(OtherGrid, PrintGrid.api.pinnedRowModel.pinnedBottomRows[0].data, 'other');
                else
                    createNewRowLength(OtherGrid, PrintGrid.api.pinnedRowModel.pinnedTopRows[0].data, 'other');

        },
        onSelectionChanged: function (e) {
            if (this.api.getSelectedNodes().length > 0)
                $('#other_remove_items').show();
            else
                $('#other_remove_items').hide();
        } ,
        onCellEditingStarted: function (e) {
            if ((e.node.rowPinned == 'top' && e.column.colId != 'grp') || ((e.node.rowPinned == 'bottom'))) {
                if (e.column.cellEditor !== undefined) {
                    if (e.column.cellEditor.prototype !== undefined) {
                        e.column.cellEditor.prototype.destroy();
                    }
                }
                c = this.api.gridCore.eGridDiv;
                $(c).find('.ag-popup-editor').hide();
                e.api.stopEditing(true);
                console.log("locking cell");
                // Do not allow editing of an exisiting line's vendor.
            } else {
                // Do not allow adding a vendor if there is a filter applied.
                // TODO -- update vendor select box on filter change
                if (((e.node.rowPinned == 'bottom') && (e.column.colId == 'daypart') && (e.api.isAnyFilterPresent()))) {
                    global_notification('warning', 'Sorry, you must reset any filters before adding a new line.', undefined, 'ws_reset_filter');
                    e.api.stopEditing(true);
                }
            }
        },
    };
    var OOHGrid = {
        suppressDragLeaveHidesColumns: true,
        columnDefs: generalColumnDef,
        enableFilter: true,
        enableSorting: true,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        headerHeight: 20,
        rowHeight: 20,
        stopEditingWhenGridLosesFocus: true,
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        pinnedTopRowData: generalColumnDefTotals,
        pinnedBottomRowData: genaralColumnDefBottom,
        defaultColDef: {
            suppressToolPanel: true
        },
        enableColResize: true,
        rowSelection: 'multiple',
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        onCellValueChanged: function (e) {
           $('#ooh_apply_div').hide();
            saved_all[0]['ooh']=0;
            update_market_totals('ooh');
            var cell_changed_refresh = [];
            var nodes_to_refresh = [];
            if (e.colDef.field === 'grp' && e.node.rowPinned === 'top') {
                array_to_allocate['ooh']['total'] = 1;
                $('#ooh_refresh_grp').show();
                var top_line_grp = this.api.pinnedRowModel.pinnedTopRows[0].data.grp;
                swal({
                        title: "Warning",
                        text: "Would you like to refresh the GRI Goal Allocation based on the new GRI Total?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Yes, refresh.",
                        cancelButtonText: "No",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if(isConfirm){
                            OOHGrid.api.forEachNode(function (node) {
                                var grp = (!isNaN(top_line_grp) && top_line_grp > 0 && !isNaN(parseFloat(node.data.grp_percent)) ) ? ((node.data.grp_percent * top_line_grp) / 100) : 0;
                                node.data.grp = grp;
                                cell_changed_refresh.push('grp');
                                nodes_to_refresh.push(node);
                            });
                            OOHGrid.api.refreshCells({rowNodes: nodes_to_refresh, columns:  cell_changed_refresh, force: false});
                        }
                    });
            }
            if (e.colDef.field === 'grp_percent') {
                array_to_allocate['ooh']['grp'] = 1;
                var top_percent = 0;
                e.api.forEachNode(function (node) {
                    console.log('perce ...', node.data.grp_percent);
                    top_percent += (!isNaN(parseFloat(node.data.grp_percent))) ? parseFloat(node.data.grp_percent) : 0;
                });
                var top_row_data_invoice = {
                    market_cost: '',
                    grp: this.api.pinnedRowModel.pinnedTopRows[0].data.grp,
                    total_cost: this.api.pinnedRowModel.pinnedTopRows[0].data.total_cost,
                    grp_percent: parseFloat(top_percent).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    percent: this.api.pinnedRowModel.pinnedTopRows[0].data.percent
                };
                console.log('top_row_data_invoice  ****', top_row_data_invoice);
                this.api.setPinnedTopRowData([top_row_data_invoice]);
            }
            if ((e.colDef.field === 'market_cost' || e.colDef.field === 'grp') && e.node.rowPinned !== 'top') {
                var cell_changed_refresh = [];
                var grp = 0;
                var market_cost = 0;
                var total = 0;
                if (!isNaN(parseFloat(e.node.data.grp)) && !isNaN(parseFloat(e.node.data.market_cost))) {
                    e.node.data.total_cost = parseFloat(e.node.data.grp * e.node.data.market_cost).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    var perc = 0;
                    if (camp_selected_week_budget > 0)
                        perc = (e.node.data.grp * e.node.data.market_cost * 100) / camp_selected_week_budget;

                    e.node.data.percent = parseFloat(perc).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%';

                    cell_changed_refresh.push('total_cost');
                    cell_changed_refresh.push('percent');
                    // e.api.refreshCells({rowNodes: [e.node], columns:  ['total_cost' , 'percent'], force: true});
                } else {
                    e.node.data.total_cost = '$0.00';
                    e.node.data.percent = '0%';
                    cell_changed_refresh.push('total_cost');
                    cell_changed_refresh.push('percent');
                }
                var total_budget_percent = 0;
                e.api.forEachNode(function (node) {
                    if (!isNaN(parseFloat(node.data.market_cost)))
                        market_cost += parseFloat(node.data.market_cost);
                    if (!isNaN(parseFloat(node.data.grp)))
                        grp += parseFloat(node.data.grp);
                    if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                        total += parseFloat(node.data.grp) * parseFloat(node.data.market_cost);
                    if (camp_selected_week_budget > 0 && !isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                        total_budget_percent += parseFloat((node.data.grp * node.data.market_cost * 100) / camp_selected_week_budget);
                });
                total = parseFloat(total).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                var top_row_data_invoice = {
                    market_cost: '',
                    grp: grp,
                    total_cost: total,
                    percent: parseFloat(total_budget_percent).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    grp_percent: this.api.pinnedRowModel.pinnedTopRows[0].data.grp_percent,
                };
                this.api.setPinnedTopRowData([top_row_data_invoice]);

                if(e.colDef.field === 'grp'){
                    var top_line_grp_percent = 0;
                    var top_line_grp = this.api.pinnedRowModel.pinnedTopRows[0].data.grp;
                    e.api.forEachNode(function (node) {
                        var perc = (!isNaN(top_line_grp) && top_line_grp > 0 && !isNaN(parseFloat(node.data.grp)) ) ? ((node.data.grp * 100) / top_line_grp) : 0;
                        top_line_grp_percent += parseFloat(perc);
                        node.data.grp_percent = perc;
                        cell_changed_refresh.push('grp_percent');
                        nodes_to_refresh.push(node);
                    });
                    var top_row_data_invoice = {
                        market_cost: '',
                        grp: this.api.pinnedRowModel.pinnedTopRows[0].data.grp,
                        total_cost: this.api.pinnedRowModel.pinnedTopRows[0].data.total_cost,
                        grp_percent: parseFloat(top_line_grp_percent).toLocaleString("en-US", {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }) + '%',
                        percent:  this.api.pinnedRowModel.pinnedTopRows[0].data.percent,
                    };
                    console.log('top_row_data_invoice  ****', top_row_data_invoice);
                    this.api.setPinnedTopRowData([top_row_data_invoice]);
                }
            }
            if (cell_changed_refresh.length > 0) {
                try {
                    // e.api.refreshCells({rowNodes: [e.node], columns:  cell_changed_refresh, force: true});
                    e.api.refreshCells({rowNodes: [e.node], columns: cell_changed_refresh, force: false});
                    if (nodes_to_refresh.length > 0)
                        e.api.refreshCells({rowNodes: nodes_to_refresh, columns: cell_changed_refresh, force: false});
                }
                catch(err) {
                    e.api.rowRenderer.startEditingCell(e.api.getFocusedCell(), null, null);
                }
            }
            if(e.colDef.field === 'market_cost') {
                this.api.setFocusedCell(e.rowIndex, 'grp');
            }
        },
        onCellClicked: function (e) {
            if(e.node.rowPinned=='bottom' && e.colDef.field == 'length')
                if(typeof PrintGrid.api.pinnedRowModel.pinnedBottomRows[0] !== 'undefined')
                    createNewRowLength(OOHGrid, PrintGrid.api.pinnedRowModel.pinnedBottomRows[0].data, 'ooh');
                else
                    createNewRowLength(OOHGrid, PrintGrid.api.pinnedRowModel.pinnedTopRows[0].data, 'ooh');
        },
        onSelectionChanged: function (e) {
            if (this.api.getSelectedNodes().length > 0)
                $('#ooh_remove_items').show();
            else
                $('#ooh_remove_items').hide();
        } ,
        onCellEditingStarted: function (e) {
            if ((e.node.rowPinned == 'top' && e.column.colId != 'grp') || ((e.node.rowPinned == 'bottom'))) {
                if (e.column.cellEditor !== undefined) {
                    if (e.column.cellEditor.prototype !== undefined) {
                        e.column.cellEditor.prototype.destroy();
                    }
                }
                c = this.api.gridCore.eGridDiv;
                $(c).find('.ag-popup-editor').hide();
                e.api.stopEditing(true);
                console.log("locking cell");
                // Do not allow editing of an exisiting line's vendor.
            } else {
                // Do not allow adding a vendor if there is a filter applied.
                // TODO -- update vendor select box on filter change
                if (((e.node.rowPinned == 'bottom') && (e.column.colId == 'daypart') && (e.api.isAnyFilterPresent()))) {
                    global_notification('warning', 'Sorry, you must reset any filters before adding a new line.', undefined, 'ws_reset_filter');
                    e.api.stopEditing(true);
                }
            }
        },
    };
    var OTTGrid = {
        suppressDragLeaveHidesColumns: true,
        columnDefs: generalColumnDef,
        enableFilter: true,
        enableSorting: true,
        defaultColDef: {
            suppressToolPanel: true
        },
        headerHeight: 20,
        rowHeight: 20,
        stopEditingWhenGridLosesFocus: true,
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        pinnedTopRowData: generalColumnDefTotals,
        pinnedBottomRowData: genaralColumnDefBottom,
        defaultColDef: {
            suppressToolPanel: true
        },
        enableColResize: true,
        rowSelection: 'multiple',
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        onCellValueChanged: function (e) {
           $('#ott_apply_div').hide();
            saved_all[0]['ott']=0;
            update_market_totals('ott');
            var cell_changed_refresh = [];
            var nodes_to_refresh = [];
            if (e.colDef.field === 'grp' && e.node.rowPinned === 'top') {
                array_to_allocate['ott']['total'] = 1;
                $('#ott_refresh_grp').show();
                var top_line_grp = this.api.pinnedRowModel.pinnedTopRows[0].data.grp;
                swal({
                        title: "Warning",
                        text: "Would you like to refresh the GRI Goal Allocation based on the new GRI Total?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Yes, refresh.",
                        cancelButtonText: "No",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if(isConfirm){
                            OTTGrid.api.forEachNode(function (node) {
                                var grp = (!isNaN(top_line_grp) && top_line_grp > 0 && !isNaN(parseFloat(node.data.grp_percent)) ) ? ((node.data.grp_percent * top_line_grp) / 100) : 0;
                                node.data.grp = grp;
                                cell_changed_refresh.push('grp');
                                nodes_to_refresh.push(node);
                            });
                            OTTGrid.api.refreshCells({rowNodes: nodes_to_refresh, columns:  cell_changed_refresh, force: false});
                        }
                    });
            }
            if (e.colDef.field === 'grp_percent') {
                array_to_allocate['ott']['grp'] = 1;
                var top_percent = 0;
                e.api.forEachNode(function (node) {
                    top_percent += (!isNaN(parseFloat(node.data.grp_percent))) ? parseFloat(node.data.grp_percent) : 0;
                });
                var top_row_data_invoice = {
                    market_cost: '',
                    grp: this.api.pinnedRowModel.pinnedTopRows[0].data.grp,
                    total_cost: this.api.pinnedRowModel.pinnedTopRows[0].data.total_cost,
                    grp_percent: parseFloat(top_percent).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    percent: this.api.pinnedRowModel.pinnedTopRows[0].data.percent
                };
                this.api.setPinnedTopRowData([top_row_data_invoice]);
            }
            if ((e.colDef.field === 'market_cost' || e.colDef.field === 'grp') && e.node.rowPinned !== 'top') {
                var cell_changed_refresh = [];
                var grp = 0;
                var market_cost = 0;
                var total = 0;
                if (!isNaN(parseFloat(e.node.data.grp)) && !isNaN(parseFloat(e.node.data.market_cost))) {
                    e.node.data.total_cost = parseFloat(e.node.data.grp * e.node.data.market_cost).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    var perc = 0;
                    if (camp_selected_week_budget > 0)
                        perc = (e.node.data.grp * e.node.data.market_cost * 100) / camp_selected_week_budget;

                    e.node.data.percent = parseFloat(perc).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%';

                    cell_changed_refresh.push('total_cost');
                    cell_changed_refresh.push('percent');
                    // e.api.refreshCells({rowNodes: [e.node], columns:  ['total_cost' , 'percent'], force: true});
                } else {
                    e.node.data.total_cost = '$0.00';
                    e.node.data.percent = '0%';
                    cell_changed_refresh.push('total_cost');
                    cell_changed_refresh.push('percent');
                }
                var total_budget_percent = 0;
                e.api.forEachNode(function (node) {
                    if (!isNaN(parseFloat(node.data.market_cost)))
                        market_cost += parseFloat(node.data.market_cost);
                    if (!isNaN(parseFloat(node.data.grp)))
                        grp += parseFloat(node.data.grp);
                    if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                        total += parseFloat(node.data.grp) * parseFloat(node.data.market_cost);
                    if (camp_selected_week_budget > 0 && !isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                        total_budget_percent += parseFloat((node.data.grp * node.data.market_cost * 100) / camp_selected_week_budget);
                });
                total = parseFloat(total).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                var top_row_data_invoice = {
                    market_cost: '',
                    grp: grp,
                    total_cost: total,
                    percent: parseFloat(total_budget_percent).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    grp_percent: this.api.pinnedRowModel.pinnedTopRows[0].data.grp_percent,
                };
                this.api.setPinnedTopRowData([top_row_data_invoice]);

                if(e.colDef.field === 'grp'){
                    var top_line_grp_percent = 0;
                    var top_line_grp = this.api.pinnedRowModel.pinnedTopRows[0].data.grp;
                    e.api.forEachNode(function (node) {
                        var perc = (!isNaN(top_line_grp) && top_line_grp > 0 && !isNaN(parseFloat(node.data.grp)) ) ? ((node.data.grp * 100) / top_line_grp) : 0;
                        top_line_grp_percent += parseFloat(perc);
                        node.data.grp_percent = perc;
                        cell_changed_refresh.push('grp_percent');
                        nodes_to_refresh.push(node);
                    });
                    var top_row_data_invoice = {
                        market_cost: '',
                        grp: this.api.pinnedRowModel.pinnedTopRows[0].data.grp,
                        total_cost: this.api.pinnedRowModel.pinnedTopRows[0].data.total_cost,
                        grp_percent: parseFloat(top_line_grp_percent).toLocaleString("en-US", {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }) + '%',
                        percent:  this.api.pinnedRowModel.pinnedTopRows[0].data.percent,
                    };
                    this.api.setPinnedTopRowData([top_row_data_invoice]);
                }
            }
            if (cell_changed_refresh.length > 0) {
                try {
                    e.api.refreshCells({rowNodes: [e.node], columns: cell_changed_refresh, force: false});
                    if (nodes_to_refresh.length > 0)
                        e.api.refreshCells({rowNodes: nodes_to_refresh, columns: cell_changed_refresh, force: false});
                }
                catch(err) {
                    e.api.rowRenderer.startEditingCell(e.api.getFocusedCell(), null, null);
                }
            }
            if(e.colDef.field === 'market_cost') {
                this.api.setFocusedCell(e.rowIndex, 'grp');
            }
        },
        onCellClicked: function (e) {
            if(e.node.rowPinned=='bottom' && e.colDef.field == 'length')
                if(typeof PrintGrid.api.pinnedRowModel.pinnedBottomRows[0] !== 'undefined')
                    createNewRowLength(OTTGrid, PrintGrid.api.pinnedRowModel.pinnedBottomRows[0].data, 'ott');
                else
                    createNewRowLength(OTTGrid, PrintGrid.api.pinnedRowModel.pinnedTopRows[0].data, 'ott');
        },
        onSelectionChanged: function (e) {
            if (this.api.getSelectedNodes().length > 0)
                $('#ott_remove_items').show();
            else
                $('#ott_remove_items').hide();
        } ,
        onCellEditingStarted: function (e) {
            if ((e.node.rowPinned == 'top' && e.column.colId != 'grp') || ((e.node.rowPinned == 'bottom'))) {
                if (e.column.cellEditor !== undefined) {
                    if (e.column.cellEditor.prototype !== undefined) {
                        e.column.cellEditor.prototype.destroy();
                    }
                }
                c = this.api.gridCore.eGridDiv;
                $(c).find('.ag-popup-editor').hide();
                e.api.stopEditing(true);
            } else {
                // Do not allow adding a vendor if there is a filter applied.
                // TODO -- update vendor select box on filter change
                if (((e.node.rowPinned == 'bottom') && (e.column.colId == 'daypart') && (e.api.isAnyFilterPresent()))) {
                    global_notification('warning', 'Sorry, you must reset any filters before adding a new line.', undefined, 'ws_reset_filter');
                    e.api.stopEditing(true);
                }
            }
        },
    };
    var totalColumnDef = [
        {
            headerName: "Media Type",
            field: 'media_type',
            width: 150,
            cellStyle: {'text-align': "left"},
            pinned: 'left',
        },
        {
            headerName: "GRP Goal",
            field: 'grp',
            width: 130,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "GRI Goal",
            field: 'gri',
            width: 130,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Total Spend",
            field: 'total_spend',
            width: 150,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Spend Percent",
            field: 'spend_percent',
            width: 130,
            cellStyle: {'text-align': "right"},
        },
    ];
    var TotalGrid = {
        suppressDragLeaveHidesColumns: true,
        columnDefs: totalColumnDef,
        enableFilter: true,
        enableSorting: true,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        headerHeight: 20,
        rowHeight: 20,
        stopEditingWhenGridLosesFocus: true,
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        pinnedTopRowData: generalColumnDefTotals,
        pinnedBottomRowData: genaralColumnDefBottom,
        defaultColDef: {
            suppressToolPanel: true
        },
        enableColResize: true,
        rowSelection: 'multiple',
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
    };

    function LengthFormatRenderer() {
    }
    LengthFormatRenderer.prototype.init = function (params) {
        this.eGui = document.createElement('div');
        $(this.eGui).css('text-align', 'center');
        if (typeof params.value !== 'undefined') {
            this.eGui.innerHTML =  params.value;
            // if (params.node.rowPinned !== 'bottom' &&( ( params.data.media_type=='radio') || (  params.data.media_type=='television'))) {
            //     this.eGui.innerHTML = ':' + params.value;
            // } else {
            //     this.eGui.innerHTML =  params.value;
            // }
        } else {
            this.eGui.innerHTML = '';
        }
    };
    LengthFormatRenderer.prototype.getGui = function () {
        return this.eGui;
    };

    function IntegerCellEditor() {
    }
    IntegerCellEditor.prototype.init = function (params) {
        var active='';
        $('#newPlannerModal .tab-pane').each(function () {
            if ($(this).hasClass('active'))
                active= $(this).attr('id');
        });

        if (params.node.rowPinned == 'bottom') {
            this.eInput = document.createElement('button');
        }else{
            this.eInput = document.createElement('input');
        }
        if ((params.value === '') || (typeof params.value === 'undefined') ) {
            if(active=='tv' || active=='radio')
             params.value = 0;
            else
                params.value = '';
        }
        if (params.node.rowPinned == 'bottom') {
            // if(active=='print')
            //     createNewRowLength(PrintGrid, PrintGrid.api.pinnedRowModel.pinnedBottomRows[0].data, active);
            // if(active=='other')
            //     createNewRowLength(OtherGrid, OtherGrid.api.pinnedRowModel.pinnedBottomRows[0].data, active);
            // if(active=='mail')
            //     createNewRowLength(MailGrid, MailGrid.api.pinnedRowModel.pinnedBottomRows[0].data, active);
            // if(active=='ooh')
            //     createNewRowLength(OOHGrid, OOHGrid.api.pinnedRowModel.pinnedBottomRows[0].data, active);
            // if(active=='digital')
            //     createNewRowLength(DigitalGrid, DigitalGrid.api.pinnedRowModel.pinnedBottomRows[0].data, active);
            // params.api.stopEditing(true);
            /*if(active=='tv')
                createNewRowLength(TvLengthGrid, TvLengthGrid.api.pinnedRowModel.pinnedBottomRows[0].data, active)
            if(active=='radio')
                createNewRowLength(RadioLengthGrid, TvLengthGrid.api.pinnedRowModel.pinnedBottomRows[0].data, active)*/
        }
        else {
            this.eInput = document.createElement('input');
            this.params = params;
            if (params.value == undefined) {
                params.value = '';
            }
            if (params.charPress !== null) {
                this.eInput.value = params.charPress;
            } else {
                // Remove value on delete/backspace
                if ((params.keyPress == 8) || (params.keyPress == 46)) {
                    this.eInput.value = '';
                    // Otherwise set the params value.
                } else {
                    this.eInput.value = params.value;
                    if (params.keyPress == null) {
                        this.tabbed = true;
                    }
                }
            }
          //   this.eInput = document.createElement('input');
          //   if(active == 'tv' || active == 'radio') {
          //       $(this.eInput).mask("0#");
          //   }
          // //  this.tabbed = false;
          //   // If a "printable key" is pressed.
          //   if (params.charPress !== null) {
          //       console.log('get into the first');
          //       if(active == 'tv' || active=='radio'){
          //           number = parseInt(params.charPress);
          //           // If a number, set that value.
          //           if (!isNaN(number)) {
          //               this.eInput.value = number;
          //               // Otherwise set the params value.
          //           } else
          //               this.eInput.value = params.value;
          //       }
          //       else {
          //           this.eInput.value = params.value
          //           console.log('get into the else');
          //       }
          //   } else {
          //       // Remove value on delete/backspace
          //       if ((params.keyPress == 8) || (params.keyPress == 46)) {
          //           this.eInput.value = 0;
          //           // Otherwise set the params value.
          //       } else {
          //           this.eInput.value = params.value;
          //       }
          //   }
          //   if (params.charPress === null) {
          //       this.tabbed = true;
          //   }
        }
       // params.stopPropagation();
    };
    IntegerCellEditor.prototype.getGui = function () {
        if (this.tabbed === true) {
            $(this.eInput).addClass('ws-tabbed-input');
        }
        return this.eInput;
    };
    IntegerCellEditor.prototype.afterGuiAttached = function () {
        $(this.eInput).bind('keydown', function (e) {
            var key = e.which || e.keyCode;
            // Let arrow keys through
            if ((!e.shiftKey) && ((key === 37) || (key === 39))) {
                e.stopPropagation();
                return true;
            }
        });

        this.eInput.focus();
        if (this.tabbed) {
            this.eInput.select();
        }
    };
    IntegerCellEditor.prototype.getValue = function () {
        return this.eInput.value;
    };
    IntegerCellEditor.prototype.destroy = function () {
        $(this.eInput).unbind('keydown');
    };
    IntegerCellEditor.prototype.isPopup = function () {
        return false;
    };

    function FloatingLengthFormatRenderer() {
    }
    FloatingLengthFormatRenderer.prototype.init = function (params) {
        this.eGui = document.createElement('div');
        if (params.node.rowPinned == 'top') {
            this.eGui.innerHTML = '';
        } else {
            this.eGui.innerHTML = '<i class="fa fa-plus fa-fw fa-pull-left"></i> NEW';
        }
    };
    FloatingLengthFormatRenderer.prototype.getGui = function () {
        return this.eGui;
    };
    FloatingLengthFormatRenderer.prototype.refresh = function (params) {
        if (params.node.rowPinned == 'top') {
            this.eGui.innerHTML = '';
        } else {
            this.eGui.innerHTML = '<i class="fa fa-plus fa-fw fa-pull-left"></i> NEW';
        }
    };

    function DPCellEditor() {
    }
    DPCellEditor.prototype.init = function (params) {
        if (params.node.rowPinned == 'bottom') {
            this.eInput = document.createElement('select');
        }else{
            this.eInput = document.createElement('input');
        }

        this.params = params;
        var vendor_cell_input = $(this.eInput);
        var old_value = params.value;
        this.outerSource = [];
        var source = [];

      params.values.sort(function(a, b) {
            var textA = a.abbreviation.toUpperCase();
            var textB = b.abbreviation.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });

        if (params.node.rowPinned == 'bottom') {
            vendor_cell_input.addClass('form-control ws-custom-select');
            vendor_cell_input.append('<option value="-"></option>');
            var vendors_option=[];
            $.each(params.values, function (index, value) {
                if(vendors_option.indexOf(value.id) === -1) {
                    vendor_cell_input.append('<option value="' + value.id + '">' + value.abbreviation + '</option>');
                    vendors_option.push(value.id);
                }
            });
            if (typeof params.value !== 'undefined') {
                vendor_cell_input.val(params.value);
            }
        }else{
            $.each(params.values, function (index, value) {
                source.push({ label: value.abbreviation, value: value.id })
            });
            $( vendor_cell_input ).autocomplete({
                source: source,
                autoFocus: true,
                messages: {
                    noResults: '',
                    results: function() {}
                },
                select: function( event, ui ) {},
                change: function( event, ui ) {}
            });
            if (typeof params.value !== 'undefined') {
                vendor_cell_input.val(params.value);
            }
        }
        this.outerSource = source;
        this.old_val_out = old_value;
    };
    DPCellEditor.prototype.getGui = function () {
        return this.eInput;
    };
    DPCellEditor.prototype.afterGuiAttached = function () {
        // Set the select box to empty if this is the floating bottom row.
        var source = this.outerSource;
        if (this.params.node.rowPinned === 'bottom') {
            $(this.eInput).val('-');
            $(this.eInput).change(function (e) {
                if ($(this).val() !== '-') {
                    if(typeof TvDPGrid.api.pinnedRowModel.pinnedBottomRows[0] !== 'undefined')
                        createNewRow(TvDPGrid, TvDPGrid.api.pinnedRowModel.pinnedBottomRows[0].data, $(this).val());
                    else
                        createNewRow(TvDPGrid, TvDPGrid.api.pinnedRowModel.pinnedTopRows[0].data, $(this).val());
                }
            });
        }
        this.eInput.focus();
        $(this.eInput).select();
    };
    DPCellEditor.prototype.getValue = function () {
        return this.eInput.value.toLowerCase();
    };
    DPCellEditor.prototype.destroy = function () {
        $(this.eInput).unbind('change');
    };
    DPCellEditor.prototype.isPopup = function () {
        return false;
    };

    function DPRadioCellEditor() {
    }
    DPRadioCellEditor.prototype.init = function (params) {
        if (params.node.rowPinned == 'bottom') {
            this.eInput = document.createElement('select');
        }else{
            this.eInput = document.createElement('input');
        }

        this.params = params;
        var vendor_cell_input = $(this.eInput);
        var old_value = params.value;
        this.outerSource = [];
        var source = [];

        params.values.sort(function(a, b) {
            var textA = a.abbreviation.toUpperCase();
            var textB = b.abbreviation.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });

        if (params.node.rowPinned == 'bottom') {
            vendor_cell_input.addClass('form-control ws-custom-select');
            vendor_cell_input.append('<option value="-"></option>');
            var vendors_option=[];
            $.each(params.values, function (index, value) {
                if(vendors_option.indexOf(value.id) === -1) {
                    vendor_cell_input.append('<option value="' + value.id + '">' + value.abbreviation + '</option>');
                    vendors_option.push(value.id);
                }
            });
            if (typeof params.value !== 'undefined') {
                vendor_cell_input.val(params.value);
            }
        }else{
            $.each(params.values, function (index, value) {
                source.push({ label: value.abbreviation, value: value.id })
            });
            $( vendor_cell_input ).autocomplete({
                source: source,
                autoFocus: true,
                messages: {
                    noResults: '',
                    results: function() {}
                },
                select: function( event, ui ) {},
                change: function( event, ui ) {}
            });
            if (typeof params.value !== 'undefined') {
                vendor_cell_input.val(params.value);
            }
        }
        this.outerSource = source;
        this.old_val_out = old_value;
    };
    DPRadioCellEditor.prototype.getGui = function () {
        return this.eInput;
    };
    DPRadioCellEditor.prototype.afterGuiAttached = function () {
        // Set the select box to empty if this is the floating bottom row.
        var source = this.outerSource;
        if (this.params.node.rowPinned === 'bottom') {
            $(this.eInput).val('-');
            $(this.eInput).change(function (e) {
                if ($(this).val() !== '-') {
                    if(typeof RadioDPGrid.api.pinnedRowModel.pinnedBottomRows[0] !== 'undefined')
                        createNewRow(RadioDPGrid, RadioDPGrid.api.pinnedRowModel.pinnedBottomRows[0].data, $(this).val());
                    else
                        createNewRow(RadioDPGrid, RadioDPGrid.api.pinnedRowModel.pinnedTopRows[0].data, $(this).val());
                }
            });
        }
        this.eInput.focus();
        $(this.eInput).select();
    };
    DPRadioCellEditor.prototype.getValue = function () {
        return this.eInput.value.toLowerCase();
    };
    DPRadioCellEditor.prototype.destroy = function () {
        $(this.eInput).unbind('change');
    };
    DPRadioCellEditor.prototype.isPopup = function () {
        return false;
    };

    var createNewRow = function (e, data, vendor) {
        if (vendor !== '-') {
            var new_row = _.clone(data);
            new_row.status = 'new';
            new_row.int_id='-';
            new_row.daypart = vendor;
            new_row.media_type = 'television';
            new_row.week =  week_selected;
            new_row.market_cost =  0;
            new_row.grp =  0;
            new_row.broadcast_month_name = broadcast_month_selected;
            new_row.broadcast_month = broadcast_month_selected_number;
            new_row.total_cost ='$0.00';
            new_row.percent ='0.0%';

            var index= e.api.getModel().rowsToDisplay.length;

            e.api.updateRowData({add: [new_row], addIndex: index});
            e.api.ensureColumnVisible('market_cost');
            e.api.ensureIndexVisible(index);
            e.api.setFocusedCell(index, 'market_cost', null);
        }
    };
    var createNewRowLength= function (e, data, active) {
        if(active =='tv')
            active='television';
        var new_row = _.clone(data);
        new_row.status = 'new';
        new_row.length = '';
        new_row.int_id='-';
        new_row.media_type = active;
        new_row.market_cost =  0;
        new_row.grp =  0;
        new_row.week =  week_selected;
        new_row.broadcast_month_name = broadcast_month_selected;
        new_row.total_cost ='$0.00';
        new_row.percent ='0.0%';
       // e.api.addItems([new_row]);

        var index= e.api.getModel().rowsToDisplay.length;
        e.api.updateRowData({add: [new_row], addIndex: index});
        e.api.ensureColumnVisible('length');
        e.api.ensureIndexVisible(index);
        e.api.setFocusedCell(index, 'length', null);
    };
    var update_media_totals = function (media) {
        var grp = 0;
        var market_cost = 0;
        var total = 0;
       if(media=='television'){
           TvDPGrid.api.forEachNode(function (node) {
               if (!isNaN(parseFloat(node.data.market_cost)))
                   market_cost += parseFloat(node.data.market_cost);
               if (!isNaN(parseFloat(node.data.grp)))
                   grp += parseFloat(node.data.grp);
               if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                   total += parseFloat(node.data.market_cost) * parseFloat(node.data.grp);
           });
          /* TvLengthGrid.api.forEachNode(function (node) {
               if (!isNaN(parseFloat(node.data.market_cost)))
                   market_cost += parseFloat(node.data.market_cost);
               if (!isNaN(parseFloat(node.data.grp)))
                   grp += parseFloat(node.data.grp);
               if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                   total += parseFloat(node.data.market_cost) * parseFloat(node.data.grp);
           });*/

           // $('.tv_mark_total').html('');
           // $('.tv_mark_total').html('Media Cost: '+  parseFloat(market_cost ).toLocaleString("en-US", {
           //     style: "currency",
           //     currency: "USD",
           //     minimumFractionDigits: 2
           // }),);
           // $('.tv_grp_total').html('');
           // $('.tv_grp_total').html('GRP Goal:  '+  parseFloat(grp).toLocaleString("en-US", {
           //     minimumFractionDigits: 1
           // }),);
           // $('.tv_total').html('');
           // $('.tv_total').html('Total Cost:  '+  parseFloat(total ).toLocaleString("en-US", {
           //     style: "currency",
           //     currency: "USD",
           //     minimumFractionDigits: 2
           // }),);
       }
       if(media=='radio'){
           RadioDPGrid.api.forEachNode(function (node) {
               if (!isNaN(parseFloat(node.data.market_cost)))
                   market_cost += parseFloat(node.data.market_cost);
               if (!isNaN(parseFloat(node.data.grp)))
                   grp += parseFloat(node.data.grp);
               if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                   total += parseFloat(node.data.market_cost) * parseFloat(node.data.grp);
           });
           // RadioLengthGrid.api.forEachNode(function (node) {
           //     if (!isNaN(parseFloat(node.data.market_cost)))
           //         market_cost += parseFloat(node.data.market_cost);
           //     if (!isNaN(parseFloat(node.data.grp)))
           //         grp += parseFloat(node.data.grp);
           //     if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
           //         total += parseFloat(node.data.market_cost) * parseFloat(node.data.grp);
           // });
           // $('.radio_mark_total').html('');
           // $('.radio_mark_total').html('Media Cost:  '+  parseFloat(market_cost ).toLocaleString("en-US", {
           //     style: "currency",
           //     currency: "USD",
           //     minimumFractionDigits: 2
           // }),);
           // $('.radio_grp_total').html('');
           // $('.radio_grp_total').html('GRP Goal:  '+  parseFloat(grp ).toLocaleString("en-US", {
           //     minimumFractionDigits: 1
           // }),);
           // $('.radio_total').html('');
           // $('.radio_total').html('Total Cost:  '+  parseFloat(total).toLocaleString("en-US", {
           //     style: "currency",
           //     currency: "USD",
           //     minimumFractionDigits: 2
           // }),);
       }
    };
    var update_market_totals = function (media) {
        var grp = 0;
        var market_cost = 0;
        var total = 0;
        TvDPGrid.api.forEachNode(function (node) {
            if (!isNaN(parseFloat(node.data.market_cost)))
                market_cost += parseFloat(node.data.market_cost);
            if (!isNaN(parseFloat(node.data.grp)))
                grp += parseFloat(node.data.grp);
            if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                total += parseFloat(node.data.market_cost) * parseFloat(node.data.grp);
        });
       /* TvLengthGrid.api.forEachNode(function (node) {
            if (!isNaN(parseFloat(node.data.market_cost)))
                market_cost += parseFloat(node.data.market_cost);
            if (!isNaN(parseFloat(node.data.grp)))
                grp += parseFloat(node.data.grp);
            if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                total += parseFloat(node.data.market_cost) * parseFloat(node.data.grp);
        });*/

        RadioDPGrid.api.forEachNode(function (node) {
            if (!isNaN(parseFloat(node.data.market_cost)))
                market_cost += parseFloat(node.data.market_cost);
            if (!isNaN(parseFloat(node.data.grp)))
                grp += parseFloat(node.data.grp);
            if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                total += parseFloat(node.data.market_cost) * parseFloat(node.data.grp);
        });
        /*RadioLengthGrid.api.forEachNode(function (node) {
            if (!isNaN(parseFloat(node.data.market_cost)))
                market_cost += parseFloat(node.data.market_cost);
            if (!isNaN(parseFloat(node.data.grp)))
                grp += parseFloat(node.data.grp);
            if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                total += parseFloat(node.data.market_cost) * parseFloat(node.data.grp);
        });*/
        DigitalGrid.api.forEachNode(function (node) {
            if (!isNaN(parseFloat(node.data.market_cost)))
                market_cost += parseFloat(node.data.market_cost);
            if (!isNaN(parseFloat(node.data.grp)))
                grp += parseFloat(node.data.grp);
            if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                total += parseFloat(node.data.market_cost) * parseFloat(node.data.grp);
        });
        MailGrid.api.forEachNode(function (node) {
            if (!isNaN(parseFloat(node.data.market_cost)))
                market_cost += parseFloat(node.data.market_cost);
            if (!isNaN(parseFloat(node.data.grp)))
                grp += parseFloat(node.data.grp);
            if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                total += parseFloat(node.data.market_cost) * parseFloat(node.data.grp);
        });
        PrintGrid.api.forEachNode(function (node) {
            if (!isNaN(parseFloat(node.data.market_cost)))
                market_cost += parseFloat(node.data.market_cost);
            if (!isNaN(parseFloat(node.data.grp)))
                grp += parseFloat(node.data.grp);
            if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                total += parseFloat(node.data.market_cost) * parseFloat(node.data.grp);
        });
        OOHGrid.api.forEachNode(function (node) {
            if (!isNaN(parseFloat(node.data.market_cost)))
                market_cost += parseFloat(node.data.market_cost);
            if (!isNaN(parseFloat(node.data.grp)))
                grp += parseFloat(node.data.grp);
            if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                total += parseFloat(node.data.market_cost) * parseFloat(node.data.grp);
        });
        OtherGrid.api.forEachNode(function (node) {
            if (!isNaN(parseFloat(node.data.market_cost)))
                market_cost += parseFloat(node.data.market_cost);
            if (!isNaN(parseFloat(node.data.grp)))
                grp += parseFloat(node.data.grp);
            if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                total += parseFloat(node.data.market_cost) * parseFloat(node.data.grp);
        });
        // $('.mark_cost_total').html('');
        // $('.mark_cost_total').html('Market Cost:  '+  parseFloat(market_cost ).toLocaleString("en-US", {
        //     style: "currency",
        //     currency: "USD",
        //     minimumFractionDigits: 2
        // }),);
        // $('.mark_grp_total').html('');
        // $('.mark_grp_total').html('GRP Goal:  '+  parseFloat(grp ).toLocaleString("en-US", {
        //     minimumFractionDigits: 1
        // }),);
        // $('.mark_total').html('');
        // $('.mark_total').html('Total Cost:  '+  parseFloat(total).toLocaleString("en-US", {
        //     style: "currency",
        //     currency: "USD",
        //     minimumFractionDigits: 2
        // }),);

        update_week_totals(market_cost, grp ,total, camp_selected_week_budget , cost_other_market , grp_other_market , total_other_market );



    };

    function DPFormatRenderer() {
    }
    DPFormatRenderer.prototype.init = function (params) {
        this.eGui = document.createElement('div');
        if (params.value == '-') {
            this.eGui.innerHTML = '';
        } else {
            var vendor_string = '';
            var vendor_slug = params.value;
            $.each(params.column.colDef.cellEditorParams.values, function (index, value) {
                if (value.id == vendor_slug) {
                    vendor_string = value.abbreviation;
                }
            });

            if (vendor_string !== '') {
                this.eGui.innerHTML = vendor_string;
            } else {
                this.eGui.innerHTML = '';
            }
        }
    };
    DPFormatRenderer.prototype.getGui = function () {
        return this.eGui;
    };

    function FloatingDPFormatRenderer() {
    }
    FloatingDPFormatRenderer.prototype.init = function (params) {
        this.eGui = document.createElement('div');
        if (params.node.rowPinned == 'top') {
            this.eGui.innerHTML = '';
        } else {
            this.eGui.innerHTML = '<i class="fa fa-plus fa-fw fa-pull-left"></i> NEW';
        }
    };
    FloatingDPFormatRenderer.prototype.getGui = function () {
        return this.eGui;
    };
    FloatingDPFormatRenderer.prototype.refresh = function (params) {
        if (params.node.rowPinned == 'top') {
            this.eGui.innerHTML = '';
        } else {
            this.eGui.innerHTML = '<i class="fa fa-plus fa-fw fa-pull-left"></i> NEW';
        }
    };
    function BlankFormatRenderer() {
    }

    BlankFormatRenderer.prototype.init = function (params) {
        this.eGui = document.createElement('div');
        // if((params.column.colDef.field !== 'vendor')){
        this.eGui.innerHTML = '';
        // }
    };

    BlankFormatRenderer.prototype.getGui = function () {
        return this.eGui;
    };

    function CurrencyCellEditor() {
    }
    $.fn.setCursorPosition = function(pos) {
        this.each(function(index, elem) {
            if (elem.setSelectionRange) {
                elem.setSelectionRange(pos, pos);
            } else if (elem.createTextRange) {
                var range = elem.createTextRange();
                range.collapse(true);
                range.moveEnd('character', pos);
                range.moveStart('character', pos);
                range.select();
            }
        });
        return this;
    };
    CurrencyCellEditor.prototype.init = function (params) {
        // Auto calculate Net/Gross Rate based off of eachother.
        if (params.value === '') {
            params.value = 0;
        }
        this.eInput = document.createElement('input');
        var el = new AutoNumeric(this.eInput,
            {
                minimumValue: 0,
                selectOnFocus: false,
                caretPositionOnFocus: null,
                digitGroupSeparator: ',',
                digitalGroupSpacing: '3',
                decimalCharacter: '.',
                allowDecimalPadding: true,
                showOnlyNumbersOnFocus: true,
                showWarnings: false,
            });
        this.tabbed = false;
        if (params.charPress === null) {
            this.tabbed = true;
        }

        // If a "printable key" is pressed.
        if (params.charPress !== null) {
            var vv = parseFloat(params.charPress);
            if(!isNaN(vv))
                el.set(params.charPress);
        } else {
            // Remove value on delete/backspace
            if ((params.keyPress === 8) || (params.keyPress === 46)) {
                el.set(parseFloat(0));
                // Otherwise set the params value.
            } else {
                el.set(parseFloat(params.value).toFixed(2));
                if (params.charPress === null) {
                    this.tabbed = true;
                }
            }
        }
    };
    CurrencyCellEditor.prototype.getGui = function () {
        if (this.tabbed === true) {
            $(this.eInput).addClass('ws-tabbed-input');
        }
        return this.eInput;
    };
    CurrencyCellEditor.prototype.afterGuiAttached = function () {
        $(this.eInput).bind('keydown', function (e) {
            var key = e.which || e.keyCode;
            // Let arrow keys through
            if ((!e.shiftKey) && (key > 37 ) && (key < 39)) {
                e.stopPropagation();
                return true;
            }
            // Ignore commas.
            if(key === 188){
                e.preventDefault();
                return true;
            }
        });
        $(this.eInput).css('text-align', 'right');
        this.eInput.focus();
        if (this.tabbed) {
            $(this.eInput).select();
        }else{
            $(this.eInput).setCursorPosition(1);
        }
    };
    CurrencyCellEditor.prototype.getValue = function () {
        return this.eInput.value.replace(',', '');
    };
    CurrencyCellEditor.prototype.destroy = function () {
        $(this.eInput).unbind('keydown');
    };
    CurrencyCellEditor.prototype.isPopup = function () {
        return false;
    };

    function CurrencyFormatRenderer() {
    }
    CurrencyFormatRenderer.prototype.init = function (params) {
        this.eGui = document.createElement('div');
        $(this.eGui).css('text-align', 'right');
        if (typeof params.value !== 'undefined') {
            if (params.node.rowPinned !== 'bottom') {
                param_val = parseFloat(params.value).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    //minimumFractionDigits: 2
                });
                if (isNaN(parseFloat(params.value))) {

                    this.eGui.innerHTML = '$0.00';
                } else {
                    this.eGui.innerHTML = param_val;
                }
            } else {
                this.eGui.innerHTML = '';
            }
        } else {
            this.eGui.innerHTML = '$0.00';
        }
    };
    CurrencyFormatRenderer.prototype.getGui = function () {
        return this.eGui;
    };

    function FloatCellEditor() {
    }
    $.fn.setCursorPosition = function(pos) {
        this.each(function(index, elem) {
            if (elem.setSelectionRange) {
                elem.setSelectionRange(pos, pos);
            } else if (elem.createTextRange) {
                var range = elem.createTextRange();
                range.collapse(true);
                range.moveEnd('character', pos);
                range.moveStart('character', pos);
                range.select();
            }
        });
        return this;
    };
    FloatCellEditor.prototype.init = function (params) {
        this.tabbed = false;
        this.eInput = document.createElement('input');
        var el;
        el = new AutoNumeric(this.eInput,
            {
                decimalPlaces: 1,
                minimumValue: 0,
                selectOnFocus: false,
                caretPositionOnFocus: null,
                digitGroupSeparator: ',',
                digitalGroupSpacing: '3',
                decimalCharacter: '.',
                allowDecimalPadding: true,
                showOnlyNumbersOnFocus: true,
                showWarnings: false,
            });

        if (params.charPress === null) {
            this.tabbed = true;
        }
        // If a "printable key" is pressed.
        if (params.charPress !== null) {
            var vv = parseFloat(params.charPress);
            if(!isNaN(vv))
                el.set(params.charPress);
        } else {
            // Remove value on delete/backspace
            if ((params.keyPress === 8) || (params.keyPress === 46)) {
                el.set(parseFloat(0));
                // Otherwise set the params value.
            } else {
                if (params.column.colDef.field === 'rating' || params.column.colDef.field.indexOf("impression") !== -1 || params.column.colDef.field === 'reach' || params.column.colDef.field === 'frequency' || params.column.colDef.field === 'grp' || params.column.colDef.field.indexOf("gi") !== -1) {
                    el.set(parseFloat(params.value).toFixed(1));
                } else {
                    el.set(parseFloat(params.value).toFixed(2));
                }
                if (params.charPress === null) {
                    this.tabbed = true;
                }
            }
        }
    };
    FloatCellEditor.prototype.getGui = function () {
        if (this.tabbed === true) {
            $(this.eInput).addClass('ws-tabbed-input');
        }
        return this.eInput;
    };
    FloatCellEditor.prototype.afterGuiAttached = function () {
        $(this.eInput).bind('keydown', function (e) {
            value_flag = -1;
            if(typeof value_flag_demo_analisis !== "undefined")
                value_flag_demo_analisis = -1
            var key = e.which || e.keyCode;
            // Let arrow keys through
            if ((!e.shiftKey) && ((key === 37 ) || (key === 39))) {
                e.stopPropagation();
                return true;
            } else {
                if(parseFloat(this.value) <= 0){
                    /*console.log(e);
                    this.value = "." + e.originalEvent.key;*/
                }else{

                }
            }
            // Ignore commas.
            if(key === 188){
                e.preventDefault();
                return true;
            }
        });
        $(this.eInput).css('text-align', 'right');
        this.eInput.focus();
        if (this.tabbed === true) {
            $(this.eInput).select();
        }else{
            $(this.eInput).setCursorPosition(1);
        }
    };
    FloatCellEditor.prototype.getValue = function () {
        return this.eInput.value.replace(',', '');
    };
    FloatCellEditor.prototype.destroy = function () {
        $(this.eInput).unbind('keydown');
    };
    FloatCellEditor.prototype.isPopup = function () {
        return false;
    };

    function FloatFormatRenderer() {
    }
    function makeid() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < 5; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }
    FloatFormatRenderer.prototype.init = function (params) {
        var val=0;
        this.eGui = document.createElement('div');
        $(this.eGui).attr("id", makeid());

        $(this.eGui).css('text-align', 'right');
        if (typeof params.value !== 'undefined') {
            if (params.node.rowPinned !== 'bottom') {
                 val = parseFloat(params.value).toFixed(1);
                if (isNaN(val)) {
                    this.eGui.innerHTML = '0.0';
                } else {
                    this.eGui.innerHTML = val;
                }
            } else {
                this.eGui.innerHTML = '';
            }
        } else {
            this.eGui.innerHTML = '0.0';
        }
    };
    FloatFormatRenderer.prototype.getGui = function () {
        return this.eGui;
    };

    function FloatPercentFormatRenderer() {
    }
    FloatPercentFormatRenderer.prototype.init = function (params) {
        console.log('percent params params ', params);
        var val=0;
        this.eGui = document.createElement('div');
        $(this.eGui).attr("id", makeid());

        $(this.eGui).css('text-align', 'right');
        if (typeof params.value !== 'undefined') {
            if (params.node.rowPinned !== 'bottom') {
                split = params.value.toString().split('%')
                val = parseFloat(split[0]).toFixed(1);
                if (isNaN(val)) {
                   this.eGui.innerHTML = '0.0%';
                } else {
                    this.eGui.innerHTML = val+'%';
                }
            } else {
                this.eGui.innerHTML = '';
            }
        } else {
            if(params.node.rowPinned !== 'bottom')
                this.eGui.innerHTML = '0.0%';
            else
                this.eGui.innerHTML = '';
        }

    };
    FloatPercentFormatRenderer.prototype.getGui = function () {
        return this.eGui;
    };
   var showCampPlanner= function (camp_id,week, month, field , e) {
       saved_all=[ {tv_dp: 1, tv_len: 1, radio_dp: 1, radio_len: 1, print: 1, digital: 1, ooh: 1, mail: 1, other: 1, ott: 1, }]
       camapaign_selected= camp_id;
       selected_week= week;
       column_week= field;
       selected_row= e;
        $.ajax({
                type: 'GET',
                url: '/planner/get/campaign/week/' + camp_id +'/' +week,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    if (data.budget == null) {
                        hide_loader();
                        swal({
                                title: 'Warning',
                                text: "This Campaign has no budget for the current week.\n Please enter the week budget first.",
                                type: "warning",
                                showCancelButton: true,
                                confirmButtonClass: "btn-danger",
                                confirmButtonText: "OK",
                                cancelButtonText: "Close",
                                closeOnConfirm: true,
                                closeOnCancel: true
                            },
                            function (isConfirm) {

                            });
                    }
                    else{
                        current_camp_fd= data.fds;
                        current_camp_markets= data.markets;
                        selected_cam_media_types = data.media_types;

                        if (data.markets.length < 2)
                            cam_mark_count = false;
                        else
                            cam_mark_count = true;

                        $('#tv_apply_div').show();
                        $('#radio_apply_div').show();
                        $('#other_apply_div').show();
                        $('#print_apply_div').show();
                        $('#mail_apply_div').show();
                        $('#digital_apply_div').show();
                        $('#ooh_apply_div').show();
                        $('#ott_apply_div').show();

                        if (cam_mark_count == true) {
                            $('#tv_dp_apply_market').show();
                            $('#radio_dp_apply_market').show();
                            $('#print_apply_market').show();
                            $('#digital_apply_market').show();
                            $('#mail_apply_market').show();
                            $('#ooh_apply_market').show();
                            $('#other_apply_market').show();
                            $('#ott_apply_market').show();
                        } else {
                            $('#tv_dp_apply_market').hide();
                            $('#radio_dp_apply_market').hide();
                            $('#print_apply_market').hide();
                            $('#digital_apply_market').hide();
                            $('#mail_apply_market').hide();
                            $('#ooh_apply_market').hide();
                            $('#other_apply_market').hide();
                            $('#ott_apply_market').hide();
                        }

                        $("#tv_dp_remove_items").hide();
                        $("#tv_len_remove_items").hide();
                        $("#radio_dp_remove_items").hide();
                        $("#radio_len_remove_items").hide();
                        $("#print_remove_items").hide();
                        $("#digital_remove_items").hide();
                        $("#ooh_remove_items").hide();
                        $("#mail_remove_items").hide();
                        $("#other_remove_items").hide();
                        $("#ott_remove_items").hide();

                        $('.campaign_name_header').html('');
                        $('.campaign_name_header').html( data.campaign.name);
                        $('.week_name_header').html('');
                        $('.week_name_header').html('Week: ' + moment(week).format('L'));
                        $('.budget_name_header').html('');
                        $('.budget_name_header').html('Week Budget: '+parseFloat(data.budget.budget).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }),);

                        $('#campaign_market').select2({
                            minimumResultsForSearch: 5
                        });
                        $('#campaign_market').html('');

                        var html = '';
                        var html2 = '';
                        for (var i in data.markets) {
                            var selected = '';
                            if (i == 0)
                                selected = 'selected';
                            html += '<option value="' + data.markets[i].id + '" ' + selected + '>' + data.markets[i].type.toUpperCase() + ' - ' + data.markets[i].name + '</option>';
                            if (i > 0)
                                html2 += '<option value="' + data.markets[i].id + '" >' + data.markets[i].type.toUpperCase() + ' - ' + data.markets[i].name + '</option>';
                        }
                        $('#campaign_market').html(html);

                        $('#apply_market').multiSelect({
                            selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                            selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm ' id='select_all_appl_mark' ><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='deselect_all_appl_mark'><i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                            afterInit: function (ms) {
                                var that = this,
                                    $selectableSearch = that.$selectableUl.prev(),
                                    selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                                    .on('keydown', function (e) {
                                        if (e.which === 40) {
                                            that.$selectableUl.focus();
                                            return false;
                                        }
                                    });
                            },
                            afterSelect: function (values) {
                                this.qs1.cache();
                            },
                            afterDeselect: function (values) {
                                this.qs1.cache();
                            }
                        });
                        $('#apply_market').html(html2).multiSelect('refresh');

                        $('#select_all_appl_mark').on('click', function (e) {
                            $('#apply_market').multiSelect('select_all');
                        });
                        $('#deselect_all_appl_mark').on('click', function (e) {
                            $('#apply_market').multiSelect('deselect_all');
                        });


                        var htmlMedia = '';
                        $('.media_tabs li').hide();
                        if (data.media_types.indexOf('tv') !== -1)
                            $('#tv_id').show();
                        else
                            $('#tv_id').hide();
                        $('#tv').removeClass('active');
                        $('#tv_id').removeClass('active');
                        if (data.media_types.indexOf('radio') !== -1)
                            $('#radio_id').show();
                        else
                            $('#radio_id').hide();
                        $('#radio').removeClass('active');
                        $('#radio_id').removeClass('active');
                        if (data.media_types.indexOf('print') !== -1)
                            $('#print_id').show();
                        else
                            $('#print_id').hide();
                        $('#print').removeClass('active');
                        $('#print_id').removeClass('active');
                        if (data.media_types.indexOf('digital') !== -1)
                            $('#digital_id').show();
                        else
                            $('#digital_id').hide();
                        $('#digital').removeClass('active');
                        $('#digital_id').removeClass('active');
                        if (data.media_types.indexOf('ooh') !== -1)
                            $('#ooh_id').show();
                        else
                            $('#ooh_id').hide();
                        $('#ooh').removeClass('active');
                        $('#ooh_id').removeClass('active');
                        if (data.media_types.indexOf('mail') !== -1)
                            $('#mail_id').show();
                        else
                            $('#mail_id').hide();
                        $('#mail').removeClass('active');
                        $('#mail_id').removeClass('active');
                        if (data.media_types.indexOf('other') !== -1)
                            $('#other_id').show();
                        else
                            $('#other_id').hide();
                        $('#other').removeClass('active');
                        $('#other_id').removeClass('active');

                        if (data.media_types.indexOf('ott') !== -1)
                            $('#ott_id').show();
                        else
                            $('#ott_id').hide();
                        $('#ott').removeClass('active');
                        $('#ott_id').removeClass('active');

                        $('#total').removeClass('active');
                        $('#totals_id').removeClass('active');
                        $("#" + data.media_types[0] + "").addClass('active');
                        $("#" + data.media_types[0] + "_id").addClass('active');

                        TvDPGrid.rowData = [];
                        // TvLengthGrid.rowData = [];
                        RadioDPGrid.rowData = [];
                        // RadioLengthGrid.rowData = [];
                        PrintGrid.rowData = [];
                        DigitalGrid.rowData = [];
                        MailGrid.rowData = [];
                        OtherGrid.rowData = [];
                        OOHGrid.rowData = [];
                        OTTGrid.rowData = [];

                        deletedItemsDPTV = [];
                        deletedItemsLenTV = [];
                        deletedItemsDPRadio = [];
                        deletedItemsLenRadio = [];
                        deletedItemsPrint = [];
                        deletedItemsDigital = [];
                        deletedItemsOOH = [];
                        deletedItemsMail = [];
                        deletedItemsOther = [];
                        deletedItemsOTT = [];
                        var totals_array = {
                            tv: [
                                daypart = {
                                    grp: 0, market_cost: 0, total_cost: 0, grp_percent : 0, budget_percent: 0
                                },
                                len = {
                                    grp: 0, market_cost: 0, total_cost: 0
                                }
                            ],
                            radio: [
                                daypart = {
                                    grp: 0, market_cost: 0, total_cost: 0, grp_percent : 0, budget_percent: 0
                                },
                                len = {
                                    grp: 0, market_cost: 0, total_cost: 0
                                }
                            ],
                            mail: {grp: 0, market_cost: 0, total_cost: 0, grp_percent : 0, budget_percent: 0},
                            digital: {grp: 0, market_cost: 0, total_cost: 0, grp_percent : 0, budget_percent: 0},
                            print: {grp: 0, market_cost: 0, total_cost: 0, grp_percent : 0, budget_percent: 0},
                            other: {grp: 0, market_cost: 0, total_cost: 0, grp_percent : 0, budget_percent: 0},
                            ooh: {grp: 0, market_cost: 0, total_cost: 0, grp_percent : 0, budget_percent: 0},
                            ott: {grp: 0, market_cost: 0, total_cost: 0, grp_percent : 0, budget_percent: 0},
                        };
                        var media_totals = {
                            tv: {grp: 0, market_cost: 0, total_cost: 0},
                            radio: {grp: 0, market_cost: 0, total_cost: 0},
                        };
                        global_week_budget = data.budget.budget;
                        global_week_media_types = data.media_types;
                        week_selected = week;
                        broadcast_month_selected = moment('2019-' + month + '-01').format('MMMM');
                        broadcast_month_selected_number = month;
                        for (var i in data.plannings) {
                            if (data.plannings[i].media_type == 'television') {
                                if (data.plannings[i].daypart != '' && data.plannings[i].daypart != null) {
                                    var pp=0;
                                    if(data.budget.budget > 0)
                                        pp= (data.plannings[i].cost *  data.plannings[i].grp  *100 ) / data.budget.budget;
                                    var grp_percent= 0;
                                    if(typeof data.grp_totals['television'] !== 'undefined' && data.grp_totals['television'] > 0)
                                        grp_percent = (data.plannings[i].grp  * 100) / data.grp_totals['television'];
                                    TvDPGrid.rowData.push({
                                        int_id: data.plannings[i].id,
                                        planner_id: data.plannings[i].id,
                                        campaign_id: camp_id,
                                        market_id: $('#campaign_market option:selected').val(),
                                        media_type: 'television',
                                        type: 'daypart',
                                        week: week,
                                        broadcast_month: month,
                                        daypart: data.plannings[i].daypart_id,
                                        market_cost: data.plannings[i].cost,
                                        grp: data.plannings[i].grp,
                                        grp_percent: grp_percent,
                                        broadcast_month_name: moment('2019-' + month + '-01').format('MMMM'),
                                        total_cost: parseFloat(data.plannings[i].cost * data.plannings[i].grp).toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                            minimumFractionDigits: 2
                                        }),
                                        percent:parseFloat(pp).toLocaleString("en-US", {
                                            minimumFractionDigits: 1
                                        }) + '%',
                                    });
                                    totals_array['tv'][0]['market_cost'] += parseFloat(data.plannings[i].cost);
                                    totals_array['tv'][0]['grp'] += parseFloat(data.plannings[i].grp);
                                    totals_array['tv'][0]['total_cost'] += parseFloat(data.plannings[i].cost * data.plannings[i].grp);
                                    totals_array['tv'][0]['grp_percent'] += parseFloat(grp_percent)
                                    totals_array['tv'][0]['budget_percent'] += parseFloat(pp);

                                    media_totals['tv']['grp'] += parseFloat(data.plannings[i].grp);
                                    media_totals['tv']['market_cost'] += parseFloat(data.plannings[i].cost);
                                    media_totals['tv']['total_cost'] += parseFloat(data.plannings[i].cost * data.plannings[i].grp);
                                }
                            }
                            if (data.plannings[i].media_type == 'radio') {
                                if (data.plannings[i].daypart != '' && data.plannings[i].daypart != null) {
                                    if(data.budget.budget > 0)
                                        pp= (data.plannings[i].cost *  data.plannings[i].grp  *100 ) / data.budget.budget;

                                    var grp_percent= 0;
                                    if(typeof data.grp_totals['radio'] !== 'undefined' && data.grp_totals['radio'] > 0)
                                        grp_percent = (data.plannings[i].grp  * 100) / data.grp_totals['radio'];

                                    RadioDPGrid.rowData.push({
                                        int_id: data.plannings[i].id,
                                        planner_id: data.plannings[i].id,
                                        campaign_id: camp_id,
                                        market_id: $('#campaign_market option:selected').val(),
                                        media_type: 'radio',
                                        grp_percent: grp_percent,
                                        type: 'daypart',
                                        week: week,
                                        broadcast_month: month,
                                        daypart: data.plannings[i].daypart_id,
                                        market_cost: data.plannings[i].cost,
                                        grp: data.plannings[i].grp,
                                        broadcast_month_name: moment('2019-' + month + '-01').format('MMMM'),
                                        total_cost: parseFloat(data.plannings[i].cost * data.plannings[i].grp).toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                            minimumFractionDigits: 2
                                        }),
                                        percent:parseFloat(pp).toLocaleString("en-US", {
                                            minimumFractionDigits: 1
                                        }) + '%',
                                    });
                                    totals_array['radio'][0]['market_cost'] += parseFloat(data.plannings[i].cost);
                                    totals_array['radio'][0]['grp'] += parseFloat(data.plannings[i].grp);
                                    totals_array['radio'][0]['total_cost'] += parseFloat(data.plannings[i].cost * data.plannings[i].grp);
                                    totals_array['radio'][0]['grp_percent'] += parseFloat(grp_percent)
                                    totals_array['radio'][0]['budget_percent'] += parseFloat(pp);

                                    media_totals['radio']['grp'] += parseFloat(data.plannings[i].grp);
                                    media_totals['radio']['market_cost'] += parseFloat(data.plannings[i].cost);
                                    media_totals['radio']['total_cost'] += parseFloat(data.plannings[i].cost * data.plannings[i].grp);
                                }
                            }
                            if (data.plannings[i].media_type == 'print') {
                                if (data.plannings[i].name != '' && data.plannings[i].name != null) {
                                    var pp=0;
                                    if(data.budget.budget > 0)
                                        pp= (data.plannings[i].cost *  data.plannings[i].grp  *100 ) / data.budget.budget;
                                    var grp_percent= 0;
                                    if(typeof data.grp_totals['print'] !== 'undefined' && data.grp_totals['print'] > 0)
                                        grp_percent = (data.plannings[i].grp  * 100) / data.grp_totals['print'];


                                    PrintGrid.rowData.push({
                                        int_id: data.plannings[i].id,
                                        planner_id: data.plannings[i].id,
                                        campaign_id: camp_id,
                                        market_id: $('#campaign_market option:selected').val(),
                                        media_type: 'print',
                                        week: week,
                                        broadcast_month: month,
                                        length: data.plannings[i].name,
                                        market_cost: data.plannings[i].cost,
                                        grp: data.plannings[i].grp,
                                        grp_percent: grp_percent,
                                        broadcast_month_name: moment('2019-' + month + '-01').format('MMMM'),
                                        total_cost: parseFloat(data.plannings[i].cost * data.plannings[i].grp).toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                            minimumFractionDigits: 2
                                        }),
                                        percent:parseFloat(pp).toLocaleString("en-US", {
                                            minimumFractionDigits: 1
                                        }) + '%',
                                    });
                                    totals_array['print']['market_cost'] += parseFloat(data.plannings[i].cost);
                                    totals_array['print']['grp'] +=parseFloat( data.plannings[i].grp);
                                    totals_array['print']['total_cost'] += parseFloat(data.plannings[i].cost * data.plannings[i].grp);

                                    totals_array['print']['grp_percent'] += parseFloat(grp_percent)
                                    totals_array['print']['budget_percent'] += parseFloat(pp);

                                }
                            }
                            if (data.plannings[i].media_type == 'digital') {
                                if (data.plannings[i].name != '' && data.plannings[i].name != null) {
                                    var pp=0;
                                    if(data.budget.budget > 0)
                                        pp= (data.plannings[i].cost *  data.plannings[i].grp  *100 ) / data.budget.budget;

                                    var grp_percent= 0;
                                    if(typeof data.grp_totals['digital'] !== 'undefined' && data.grp_totals['digital'] > 0)
                                        grp_percent = (data.plannings[i].grp  * 100) / data.grp_totals['digital'];

                                    DigitalGrid.rowData.push({
                                        int_id: data.plannings[i].id,
                                        planner_id: data.plannings[i].id,
                                        campaign_id: camp_id,
                                        market_id: $('#campaign_market option:selected').val(),
                                        media_type: 'digital',
                                        type: 'digital',
                                        week: week,
                                        broadcast_month: month,
                                        length: data.plannings[i].name,
                                        market_cost: data.plannings[i].cost,
                                        grp: data.plannings[i].grp,
                                        grp_percent: grp_percent,
                                        broadcast_month_name: moment('2019-' + month + '-01').format('MMMM'),
                                        total_cost: parseFloat(data.plannings[i].cost * data.plannings[i].grp).toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                            minimumFractionDigits: 2
                                        }),
                                        percent:parseFloat(pp).toLocaleString("en-US", {
                                            minimumFractionDigits: 1
                                        }) + '%',
                                    });
                                    totals_array['digital']['market_cost'] += parseFloat(data.plannings[i].cost);
                                    totals_array['digital']['grp'] += parseFloat(data.plannings[i].grp);
                                    totals_array['digital']['total_cost'] += parseFloat(data.plannings[i].cost * data.plannings[i].grp);
                                    totals_array['digital']['grp_percent'] += parseFloat(grp_percent)
                                    totals_array['digital']['budget_percent'] += parseFloat(pp);
                                }
                            }
                            if (data.plannings[i].media_type == 'mail') {
                                if (data.plannings[i].name != '' && data.plannings[i].name != null) {
                                    var pp=0;
                                    if(data.budget.budget > 0)
                                        pp= (data.plannings[i].cost *  data.plannings[i].grp  *100 ) / data.budget.budget;
                                    var grp_percent= 0;
                                    if(typeof data.grp_totals['mail'] !== 'undefined' && data.grp_totals['mail'] > 0)
                                        grp_percent = (data.plannings[i].grp  * 100) / data.grp_totals['mail'];

                                    MailGrid.rowData.push({
                                        int_id: data.plannings[i].id,
                                        planner_id: data.plannings[i].id,
                                        campaign_id: camp_id,
                                        market_id: $('#campaign_market option:selected').val(),
                                        media_type: 'mail',
                                        type: 'mail',
                                        week: week,
                                        broadcast_month: month,
                                        length: data.plannings[i].name,
                                        market_cost: data.plannings[i].cost,
                                        grp: data.plannings[i].grp,
                                        grp_percent: grp_percent,
                                        broadcast_month_name: moment('2019-' + month + '-01').format('MMMM'),
                                        total_cost: parseFloat(data.plannings[i].cost * data.plannings[i].grp).toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                            minimumFractionDigits: 2
                                        }),
                                        percent:parseFloat(parseFloat(data.plannings[i].cost )* parseFloat(data.plannings[i].grp)).toLocaleString("en-US", {
                                            minimumFractionDigits: 1
                                        }) + '%',
                                    });
                                    totals_array['mail']['market_cost'] += parseFloat(data.plannings[i].cost);
                                    totals_array['mail']['grp'] += parseFloat(data.plannings[i].grp);
                                    totals_array['mail']['total_cost'] += parseFloat(data.plannings[i].cost * data.plannings[i].grp);
                                    totals_array['mail']['grp_percent'] += parseFloat(grp_percent)
                                    totals_array['mail']['budget_percent'] += parseFloat(pp);
                                }
                            }
                            if (data.plannings[i].media_type == 'other') {
                                if (data.plannings[i].name != '' && data.plannings[i].name != null) {
                                    var pp=0;
                                    if(data.budget.budget > 0)
                                        pp= (data.plannings[i].cost *  data.plannings[i].grp  *100 ) / data.budget.budget;
                                    var grp_percent= 0;
                                    if(typeof data.grp_totals['other'] !== 'undefined' && data.grp_totals['other'] > 0)
                                        grp_percent = (data.plannings[i].grp  * 100) / data.grp_totals['other'];

                                    OtherGrid.rowData.push({
                                        int_id: data.plannings[i].id,
                                        planner_id: data.plannings[i].id,
                                        campaign_id: camp_id,
                                        market_id: $('#campaign_market option:selected').val(),
                                        media_type: 'other',
                                        type: 'other',
                                        week: week,
                                        broadcast_month: month,
                                        length: data.plannings[i].name,
                                        market_cost: data.plannings[i].cost,
                                        grp: data.plannings[i].grp,
                                        grp_percent: grp_percent,
                                        broadcast_month_name: moment('2019-' + month + '-01').format('MMMM'),
                                        total_cost: parseFloat(data.plannings[i].cost * data.plannings[i].grp).toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                            minimumFractionDigits: 2
                                        }),
                                        percent:parseFloat(pp).toLocaleString("en-US", {
                                            minimumFractionDigits: 1
                                        }) + '%',
                                    });
                                    totals_array['other']['market_cost'] += parseFloat(data.plannings[i].cost);
                                    totals_array['other']['grp'] += parseFloat(data.plannings[i].grp);
                                    totals_array['other']['total_cost'] += parseFloat(data.plannings[i].cost * data.plannings[i].grp);
                                    totals_array['other']['grp_percent'] += parseFloat(grp_percent)
                                    totals_array['other']['budget_percent'] += parseFloat(pp);
                                }
                            }
                            if (data.plannings[i].media_type == 'ooh') {
                                if (data.plannings[i].name != '' && data.plannings[i].name != null) {
                                    var pp=0;
                                    if(data.budget.budget > 0)
                                        pp= (data.plannings[i].cost *  data.plannings[i].grp  *100 ) / data.budget.budget;
                                    var grp_percent= 0;
                                    if(typeof data.grp_totals['ooh'] !== 'undefined' && data.grp_totals['ooh'] > 0)
                                        grp_percent = (data.plannings[i].grp  * 100) / data.grp_totals['ooh'];

                                    OOHGrid.rowData.push({
                                        int_id: data.plannings[i].id,
                                        planner_id: data.plannings[i].id,
                                        campaign_id: camp_id,
                                        market_id: $('#campaign_market option:selected').val(),
                                        media_type: 'ooh',
                                        type: 'ooh',
                                        week: week,
                                        broadcast_month: month,
                                        length: data.plannings[i].name,
                                        market_cost: data.plannings[i].cost,
                                        grp: data.plannings[i].grp,
                                        grp_percent: grp_percent,
                                        broadcast_month_name: moment('2019-' + month + '-01').format('MMMM'),
                                        total_cost: parseFloat(data.plannings[i].cost * data.plannings[i].grp).toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                            minimumFractionDigits: 2
                                        }),
                                        percent:parseFloat(pp).toLocaleString("en-US", {
                                            minimumFractionDigits: 1
                                        }) + '%',
                                    });
                                    totals_array['ooh']['market_cost'] += parseFloat(data.plannings[i].cost);
                                    totals_array['ooh']['grp'] += parseFloat(data.plannings[i].grp);
                                    totals_array['ooh']['total_cost'] += parseFloat(data.plannings[i].cost * data.plannings[i].grp);
                                    totals_array['ooh']['grp_percent'] += parseFloat(grp_percent)
                                    totals_array['ooh']['budget_percent'] += parseFloat(pp);
                                }
                            }
                            if (data.plannings[i].media_type == 'ott') {
                                if (data.plannings[i].name != '' && data.plannings[i].name != null) {
                                    var pp=0;
                                    if(data.budget.budget > 0)
                                        pp= (data.plannings[i].cost *  data.plannings[i].grp  *100 ) / data.budget.budget;
                                    var grp_percent= 0;
                                    if(typeof data.grp_totals['ott'] !== 'undefined' && data.grp_totals['ott'] > 0)
                                        grp_percent = (data.plannings[i].grp  * 100) / data.grp_totals['ott'];

                                    OTTGrid.rowData.push({
                                        int_id: data.plannings[i].id,
                                        planner_id: data.plannings[i].id,
                                        campaign_id: camp_id,
                                        market_id: $('#campaign_market option:selected').val(),
                                        media_type: 'ott',
                                        type: 'ott',
                                        week: week,
                                        broadcast_month: month,
                                        length: data.plannings[i].name,
                                        market_cost: data.plannings[i].cost,
                                        grp: data.plannings[i].grp,
                                        grp_percent: grp_percent,
                                        broadcast_month_name: moment('2019-' + month + '-01').format('MMMM'),
                                        total_cost: parseFloat(data.plannings[i].cost * data.plannings[i].grp).toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                            minimumFractionDigits: 2
                                        }),
                                        percent:parseFloat(pp).toLocaleString("en-US", {
                                            minimumFractionDigits: 1
                                        }) + '%',
                                    });
                                    totals_array['ott']['market_cost'] += parseFloat(data.plannings[i].cost);
                                    totals_array['ott']['grp'] += parseFloat(data.plannings[i].grp);
                                    totals_array['ott']['total_cost'] += parseFloat(data.plannings[i].cost * data.plannings[i].grp);
                                    totals_array['ott']['grp_percent'] += parseFloat(grp_percent)
                                    totals_array['ott']['budget_percent'] += parseFloat(pp);
                                }
                            }
                        }
                        totals_array['tv'][0]['total_cost'] = parseFloat(totals_array['tv'][0]['total_cost']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        totals_array['tv'][1]['total_cost'] = parseFloat(totals_array['tv'][1]['total_cost']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        totals_array['radio'][0]['total_cost'] = parseFloat(totals_array['radio'][0]['total_cost']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        totals_array['radio'][1]['total_cost'] = parseFloat(totals_array['radio'][1]['total_cost']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        totals_array['print']['total_cost'] = parseFloat(totals_array['print']['total_cost']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        totals_array['digital']['total_cost'] = parseFloat(totals_array['digital']['total_cost']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        totals_array['ooh']['total_cost'] = parseFloat(totals_array['ooh']['total_cost']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        totals_array['mail']['total_cost'] = parseFloat(totals_array['mail']['total_cost']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        totals_array['other']['total_cost'] = parseFloat(totals_array['other']['total_cost']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        totals_array['ott']['total_cost'] = parseFloat(totals_array['ott']['total_cost']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });

                        $('#tvDPGrid').html("");
                        var tvDPGridGrid = document.querySelector('#tvDPGrid');
                        var g5 = new agGrid.Grid(tvDPGridGrid, TvDPGrid);
                        TvDPGrid.api.setPinnedTopRowData([{
                            market_cost: totals_array['tv'][0]['market_cost'],
                            grp: totals_array['tv'][0]['grp'],
                            total_cost: totals_array['tv'][0]['total_cost'],
                            grp_percent: parseFloat(totals_array['tv'][0]['grp_percent']).toLocaleString("en-US", {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '%',
                            percent: parseFloat(totals_array['tv'][0]['budget_percent']).toLocaleString("en-US", {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '%',
                        }]);

                        $('#radioDPGrid').html("");
                        var radioDPGridGrid = document.querySelector('#radioDPGrid');
                        var g5 = new agGrid.Grid(radioDPGridGrid, RadioDPGrid);
                        RadioDPGrid.api.setPinnedTopRowData([{
                            market_cost: totals_array['radio'][0]['market_cost'],
                            grp: totals_array['radio'][0]['grp'],
                            total_cost: totals_array['radio'][0]['total_cost'],
                            grp_percent: parseFloat(totals_array['radio'][0]['grp_percent']).toLocaleString("en-US", {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '%',
                            percent: parseFloat(totals_array['radio'][0]['budget_percent']).toLocaleString("en-US", {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '%',
                        }]);

                        $('#PrintGrid').html("");
                        var printGridGrid = document.querySelector('#PrintGrid');
                        var g5 = new agGrid.Grid(printGridGrid, PrintGrid);
                        PrintGrid.api.setPinnedTopRowData([{
                            market_cost: totals_array['print']['market_cost'],
                            grp: totals_array['print']['grp'],
                            total_cost: totals_array['print']['total_cost'],
                            grp_percent: parseFloat(totals_array['print']['grp_percent']).toLocaleString("en-US", {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '%',
                            percent: parseFloat(totals_array['print']['budget_percent']).toLocaleString("en-US", {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '%',
                        }]);

                        $('#DigitalGrid').html("");
                        var digitalGridGrid = document.querySelector('#DigitalGrid');
                        var g5 = new agGrid.Grid(digitalGridGrid, DigitalGrid);
                        DigitalGrid.api.setPinnedTopRowData([{
                            market_cost: totals_array['digital']['market_cost'],
                            grp: totals_array['digital']['grp'],
                            total_cost: totals_array['digital']['total_cost'],
                            grp_percent: parseFloat(totals_array['digital']['grp_percent']).toLocaleString("en-US", {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '%',
                            percent: parseFloat(totals_array['digital']['budget_percent']).toLocaleString("en-US", {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '%',
                        }]);

                        $('#MailGrid').html("");
                        var mailGridGrid = document.querySelector('#MailGrid');
                        var g5 = new agGrid.Grid(mailGridGrid, MailGrid);
                        MailGrid.api.setPinnedTopRowData([{
                            market_cost: totals_array['mail']['market_cost'],
                            grp: totals_array['mail']['grp'],
                            total_cost: totals_array['mail']['total_cost'],
                            grp_percent: parseFloat(totals_array['mail']['grp_percent']).toLocaleString("en-US", {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '%',
                            percent: parseFloat(totals_array['mail']['budget_percent']).toLocaleString("en-US", {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '%',

                        }]);

                        $('#OOHGrid').html("");
                        var OOHGridGrid = document.querySelector('#OOHGrid');
                        var g5 = new agGrid.Grid(OOHGridGrid, OOHGrid);
                        OOHGrid.api.setPinnedTopRowData([{
                            market_cost: totals_array['ooh']['market_cost'],
                            grp: totals_array['ooh']['grp'],
                            total_cost: totals_array['ooh']['total_cost'],
                            grp_percent: parseFloat(totals_array['ooh']['grp_percent']).toLocaleString("en-US", {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '%',
                            percent: parseFloat(totals_array['ooh']['budget_percent']).toLocaleString("en-US", {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '%',
                        }]);

                        $('#OtherGrid').html("");
                        var OtherGridGrid = document.querySelector('#OtherGrid');
                        var g5 = new agGrid.Grid(OtherGridGrid, OtherGrid);
                        OtherGrid.api.setPinnedTopRowData([{
                            market_cost: totals_array['other']['market_cost'],
                            grp: totals_array['other']['grp'],
                            total_cost: totals_array['other']['total_cost'],
                            grp_percent: parseFloat(totals_array['other']['grp_percent']).toLocaleString("en-US", {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '%',
                            percent: parseFloat(totals_array['other']['budget_percent']).toLocaleString("en-US", {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '%',
                        }]);

                        $('#OTTGrid').html("");
                        var OTTGridGrid = document.querySelector('#OTTGrid');
                        var g5 = new agGrid.Grid(OTTGridGrid, OTTGrid);
                        OTTGrid.api.setPinnedTopRowData([{
                            market_cost: totals_array['ott']['market_cost'],
                            grp: totals_array['ott']['grp'],
                            total_cost: totals_array['ott']['total_cost'],
                            grp_percent: parseFloat(totals_array['ott']['grp_percent']).toLocaleString("en-US", {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '%',
                            percent: parseFloat(totals_array['ott']['budget_percent']).toLocaleString("en-US", {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '%',
                        }]);


                        $('#newPlannerModal').modal({backdrop: 'static', keyboard: false})
                        $('#newPlannerModal').modal('show');

                    }
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    debug(xhr.responseText);
                }
            });
    };
  $('#totals_id').on('click', function(){
      show_overlay_loader($("#newPlannerModal .modal-content"));
       var total_row = {gri: 0, grp: 0, total_spend:0, spend_percent: 0};
       TotalGrid.rowData = [];
       media_types = global_week_media_types;
      for(var i in media_types){
           if(media_types[i] == 'tv') {
               var top_line = TvDPGrid.api.pinnedRowModel.pinnedTopRows[0].data;
               var media = 'Television';
           }
           if(media_types[i] == 'radio') {
               var top_line = RadioDPGrid.api.pinnedRowModel.pinnedTopRows[0].data;
               var media = 'Radio';
           }
           if(media_types[i] == 'print') {
               var top_line = PrintGrid.api.pinnedRowModel.pinnedTopRows[0].data;
               var media = 'Print';
           }
           if(media_types[i] == 'digital') {
               var top_line = DigitalGrid.api.pinnedRowModel.pinnedTopRows[0].data;
               var media = 'Digital';
           }
           if(media_types[i] == 'mail') {
               var top_line = MailGrid.api.pinnedRowModel.pinnedTopRows[0].data;
               var media = 'Mail';
           }
           if(media_types[i] == 'other') {
               var top_line = OtherGrid.api.pinnedRowModel.pinnedTopRows[0].data;
               var media = 'Other';
           }
           if(media_types[i] == 'ooh') {
               var top_line = OOHGrid.api.pinnedRowModel.pinnedTopRows[0].data;
               var media = 'OOH';
           }
          if(media_types[i] == 'ott') {
              var top_line = OTTGrid.api.pinnedRowModel.pinnedTopRows[0].data;
              var media = 'OTT';
          }
           if(media_types[i] != 'cable') {
               var total_cost = top_line.total_cost.replace('$', '');
               total_cost = total_cost.replace(/,/g, '');

               total_row['grp'] +=((media == 'Radio' || media == 'Television') && !isNaN(parseFloat(top_line.grp)) ) ? parseFloat(top_line.grp) : 0;
               total_row['gri'] +=((media != 'Radio' && media != 'Television') && !isNaN(parseFloat(top_line.grp)) ) ? parseFloat(top_line.grp) : 0;
               var perc = (!isNaN(parseFloat(total_cost)) && !isNaN(parseFloat(global_week_budget )) && parseFloat(global_week_budget ) > 0) ? (parseFloat(total_cost) * 100) / parseFloat(global_week_budget ) : 0;
               total_row['spend_percent'] += parseFloat(perc);
               total_row['total_spend'] += (!isNaN(parseFloat(total_cost))) ? parseFloat(total_cost) : 0;

               TotalGrid.rowData.push({
                   media_type: media,
                   grp: (media == 'Radio' || media == 'Television') ? parseFloat(top_line.grp).toLocaleString("en-US", {
                       minimumFractionDigits: 1,
                       maximumFractionDigits: 1,
                   }) : parseFloat(0.0).toLocaleString("en-US", {
                       minimumFractionDigits: 1,
                       maximumFractionDigits: 1,
                   }),
                   gri: (media != 'Radio' && media != 'Television') ? parseFloat(top_line.grp).toLocaleString("en-US", {
                       minimumFractionDigits: 1,
                       maximumFractionDigits: 1,
                   }) : parseFloat(0.0).toLocaleString("en-US", {
                       minimumFractionDigits: 1,
                       maximumFractionDigits: 1,
                   }),
                   total_spend: top_line.total_cost,
                   spend_percent: parseFloat(perc).toLocaleString("en-US", {
                       minimumFractionDigits: 1,
                       maximumFractionDigits: 1,
                   }) + '%',
               });
           }
       }
       $('#TotalGrid').html("");
       var TotalGridGrid = document.querySelector('#TotalGrid');
       var g5 = new agGrid.Grid(TotalGridGrid, TotalGrid);
       TotalGrid.api.setPinnedTopRowData([{
           gri: parseFloat(total_row['gri']).toLocaleString("en-US", {
               minimumFractionDigits: 1,
               maximumFractionDigits: 1,
           }) ,
           grp: parseFloat(total_row['grp']).toLocaleString("en-US", {
               minimumFractionDigits: 1,
               maximumFractionDigits: 1,
           }) ,
           spend_percent: parseFloat(total_row['spend_percent']).toLocaleString("en-US", {
               minimumFractionDigits: 1,
               maximumFractionDigits: 1,
           }) + '%',
           total_spend: parseFloat(total_row['total_spend']).toLocaleString("en-US", {
               style: "currency",
               currency: "USD",
               minimumFractionDigits: 2
           }),
       }]);
      hide_overlay_loader($("#newPlannerModal .modal-content"));
   });

   $('#tv_dp_refresh_grp').on("click", function(){
       refresh_grp_goal(TvDPGrid, 'tv');
   });
    $('#radio_dp_refresh_grp').on("click", function(){
        refresh_grp_goal(RadioDPGrid, 'radio');
    });
    $('#digital_refresh_grp').on("click", function(){
        refresh_grp_goal(DigitalGrid, 'digital');
    });
    $('#print_refresh_grp').on("click", function(){
        refresh_grp_goal(PrintGrid, 'print');
    });
    $('#mail_refresh_grp').on("click", function(){
        refresh_grp_goal(MailGrid, 'mail');
    });
    $('#other_refresh_grp').on("click", function(){
        refresh_grp_goal(OtherGrid, 'other');
    });
    $('#ooh_refresh_grp').on("click", function(){
        refresh_grp_goal(OOHGrid, 'ooh');
    });
    $('#ott_refresh_grp').on("click", function(){
        refresh_grp_goal(OTTGrid, 'ott');
    });
    var refresh_grp_goal = function(grid, media_type){
       var top_line = grid.api.pinnedRowModel.pinnedTopRows[0].data;
       if(top_line.grp_percent !== '100.0%') {
           if(media_type == 'tv' || media_type == 'radio')
               var msj = 'GRP Percent must be equal to 100.0% to to allocate GRP.';
           else
               var msj = 'GRI Percent must be equal to 100.0% to to allocate GRI.';
           swal({
                   title: "Warning",
                   text: msj,
                   type: "warning",
                   showCancelButton: false,
                   confirmButtonClass: "btn-danger",
                   confirmButtonText: "OK",
                   //cancelButtonText: "No",
                   closeOnConfirm: true,
                   closeOnCancel: true
               },
               function (isConfirm) {
                   if (isConfirm) {
                   }
               });

       }else {
           //array_to_allocate[media_type]['total'] = 0;
           array_to_allocate[media_type]['grp'] = 0;
           var nodes_to_refresh = [];
           var cell_changed_refresh = [];
           var top_budget_perc = 0;
           var top_total_cost = 0;
           grid.api.forEachNode(function (node) {
               var grp = (!isNaN(top_line.grp) && !isNaN(parseFloat(node.data.grp_percent))) ? ((node.data.grp_percent * top_line.grp) / 100) : 0;
               var tt_cost = (!isNaN(grp) && !isNaN(parseFloat(node.data.market_cost))) ? (node.data.market_cost * grp) : 0;
               var perc = (camp_selected_week_budget > 0 && !isNaN(parseFloat(node.data.market_cost))) ? (grp * node.data.market_cost * 100) / camp_selected_week_budget : 0;
               top_budget_perc += parseFloat(perc);
               top_total_cost += parseFloat(tt_cost);
               node.data.grp = grp;
               node.data.total_cost = parseFloat(tt_cost).toLocaleString("en-US", {
                   style: "currency",
                   currency: "USD",
                   minimumFractionDigits: 2
               });
               node.data.percent = parseFloat(perc).toLocaleString("en-US", {
                   minimumFractionDigits: 1,
                   maximumFractionDigits: 1,
               }) + '%';
               nodes_to_refresh.push(node);
           });
           cell_changed_refresh.push('grp');
           grid.api.refreshCells({rowNodes: nodes_to_refresh, columns: cell_changed_refresh, force: false});
           var top_row_data_invoice = {
               grp: top_line.grp,
               total_cost: parseFloat(top_total_cost).toLocaleString("en-US", {
                   style: "currency",
                   currency: "USD",
                   minimumFractionDigits: 2
               }),
               grp_percent: top_line.grp_percent,
               percent: parseFloat(top_budget_perc).toLocaleString("en-US", {
                   minimumFractionDigits: 1,
                   maximumFractionDigits: 1,
               }) + '%',
           };
           grid.api.setPinnedTopRowData([top_row_data_invoice]);
           global_notification('success', 'GRP has been allocated...')
       }
   }
    $("#tv_dp_remove_items").on("click", function(){
        var selectedNodes = TvDPGrid.api.getSelectedNodes();
        for(var i in selectedNodes) {
            if (selectedNodes[i].data.int_id !== "-")
                deletedItemsDPTV.push(selectedNodes[i].data.int_id);
        }
        TvDPGrid.api.removeItems(selectedNodes);
        //var rr = TvDPGrid.api.updateRowData({remove: selectedNodes});
        var grp = 0;
        var market_cost = 0;
        var total = 0;
        TvDPGrid.api.forEachNode(function (node) {
            if (!isNaN(parseFloat(node.data.market_cost)))
                market_cost += parseFloat(node.data.market_cost);
            if (!isNaN(parseFloat(node.data.grp)))
                grp += parseFloat(node.data.grp);
            if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                total += market_cost * grp;
        });
        market_cost = parseFloat(market_cost).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        });
        total = parseFloat(total).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        });
        var top_row_data_invoice = {
            market_cost: market_cost,
            grp: grp,
            total_cost: total,
        };
        TvDPGrid.api.setPinnedTopRowData([top_row_data_invoice]);
        update_market_totals('');
    });
    $("#radio_dp_remove_items").on("click", function(){
        var selectedNodes = RadioDPGrid.api.getSelectedNodes();
        for(var i in selectedNodes) {
            if (selectedNodes[i].data.int_id !== "-")
                deletedItemsDPRadio.push(selectedNodes[i].data.int_id);
        }
        RadioDPGrid.api.removeItems(selectedNodes);
        //var rr = RadioDPGrid.api.updateRowData({remove: selectedNodes});
        var grp = 0;
        var market_cost = 0;
        var total = 0;
        RadioDPGrid.api.forEachNode(function (node) {
            if (!isNaN(parseFloat(node.data.market_cost)))
                market_cost += parseFloat(node.data.market_cost);
            if (!isNaN(parseFloat(node.data.grp)))
                grp += parseFloat(node.data.grp);
            if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                total += market_cost * grp;
        });
        market_cost = parseFloat(market_cost).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        });
        total = parseFloat(total).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        });
        var top_row_data_invoice = {
            market_cost: market_cost,
            grp: grp,
            total_cost: total,
        };
        RadioDPGrid.api.setPinnedTopRowData([top_row_data_invoice]);
        update_market_totals('');
    });
    $("#print_remove_items").on("click", function(){
        var selectedNodes = PrintGrid.api.getSelectedNodes();
        for(var i in selectedNodes) {
            if (selectedNodes[i].data.int_id !== "-")
                deletedItemsPrint.push(selectedNodes[i].data.int_id);
        }
        PrintGrid.api.removeItems(selectedNodes);
        //var rr = PrintGrid.api.updateRowData({remove: selectedNodes});
        var grp = 0;
        var market_cost = 0;
        var total = 0;
        PrintGrid.api.forEachNode(function (node) {
            if (!isNaN(parseFloat(node.data.market_cost)))
                market_cost += parseFloat(node.data.market_cost);
            if (!isNaN(parseFloat(node.data.grp)))
                grp += parseFloat(node.data.grp);
            if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                total += market_cost * grp;
        });
        market_cost = parseFloat(market_cost).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        });
        total = parseFloat(total).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        });
        var top_row_data_invoice = {
            market_cost: market_cost,
            grp: grp,
            total_cost: total,
        };
        PrintGrid.api.setPinnedTopRowData([top_row_data_invoice]);
        update_market_totals('');
    });
    $("#digital_remove_items").on("click", function(){
        var selectedNodes = DigitalGrid.api.getSelectedNodes();
        for(var i in selectedNodes) {
            if (selectedNodes[i].data.int_id !== "-")
                deletedItemsDigital.push(selectedNodes[i].data.int_id);
        }
        DigitalGrid.api.removeItems(selectedNodes);
        //var rr = DigitalGrid.api.updateRowData({remove: selectedNodes});
        var grp = 0;
        var market_cost = 0;
        var total = 0;
        DigitalGrid.api.forEachNode(function (node) {
            if (!isNaN(parseFloat(node.data.market_cost)))
                market_cost += parseFloat(node.data.market_cost);
            if (!isNaN(parseFloat(node.data.grp)))
                grp += parseFloat(node.data.grp);
            if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                total += market_cost * grp;
        });
        market_cost = parseFloat(market_cost).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        });
        total = parseFloat(total).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        });
        var top_row_data_invoice = {
            market_cost: market_cost,
            grp: grp,
            total_cost: total,
        };
        DigitalGrid.api.setPinnedTopRowData([top_row_data_invoice]);
        update_market_totals('');
    });
    $("#ooh_remove_items").on("click", function(){
        var selectedNodes = OOHGrid.api.getSelectedNodes();
        for(var i in selectedNodes) {
            if (selectedNodes[i].data.int_id !== "-")
                deletedItemsOOH.push(selectedNodes[i].data.int_id);
        }
        OOHGrid.api.removeItems(selectedNodes);
        //var rr = OOHGrid.api.updateRowData({remove: selectedNodes});
        var grp = 0;
        var market_cost = 0;
        var total = 0;
        OOHGrid.api.forEachNode(function (node) {
            if (!isNaN(parseFloat(node.data.market_cost)))
                market_cost += parseFloat(node.data.market_cost);
            if (!isNaN(parseFloat(node.data.grp)))
                grp += parseFloat(node.data.grp);
            if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                total += market_cost * grp;
        });
        market_cost = parseFloat(market_cost).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        });
        total = parseFloat(total).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        });
        var top_row_data_invoice = {
            market_cost: market_cost,
            grp: grp,
            total_cost: total,
        };
        OOHGrid.api.setPinnedTopRowData([top_row_data_invoice]);
        update_market_totals('');
    });
    $("#mail_remove_items").on("click", function(){
        var selectedNodes = MailGrid.api.getSelectedNodes();
        for(var i in selectedNodes) {
            if (selectedNodes[i].data.int_id !== "-")
                deletedItemsMail.push(selectedNodes[i].data.int_id);
        }
        MailGrid.api.removeItems(selectedNodes);
        //var rr = MailGrid.api.updateRowData({remove: selectedNodes});
        var grp = 0;
        var market_cost = 0;
        var total = 0;
        MailGrid.api.forEachNode(function (node) {
            if (!isNaN(parseFloat(node.data.market_cost)))
                market_cost += parseFloat(node.data.market_cost);
            if (!isNaN(parseFloat(node.data.grp)))
                grp += parseFloat(node.data.grp);
            if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                total += market_cost * grp;
        });
        market_cost = parseFloat(market_cost).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        });
        total = parseFloat(total).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        });
        var top_row_data_invoice = {
            market_cost: market_cost,
            grp: grp,
            total_cost: total,
        };
        MailGrid.api.setPinnedTopRowData([top_row_data_invoice]);
        update_market_totals('');
    });
    $("#other_remove_items").on("click", function(){
        var selectedNodes = OtherGrid.api.getSelectedNodes();
        for(var i in selectedNodes) {
            if (selectedNodes[i].data.int_id !== "-")
                deletedItemsOther.push(selectedNodes[i].data.int_id);
        }
        OtherGrid.api.removeItems(selectedNodes);
        //var rr = OtherGrid.api.updateRowData({remove: selectedNodes});
        var grp = 0;
        var market_cost = 0;
        var total = 0;
        OtherGrid.api.forEachNode(function (node) {
            if (!isNaN(parseFloat(node.data.market_cost)))
                market_cost += parseFloat(node.data.market_cost);
            if (!isNaN(parseFloat(node.data.grp)))
                grp += parseFloat(node.data.grp);
            if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                total += market_cost * grp;
        });
        market_cost = parseFloat(market_cost).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        });
        total = parseFloat(total).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        });
        var top_row_data_invoice = {
            market_cost: market_cost,
            grp: grp,
            total_cost: total,
        };
        OtherGrid.api.setPinnedTopRowData([top_row_data_invoice]);
        update_market_totals('');
    });
    $("#ott_remove_items").on("click", function(){
        var selectedNodes = OTTGrid.api.getSelectedNodes();
        for(var i in selectedNodes) {
            if (selectedNodes[i].data.int_id !== "-")
                deletedItemsOther.push(selectedNodes[i].data.int_id);
        }
        OTTGrid.api.removeItems(selectedNodes);
        var grp = 0;
        var market_cost = 0;
        var total = 0;
        OTTGrid.api.forEachNode(function (node) {
            if (!isNaN(parseFloat(node.data.market_cost)))
                market_cost += parseFloat(node.data.market_cost);
            if (!isNaN(parseFloat(node.data.grp)))
                grp += parseFloat(node.data.grp);
            if (!isNaN(parseFloat(node.data.grp)) && !isNaN(parseFloat(node.data.market_cost)))
                total += market_cost * grp;
        });
        market_cost = parseFloat(market_cost).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        });
        total = parseFloat(total).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        });
        var top_row_data_invoice = {
            market_cost: market_cost,
            grp: grp,
            total_cost: total,
        };
        OTTGrid.api.setPinnedTopRowData([top_row_data_invoice]);
        update_market_totals('');
    });

    $('#tv_dp_save_items').on('click', function () {
        if(array_to_allocate ['tv']['total'] == 1 && array_to_allocate ['tv']['grp'] == 1 ){
            swal({
                    title: "Warning!",
                    text: "Please Allocate GRP before save. \n  If you continue the GRP percent changes will be lost. \n Do you want to continue anyway?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Continue",
                    cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if(isConfirm){
                        show_overlay_loader($("#newPlannerModal .modal-content"));
                        var params = {
                            campaign_id: camapaign_selected,
                            lines: [],
                            deleted: deletedItemsDPTV,
                            week: week_selected,
                            broadcast_month: broadcast_month_selected,
                            market_id: $('#campaign_market option:selected').val(),
                            media_type: 'television',
                            type: 'daypart',
                        };
                        TvDPGrid.api.forEachNode(function (node) {
                            if (node.data.market_cost === "")
                                node.data.market_cost = 0
                            if (node.data.grp === "")
                                node.data.grp = 0
                            if (node.data.daypart !== "" && node.data.daypart !== 'undefined') {
                                params.lines.push(node.data);
                            }
                        });
                        $.ajax({
                            type: 'POST',
                            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                            url: '/planner/single-grid/save-lines',
                            data: JSON.stringify(params),
                            contentType: "application/json",
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                // $('#tv_dp_apply').show();
                                $('#tv_apply_div').show();

                                if (cam_mark_count == true)
                                    $('#tv_dp_apply_market').show();
                                var x = 0;
                                if (data.news.length > 0) {
                                    TvDPGrid.api.forEachNode(function (node) {
                                        if (node.data['int_id'] == '-') {
                                            node.data['int_id'] = data.news[x];
                                            //TvDPGrid.api.refreshCells([node], ['int_id']);
                                            TvDPGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                            x++;
                                        }
                                    });
                                }
                                saved_all[0]['tv_dp'] = 1;
                                updateMainGrid();
                                //show_overlay_loader($("#newPlannerModal .modal-content"));
                                hide_overlay_loader($('#newPlannerModal .modal-content'))
                                global_notification("success", "Items saved...");
                            },
                            error: function (xhr) {
                                debug(xhr.responseText);
                            }
                        });
                        deletedItemsDPTV = [];
                    }
                });
        }
        else {
            show_overlay_loader($("#newPlannerModal .modal-content"));
            var params = {
                campaign_id: camapaign_selected,
                lines: [],
                deleted: deletedItemsDPTV,
                week: week_selected,
                broadcast_month: broadcast_month_selected,
                market_id: $('#campaign_market option:selected').val(),
                media_type: 'television',
                type: 'daypart',
            };
            TvDPGrid.api.forEachNode(function (node) {
                if (node.data.market_cost === "")
                    node.data.market_cost = 0
                if (node.data.grp === "")
                    node.data.grp = 0
                if (node.data.daypart !== "" && node.data.daypart !== 'undefined') {
                    params.lines.push(node.data);
                }
            });
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: '/planner/single-grid/save-lines',
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    // $('#tv_dp_apply').show();
                    $('#tv_apply_div').show();

                    if (cam_mark_count == true)
                        $('#tv_dp_apply_market').show();
                    var x = 0;
                    if (data.news.length > 0) {
                        TvDPGrid.api.forEachNode(function (node) {
                            if (node.data['int_id'] == '-') {
                                node.data['int_id'] = data.news[x];
                                //TvDPGrid.api.refreshCells([node], ['int_id']);
                                TvDPGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                x++;
                            }
                        });
                    }
                    saved_all[0]['tv_dp'] = 1;
                    updateMainGrid();
                    //show_overlay_loader($("#newPlannerModal .modal-content"));
                    hide_overlay_loader($('#newPlannerModal .modal-content'))
                    global_notification("success", "Items saved...");
                },
                error: function (xhr) {
                    debug(xhr.responseText);
                }
            });
            deletedItemsDPTV = [];
        }
    });
    $('#radio_dp_save_items').on('click', function () {
        if(array_to_allocate['radio']['total'] == 1 && array_to_allocate ['radio']['grp'] == 1 ){
            swal({
                    title: "Warning!",
                    text: "Please Allocate GRP before save. \n  If you continue the GRP percent changes will be lost. \n Do you want to continue anyway?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Continue",
                    cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if(isConfirm){
                        show_overlay_loader($("#newPlannerModal .modal-content"));
                        var params = {
                            campaign_id: camapaign_selected,
                            lines: [],
                            deleted: deletedItemsDPRadio,
                            week: week_selected,
                            broadcast_month: broadcast_month_selected,
                            market_id: $('#campaign_market option:selected').val(),
                            media_type: 'radio',
                            type: 'daypart',
                        };
                        RadioDPGrid.api.forEachNode(function (node) {
                            if (node.data.market_cost === "")
                                node.data.market_cost = 0
                            if (node.data.grp === "")
                                node.data.grp = 0
                            if (node.data.daypart !== "" && node.data.daypart !== 'undefined') {
                                params.lines.push(node.data);
                            }
                        });
                        $.ajax({
                            type: 'POST',
                            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                            url: '/planner/single-grid/save-lines',
                            data: JSON.stringify(params),
                            contentType: "application/json",
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                //   $('#radio_dp_apply').show();
                                $('#radio_apply_div').show();
                                if (cam_mark_count == true)
                                    $('#radio_dp_apply_market').show();
                                var x = 0;
                                if (data.news.length > 0) {
                                    RadioDPGrid.api.forEachNode(function (node) {
                                        if (node.data['int_id'] == '-') {
                                            node.data['int_id'] = data.news[x];
                                            //RadioDPGrid.api.refreshCells([node], ['int_id']);
                                            RadioDPGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                            x++;
                                        }
                                    });
                                }
                                updateMainGrid();
                                saved_all[0]['radio_dp'] = 1;
                                hide_overlay_loader($('#newPlannerModal .modal-content'));
                                global_notification("success", "Items saved...");
                            },
                            error: function (xhr) {
                                debug(xhr.responseText);
                            }
                        });
                        deletedItemsDPRadio = [];
                    }
                });
        }
        else {
            show_overlay_loader($("#newPlannerModal .modal-content"));
            var params = {
                campaign_id: camapaign_selected,
                lines: [],
                deleted: deletedItemsDPRadio,
                week: week_selected,
                broadcast_month: broadcast_month_selected,
                market_id: $('#campaign_market option:selected').val(),
                media_type: 'radio',
                type: 'daypart',
            };
            RadioDPGrid.api.forEachNode(function (node) {
                if (node.data.market_cost === "")
                    node.data.market_cost = 0
                if (node.data.grp === "")
                    node.data.grp = 0
                if (node.data.daypart !== "" && node.data.daypart !== 'undefined') {
                    params.lines.push(node.data);
                }
            });
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: '/planner/single-grid/save-lines',
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    //   $('#radio_dp_apply').show();
                    $('#radio_apply_div').show();
                    if (cam_mark_count == true)
                        $('#radio_dp_apply_market').show();
                    var x = 0;
                    if (data.news.length > 0) {
                        RadioDPGrid.api.forEachNode(function (node) {
                            if (node.data['int_id'] == '-') {
                                node.data['int_id'] = data.news[x];
                                //RadioDPGrid.api.refreshCells([node], ['int_id']);
                                RadioDPGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                x++;
                            }
                        });
                    }
                    updateMainGrid();
                    saved_all[0]['radio_dp'] = 1;
                    hide_overlay_loader($('#newPlannerModal .modal-content'));
                    global_notification("success", "Items saved...");
                },
                error: function (xhr) {
                    debug(xhr.responseText);
                }
            });
            deletedItemsDPRadio = [];
        }
    });

    $('#print_save_items').on('click', function () {
        if(array_to_allocate ['print']['total'] == 1 && array_to_allocate ['print']['grp'] == 1 ){
            swal({
                    title: "Warning!",
                    text: "Please Allocate GRI before save. \n  If you continue the GRI percent changes will be lost. \n Do you want to continue anyway?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Continue",
                    cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if(isConfirm){
                        show_overlay_loader($("#newPlannerModal .modal-content"));
                        var params = {
                            campaign_id: camapaign_selected,
                            lines: [],
                            deleted: deletedItemsPrint,
                            week: week_selected,
                            broadcast_month: broadcast_month_selected,
                            market_id: $('#campaign_market option:selected').val(),
                            media_type: 'print',
                            type: 'length',
                        };
                        PrintGrid.api.forEachNode(function (node) {
                            if(node.data.market_cost === "")
                                node.data.market_cost = 0
                            if(node.data.grp === "")
                                node.data.grp = 0
                            if (node.data.length !== "" && node.data.length !=='undefined') {
                                params.lines.push(node.data);
                            }
                        });
                        $.ajax({
                            type: 'POST',
                            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                            url: '/planner/single-grid/save-lines',
                            data: JSON.stringify(params),
                            contentType: "application/json",
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                // $('#print_apply').show();
                                $('#print_apply_div').show();
                                if(cam_mark_count == true)
                                    $('#print_apply_market').show();
                                var x=0;
                                if(data.news.length > 0) {
                                    PrintGrid.api.forEachNode(function (node) {
                                        if (node.data['int_id'] == '-') {
                                            node.data['int_id'] = data.news[x];
                                            //PrintGrid.api.refreshCells([node], ['int_id']);
                                            PrintGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                            x++;
                                        }
                                    });
                                }
                                saved_all[0]['print']=1;
                                // updateMainGrid();
                                hide_overlay_loader($('#newPlannerModal .modal-content'));
                                global_notification("success", "Items saved...");
                            },
                            error: function (xhr) {
                                debug(xhr.responseText);
                            }
                        });
                        deletedItemsPrint = [];
                    }
                });
        }
        else {
            show_overlay_loader($("#newPlannerModal .modal-content"));
            var params = {
                campaign_id: camapaign_selected,
                lines: [],
                deleted: deletedItemsPrint,
                week: week_selected,
                broadcast_month: broadcast_month_selected,
                market_id: $('#campaign_market option:selected').val(),
                media_type: 'print',
                type: 'length',
            };
            PrintGrid.api.forEachNode(function (node) {
                if (node.data.market_cost === "")
                    node.data.market_cost = 0
                if (node.data.grp === "")
                    node.data.grp = 0
                if (node.data.length !== "" && node.data.length !== 'undefined') {
                    params.lines.push(node.data);
                }
            });
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: '/planner/single-grid/save-lines',
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    // $('#print_apply').show();
                    $('#print_apply_div').show();
                    if (cam_mark_count == true)
                        $('#print_apply_market').show();
                    var x = 0;
                    if (data.news.length > 0) {
                        PrintGrid.api.forEachNode(function (node) {
                            if (node.data['int_id'] == '-') {
                                node.data['int_id'] = data.news[x];
                                //PrintGrid.api.refreshCells([node], ['int_id']);
                                PrintGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                x++;
                            }
                        });
                    }
                    saved_all[0]['print'] = 1;
                    // updateMainGrid();
                    hide_overlay_loader($('#newPlannerModal .modal-content'));
                    global_notification("success", "Items saved...");
                },
                error: function (xhr) {
                    debug(xhr.responseText);
                }
            });
            deletedItemsPrint = [];
        }
    });
    $('#digital_save_items').on('click', function () {
        if(array_to_allocate ['digital']['total'] == 1 && array_to_allocate ['digital']['grp'] == 1 ){
            swal({
                    title: "Warning!",
                    text: "Please Allocate GRI before save. \n  If you continue the GRI percent changes will be lost. \n Do you want to continue anyway?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Continue",
                    cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if(isConfirm){
                        show_overlay_loader($("#newPlannerModal .modal-content"));
                        var params = {
                            campaign_id: camapaign_selected,
                            lines: [],
                            deleted: deletedItemsDigital,
                            week: week_selected,
                            broadcast_month: broadcast_month_selected,
                            market_id: $('#campaign_market option:selected').val(),
                            media_type: 'digital',
                            type: 'length',
                        };
                        DigitalGrid.api.forEachNode(function (node) {
                            if(node.data.market_cost === "")
                                node.data.market_cost = 0
                            if(node.data.grp === "")
                                node.data.grp = 0
                            if (node.data.length !== "" && node.data.length !=='undefined') {
                                params.lines.push(node.data);
                            }
                        });
                        $.ajax({
                            type: 'POST',
                            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                            url: '/planner/single-grid/save-lines',
                            data: JSON.stringify(params),
                            contentType: "application/json",
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                // $('#digital_apply').show();
                                $('#digital_apply_div').show();
                                if(cam_mark_count == true)
                                    $('#digital_apply_market').show();
                                var x=0;
                                if(data.news.length > 0) {
                                    DigitalGrid.api.forEachNode(function (node) {
                                        if (node.data['int_id'] == '-') {
                                            node.data['int_id'] = data.news[x];
                                            //DigitalGrid.api.refreshCells([node], ['int_id']);
                                            DigitalGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                            x++;
                                        }
                                    });
                                }
                                saved_all[0]['digital']=1;
                                //  updateMainGrid();
                                hide_overlay_loader($('#newPlannerModal .modal-content'));
                                global_notification("success", "Items saved...");
                            },
                            error: function (xhr) {
                                debug(xhr.responseText);
                            }
                        });
                        deletedItemsDigital = [];
                    }
                });
        }
        else {
            show_overlay_loader($("#newPlannerModal .modal-content"));
            var params = {
                campaign_id: camapaign_selected,
                lines: [],
                deleted: deletedItemsDigital,
                week: week_selected,
                broadcast_month: broadcast_month_selected,
                market_id: $('#campaign_market option:selected').val(),
                media_type: 'digital',
                type: 'length',
            };
            DigitalGrid.api.forEachNode(function (node) {
                if (node.data.market_cost === "")
                    node.data.market_cost = 0
                if (node.data.grp === "")
                    node.data.grp = 0
                if (node.data.length !== "" && node.data.length !== 'undefined') {
                    params.lines.push(node.data);
                }
            });
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: '/planner/single-grid/save-lines',
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    // $('#digital_apply').show();
                    $('#digital_apply_div').show();
                    if (cam_mark_count == true)
                        $('#digital_apply_market').show();
                    var x = 0;
                    if (data.news.length > 0) {
                        DigitalGrid.api.forEachNode(function (node) {
                            if (node.data['int_id'] == '-') {
                                node.data['int_id'] = data.news[x];
                                //DigitalGrid.api.refreshCells([node], ['int_id']);
                                DigitalGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                x++;
                            }
                        });
                    }
                    saved_all[0]['digital'] = 1;
                    //  updateMainGrid();
                    hide_overlay_loader($('#newPlannerModal .modal-content'));
                    global_notification("success", "Items saved...");
                },
                error: function (xhr) {
                    debug(xhr.responseText);
                }
            });
            deletedItemsDigital = [];
        }
    });
    $('#ooh_save_items').on('click', function () {
        if(array_to_allocate ['ooh']['total'] == 1 && array_to_allocate ['ooh']['grp'] == 1 ){
            swal({
                    title: "Warning!",
                    text: "Please Allocate GRI before save. \n  If you continue the GRI percent changes will be lost. \n Do you want to continue anyway?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Continue",
                    cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if(isConfirm){
                        show_overlay_loader($("#newPlannerModal .modal-content"));
                        var params = {
                            campaign_id: camapaign_selected,
                            lines: [],
                            deleted: deletedItemsOOH,
                            week: week_selected,
                            broadcast_month: broadcast_month_selected,
                            market_id: $('#campaign_market option:selected').val(),
                            media_type: 'ooh',
                            type: 'length',
                        };
                        OOHGrid.api.forEachNode(function (node) {
                            if(node.data.market_cost === "")
                                node.data.market_cost = 0
                            if(node.data.grp === "")
                                node.data.grp = 0
                            if (node.data.length !== "" && node.data.length !=='undefined') {
                                params.lines.push(node.data);
                            }
                        });
                        $.ajax({
                            type: 'POST',
                            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                            url: '/planner/single-grid/save-lines',
                            data: JSON.stringify(params),
                            contentType: "application/json",
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                //$('#ooh_apply').show();
                                $('#ooh_apply_div').show();
                                if(cam_mark_count == true)
                                    $('#ooh_apply_market').show();
                                var x=0;
                                if(data.news.length > 0) {
                                    OOHGrid.api.forEachNode(function (node) {
                                        if (node.data['int_id'] == '-') {
                                            node.data['int_id'] = data.news[x];
                                            //OOHGrid.api.refreshCells([node], ['int_id']);
                                            OOHGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                            x++;
                                        }
                                    });
                                }
                                saved_all[0]['ooh']=1;
                                // updateMainGrid();
                                hide_overlay_loader($('#newPlannerModal .modal-content'));
                                global_notification("success", "Items saved...");
                            },
                            error: function (xhr) {
                                debug(xhr.responseText);
                            }
                        });
                        deletedItemsOOH = [];
                    }
                });
        }
        else{
            show_overlay_loader($("#newPlannerModal .modal-content"));
            var params = {
                campaign_id: camapaign_selected,
                lines: [],
                deleted: deletedItemsOOH,
                week: week_selected,
                broadcast_month: broadcast_month_selected,
                market_id: $('#campaign_market option:selected').val(),
                media_type: 'ooh',
                type: 'length',
            };
            OOHGrid.api.forEachNode(function (node) {
                if(node.data.market_cost === "")
                    node.data.market_cost = 0
                if(node.data.grp === "")
                    node.data.grp = 0
                if (node.data.length !== "" && node.data.length !=='undefined') {
                    params.lines.push(node.data);
                }
            });
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: '/planner/single-grid/save-lines',
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    //$('#ooh_apply').show();
                    $('#ooh_apply_div').show();
                    if(cam_mark_count == true)
                        $('#ooh_apply_market').show();
                    var x=0;
                    if(data.news.length > 0) {
                        OOHGrid.api.forEachNode(function (node) {
                            if (node.data['int_id'] == '-') {
                                node.data['int_id'] = data.news[x];
                                //OOHGrid.api.refreshCells([node], ['int_id']);
                                OOHGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                x++;
                            }
                        });
                    }
                    saved_all[0]['ooh']=1;
                    // updateMainGrid();
                    hide_overlay_loader($('#newPlannerModal .modal-content'));
                    global_notification("success", "Items saved...");
                },
                error: function (xhr) {
                    debug(xhr.responseText);
                }
            });
            deletedItemsOOH = [];
        }

    });
    $('#mail_save_items').on('click', function () {
        if(array_to_allocate ['mail']['total'] == 1 && array_to_allocate ['mail']['grp'] == 1 ){
            swal({
                    title: "Warning!",
                    text: "Please Allocate GRI before save. \n  If you continue the GRI percent changes will be lost. \n Do you want to continue anyway?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Continue",
                    cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if(isConfirm){
                        show_overlay_loader($("#newPlannerModal .modal-content"));
                        var params = {
                            campaign_id: camapaign_selected,
                            lines: [],
                            deleted: deletedItemsMail,
                            week: week_selected,
                            broadcast_month: broadcast_month_selected,
                            market_id: $('#campaign_market option:selected').val(),
                            media_type: 'mail',
                            type: 'length',
                        };
                        MailGrid.api.forEachNode(function (node) {
                            if(node.data.market_cost === "")
                                node.data.market_cost = 0
                            if(node.data.grp === "")
                                node.data.grp = 0
                            if (node.data.length !== "" && node.data.length !=='undefined') {
                                params.lines.push(node.data);
                            }
                        });
                        $.ajax({
                            type: 'POST',
                            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                            url: '/planner/single-grid/save-lines',
                            data: JSON.stringify(params),
                            contentType: "application/json",
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                //    $('#mail_apply').show();
                                $('#mail_apply_div').show();
                                if(cam_mark_count == true)
                                    $('#mail_apply_market').show();
                                var x=0;
                                if(data.news.length > 0) {
                                    MailGrid.api.forEachNode(function (node) {
                                        if (node.data['int_id'] == '-') {
                                            node.data['int_id'] = data.news[x];
                                            //MailGrid.api.refreshCells([node], ['int_id']);
                                            MailGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                            x++;
                                        }
                                    });
                                }
                                //  updateMainGrid();
                                saved_all[0]['mail']=1;
                                hide_overlay_loader($('#newPlannerModal .modal-content'));
                                global_notification("success", "Items saved...");
                            },
                            error: function (xhr) {
                                debug(xhr.responseText);
                            }
                        });
                        deletedItemsMail = [];
                    }
                });
        }
        else {
            show_overlay_loader($("#newPlannerModal .modal-content"));
            var params = {
                campaign_id: camapaign_selected,
                lines: [],
                deleted: deletedItemsMail,
                week: week_selected,
                broadcast_month: broadcast_month_selected,
                market_id: $('#campaign_market option:selected').val(),
                media_type: 'mail',
                type: 'length',
            };
            MailGrid.api.forEachNode(function (node) {
                if (node.data.market_cost === "")
                    node.data.market_cost = 0
                if (node.data.grp === "")
                    node.data.grp = 0
                if (node.data.length !== "" && node.data.length !== 'undefined') {
                    params.lines.push(node.data);
                }
            });
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: '/planner/single-grid/save-lines',
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    //    $('#mail_apply').show();
                    $('#mail_apply_div').show();
                    if (cam_mark_count == true)
                        $('#mail_apply_market').show();
                    var x = 0;
                    if (data.news.length > 0) {
                        MailGrid.api.forEachNode(function (node) {
                            if (node.data['int_id'] == '-') {
                                node.data['int_id'] = data.news[x];
                                //MailGrid.api.refreshCells([node], ['int_id']);
                                MailGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                x++;
                            }
                        });
                    }
                    //  updateMainGrid();
                    saved_all[0]['mail'] = 1;
                    hide_overlay_loader($('#newPlannerModal .modal-content'));
                    global_notification("success", "Items saved...");
                },
                error: function (xhr) {
                    debug(xhr.responseText);
                }
            });
            deletedItemsMail = [];
        }
    });
    $('#other_save_items').on('click', function () {
        if(array_to_allocate ['other']['total'] == 1 && array_to_allocate ['other']['grp'] == 1 ){
            swal({
                    title: "Warning!",
                    text: "Please Allocate GRI before save. \n  If you continue the GRI percent changes will be lost. \n Do you want to continue anyway?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Continue",
                    cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if(isConfirm){
                        show_overlay_loader($("#newPlannerModal .modal-content"));
                        var params = {
                            campaign_id: camapaign_selected,
                            lines: [],
                            deleted: deletedItemsOther,
                            week: week_selected,
                            broadcast_month: broadcast_month_selected,
                            market_id: $('#campaign_market option:selected').val(),
                            media_type: 'other',
                            type: 'length',

                        };
                        OtherGrid.api.forEachNode(function (node) {
                            if(node.data.market_cost === "")
                                node.data.market_cost = 0
                            if(node.data.grp === "")
                                node.data.grp = 0
                            if (node.data.length !== "" && node.data.length !=='undefined') {
                                params.lines.push(node.data);
                            }
                        });
                        $.ajax({
                            type: 'POST',
                            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                            url: '/planner/single-grid/save-lines',
                            data: JSON.stringify(params),
                            contentType: "application/json",
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                // $('#other_apply').show();
                                $('#other_apply_div').show();
                                if(cam_mark_count == true)
                                    $('#other_apply_market').show();
                                var x=0;
                                if(data.news.length > 0) {
                                    OtherGrid.api.forEachNode(function (node) {
                                        if (node.data['int_id'] == '-') {
                                            node.data['int_id'] = data.news[x];
                                            //OtherGrid.api.refreshCells([node], ['int_id']);
                                            OtherGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                            x++;
                                        }
                                    });
                                }
                                saved_all[0]['other']=1;
                                //  updateMainGrid();
                                hide_overlay_loader($('#newPlannerModal .modal-content'));
                                global_notification("success", "Items saved...");
                            },
                            error: function (xhr) {
                                debug(xhr.responseText);
                            }
                        });
                        deletedItemsOther = [];
                    }
                });
        }
        else {
            show_overlay_loader($("#newPlannerModal .modal-content"));
            var params = {
                campaign_id: camapaign_selected,
                lines: [],
                deleted: deletedItemsOther,
                week: week_selected,
                broadcast_month: broadcast_month_selected,
                market_id: $('#campaign_market option:selected').val(),
                media_type: 'other',
                type: 'length',

            };
            OtherGrid.api.forEachNode(function (node) {
                if (node.data.market_cost === "")
                    node.data.market_cost = 0
                if (node.data.grp === "")
                    node.data.grp = 0
                if (node.data.length !== "" && node.data.length !== 'undefined') {
                    params.lines.push(node.data);
                }
            });
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: '/planner/single-grid/save-lines',
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    // $('#other_apply').show();
                    $('#other_apply_div').show();
                    if (cam_mark_count == true)
                        $('#other_apply_market').show();
                    var x = 0;
                    if (data.news.length > 0) {
                        OtherGrid.api.forEachNode(function (node) {
                            if (node.data['int_id'] == '-') {
                                node.data['int_id'] = data.news[x];
                                //OtherGrid.api.refreshCells([node], ['int_id']);
                                OtherGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                x++;
                            }
                        });
                    }
                    saved_all[0]['other'] = 1;
                    //  updateMainGrid();
                    hide_overlay_loader($('#newPlannerModal .modal-content'));
                    global_notification("success", "Items saved...");
                },
                error: function (xhr) {
                    debug(xhr.responseText);
                }
            });
            deletedItemsOther = [];
        }
    });
    $('#ott_save_items').on('click', function () {
        if(array_to_allocate ['ott']['total'] == 1 && array_to_allocate ['ott']['grp'] == 1 ){
            swal({
                    title: "Warning!",
                    text: "Please Allocate GRI before save. \n  If you continue the GRI percent changes will be lost. \n Do you want to continue anyway?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Continue",
                    cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if(isConfirm){
                        show_overlay_loader($("#newPlannerModal .modal-content"));
                        var params = {
                            campaign_id: camapaign_selected,
                            lines: [],
                            deleted: deletedItemsOTT,
                            week: week_selected,
                            broadcast_month: broadcast_month_selected,
                            market_id: $('#campaign_market option:selected').val(),
                            media_type: 'ott',
                            type: 'length',

                        };
                        OTTGrid.api.forEachNode(function (node) {
                            if(node.data.market_cost === "")
                                node.data.market_cost = 0
                            if(node.data.grp === "")
                                node.data.grp = 0
                            if (node.data.length !== "" && node.data.length !=='undefined') {
                                params.lines.push(node.data);
                            }
                        });
                        $.ajax({
                            type: 'POST',
                            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                            url: '/planner/single-grid/save-lines',
                            data: JSON.stringify(params),
                            contentType: "application/json",
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                $('#ott_apply_div').show();
                                if(cam_mark_count == true)
                                    $('#ott_apply_market').show();
                                var x=0;
                                if(data.news.length > 0) {
                                    OTTGrid.api.forEachNode(function (node) {
                                        if (node.data['int_id'] == '-') {
                                            node.data['int_id'] = data.news[x];
                                            OTTGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                            x++;
                                        }
                                    });
                                }
                                saved_all[0]['ott']=1;
                                hide_overlay_loader($('#newPlannerModal .modal-content'));
                                global_notification("success", "Items saved...");
                            },
                            error: function (xhr) {
                                debug(xhr.responseText);
                            }
                        });
                        deletedItemsTT = [];
                    }
                });
        }
        else {
            show_overlay_loader($("#newPlannerModal .modal-content"));
            var params = {
                campaign_id: camapaign_selected,
                lines: [],
                deleted: deletedItemsOTT,
                week: week_selected,
                broadcast_month: broadcast_month_selected,
                market_id: $('#campaign_market option:selected').val(),
                media_type: 'ott',
                type: 'length',

            };
            OTTGrid.api.forEachNode(function (node) {
                if (node.data.market_cost === "")
                    node.data.market_cost = 0
                if (node.data.grp === "")
                    node.data.grp = 0
                if (node.data.length !== "" && node.data.length !== 'undefined') {
                    params.lines.push(node.data);
                }
            });
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: '/planner/single-grid/save-lines',
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    $('#ott_apply_div').show();
                    if (cam_mark_count == true)
                        $('#ott_apply_market').show();
                    var x = 0;
                    if (data.news.length > 0) {
                        OTTGrid.api.forEachNode(function (node) {
                            if (node.data['int_id'] == '-') {
                                node.data['int_id'] = data.news[x];
                                OTTGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                x++;
                            }
                        });
                    }
                    saved_all[0]['ott'] = 1;
                    hide_overlay_loader($('#newPlannerModal .modal-content'));
                    global_notification("success", "Items saved...");
                },
                error: function (xhr) {
                    debug(xhr.responseText);
                }
            });
            deletedItemsOTT = [];
        }
    });

    //Apply to Month
    $('#tv_dp_apply').on('click', function () {
        show_div_to_copy_lines('television', 'month');
    });
    $('#radio_dp_apply').on('click', function () {
        show_div_to_copy_lines('radio', 'month');
    });
    $('#digital_apply').on('click', function () {
        show_div_to_copy_lines('digital', 'month');
    });
    $('#print_apply').on('click', function () {
        show_div_to_copy_lines('print', 'month');
    });
    $('#mail_apply').on('click', function () {
        show_div_to_copy_lines('mail', 'month');
    });
    $('#ooh_apply').on('click', function () {
        show_div_to_copy_lines('ooh', 'month');
    });
    $('#other_apply').on('click', function () {
        show_div_to_copy_lines('other', 'month');
    });
    $('#ott_apply').on('click', function () {
        show_div_to_copy_lines('ott', 'month');
    });
    function confirmed_copy_to_month() {
        show_overlay_loader($('#newPlannerModal .modal-content'));
        var params = {
            campaign_id: camapaign_selected,
            lines: [],
            week: week_selected,
            market_id: $('#campaign_market option:selected').val(),
            media_type: $('#media_type_to_copy').val(),
            replace :  ($("input:checkbox[name=replace_or_copy]").prop('checked') === true) ? 1 : 0,
        };
        var media = $('#media_type_to_copy').val();

        var grid = '';
        if ($('#media_type_to_copy').val() === 'television')
            grid = TvDPGrid;
        else if ($('#media_type_to_copy').val() === 'radio')
            grid = RadioDPGrid;
        else if ($('#media_type_to_copy').val() === 'digital')
            grid = DigitalGrid;
        else if ($('#media_type_to_copy').val() === 'print')
            grid = PrintGrid;
        else if ($('#media_type_to_copy').val() === 'mail')
            grid = MailGrid;
        else if ($('#media_type_to_copy').val() === 'ooh')
            grid = OOHGrid;
        else if ($('#media_type_to_copy').val() === 'ott')
            grid = OTTGrid;
        else
            grid = OtherGrid;

        var lines = 'all';
        if (grid.api.getSelectedNodes().length > 0)
            lines = $("input:radio[name=all_lines]:checked").attr('value');

        if (lines === "all") {
            grid.api.forEachNode(function (node) {
                if (node.data.market_cost === "")
                    node.data.market_cost = 0
                if (node.data.grp === "")
                    node.data.grp = 0
                if (media !== 'television' && media !== 'radio') {
                    if (node.data.length !== "" && node.data.length !== 'undefined')
                        params.lines.push(node.data);

                } else {
                    if (node.data.daypart !== "" && node.data.daypart !== 'undefined')
                        params.lines.push(node.data);
                }
            });
        } else {
            var selectedNodes = grid.api.getSelectedNodes();
            for (var i in selectedNodes) {
                var node = selectedNodes[i];
                if (node.data.market_cost === "")
                    node.data.market_cost = 0
                if (node.data.grp === "")
                    node.data.grp = 0
                if (media !== 'television' && media !== 'radio') {
                    if (node.data.length !== "" && node.data.length !== 'undefined')
                        params.lines.push(node.data);

                } else if (node.data.daypart !== "" && node.data.daypart !== 'undefined')
                    params.lines.push(node.data);

            }
        }

        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            url: '/planner/single-grid/apply_to_all',
            data: JSON.stringify(params),
            contentType: "application/json",
            dataType: 'json',
            encode: true,
            success: function (data) {
                for (var i in data.result) {
                    var totals = parseFloat(data.result[i]).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    var cc = 'week_' + i;

                    selected_row.node.setDataValue(cc, totals);
                    selected_row.node.data.percent = parseFloat(data.percent).toFixed(1);
                    MainGrid.api.refreshCells({rowNodes: [selected_row.node], columns: ['percent'], force: true});

                }
                $('#selectOrAllModal').modal('hide');
                hide_overlay_loader($('#newPlannerModal .modal-content'));
                global_notification('success', 'The current planning have been applied to all the broadcast month..');

            },
            error: function (xhr) {
                hide_overlay_loader($('#newPlannerModal .modal-content'));
                debug(xhr.responseText);
            }
        });
    }

    //Apply to Market
    $('#tv_dp_apply_market').on('click', function () {
        apply_market('television',  'Television');
    });
    $('#radio_dp_apply_market').on('click', function () {
        apply_market('radio',  'Radio');
    });
    $('#print_apply_market').on('click', function () {
        apply_market('print',  'Print');
    });
    $('#digital_apply_market').on('click', function () {
        apply_market('digital',  'Digital');
    });
    $('#mail_apply_market').on('click', function () {
        apply_market('mail',  'Mail');
    });
    $('#other_apply_market').on('click', function () {
        apply_market('other',  'Other');
    });
    $('#ooh_apply_market').on('click', function () {
        apply_market('ooh',  'OOH');
    });
    $('#ott_apply_market').on('click', function () {
        apply_market('ott',  'OTT');
    });
    var apply_market= function (media,  Media) {
        $('#media_appl_hidden').val(media);
        $('#media_show_appl_hidden').val(Media);
        $('#applyToSelectMarket').modal('show');
    };
    $('#submit_markets_apply').on('click', function(){
        if($('#apply_market').val().length == 0){
            swal({
                        title: "Warning!",
                        text: "Please select at least one Market.",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Continue",
                        cancelButtonText: "Cancel",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                        }
                    });
        }
        else
           show_div_to_copy_lines($('#media_appl_hidden').val(), 'market');
    });
    function confirmed_copy_to_market() {
        show_overlay_loader($('#applyToSelectMarket .modal-content'));
        var params = {
            campaign_id: camapaign_selected,
            lines: [],
            week: week_selected,
            market_id: $('#campaign_market option:selected').val(),
            media_type: $('#media_type_to_copy').val(),
            markets_selected: $('#apply_market').val(),
            replace :  ($("input:checkbox[name=replace_or_copy]").prop('checked') === true) ? 1 : 0,
        };

        var media = $('#media_type_to_copy').val();
        var grid  = '';
        if (media == 'television')
            grid = TvDPGrid;
        if (media == 'radio')
            grid = RadioDPGrid;
        if (media == 'print')
            grid = PrintGrid;
        if (media == 'digital')
            grid = DigitalGrid;
        if (media == 'mail')
            grid = MailGrid;
        if (media == 'ooh')
            grid = OOHGrid;
        if (media == 'other')
            grid = OtherGrid;
        if (media == 'ott')
            grid = OTTGrid;


        var lines = 'all';
        if (grid.api.getSelectedNodes().length > 0)
            lines = $("input:radio[name=all_lines]:checked").attr('value');

        if (lines === "all") {
            grid.api.forEachNode(function (node) {
                if (node.data.market_cost === "")
                    node.data.market_cost = 0
                if (node.data.grp === "")
                    node.data.grp = 0
                if (media !== 'television' && media !== 'radio') {
                    if (node.data.length !== "" && node.data.length !== 'undefined')
                        params.lines.push(node.data);
                } else {
                    if (node.data.daypart !== "" && node.data.daypart !== 'undefined')
                        params.lines.push(node.data);
                }
            });
        } else {
            var selectedNodes = grid.api.getSelectedNodes();
            for (var i in selectedNodes) {
                var node = selectedNodes[i];
                if (node.data.market_cost === "")
                    node.data.market_cost = 0
                if (node.data.grp === "")
                    node.data.grp = 0
                if (media !== 'television' && media !== 'radio') {
                    if (node.data.length !== "" && node.data.length !== 'undefined')
                        params.lines.push(node.data);

                } else {
                    if (node.data.daypart !== "" && node.data.daypart !== 'undefined')
                        params.lines.push(node.data);
                }
            }
        }
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            url: '/planner/single-grid/apply_to_selected_markets',
            data: JSON.stringify(params),
            contentType: "application/json",
            dataType: 'json',
            encode: true,
            success: function (data) {
                $('#selectOrAllModal').modal('hide');
                $('#applyToSelectMarket').modal('hide');
                hide_overlay_loader($('#applyToSelectMarket .modal-content'));
                global_notification('success', 'The current planning have been applied to all selected Market(s).');
            },
            error: function (xhr) {
                hide_overlay_loader($('#applyToSelectMarket .modal-content'));
                debug(xhr.responseText);
            }
        });
    }

    //Apply to entire Campaign
    $('#tv_dp_apply_campaign').on('click', function () {
        show_div_to_copy_lines('television', 'campaign');
    });
    $('#radio_dp_apply_campaign').on('click', function () {
        show_div_to_copy_lines('radio', 'campaign');
    });
    $('#print_apply_campaign').on('click', function () {
        show_div_to_copy_lines('print', 'campaign');
    });
    $('#digital_apply_campaign').on('click', function () {
        show_div_to_copy_lines('digital', 'campaign');
    });
    $('#other_apply_campaign').on('click', function () {
        show_div_to_copy_lines('other', 'campaign');
    });
    $('#mail_apply_campaign').on('click', function () {
        show_div_to_copy_lines('mail', 'campaign');
    });
    $('#ooh_apply_campaign').on('click', function () {
        show_div_to_copy_lines('ooh', 'campaign');
    });
    $('#ott_apply_campaign').on('click', function () {
        show_div_to_copy_lines('ott', 'campaign');
    });
    function confirmed_copy_to_campaign () {
        show_overlay_loader($('#newPlannerModal .modal-content'));
        var params = {
            campaign_id: camapaign_selected,
            lines: [],
            week: week_selected,
            broadcast_month: broadcast_month_selected,
            market_id: $('#campaign_market option:selected').val(),
            media_type: $('#media_type_to_copy').val(),
            replace :  ($("input:checkbox[name=replace_or_copy]").prop('checked') === true) ? 1 : 0,
        };

        var media = $('#media_type_to_copy').val();
        var grid = '';
        if (media == 'television')
            grid = TvDPGrid;
        if (media == 'radio')
            grid = RadioDPGrid;
        if (media == 'print')
            grid = PrintGrid;
        if (media == 'digital')
            grid = DigitalGrid;
        if (media == 'mail')
            grid = MailGrid;
        if (media == 'ooh')
            grid = OOHGrid;
        if (media == 'other')
            grid = OtherGrid;
        if (media == 'ott')
            grid = OTTGrid;

        var lines = 'all';
        if (grid.api.getSelectedNodes().length > 0)
            lines = $("input:radio[name=all_lines]:checked").attr('value');

        if (lines === "all") {
            grid.api.forEachNode(function (node) {
                if (node.data.market_cost === "")
                    node.data.market_cost = 0
                if (node.data.grp === "")
                    node.data.grp = 0
                if (media !== 'television' && media !== 'radio') {
                    if (node.data.length !== "" && node.data.length !== 'undefined')
                        params.lines.push(node.data);

                } else {
                    if (node.data.daypart !== "" && node.data.daypart !== 'undefined')
                        params.lines.push(node.data);
                }
            });
        } else {
            var selectedNodes = grid.api.getSelectedNodes();
            for (var i in selectedNodes) {
                var node = selectedNodes[i];
                if (node.data.market_cost === "")
                    node.data.market_cost = 0
                if (node.data.grp === "")
                    node.data.grp = 0
                if (media !== 'television' && media !== 'radio') {
                    if (node.data.length !== "" && node.data.length !== 'undefined')
                        params.lines.push(node.data);
                } else {
                    if (node.data.daypart !== "" && node.data.daypart !== 'undefined')
                        params.lines.push(node.data);
                }

            }
        }

        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            url: '/planner/single-grid/apply_to_campaign',
            data: JSON.stringify(params),
            contentType: "application/json",
            dataType: 'json',
            encode: true,
            success: function (data) {
                for (var i in data.result) {
                    var totals = parseFloat(data.result[i]).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    var cc = 'week_' + i;
                    selected_row.node.setDataValue(cc, totals);
                    selected_row.node.data.percent = parseFloat(data.percent).toFixed(1);
                    MainGrid.api.refreshCells({rowNodes: [selected_row.node], columns: ['percent'], force: true});
                }

                $('#selectOrAllModal').modal('hide');
                hide_overlay_loader($('#newPlannerModal .modal-content'));
                global_notification('success', 'The current plans have been applied to the entire campaign..');
            },
            error: function (xhr) {
                hide_overlay_loader($('#newPlannerModal .modal-content'));
                debug(xhr.responseText);
            }
        });

    };

    //Apply to custom
    $('#tv_dp_apply_custom').on('click', function () {
        show_custom_modal('television', 'Television');
    });
    $('#radio_dp_apply_custom').on('click', function () {
        show_custom_modal('radio', 'Radio');
    });
    $('#print_apply_custom').on('click', function () {
        show_custom_modal('print', 'Print');
    });
    $('#digital_apply_custom').on('click', function () {
        show_custom_modal('digital', 'Digital');
    });
    $('#ooh_apply_custom').on('click', function () {
        show_custom_modal('ooh', 'OOH');
    });
    $('#mail_apply_custom').on('click', function () {
        show_custom_modal('mail', 'Mail');
    });
    $('#other_apply_custom').on('click', function () {
        show_custom_modal('other', 'Other');
    });
    $('#ott_apply_custom').on('click', function () {
        show_custom_modal('ott', 'OTT');
    });
    var show_custom_modal = function (media, Media) {
        $('#custom_weeks').multiSelect({
            selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm ' id='select_all_appl_cw' ><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='deselect_all_appl_cw'><i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
            afterInit: function (ms) {
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function (e) {
                        if (e.which === 40) {
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function (values) {
                this.qs1.cache();
            },
            afterDeselect: function (values) {
                this.qs1.cache();
            }
        });
        $('#custom_weeks').html('').multiSelect('refresh');
        var html='';
        for(var i in current_camp_fd)
            html += '<option value="' + moment(current_camp_fd[i].start).format('YYYY-MM-DD') + '">'+moment(current_camp_fd[i].start).format('MM/DD/YYYY')+'</option>' ;
        $('#custom_weeks').html(html).multiSelect('refresh');

        $('#custom_markets').multiSelect({
            selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm ' id='select_all_appl_cm' ><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='deselect_all_appl_cm'><i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
            afterInit: function (ms) {
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function (e) {
                        if (e.which === 40) {
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function (values) {
                this.qs1.cache();
            },
            afterDeselect: function (values) {
                this.qs1.cache();
            }
        });
        $('#custom_markets').html('').multiSelect('refresh');
        var html='';
        for(var i in current_camp_markets) {
            if(current_camp_markets[i].type=='')
                tp='Custom - ';
            else
                tp=current_camp_markets[i].type.toUpperCase()+' - ';
            html += '<option value="' + current_camp_markets[i].id + '">' + tp+ current_camp_markets[i].name + '</option>'
        }

        $('.current-mm').html('<b>Current Market: </b>  ' +$('#campaign_market option:selected').text());
        $('.current-ww').html('<b>Current Week: </b>  ' +moment(selected_week).format('MM/DD/YYYY'));
        $('#modalTT').html('<b>Apply current '+ Media+' planning to:</b>');
        $('#media_appl_custom_hidden').val(media);
        $('#media_show_custom_appl_hidden').val(Media);
        $('#custom_markets').html(html).multiSelect('refresh');
        $('#customModalApply').modal('show');

        $('#select_all_appl_cm').on('click', function(){
            $('#custom_markets').multiSelect('select_all');
        });
        $('#deselect_all_appl_cm').on('click', function(){
            $('#custom_markets').multiSelect('deselect_all');
        });
        $('#select_all_appl_cw').on('click', function(){
            $('#custom_weeks').multiSelect('select_all');
        });
        $('#deselect_all_appl_cw').on('click', function(){
            $('#custom_weeks').multiSelect('deselect_all');
        });
    };
    $('#submit_weeks_apply').on('click', function(){
        var media= $('#media_appl_custom_hidden').val();
        if($('#custom_weeks').val().length === 0 || $('#custom_markets').val().length === 0  ){
            swal({
                    title: "Warning",
                    text: "Please select at least a Market and a Week.",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {}
                });
        }
        else
            show_div_to_copy_lines(media, 'custom');
    });
    function confirmed_copy_to_custom() {
        show_overlay_loader($('#newPlannerModal .modal-content'));
        var params = {
            campaign_id: camapaign_selected,
            lines: [],
            week: week_selected,
            market_id: $('#campaign_market option:selected').val(),
            markets_selected: $('#custom_markets').val(),
            weeks_selected: $('#custom_weeks').val(),
            media_type:  $('#media_type_to_copy').val(),
            replace :  ($("input:checkbox[name=replace_or_copy]").prop('checked') === true) ? 1 : 0,
        };
        var media = $('#media_type_to_copy').val();
        var  grid = '';
        if (media == 'television')
            grid = TvDPGrid;
        if (media == 'radio')
            grid = RadioDPGrid;
        if (media == 'print')
            grid = PrintGrid;
        if (media == 'digital')
            grid = DigitalGrid;
        if (media == 'mail')
            grid = MailGrid;
        if (media == 'ooh')
            grid = OOHGrid;
        if (media == 'other')
            grid = OtherGrid;
        if (media == 'ott')
            grid = OTTGrid;

        var lines = 'all';
        if (grid.api.getSelectedNodes().length > 0)
            lines = $("input:radio[name=all_lines]:checked").attr('value');

        if (lines === "all") {
            grid.api.forEachNode(function (node) {
                if (node.data.market_cost === "")
                    node.data.market_cost = 0
                if (node.data.grp === "")
                    node.data.grp = 0
                if (media !== 'television' && media !== 'radio') {
                    if (node.data.length !== "" && node.data.length !== 'undefined')
                        params.lines.push(node.data);

                } else {
                    if (node.data.daypart !== "" && node.data.daypart !== 'undefined')
                        params.lines.push(node.data);
                }
            });
        } else {
            var selectedNodes = grid.api.getSelectedNodes();
            for (var i in selectedNodes) {
                var node = selectedNodes[i];
                if (node.data.market_cost === "")
                    node.data.market_cost = 0
                if (node.data.grp === "")
                    node.data.grp = 0
                if (media !== 'television' && media !== 'radio') {
                    if (node.data.length !== "" && node.data.length !== 'undefined')
                        params.lines.push(node.data);

                } else {
                    if (node.data.daypart !== "" && node.data.daypart !== 'undefined')
                        params.lines.push(node.data);
                }
            }
        }

        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            url: '/planner/single-grid/apply_to_custom',
            data: JSON.stringify(params),
            contentType: "application/json",
            dataType: 'json',
            encode: true,
            success: function (data) {
                for (var i in data.result) {
                    var totals = parseFloat(data.result[i]).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    var cc = 'week_' + i;
                    selected_row.node.setDataValue(cc, totals);
                    selected_row.node.data.percent = parseFloat(data.percent).toFixed(1);
                    MainGrid.api.refreshCells({
                        rowNodes: [selected_row.node],
                        columns: ['percent'],
                        force: true
                    });

                }
                $('#selectOrAllModal').modal('hide');
                $('#customModalApply').modal('hide');

                hide_overlay_loader($('#newPlannerModal .modal-content'));
                global_notification('success', 'The current planning have been applied to selected Market(s) in the chosen Week(s).');
            },
            error: function (xhr) {
                hide_overlay_loader($('#newPlannerModal .modal-content'));
                debug(xhr.responseText);
            }
        });
    };

    //General
    function show_div_to_copy_lines(media_type, type) {
        $('#media_type_to_copy').val(media_type);
        $('#_type_to_copy').val(type);

        var grid = '';
        var text = '';

        if ($('#media_type_to_copy').val() === 'television') {
            grid = TvDPGrid;
            text = 'Television';
        } else if ($('#media_type_to_copy').val() === 'radio') {
            grid = RadioDPGrid;
            text = 'Radio';
        } else if ($('#media_type_to_copy').val() === 'digital') {
            grid = DigitalGrid;
            text = 'Digital';
        } else if ($('#media_type_to_copy').val() === 'print') {
            grid = PrintGrid;
            text = 'Print';
        } else if ($('#media_type_to_copy').val() === 'mail') {
            grid = MailGrid;
            text = 'Mail';
        } else if ($('#media_type_to_copy').val() === 'ooh') {
            grid = OOHGrid;
            text = 'OOH';
        } else if ($('#media_type_to_copy').val() === 'ott') {
            grid = OTTGrid;
            text = 'OTT';
        } else {
            grid = OtherGrid;
            text = 'Other';
        }
        var text_type = '';
        if (type === 'month')
            text_type = ' for all broadcast month (current market only).';
        if (type === 'market')
            text_type = ' for all selected Market(s).';
        if (type === 'campaign')
            text_type = " for each Campaign's Week in all markets.";
        if (type === 'custom')
            text_type = " for each selected Market in the chosen weeks.";

        $('#replace_or_copy_label').html('Replace the existing data'+ text_type +'');
        $("input:checkbox[name=replace_or_copy]:checked").prop('checked', false)

        var lines_c = (grid.api.getSelectedNodes().length > 1) ? 's' : '';

        if (grid.api.getSelectedNodes().length > 0) {
            $('#about_to_copy_span').html('You are about to copy the selected line'+ lines_c +' <b>(' + grid.api.getSelectedNodes().length + ')</b> ' + text_type);
            $('#div_show_radios').show();
            $('#div_show_message').hide();
        } else {
            $('#div_show_radios').hide();
            $('#div_show_message').html(' This action will copy the ' + text + ' planning' + text_type + ' Are you sure you want to continue?');
            $('#div_show_message').show();
        }
        $('#selectOrAllModal').modal('show');

    }
    $('#submit_copy_type').on('click', function () {
        if($('#_type_to_copy').val() === 'month')
            confirmed_copy_to_month();
        if($('#_type_to_copy').val() === 'market')
            confirmed_copy_to_market();
        if($('#_type_to_copy').val() === 'campaign')
            confirmed_copy_to_campaign()
        if($('#_type_to_copy').val() === 'custom')
            confirmed_copy_to_custom()
    });
    $('#replace_or_copy_label').on('click', function(){
        if($("input:checkbox[name=replace_or_copy]").prop('checked') === true)
            $("input:checkbox[name=replace_or_copy]").prop('checked', false)
        else
            $("input:checkbox[name=replace_or_copy]").prop('checked', true)
    });

    var updateMainGrid= function () {
        /*var totals=0;
        TvDPGrid.api.forEachNode(function (node) {
           if(!isNaN(node.data.grp) && !isNaN(node.data.market_cost)){
               totals+= node.data.grp * node.data.market_cost;
           }
        });
        TvLengthGrid.api.forEachNode(function (node) {
            if(!isNaN(node.data.grp) && !isNaN(node.data.market_cost)){
                totals+= node.data.grp * node.data.market_cost;
            }
        });
        RadioDPGrid.api.forEachNode(function (node) {
            if(!isNaN(node.data.grp) && !isNaN(node.data.market_cost)){
                totals+= node.data.grp * node.data.market_cost;
            }
        });
        RadioLengthGrid.api.forEachNode(function (node) {
            if(!isNaN(node.data.grp) && !isNaN(node.data.market_cost)){
                totals+= node.data.grp * node.data.market_cost;
            }
        });
        PrintGrid.api.forEachNode(function (node) {
            if(!isNaN(node.data.grp) && !isNaN(node.data.market_cost)){
                totals+= node.data.grp * node.data.market_cost;
            }
        });
        MailGrid.api.forEachNode(function (node) {
            if(!isNaN(node.data.grp) && !isNaN(node.data.market_cost)){
                totals+= node.data.grp * node.data.market_cost;
            }
        });
        DigitalGrid.api.forEachNode(function (node) {
            if(!isNaN(node.data.grp) && !isNaN(node.data.market_cost)){
                totals+= node.data.grp * node.data.market_cost;
            }
        });
        OOHGrid.api.forEachNode(function (node) {
            if(!isNaN(node.data.grp) && !isNaN(node.data.market_cost)){
                totals+= node.data.grp * node.data.market_cost;
            }
        });
        OtherGrid.api.forEachNode(function (node) {
            if(!isNaN(node.data.grp) && !isNaN(node.data.market_cost)){
                totals+= node.data.grp * node.data.market_cost;
            }
        });
        totals=parseFloat(totals ).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        });
        selected_row.node.setDataValue(column_week, totals);*/
    };

    $('#campaign_market').on('select2:selecting', function (e) {
        var x= 0;
        var show='';
       for(var i in saved_all[0]){
           if(saved_all[0][i]==0) {
             x++;
             if(x == 1){
                 if(i =='tv_dp')
                     show= 'Television';
                 else if(i =='tv_len')
                     show= 'Television';
                 else if(i =='radio_dp')
                     show= 'Radio Planner';
                 // else if(i =='')
                 //     show= 'Radio Lenght Planner';
                 else if(i =='print')
                     show= 'Print';
                 else if(i =='mail')
                     show= 'Mail';
                 else if(i =='other')
                     show= 'Other';
                 else if(i =='ooh')
                     show= 'OOH';
                 else if(i =='digital')
                     show= 'Digital';
                 else if(i =='ott')
                     show= 'OTT';
             }
             else{
                 if(i =='tv_dp')
                     show+= ', Television';
                 // else if(i =='tv_len')
                 //     show+= ', Television Planner';
                 else if(i =='radio_dp')
                     show+= ', Radio';
                 // else if(i =='radio_len')
                 //     show+= ', Radio Planner';
                 else if(i =='print')
                     show+= ', Print';
                 else if(i =='mail')
                     show+= ', Mail';
                 else if(i =='other')
                     show+= ', Other';
                 else if(i =='ooh')
                     show+= ', OOH';
                 else if(i =='digital')
                     show+= ', Digital';
                 else if(i =='ott')
                     show+= ', OTT';
             }
           }
       }
       if(x > 0){
           e.preventDefault();
           swal({
                   title: "Warning!",
                   text: "You have not saved the previous media selections.  If you continue, the changes will be lost.  Do you want to continue? ",
                   type: "warning",
                   showCancelButton: true,
                   confirmButtonClass: "btn-danger",
                   confirmButtonText: "Continue",
                   closeOnConfirm: true,
                   closeOnCancel: true
               },
               function (isConfirm) {
                   if (!isConfirm) {
                       e.preventDefault();
                       e.stopPropagation();
                   }
                   if(isConfirm){
                       var new_v= e.params.args.data.id;
                       $('#campaign_market').val(new_v);
                       $('#campaign_market').trigger('change');
                   }

               });
       }
    });
    $('#campaign_market').on('change', function (e) {
        showChangeMarketPlanner();
    });
    var showChangeMarketPlanner= function () {
        show_overlay_loader($('#newPlannerModal .modal-content'));
        saved_all=[ {tv_dp: 1, tv_len: 1, radio_dp: 1, radio_len: 1, print: 1, digital: 1, ooh: 1, mail: 1, other: 1}]
        month= broadcast_month_selected;
        $.ajax({
            type: 'GET',
            url: '/planner/get/campaign/market/week/' + camapaign_selected +'/' + selected_week + '/' + $('#campaign_market option:selected').val(),
            dataType: 'json',
            encode: true,
            success: function (data) {
                $('#tv_dp_refresh_grp').hide();
                $('#radio_dp_refresh_grp').hide();
                $('#print_refresh_grp').hide();
                $('#digital_refresh_grp').hide();
                $('#mail_refresh_grp').hide();
                $('#ooh_refresh_grp').hide();
                $('#other_refresh_grp').hide();
                $('#ott_refresh_grp').hide();

                $('#tv_apply_div').show();
                $('#radio_apply_div').show();
                $('#other_apply_div').show();
                $('#print_apply_div').show();
                $('#mail_apply_div').show();
                $('#digital_apply_div').show();
                $('#ooh_apply_div').show();
                $('#ott_apply_div').show();

                if(cam_mark_count == true) {
                    $('#tv_dp_apply_market').show();
                    $('#radio_dp_apply_market').show();
                    $('#print_apply_market').show();
                    $('#digital_apply_market').show();
                    $('#mail_apply_market').show();
                    $('#ooh_apply_market').show();
                    $('#other_apply_market').show();
                    $('#ott_apply_market').show();
                }
                else{
                    $('#tv_dp_apply_market').hide();
                    $('#radio_dp_apply_market').hide();
                    $('#print_apply_market').hide();
                    $('#digital_apply_market').hide();
                    $('#mail_apply_market').hide();
                    $('#ooh_apply_market').hide();
                    $('#other_apply_market').hide();
                    $('#ott_apply_market').hide();
                }

                $("#tv_dp_remove_items").hide();
                $("#tv_len_remove_items").hide();
                $("#radio_dp_remove_items").hide();
                $("#radio_len_remove_items").hide();
                $("#print_remove_items").hide();
                $("#digital_remove_items").hide();
                $("#ooh_remove_items").hide();
                $("#mail_remove_items").hide();
                $("#other_remove_items").hide();
                $("#ott_remove_items").hide();
                $('#campaign_market').select2({
                    minimumResultsForSearch: 5
                });

                var html='';
                for(var i in data.markets)
                    html +=  '<option value="' + data.markets[i].id + '" >' + data.markets[i].type.toUpperCase() + ' - ' + data.markets[i].name + '</option>';

                $('#apply_market').html(html).multiSelect('refresh');

                $('#select_all_appl_mark').on('click', function(e){
                    $('#apply_market').multiSelect('select_all');
                });
                $('#deselect_all_appl_mark').on('click', function(e){
                    $('#apply_market').multiSelect('deselect_all');
                });

                var htmlMedia='';
                $('.media_tabs li').hide();
                if( data.media_types.indexOf('tv') !== -1)
                    $('#tv_id').show();
                else
                    $('#tv_id').hide();
                $('#tv').removeClass('active');
                $('#tv_id').removeClass('active');
                if( data.media_types.indexOf('radio') !== -1)
                    $('#radio_id').show();
                else
                    $('#radio_id').hide();
                $('#radio').removeClass('active');
                $('#radio_id').removeClass('active');
                if( data.media_types.indexOf('print') !== -1)
                    $('#print_id').show();
                else
                    $('#print_id').hide();
                $('#print').removeClass('active');
                $('#print_id').removeClass('active');
                if( data.media_types.indexOf('digital') !== -1)
                    $('#digital_id').show();
                else
                    $('#digital_id').hide();
                $('#digital').removeClass('active');
                $('#digital_id').removeClass('active');
                if( data.media_types.indexOf('ooh') !== -1)
                    $('#ooh_id').show();
                else
                    $('#ooh_id').hide();
                $('#ooh').removeClass('active');
                $('#ooh_id').removeClass('active');
                if( data.media_types.indexOf('mail') !== -1)
                    $('#mail_id').show();
                else
                    $('#mail_id').hide();
                $('#mail').removeClass('active');
                $('#mail_id').removeClass('active');
                if( data.media_types.indexOf('other') !== -1)
                    $('#other_id').show();
                else
                    $('#other_id').hide();
                $('#other').removeClass('active');
                $('#other_id').removeClass('active');

                if( data.media_types.indexOf('ott') !== -1)
                    $('#ott_id').show();
                else
                    $('#ott_id').hide();
                $('#ott').removeClass('active');
                $('#ott_id').removeClass('active');

                $('#total').removeClass('active');
                $('#totals_id').removeClass('active');

                $("#"+data.media_types[0]+"").addClass('active');
                $("#"+data.media_types[0]+"_id").addClass('active');

                TvDPGrid.rowData = [];
               // TvLengthGrid.rowData = [];
                RadioDPGrid.rowData = [];
               // RadioLengthGrid.rowData = [];
                PrintGrid.rowData = [];
                DigitalGrid.rowData = [];
                MailGrid.rowData = [];
                OtherGrid.rowData = [];
                OOHGrid.rowData = [];
                OTTGrid.rowData = [];

                deletedItemsDPTV = [];
                deletedItemsLenTV = [];
                deletedItemsDPRadio = [];
                deletedItemsLenRadio = [];
                deletedItemsPrint = [];
                deletedItemsDigital = [];
                deletedItemsOOH = [];
                deletedItemsMail = [];
                deletedItemsOther = [];
                deletedItemsOTT = [];
                var totals_array= {
                    tv: [
                        daypart = {
                            grp : 0, market_cost : 0, total_cost : 0, grp_percent : 0, budget_percent: 0
                        },
                        len = {
                            grp : 0, market_cost : 0, total_cost : 0
                        },
                    ],
                    radio: [
                        daypart ={
                            grp: 0, market_cost: 0, total_cost: 0, grp_percent : 0, budget_percent: 0
                        },
                        len = {
                            grp: 0, market_cost: 0, total_cost: 0
                        },
                    ],
                    mail: {grp: 0, market_cost: 0, total_cost: 0, grp_percent : 0, budget_percent: 0},
                    digital: {grp: 0, market_cost: 0, total_cost: 0, grp_percent : 0, budget_percent: 0},
                    print: {grp: 0, market_cost: 0, total_cost: 0, grp_percent : 0, budget_percent: 0},
                    other: {grp: 0, market_cost: 0, total_cost: 0, grp_percent : 0, budget_percent: 0},
                    ooh: {grp: 0, market_cost: 0, total_cost: 0, grp_percent : 0, budget_percent: 0},
                    ott: {grp: 0, market_cost: 0, total_cost: 0, grp_percent : 0, budget_percent: 0},
                };
                var media_totals={
                    tv:    { grp :0, market_cost: 0, total_cost: 0},
                    radio: { grp :0, market_cost: 0, total_cost: 0},
                };
                for (var i in data.plannings) {
                    if( data.plannings[i].media_type=='television') {
                        if (data.plannings[i].daypart != '' && data.plannings[i].daypart != null) {
                            var pp=0;
                            if(data.budget.budget > 0)
                                pp= (data.plannings[i].cost *  data.plannings[i].grp  *100 ) / data.budget.budget;
                            var grp_percent= 0;
                            if(typeof data.grp_totals['television'] !== 'undefined' && data.grp_totals['television'] > 0)
                                grp_percent = (data.plannings[i].grp  * 100) / data.grp_totals['television'];
                            TvDPGrid.rowData.push({
                                int_id: data.plannings[i].id,
                                planner_id: data.plannings[i].id,
                                campaign_id: camapaign_selected,
                                market_id: $('#campaign_market option:selected').val(),
                                media_type: 'television',
                                type: 'daypart',
                                week: selected_week,
                                broadcast_month: month,
                                daypart: data.plannings[i].daypart_id,
                                market_cost: data.plannings[i].cost,
                                grp: data.plannings[i].grp,
                                grp_percent: grp_percent,
                                broadcast_month_name: moment('2019-' + month + '-01').format('MMMM'),
                                total_cost:  parseFloat(data.plannings[i].cost * data.plannings[i].grp).toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                    minimumFractionDigits: 2
                                }),
                                percent:parseFloat(pp).toLocaleString("en-US", {
                                    minimumFractionDigits: 1
                                }) + '%',
                            });
                            totals_array['tv'][0]['market_cost']  += parseFloat(data.plannings[i].cost);
                            totals_array['tv'][0]['grp']  += parseFloat(data.plannings[i].grp);
                            totals_array['tv'][0]['total_cost']  += parseFloat(data.plannings[i].cost * data.plannings[i].grp);
                            totals_array['tv'][0]['grp_percent'] += parseFloat(grp_percent)
                            totals_array['tv'][0]['budget_percent'] += parseFloat(pp);

                            media_totals['tv']['grp']+= parseFloat(data.plannings[i].grp);
                            media_totals['tv']['market_cost']+=parseFloat(data.plannings[i].cost);
                            media_totals['tv']['total_cost']+=parseFloat(data.plannings[i].cost * data.plannings[i].grp);
                        }
                    }
                    if( data.plannings[i].media_type=='radio') {
                        if (data.plannings[i].daypart != '' && data.plannings[i].daypart != null) {
                            var pp=0;
                            if(data.budget.budget > 0)
                                pp= (data.plannings[i].cost *  data.plannings[i].grp  *100 ) / data.budget.budget;
                            var grp_percent= 0;
                            if(typeof data.grp_totals['radio'] !== 'undefined' && data.grp_totals['radio'] > 0)
                                grp_percent = (data.plannings[i].grp  * 100) / data.grp_totals['radio'];
                            console.log('radio pp ', pp);
                            RadioDPGrid.rowData.push({
                                int_id: data.plannings[i].id,
                                planner_id: data.plannings[i].id,
                                campaign_id: camapaign_selected,
                                market_id: $('#campaign_market option:selected').val(),
                                media_type: 'radio',
                                type: 'daypart',
                                week: selected_week,
                                broadcast_month: month,
                                grp_percent: grp_percent,
                                daypart: data.plannings[i].daypart_id,
                                market_cost: data.plannings[i].cost,
                                grp: data.plannings[i].grp,
                                broadcast_month_name: moment('2019-' + month + '-01').format('MMMM'),
                                total_cost:  parseFloat(data.plannings[i].cost * data.plannings[i].grp).toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                    minimumFractionDigits: 2
                                }),
                                percent:parseFloat(pp).toLocaleString("en-US", {
                                    minimumFractionDigits: 1
                                }) + '%',
                            });
                            totals_array['radio'][0]['market_cost']  += parseFloat(data.plannings[i].cost);
                            totals_array['radio'][0]['grp'] += parseFloat(data.plannings[i].grp);
                            totals_array['radio'][0]['total_cost']+= parseFloat(data.plannings[i].cost * data.plannings[i].grp);
                            totals_array['radio'][0]['grp_percent'] += parseFloat(grp_percent)
                            totals_array['radio'][0]['budget_percent'] += parseFloat(pp);

                            media_totals['radio']['grp']+=parseFloat(data.plannings[i].grp);
                            media_totals['radio']['market_cost']+=parseFloat(data.plannings[i].cost);
                            media_totals['radio']['total_cost']+=parseFloat(data.plannings[i].cost * data.plannings[i].grp);
                        }
                    }
                    if( data.plannings[i].media_type=='print') {
                        if (data.plannings[i].name != '' && data.plannings[i].name != null) {
                            var pp=0;
                            if(data.budget.budget > 0)
                                pp= (data.plannings[i].cost *  data.plannings[i].grp  *100 ) / data.budget.budget;
                            var grp_percent= 0;
                            if(typeof data.grp_totals['print'] !== 'undefined' && data.grp_totals['print'] > 0)
                                grp_percent = (data.plannings[i].grp  * 100) / data.grp_totals['print'];
                            PrintGrid.rowData.push({
                                int_id: data.plannings[i].id,
                                planner_id: data.plannings[i].id,
                                campaign_id: camapaign_selected,
                                market_id: $('#campaign_market option:selected').val(),
                                media_type: 'print',
                                week: selected_week,
                                broadcast_month: month,
                                length: data.plannings[i].name,
                                market_cost: data.plannings[i].cost,
                                grp: data.plannings[i].grp,
                                grp_percent: grp_percent,
                                broadcast_month_name: moment('2019-' + month + '-01').format('MMMM'),
                                total_cost:  parseFloat(data.plannings[i].cost * data.plannings[i].grp).toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                    minimumFractionDigits: 2
                                }),
                                percent:parseFloat(pp).toLocaleString("en-US", {
                                    minimumFractionDigits: 1
                                }) + '%',
                            });
                            totals_array['print']['market_cost'] += parseFloat(data.plannings[i].cost);
                            totals_array['print']['grp'] += parseFloat(data.plannings[i].grp);
                            totals_array['print']['total_cost']+= parseFloat(data.plannings[i].cost * data.plannings[i].grp);
                            totals_array['print']['grp_percent'] += parseFloat(grp_percent)
                            totals_array['print']['budget_percent'] += parseFloat(pp);

                        }
                    }
                    if( data.plannings[i].media_type=='digital') {
                        if (data.plannings[i].name != '' && data.plannings[i].name != null) {
                            var pp=0;
                            if(data.budget.budget > 0)
                                pp= (data.plannings[i].cost *  data.plannings[i].grp  *100 ) / data.budget.budget;
                            var grp_percent= 0;
                            if(typeof data.grp_totals['digital'] !== 'undefined' && data.grp_totals['digital'] > 0)
                                grp_percent = (data.plannings[i].grp  * 100) / data.grp_totals['digital'];
                            DigitalGrid.rowData.push({
                                int_id: data.plannings[i].id,
                                planner_id: data.plannings[i].id,
                                campaign_id: camapaign_selected,
                                market_id: $('#campaign_market option:selected').val(),
                                media_type: 'digital',
                                type: 'digital',
                                week: selected_week,
                                broadcast_month: month,
                                length: data.plannings[i].name,
                                market_cost: data.plannings[i].cost,
                                grp: data.plannings[i].grp,
                                grp_percent: grp_percent,
                                broadcast_month_name: moment('2019-' + month + '-01').format('MMMM'),
                                total_cost:  parseFloat(data.plannings[i].cost * data.plannings[i].grp).toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                    minimumFractionDigits: 2
                                }),
                                percent:parseFloat(pp).toLocaleString("en-US", {
                                    minimumFractionDigits: 1
                                }) + '%',
                            });
                            totals_array['digital']['market_cost'] += parseFloat(data.plannings[i].cost);
                            totals_array['digital']['grp'] += parseFloat(data.plannings[i].grp);
                            totals_array['digital']['total_cost'] += parseFloat(data.plannings[i].cost * data.plannings[i].grp);
                            totals_array['digital']['grp_percent'] += parseFloat(grp_percent)
                            totals_array['digital']['budget_percent'] += parseFloat(pp);
                        }
                    }
                    if( data.plannings[i].media_type=='mail') {
                        if (data.plannings[i].name != '' && data.plannings[i].name != null) {
                            var pp=0;
                            if(data.budget.budget > 0)
                                pp= (data.plannings[i].cost *  data.plannings[i].grp  *100 ) / data.budget.budget;
                            var grp_percent= 0;
                            if(typeof data.grp_totals['mail'] !== 'undefined' && data.grp_totals['mail'] > 0)
                                grp_percent = (data.plannings[i].grp  * 100) / data.grp_totals['mail'];
                            MailGrid.rowData.push({
                                int_id: data.plannings[i].id,
                                planner_id: data.plannings[i].id,
                                campaign_id: camapaign_selected,
                                market_id: $('#campaign_market option:selected').val(),
                                media_type: 'mail',
                                type: 'mail',
                                week: selected_week,
                                broadcast_month: month,
                                length: data.plannings[i].name,
                                market_cost: data.plannings[i].cost,
                                grp: data.plannings[i].grp,
                                grp_percent: grp_percent,
                                broadcast_month_name: moment('2019-' + month + '-01').format('MMMM'),
                                total_cost:  parseFloat(data.plannings[i].cost * data.plannings[i].grp).toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                    minimumFractionDigits: 2
                                }),
                                percent:parseFloat(pp).toLocaleString("en-US", {
                                    minimumFractionDigits: 1
                                }) + '%',
                            });
                            totals_array['mail']['market_cost'] += parseFloat(data.plannings[i].cost);
                            totals_array['mail']['grp'] += parseFloat(data.plannings[i].grp);
                            totals_array['mail']['total_cost'] += parseFloat(data.plannings[i].cost * data.plannings[i].grp);
                            totals_array['mail']['grp_percent'] += parseFloat(grp_percent)
                            totals_array['mail']['budget_percent'] += parseFloat(pp);
                        }
                    }
                    if( data.plannings[i].media_type=='other') {
                        if (data.plannings[i].name != '' && data.plannings[i].name != null) {
                            var pp=0;
                            if(data.budget.budget > 0)
                                pp= (data.plannings[i].cost *  data.plannings[i].grp  *100 ) / data.budget.budget;
                            var grp_percent= 0;
                            if(typeof data.grp_totals['other'] !== 'undefined' && data.grp_totals['other'] > 0)
                                grp_percent = (data.plannings[i].grp  * 100) / data.grp_totals['other'];
                            OtherGrid.rowData.push({
                                int_id: data.plannings[i].id,
                                planner_id: data.plannings[i].id,
                                campaign_id: camapaign_selected,
                                market_id: $('#campaign_market option:selected').val(),
                                media_type: 'other',
                                type: 'other',
                                week: selected_week,
                                broadcast_month: month,
                                length: data.plannings[i].name,
                                market_cost: data.plannings[i].cost,
                                grp: data.plannings[i].grp,
                                grp_percent: grp_percent,
                                broadcast_month_name: moment('2019-' + month + '-01').format('MMMM'),
                                total_cost:  parseFloat(data.plannings[i].cost * data.plannings[i].grp).toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                    minimumFractionDigits: 2
                                }),
                                percent:parseFloat(pp).toLocaleString("en-US", {
                                    minimumFractionDigits: 1
                                }) + '%',
                            });
                            totals_array['other']['market_cost'] += parseFloat(data.plannings[i].cost);
                            totals_array['other']['grp'] += parseFloat(data.plannings[i].grp);
                            totals_array['other']['total_cost'] += parseFloat(data.plannings[i].cost * data.plannings[i].grp);
                            totals_array['other']['grp_percent'] += parseFloat(grp_percent)
                            totals_array['other']['budget_percent'] += parseFloat(pp);
                        }
                    }
                    if( data.plannings[i].media_type=='ooh') {
                        if (data.plannings[i].name != '' && data.plannings[i].name != null) {
                            var pp=0;
                            if(data.budget.budget > 0)
                                pp= (data.plannings[i].cost *  data.plannings[i].grp  *100 ) / data.budget.budget;
                            var grp_percent= 0;
                            if(typeof data.grp_totals['ooh'] !== 'undefined' && data.grp_totals['ooh'] > 0)
                                grp_percent = (data.plannings[i].grp  * 100) / data.grp_totals['ooh'];
                            OOHGrid.rowData.push({
                                int_id: data.plannings[i].id,
                                planner_id: data.plannings[i].id,
                                campaign_id: camapaign_selected,
                                market_id: $('#campaign_market option:selected').val(),
                                media_type: 'ooh',
                                type: 'ooh',
                                week: selected_week,
                                broadcast_month: month,
                                length: data.plannings[i].name,
                                market_cost: data.plannings[i].cost,
                                grp: data.plannings[i].grp,
                                grp_percent: grp_percent,
                                broadcast_month_name: moment('2019-' + month + '-01').format('MMMM'),
                                total_cost:  parseFloat(data.plannings[i].cost * data.plannings[i].grp).toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                    minimumFractionDigits: 2
                                }),
                                percent:parseFloat(pp).toLocaleString("en-US", {
                                    minimumFractionDigits: 1
                                }) + '%',
                            });
                            totals_array['ooh']['market_cost'] += parseFloat(data.plannings[i].cost);
                            totals_array['ooh']['grp'] += parseFloat(data.plannings[i].grp);
                            totals_array['ooh']['total_cost'] += parseFloat(data.plannings[i].cost * data.plannings[i].grp);
                            totals_array['ooh']['grp_percent'] += parseFloat(grp_percent)
                            totals_array['ooh']['budget_percent'] += parseFloat(pp);

                        }
                    }
                    if( data.plannings[i].media_type=='ott') {
                        if (data.plannings[i].name != '' && data.plannings[i].name != null) {
                            var pp=0;
                            if(data.budget.budget > 0)
                                pp= (data.plannings[i].cost *  data.plannings[i].grp  *100 ) / data.budget.budget;
                            var grp_percent= 0;
                            if(typeof data.grp_totals['ott'] !== 'undefined' && data.grp_totals['ott'] > 0)
                                grp_percent = (data.plannings[i].grp  * 100) / data.grp_totals['ott'];
                            OTTGrid.rowData.push({
                                int_id: data.plannings[i].id,
                                planner_id: data.plannings[i].id,
                                campaign_id: camapaign_selected,
                                market_id: $('#campaign_market option:selected').val(),
                                media_type: 'ott',
                                type: 'ott',
                                week: selected_week,
                                broadcast_month: month,
                                length: data.plannings[i].name,
                                market_cost: data.plannings[i].cost,
                                grp: data.plannings[i].grp,
                                grp_percent: grp_percent,
                                broadcast_month_name: moment('2019-' + month + '-01').format('MMMM'),
                                total_cost:  parseFloat(data.plannings[i].cost * data.plannings[i].grp).toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                    minimumFractionDigits: 2
                                }),
                                percent:parseFloat(pp).toLocaleString("en-US", {
                                    minimumFractionDigits: 1
                                }) + '%',
                            });
                            totals_array['ott']['market_cost'] += parseFloat(data.plannings[i].cost);
                            totals_array['ott']['grp'] += parseFloat(data.plannings[i].grp);
                            totals_array['ott']['total_cost'] += parseFloat(data.plannings[i].cost * data.plannings[i].grp);
                            totals_array['ott']['grp_percent'] += parseFloat(grp_percent)
                            totals_array['ott']['budget_percent'] += parseFloat(pp);

                        }
                    }
                }
                totals_array['tv'][0]['total_cost']= parseFloat( totals_array['tv'][0]['total_cost'] ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                totals_array['tv'][1]['total_cost']= parseFloat( totals_array['tv'][1]['total_cost'] ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                totals_array['radio'][0]['total_cost']= parseFloat( totals_array['radio'][0]['total_cost'] ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                totals_array['radio'][1]['total_cost']= parseFloat( totals_array['radio'][1]['total_cost'] ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                totals_array['print']['total_cost']= parseFloat( totals_array['print']['total_cost'] ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                totals_array['digital']['total_cost']= parseFloat( totals_array['digital']['total_cost'] ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                totals_array['ooh']['total_cost']= parseFloat( totals_array['ooh']['total_cost'] ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                totals_array['mail']['total_cost']= parseFloat( totals_array['mail']['total_cost'] ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                totals_array['other']['total_cost']= parseFloat( totals_array['other']['total_cost'] ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                totals_array['ott']['total_cost']= parseFloat( totals_array['ott']['total_cost'] ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });

                $('#tvDPGrid').html("");
                var tvDPGridGrid = document.querySelector('#tvDPGrid');
                var g5 = new agGrid.Grid(tvDPGridGrid, TvDPGrid);
                TvDPGrid.api.setPinnedTopRowData([{
                    market_cost: totals_array['tv'][0]['market_cost'],
                    grp: totals_array['tv'][0]['grp'],
                    total_cost:totals_array['tv'][0]['total_cost'],
                    grp_percent: parseFloat(totals_array['tv'][0]['grp_percent']).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    percent: parseFloat(totals_array['tv'][0]['budget_percent']).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                } ]);

                $('#radioDPGrid').html("");
                var radioDPGridGrid = document.querySelector('#radioDPGrid');
                var g5 = new agGrid.Grid(radioDPGridGrid, RadioDPGrid);
                RadioDPGrid.api.setPinnedTopRowData([{
                    market_cost: totals_array['radio'][0]['market_cost'],
                    grp: totals_array['radio'][0]['grp'],
                    total_cost:totals_array['radio'][0]['total_cost'],
                    grp_percent: parseFloat(totals_array['radio'][0]['grp_percent']).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    percent: parseFloat(totals_array['radio'][0]['budget_percent']).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                } ]);

                $('#PrintGrid').html("");
                var printGridGrid = document.querySelector('#PrintGrid');
                var g5 = new agGrid.Grid(printGridGrid, PrintGrid);
                PrintGrid.api.setPinnedTopRowData([{
                    market_cost: totals_array['print']['market_cost'],
                    grp: totals_array['print']['grp'],
                    total_cost:totals_array['print']['total_cost'],
                    grp_percent: parseFloat(totals_array['print']['grp_percent']).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    percent: parseFloat(totals_array['print']['budget_percent']).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                } ]);

                $('#DigitalGrid').html("");
                var digitalGridGrid = document.querySelector('#DigitalGrid');
                var g5 = new agGrid.Grid(digitalGridGrid, DigitalGrid);
                DigitalGrid.api.setPinnedTopRowData([{
                    market_cost: totals_array['digital']['market_cost'],
                    grp: totals_array['digital']['grp'],
                    total_cost:totals_array['digital']['total_cost'],
                    grp_percent: parseFloat(totals_array['digital']['grp_percent']).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    percent: parseFloat(totals_array['digital']['budget_percent']).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                }]);

                $('#MailGrid').html("");
                var mailGridGrid = document.querySelector('#MailGrid');
                var g5 = new agGrid.Grid(mailGridGrid, MailGrid);
                MailGrid.api.setPinnedTopRowData([{
                    market_cost: totals_array['mail']['market_cost'],
                    grp: totals_array['mail']['grp'],
                    total_cost:totals_array['mail']['total_cost'],
                    grp_percent: parseFloat(totals_array['mail']['grp_percent']).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    percent: parseFloat(totals_array['mail']['budget_percent']).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                } ]);

                $('#OOHGrid').html("");
                var OOHGridGrid = document.querySelector('#OOHGrid');
                var g5 = new agGrid.Grid(OOHGridGrid, OOHGrid);
                OOHGrid.api.setPinnedTopRowData([{
                    market_cost: totals_array['ooh']['market_cost'],
                    grp: totals_array['ooh']['grp'], total_cost:totals_array['ooh']['total_cost'],
                    grp_percent: parseFloat(totals_array['ooh']['grp_percent']).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    percent: parseFloat(totals_array['ooh']['budget_percent']).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                } ]);

                $('#OtherGrid').html("");
                var OtherGridGrid = document.querySelector('#OtherGrid');
                var g5 = new agGrid.Grid(OtherGridGrid, OtherGrid);
                OtherGrid.api.setPinnedTopRowData([{
                    market_cost: totals_array['other']['market_cost'],
                    grp: totals_array['other']['grp'],
                    total_cost:totals_array['other']['total_cost'],
                    grp_percent: parseFloat(totals_array['other']['grp_percent']).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    percent: parseFloat(totals_array['other']['budget_percent']).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                } ]);

                $('#OTTGrid').html("");
                var OTTGridGrid = document.querySelector('#OTTGrid');
                var g5 = new agGrid.Grid(OTTGridGrid, OTTGrid);
                OTTGrid.api.setPinnedTopRowData([{
                    market_cost: totals_array['ott']['market_cost'],
                    grp: totals_array['ott']['grp'],
                    total_cost:totals_array['ott']['total_cost'],
                    grp_percent: parseFloat(totals_array['ott']['grp_percent']).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                    percent: parseFloat(totals_array['ott']['budget_percent']).toLocaleString("en-US", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '%',
                } ]);



                $('.tv_mark_total').html('');
                $('.tv_mark_total').html('Media Cost: '+  parseFloat(media_totals['tv'].market_cost ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),);

                $('.tv_grp_total').html('');
                $('.tv_grp_total').html('GRP Goal:  '+  parseFloat(media_totals['tv'].grp ).toLocaleString("en-US", {
                    minimumFractionDigits: 1
                }),);
                $('.tv_total').html('');
                $('.tv_total').html('Total Cost:  '+  parseFloat(media_totals['tv'].total_cost ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),);
                $('.radio_mark_total').html('');
                $('.radio_mark_total').html('Media Cost:  '+  parseFloat(media_totals['radio'].market_cost ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),);
                $('.radio_grp_total').html('');
                $('.radio_grp_total').html('GRP Goal:  '+  parseFloat(media_totals['radio'].grp ).toLocaleString("en-US", {
                    minimumFractionDigits: 1
                }),);
                $('.radio_total').html('');
                $('.radio_total').html('Total Cost:  '+  parseFloat(media_totals['radio'].total_cost ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),);
                var to_mcost=0;
                var to_mgrp=0;
                var to_mtotal=0;
                for(var i in data.no_market_planning){
                    to_mcost+= parseFloat(data.no_market_planning[i]['cost']);
                    to_mgrp+= parseFloat(data.no_market_planning[i]['grp']);
                    to_mtotal+= parseFloat(data.no_market_planning[i]['grp']) * parseFloat(data.no_market_planning[i]['cost']);
                }

                var market_cost_total= parseFloat(media_totals['tv'].market_cost) + parseFloat(media_totals['radio'].market_cost) + parseFloat(totals_array['ooh']['market_cost'])
                    + parseFloat(totals_array['digital']['market_cost']) + parseFloat(totals_array['print']['market_cost'])  + parseFloat(totals_array['mail']['market_cost']) + parseFloat(totals_array['other']['market_cost']);

                var market_grp_total= parseFloat(media_totals['tv'].grp) + parseFloat(media_totals['radio'].grp) + parseFloat(totals_array['ooh']['grp'])
                    + parseFloat(totals_array['digital']['grp']) + parseFloat(totals_array['print']['grp']) + parseFloat(totals_array['mail']['grp']) + parseFloat(totals_array['other']['grp']);

                var market_total_total =  (media_totals['tv'].total_cost) + (media_totals['radio'].total_cost) + (totals_array['ooh']['total_cost'])
                    + (totals_array['digital']['total_cost']) + (totals_array['print']['total_cost']) +  (totals_array['mail']['total_cost']) + (totals_array['other']['total_cost']);

                update_week_totals(market_cost_total, market_grp_total ,market_total_total, data.budget.budget, to_mcost, to_mgrp, to_mtotal);
                cost_other_market = to_mcost;
                grp_other_market = to_mgrp;
                total_other_market = to_mtotal;
                camp_selected_week_budget = data.budget.budget;

                $('.mark_cost_total').html('');
                $('.mark_cost_total').html('Market Cost:  '+  parseFloat(market_cost_total ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),);
                $('.mark_grp_total').html('');
                $('.mark_grp_total').html('GRP Goal:  '+  parseFloat(market_grp_total ).toLocaleString("en-US", {
                    minimumFractionDigits: 1
                }),);
                $('.mark_total').html('');
                $('.mark_total').html('Total Cost:  '+  parseFloat(market_total_total ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),);
                hide_overlay_loader($('#newPlannerModal .modal-content'));
            },
            error: function (xhr) {
                hide_loader();
                debug(xhr.responseText);
            }
        });
    };

    $('#close_button').on('click', function () {
        var m=true;
        for(var x in  saved_all[0]){
            if(saved_all[0][x] == 0)
                m=false;
        }
        if(m == false){
            swal({
                    title: "Warning",
                    text: "The unsaved changes will be lost. Are you sure you want to continue?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: 'Cancel',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        getValueMainGrid(selected_row,column_week, selected_week, broadcast_month_selected_number, camapaign_selected );
                    }

                });
        }
        else
           getValueMainGrid(selected_row,column_week, selected_week, broadcast_month_selected_number, camapaign_selected );
    });
    $('.close_top').on('click', function () {
        var m=true;
        for(var x in  saved_all[0]){
            if(saved_all[0][x] == 0)
                m==false;
        }
        if(m == false){
            swal({
                    title: "Warning",
                    text: "The unsaved changes will be lost. Are you sure you want to continue?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: 'Cancel',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        getValueMainGrid(selected_row,column_week, selected_week, broadcast_month_selected_number, camapaign_selected );
                    }

                });
        }
        else
            getValueMainGrid(selected_row,column_week, selected_week, broadcast_month_selected_number, camapaign_selected );
    });
    var getValueMainGrid= function (row, column ,week, month, cam_id) {
         show_overlay_loader($('#newPlannerModal .modal-content'));
         $.ajax({
             type: 'GET',
             url: '/planner/update/main/grid/' + cam_id +'/' + week ,
             dataType: 'json',
             encode: true,
             success: function (response) {
                 data=parseFloat(response.value ).toLocaleString("en-US", {
                     style: "currency",
                     currency: "USD",
                     minimumFractionDigits: 2
                 });
                // row.data[column]= data;
                 row.node.setDataValue(column, data);
                 row.node.data.percent=parseFloat(response.percent).toFixed(1);
                 MainGrid.api.refreshCells({rowNodes: [selected_row.node], columns: ['percent', column, 'campaign_total'], force: true});

                 hide_overlay_loader($('#newPlannerModal .modal-content'));
                 $('#newPlannerModal').modal('hide');

             },
             error: function (xhr) {
                 hide_loader();
                 debug(xhr.responseText);
             },
         });
     };

    $('#market_planner').on('click', function () {
         if (MainGrid.api.getSelectedNodes().length == 0) {
             swal({
                     title: "Warning",
                     text: "Please select a campaign first.",
                     type: "warning",
                     showCancelButton: false,
                     confirmButtonClass: "btn-danger",
                     confirmButtonText: "OK",
                     //cancelButtonText: 'No',
                     closeOnConfirm: true,
                     closeOnCancel: true
                 },
                 function (isConfirm) {
                     if (isConfirm) {}

                 });
         }
         else{
             show_loader();
             var camp_id= MainGrid.api.getSelectedNodes()[0].data.campaign_id;
             $.ajax({
                 type: 'GET',
                 url: '/planner/show/campaign/market/planner/' + camp_id ,
                 dataType: 'json',
                 encode: true,
                 success: function (data) {
                     var media_types=data.media_types;
                     var marketPlannerColumnDef = [
                         {
                             headerName: 'Market ID',
                             headerTooltip: '',
                             field: 'market_id',
                             editable: false,
                             minWidth: 35,
                             width: 100,
                             required: false,
                             pinned: 'left',
                             hide: true,
                         },
                         {
                             headerName: 'Market',
                             headerTooltip: '',
                             field: 'market_name',
                             editable: false,
                             minWidth: 35,
                             width: 200,
                             required: false,
                             pinned: 'left',
                             filter: 'set'
                         },
                          {
                             headerName: 'Market Type',
                             headerTooltip: '',
                             field: 'market_type',
                             editable: false,
                             minWidth: 35,
                             width: 100,
                             required: false,
                             pinned: 'left',
                             hide:true,
                         },
                         {
                             headerName: 'Month',
                             headerTooltip: '',
                             field: 'month',
                             editable: false,
                             minWidth: 35,
                             width: 100,
                             required: false,
                             pinned: 'left',
                             filter: 'set'
                         },
                     ];
                     var medias=[];
                     for(var i in data.media_types){
                         var media=data.media_types[i];
                         medias.push(media);
                         marketPlannerColumnDef.push({
                             headerName: media.toUpperCase(),
                             field: media,
                             width: 100,
                             cellStyle: {'text-align': "right"},
                         });
                     }
                     marketPlannerColumnDef.push({
                         headerName: ' MARKET TOTAL',
                         field: 'total',
                         width: 110,
                         pinned: 'right',
                         cellStyle: {'text-align': "right"},
                     });

                     var MarketPlannerColumnDefTotals=[{
                         market_id: '',
                         market_name: '',
                         market_type: '',
                     }];
                     for(var m in data.totals) {
                         MarketPlannerColumnDefTotals[0][m] = parseFloat(data.totals[m]).toLocaleString("en-US", {
                             style: "currency",
                             currency: "USD",
                             minimumFractionDigits: 2
                         });
                     }
                     MarketPlannerGrid = {
                         enableFilter: true,
                         enableSorting: true,
                         columnDefs: marketPlannerColumnDef,
                         defaultColDef: {
                             suppressToolPanel: true
                         },
                         toolPanelSuppressValues: true,defaultToolPanel: '',
                         headerHeight: 20,
                         rowHeight: 20,
                         stopEditingWhenGridLosesFocus: true,
                         rowSelection: 'multiple',
                         suppressRowClickSelection: true,
                         suppressFilter: false,
                         pinnedTopRowData: MarketPlannerColumnDefTotals,
                       //  pinnedBottomRowData: tvDpColumnDefBottom,
                         defaultColDef: {
                             suppressToolPanel: true
                         },
                         icons: {
                             groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                             groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                             menu: '<i class="fa fa-bars fa-lg"/>',
                             sortAscending: '<i class="fa fa-caret-down"/>',
                             sortDescending: '<i class="fa fa-caret-up"/>',
                             columnMoveMove: '<i class="fa fa-arrows"></i>',
                             columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                             columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                             columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                             columnMoveHide: '<i class="fa fa-remove"/>'
                         },
                         onFilterChanged: function () {
                             // if (this.api.isAnyFilterPresent())
                             //     $('#reset_filters').show();
                             // else
                             //     $('#reset_filters').hide();
                             var floating_top_row = this.api.pinnedRowModel.pinnedTopRows[0];
                             var total_maingrid={};
                             var total=0;
                             total_maingrid['total']=0;
                             for(var i in media_types){
                                 var column=media_types[i];
                                 total_maingrid[column]=0;
                                 this.api.forEachNodeAfterFilterAndSort(function (node) {
                                     var expl= node.data[column].split('$');
                                     if(typeof(expl[1] !== 'undefined') && !isNaN(parseFloat(expl[1]))) {
                                         var com= expl[1].replace(",","")
                                         total_maingrid[column] += parseFloat((com));
                                         total_maingrid['total'] += parseFloat((com));
                                         total+=parseFloat(com);

                                     }
                                 });
                                 floating_top_row.data[column]= parseFloat(total_maingrid[column]).toLocaleString("en-US", {
                                     style: "currency",
                                     currency: "USD",
                                     minimumFractionDigits: 2
                                 });
                             }
                             floating_top_row.data['total']= parseFloat(total_maingrid['total']).toLocaleString("en-US", {
                                 style: "currency",
                                 currency: "USD",
                                 minimumFractionDigits: 2
                             });

                             //this.api.refreshCells([floating_top_row]);
                             this.api.refreshCells({rowNodes: [floating_top_row], columns: [], force: true});
                         },
                     };
                     MarketPlannerGrid.rowData = [];
                     MarketPlannerGrid.rowData = data.result;
                     $('#campaign_market_planner_h5').html( MainGrid.api.getSelectedNodes()[0].data.campaign_name);
                     $('.camp_mark_planner_quarters').html(data.FD);
                     $('#marketGrid').html("");
                     var marketGridGrid = document.querySelector('#marketGrid');
                     var g5 = new agGrid.Grid(marketGridGrid, MarketPlannerGrid);
                     //MailGrid.api.setPinnedTopRowData([{market_cost: totals_array['mail']['market_cost'], grp: totals_array['mail']['grp'], total_cost:totals_array['mail']['total_cost']} ]);
                     $('#showMarketPlanner').modal('show');
                     hide_loader();

                 },
                 error: function (xhr) {
                     hide_loader();
                     debug(xhr.responseText);
                 }
             });
         }
     })

    $('.hide-column a').bind('click', function (e) {
        if ($(this).hasClass('hidden-column')) {
            MainGrid.columnApi.setColumnVisible($(this).attr('data-col'), true);
            $(this).removeClass('hidden-column');
            if(typeof hidden_columns_main_grid[$(this).attr('data-col')] !== 'undefined')
                hidden_columns_main_grid[$(this).attr('data-col')] = 1;
        } else {
            MainGrid.columnApi.setColumnVisible($(this).attr('data-col'), false);
            $(this).addClass('hidden-column');
            if(typeof hidden_columns_main_grid[$(this).attr('data-col')] !== 'undefined')
                hidden_columns_main_grid[$(this).attr('data-col')] = 0;
        }
        e.stopPropagation();
    });

    function exportGrid(format) {
        var params = {
            skipHeader: false,
            columnGroups: false,
            skipFooters: false,
            skipGroups: true,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            allColumns: false,
            onlySelected: false,
            suppressQuotes: false,
            fileName: "export",
            suppressTextAsCDATA: false,
            // excelStyles: excelStyles,
        };
        params.processHeaderCallback = function (params) {
            var x= params.column.colId.split('week_');
            if(typeof x[1] !== 'undefined'){
                var mon= moment(x[1]).format('MMMM');
                return mon+'/'+params.column.colDef.headerName;
            }
            else
                return params.column.colDef.headerName;

        };
        if (format === 'csv') {
            params.fileName = 'export.csv';
            MainGrid.api.exportDataAsCsv(params);
        } else {
            var content = MainGrid.api.getDataAsExcel(params);
            var workbook = XLSX.read(content, {type: 'binary'});
            var xlsxContent = XLSX.writeFile(workbook, 'worksheet-export.xlsx', {bookType: 'xlsx', type: 'base64'});
        }
    }
    function exportGridMarket(format) {
        var params = {
            skipHeader: false,
            columnGroups: false,
            skipFooters: false,
            skipGroups: true,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            allColumns: false,
            onlySelected: false,
            suppressQuotes: false,
            fileName: "export",
            suppressTextAsCDATA: false,
            // excelStyles: excelStyles,
        };
        if(format === "csv") {
            params.customHeader = [
                [],
                [
                    "Market Planner Report " + "\n"
                ],
                [
                    "Campaign Name: " +MainGrid.api.getSelectedNodes()[0].data.campaign_name + "\n"
                ],
                [
                    "Flight Dates: " + MainGrid.api.getSelectedNodes()[0].data.fd_start +'  -  '+ MainGrid.api.getSelectedNodes()[0].data.fd_end+ "\n"
                ],
                [],
            ];
        }
        else{
            params.customHeader = [
            [],
                [
                    {data: {type: 'String', value: 'Market Planner Report'}},
                    {data: {type: 'String', value: ''}}],
                [
                    {data: {type: 'String', value: 'Campaign Name:'}},
                    {data: {type: 'String', value: MainGrid.api.getSelectedNodes()[0].data.campaign_name}}
                ],
                [
                    {data: {type: 'String', value: 'Flight Dates:'}},
                    {data: {type: 'String', value: MainGrid.api.getSelectedNodes()[0].data.fd_start +'  -  '+ MainGrid.api.getSelectedNodes()[0].data.fd_end}}
                ],
                [],
          ];
        }
        params.processHeaderCallback = function (params) {
            var x= params.column.colId.split('week_');
            if(typeof x[1] !== 'undefined'){
                var mon= moment(x[1]).format('MMMM');
                return mon+'/'+params.column.colDef.headerName;
            }
            else
                return params.column.colDef.headerName;

        };
        if (format === 'csv') {
            params.fileName = 'export.csv';
            MarketPlannerGrid.api.exportDataAsCsv(params);
        } else {
            var content = MarketPlannerGrid.api.getDataAsExcel(params);
            var workbook = XLSX.read(content, {type: 'binary'});
            var xlsxContent = XLSX.writeFile(workbook, 'worksheet-export.xlsx', {bookType: 'xlsx', type: 'base64'});
        }
    }
    $('#report').on('click', function () {
        if (MainGrid.api.getSelectedNodes().length == 0) {
            swal({
                    title: "Warning",
                    text: "Please select a campaign first.",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    //cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {}

                });
        }
        else {
            show_loader();
            var camp_id= MainGrid.api.getSelectedNodes()[0].data.campaign_id;
            $.ajax({
                type: 'GET',
                url: '/planner/report/campaign/datas/' + camp_id ,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    $('#selected_medias').multiSelect({
                        selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                        selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm ' id='select_all_media' ><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='deselect_all_media'><i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                        afterInit: function(ms){
                            var that = this,
                                $selectableSearch = that.$selectableUl.prev(),
                                selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                                .on('keydown', function(e){
                                    if (e.which === 40){
                                        that.$selectableUl.focus();
                                        return false;
                                    }
                                });
                        },
                        afterSelect: function(values){
                            this.qs1.cache();
                        },
                        afterDeselect: function(values){
                            this.qs1.cache();
                        }
                    });
                    $('#selected_medias').html('').multiSelect('refresh');
                    var html='';
                    for(var i in data.media_types){
                        var option='';
                        if(data.media_types[i]== 'tv')
                            option='Television';
                        if(data.media_types[i]== 'radio')
                            option='Radio';
                        if(data.media_types[i]== 'digital')
                            option='Digital';
                        if(data.media_types[i]== 'print')
                            option='Print';
                        if(data.media_types[i]== 'ooh')
                            option='OOH';
                        if(data.media_types[i]== 'mail')
                            option='Mail';
                        if(data.media_types[i]== 'other')
                            option='Other';
                        if(data.media_types[i]== 'ott')
                            option='OTT JamLoop';
                        html+='<option value="'+data.media_types[i]+'">'+option+'</option>';
                    }
                    $('#selected_medias').html(html).multiSelect('refresh');
                    $('#start_date').select2({
                        minimumResultsForSearch: 10,
                        placeholder: 'Select one....',
                    });
                    $('#end_date').select2({
                        minimumResultsForSearch: 10,
                        placeholder: 'Select one....',
                    });
                    var html='';
                    var html_1='';
                    fligth_dates=data.flightDates;
                    for(var x in data.FD)
                        html+='<option value="'+moment(data.FD[x]).format('MM/DD/YYYY')+'">'+moment(data.FD[x]).format('MM/DD/YYYY')+'</option>';
                    for(var x in data.FDE) {
                        if(x == (data.FDE.length - 1))
                            selected='selected';
                        else
                            selected = '';
                        html_1 += '<option value="' + moment(data.FDE[x]).format('MM/DD/YYYY') + '" '+selected+'>' + moment(data.FDE[x]).format('MM/DD/YYYY') + '</option>';
                    }
                    $('#start_date').html(html);
                    $('#end_date').html(html_1);

                    $('#selected_markets').multiSelect({
                        selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                        selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm select_all_market' id='select_all_market'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='deselect_all_market'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                        afterInit: function(ms){
                            var that = this,
                                $selectableSearch = that.$selectableUl.prev(),
                                selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                                .on('keydown', function(e){
                                    if (e.which === 40){
                                        that.$selectableUl.focus();
                                        return false;
                                    }
                                });
                        },
                        afterSelect: function(values){
                            this.qs1.cache();
                        },
                        afterDeselect: function(values){
                            this.qs1.cache();
                        }
                    });
                    var html='';
                    for(var i in data.markets)
                        html+='<option value="'+data.markets[i].id+'">'+ data.markets[i].type.toUpperCase()+'- '+data.markets[i].name+'</option>';
                    $('#selected_markets').html(html).multiSelect('refresh');

                    var header_options_mm= $('#header_options_sc').html();
                    $('#div_logo_option_mm').hide();
                    $('#header_options_sc').multiSelect({
                        selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                        selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm ' id='select_all_header'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='deselect_all_header'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                        afterInit: function(ms){
                            var that = this,
                                $selectableSearch = that.$selectableUl.prev(),
                                selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                                .on('keydown', function(e){
                                    if (e.which === 40){
                                        that.$selectableUl.focus();
                                        return false;
                                    }
                                });
                        },
                        afterSelect: function(values){
                            if(values == 'Agency Logo')
                                $('#div_logo_option_mm').show();
                            this.qs1.cache();
                        },
                        afterDeselect: function(values){
                            if(values == 'Agency Logo')
                                $('#div_logo_option_mm').hide();
                            this.qs1.cache();
                        }
                    });
                    $("#header_options_sc").html('');
                    $("#header_options_sc").multiSelect('refresh');
                    $('#header_options_sc').html(header_options_mm);
                    $("#header_options_sc").multiSelect('refresh');
                    $('#logo_option_mm').select2({
                        minimumResultsForSearch: 10,
                    });
                    $('#report_type').select2({
                        minimumResultsForSearch: 10,
                    });
                    if($('#report_type option:selected').val()=='weekly' ) {
                        $('#show_hiatus').attr('disabled', false);
                        $('#show_week_budget').attr('disabled', false);
                        $('#show_month_budget').attr('disabled', 'disabled');
                    }
                    else {
                        $('#show_hiatus').attr('disabled', 'disabled');
                        $('#show_week_budget').attr('disabled', 'disabled');
                        $('#show_month_budget').attr('disabled', false);
                    }
                    hide_loader();
                    $('#mediaPlannerReportModal').modal('show');
                    $('#select_all_media').on('click', function(e){
                        $('#selected_medias').multiSelect('select_all');
                    });
                    $('#deselect_all_media').on('click', function(e){
                        $('#selected_medias').multiSelect('deselect_all');
                    });
                    $('.div_markets .select_all_market').on('click', function(e){
                        $('#selected_markets').multiSelect('select_all');
                    });
                    $('#deselect_all_market').on('click', function(e){
                        $('#selected_markets').multiSelect('deselect_all');
                    });
                    $('#select_all_header').on('click', function(e){
                        $('#header_options_sc').multiSelect('select_all');
                        $('#div_logo_option_mm').show();
                    });
                    $('#deselect_all_header').on('click', function(e){
                        $('#header_options_sc').multiSelect('deselect_all');
                        $('#div_logo_option_mm').hide();
                    });
                },
                error: function (xhr) {
                    hide_loader();
                    debug(xhr.responseText);
                }
            });
        }
    });
    $('#start_date').on('change', function () {
        if($(this).val()==='' || $(this).val()===null)
            $('#end_date').html('');
        else{
            html='';
            $('#end_date').html('');
            var ff = [];
            for( var i in fligth_dates){
                var end= moment(fligth_dates[i]['end']);
                if(moment($(this).val()) <= end)
                    ff.push(end.format('MM/DD/YYYY'));
            }
           ff.sort();
            for( var i in ff)
                html+='<option value="'+ff[i]+'">'+moment(ff[i]).format('MM/DD/YYYY')+'</option>';
            $('#end_date').html(html);
        }
    });
    $('#start_date2').on('change', function () {
        if($(this).val()==='' || $(this).val()===null)
            $('#end_date2').html('');
        else{
            html='';
            $('#end_date2').html('');
            var ff = [];
            for( var i in fligth_dates){
                var end= moment(fligth_dates[i]['end']);
                if(moment($(this).val()) <= end)
                    ff.push(end.format('MM/DD/YYYY'));
            }
           ff.sort();
            for( var i in ff)
                html+='<option value="'+ff[i]+'">'+moment(ff[i]).format('MM/DD/YYYY')+'</option>';
            $('#end_date2').html(html);
        }
    });
    $('#start_date_comp').on('change', function () {
        if($(this).val()==='' || $(this).val()===null)
            $('#end_date_comp').html('');
        else{
            html='';
            $('#end_date_comp').html('');
            var ff = [];
            for( var i in fligth_dates){
                var end= moment(fligth_dates[i]['end']);
                if(moment($(this).val()) <= end)
                    ff.push(end.format('MM/DD/YYYY'));
            }
            ff.sort();
            for( var i in ff)
                html+='<option value="'+ff[i]+'">'+moment(ff[i]).format('MM/DD/YYYY')+'</option>';
            $('#end_date_comp').html(html);
        }
    });
    $('#media-report-preview').on('click', function(){
        submit_report('preview', $(this).attr('data-url'));
    });
    $('#media-report-dowload').on('click', function(){
        submit_report('download', $(this).attr('data-url'));
    });
    $('#report_type').on('change', function () {
        if($('#report_type option:selected').val()=='weekly' ) {
            $('#show_hiatus').attr('disabled', false);
            $('#show_week_budget').attr('disabled', false);
            $('#show_month_budget').attr('disabled', 'disabled');
        }
        else {
            $('#show_hiatus').attr('disabled', 'disabled');
            $('#show_week_budget').attr('disabled', 'disabled');
            $('#show_month_budget').attr('disabled', false);
        }
    });
    var submit_report= function(type, url){
        $('#campaign_id_mm').val(MainGrid.api.getSelectedNodes()[0].data.campaign_id);
        $('#version_sc').val(type);
        if($('#selected_medias').val().length ==0)
            global_notification('warning', 'Please select at least one media type');
       else if($('#selected_markets').val().length ==0)
            global_notification('warning', 'Please select at least one market');
       else {
            show_overlay_loader($('#mediaPlannerReportModal .modal-content'));
            var more_options=[];
            $('.options_check input[type=checkbox]').each(function(){
                if (this.checked)
                    more_options.push( $(this).val());
            });
            var params ={
                media_types: $('#selected_medias').val(),
                type:  $('#version_sc').val(),
                header_options: $('#header_options_sc').val(),
                markets: $('#selected_markets').val(),
                logo_option: $('#logo_option_mm option:selected').val(),
                more_options: more_options,
                campaign_id: $('#campaign_id_mm').val(),
                start: $('#start_date option:selected').val(),
                end: $('#end_date option:selected').val(),
                report_type: $('#report_type option:selected').val(),
                logo_option: $('#logo_option_mm option:selected').val()
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: url,
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    hide_overlay_loader($('#mediaPlannerReportModal .modal-content'));
                    if(type=='download')
                      exportToExcel(response, 'Campaign_Planner_Report_' + moment().format("Y-MM-d_H:m:s"));
                    else
                      var win = window.open("", "Planner Report", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1100,height=1000,top=100,left=100");
                    win.document.body.innerHTML = response;
                },
                error: function (xhr) {
                    ajax_error();
                    hide_overlay_loader($('#mediaPlannerReportModal .modal-content'));
                    debug(xhr.responseText);
                }
            });

        }
    }
    function exportToExcel(html, name="download"){
        //var url='data:application/vnd.ms-excel,' + encodeURIComponent(html);
        //location.href=url;
        var a = document.createElement('a');
        var data_type = 'data:application/vnd.ms-excel,' + encodeURIComponent(html);
        a.href = data_type;
        a.download = name + '.xls';
        a.click();
        e.preventDefault();
        return false;
    }

    $('#budget_planner').on('click', function () {
        if (MainGrid.api.getSelectedNodes().length == 0) {
            swal({
                    title: "Warning",
                    text: "Please select a campaign first.",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    //cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {}

                });
        }
        else {
            show_loader();
            $.ajax({
                type: 'GET',
                url: '/planner/get/campaign/budget/' + MainGrid.api.getSelectedNodes()[0].data.campaign_id,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    $('.div-budget').html('');
                     saved_budget=true;
                    $('.campaign-budget').html('Campaign Budget: '+ parseFloat(data.campaign_budget).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }));
                    var html = '';
                    var month_budget=[];
                    var xx=0;
                    for (var month in data.FD) {
                        month_budget[month]=0;
                        html += '<div style="margin-bottom: 3%; height: 150px"><table class="" style="width: 98%;height: 150px; background-color: #F7FAFC; border-top: 1px solid #E4E7EA; border-bottom: 1px solid #E4E7EA;">';
                        var month_name = moment('2019-' + month + '-01').format('MMMM');
                        html += '<tr><td style="width: 10%;padding-right: 10px; padding-left: 10px"><h5>' + month_name + '</h5></td> ' +
                            '<td colspan="5"  style="border-bottom: 1px double #678CB1; padding-right: 20px; padding-left: 10px"><h5 data-month-total="' + month + '" id="month_total_budget'+month+'">$0.00</h5></td> </tr>';
                        html += '<tr>';
                        html += '<td style="width: 10%"></td>';
                        for (var week in  data.FD[month]) {
                            var day = moment( data.FD[month][week]).format('MM/DD');
                            html += '<td style="width: 18%; padding-top: 10px; padding-right: 10px; padding-left: 10px"><h5>' + day + '</h5></td>'
                        }
                        if ( data.FD[month].length < 5) {
                            var m = parseInt(5 -  data.FD[month].length);
                            html += '<td colspan="' + m + '"></td>';
                        }
                        html += '</tr>';
                        html += '<tr>';
                        var checked='';
                        if(xx==0)
                            checked='checked';
                        xx++;
                        html += '<td style="width: 10%; padding-right: 10px; padding-left: 10px"><div class="radio radio-primary" >' +
                            '                                                <input type="radio" name="radio_month" id="month_' + month + '" '+checked+' value="'+month+'"><label for="month_' + month + '"> </label></div></td>';
                        for (var week in  data.FD[month]) {
                            var budget=(0).toFixed(2);
                            if(typeof data.budgets[month][data.FD[month][week]] !== 'undefined') {
                                budget = parseFloat(data.budgets[month][data.FD[month][week]]).toFixed(2);
                                month_budget[month]+= parseFloat(data.budgets[month][data.FD[month][week]]);
                            }
                            html += '<td style="width: 17%; padding-right: 10px; padding-left: 10px">' +
                                '<input type="text" placeholder="$0.00"  data-month="' + month + '" class="form-control full-width" name="' +  data.FD[month][week] + '" id="week_' +  data.FD[month][week] + '" value="$'+budget+'">' +
                                '</td>';
                        }
                        if ( data.FD[month].length < 5) {
                            var m = parseInt(5 -  data.FD[month].length);
                            html += '<td colspan="' + m + '"></td>';
                        }
                        html += '</tr>';
                        html += '<tr><td colspan="6" style="padding-bottom: 20px"></td></tr>';
                        html += '</table></div>';
                    }
                    $('.div-budget').html(html);
                    for (var month in data.FD) {
                        for (var week in  data.FD[month]) {
                            new AutoNumeric('.div-budget #week_' + data.FD[month][week] + '',
                                {
                                    currencySymbol: '$',
                                    minimumValue: 0,
                                    selectOnFocus: true,
                                    caretPositionOnFocus: null,
                                    digitGroupSeparator: ',',
                                    digitalGroupSpacing: '3',
                                    decimalCharacter: '.',
                                    allowDecimalPadding: true,
                                    showOnlyNumbersOnFocus: true,
                                    showWarnings: false,
                                });
                        }
                    }

                    form = $('#media_planner_budget_form');
                    form.find('.div-budget td input').unbind('keydown').bind('keydown', function (e) {
                        if($(this).attr('type')=='text') {
                            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
                                (e.keyCode == 65 && e.ctrlKey === true) ||
                                (e.keyCode >= 35 && e.keyCode <= 39)) {
                                return;
                            }
                            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                                e.preventDefault();
                            }
                        }
                    });
                    form.find('.div-budget td input').unbind('change').bind('change', function (e) {
                        if($(this).attr('type')==='text') {
                            saved_budget=false;
                            var total = 0;
                            var data_month = $(this).attr('data-month');
                            var total_detailed = 0;

                            $(".div-budget td input").each(function () {
                                if($(this).attr('type')==='text') {
                                    if ($(this).attr('data-month') == data_month) {
                                        var str = $(this).val().replace('$', '');
                                        str = str.replace(/,/g, '')
                                        if (!isNaN(parseFloat(str)))
                                            total += parseFloat(str);
                                    }
                                    var mx = $(this).val().replace('$', '');
                                    mx = mx.replace(/,/g, '');
                                    if (!isNaN(parseFloat(mx)))
                                        total_detailed += parseFloat(mx);
                                }
                            });
                            $('.detailed-budget').html('Detailed Budget: ' + parseFloat(total_detailed).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }));
                            $("#month_total_budget" + data_month + "").html(parseFloat(total).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }));
                        }
                    });
                    form.find('.div-budget td input').unbind('focusout').bind('focusout', function (e) {
                        if($(this).attr('type')=='text') {
                            this.value = this.value.replace('$', '');
                            this.value = this.value.replace(/,/g, '');
                            if (!isNaN(parseFloat(this.value).toFixed(2)))
                                this.value = '$0.0'
                            else
                                this.value = '$'+  this.value;

                        }
                    });
                    form.find('.div-budget td input').unbind('click').bind('click', function (e) {
                        if($(this).attr('type')=='text') {
                            this.value = this.value.replace('$', '');
                            this.value = this.value.replace(/,/g, '');
                            this.value = parseFloat(this.value).toFixed(2);
                            this.select();
                        }
                    });
                    var total_detailed_init= 0;
                    for(var i in  month_budget) {
                        total_detailed_init+=parseFloat(month_budget[i]);
                        $("#month_total_budget"+i+"").html(parseFloat(month_budget[i]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }));
                    }
                    $('.detailed-budget').html('Detailed Budget: '+ parseFloat(total_detailed_init).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }));
                    $('#mediaPlannerBudget').modal({backdrop: 'static', keyboard: false})
                    $('#mediaPlannerBudget').modal('show');
                    hide_loader();
                    $('#apply_average').on('click', function(){
                        swal({
                                title: "Warning",
                                text: "This action will replace the current week's budget. Are you sure to continue?",
                                type: "warning",
                                showCancelButton: true,
                                confirmButtonClass: "btn-danger",
                                confirmButtonText: "Continue",
                                cancelButtonText: 'Cancel',
                                closeOnConfirm: true,
                                closeOnCancel: true
                            },
                            function (isConfirm) {
                                if (isConfirm) {
                                    saved_budget=false;
                                    var average= parseFloat(data.campaign_budget / data.cont_weeks).toFixed(2);
                                    $(".div-budget td input").each(function () {
                                        if($(this).attr('type')==='text') {
                                            console.log($(this).attr('id'), $(this).val());
                                            $(this).val('$' + average);
                                            AutoNumeric.getAutoNumericElement('.div-budget #' + $(this).attr('id') + '');
                                            AutoNumeric.set('.div-budget #' + $(this).attr('id') + '',  $(this).val());

                                            console.log($(this).attr('id'), $(this).val());
                                        }


                                    });
                                    var month_totals=[];
                                    var total_detailed=0;
                                    $(".div-budget td input").each(function () {
                                        if($(this).attr('type')==='text') {
                                            if(!isNaN($(this).attr('data-month'))) {
                                                if (!(typeof month_totals[$(this).attr('data-month')] !== 'undefined'))
                                                    month_totals[$(this).attr('data-month')] = 0;
                                                var str = $(this).val().replace('$', '');
                                                str = str.replace(/,/g, '');
                                                if (!isNaN(parseFloat(str)))
                                                    month_totals[$(this).attr('data-month')] += parseFloat(str);
                                            }
                                        }
                                    });
                                    $.each(month_totals, function (index, value) {
                                            if(typeof value != 'undefined') {
                                                if (!isNaN(parseFloat(value)))
                                                    total_detailed += value;
                                                $("#month_total_budget" + index + "").html(parseFloat(value).toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "USD",
                                                    minimumFractionDigits: 2
                                                }));
                                            }
                                    });
                                    $('.detailed-budget').html('Detailed Budget: '+ parseFloat(total_detailed).toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "USD",
                                        minimumFractionDigits: 2
                                      })
                                    );
                                }
                            });
                    });
                    $('#apply_budget').on('click', function(){
                        swal({
                                title: "Warning",
                                text: "This action will replace the current week's budget for the non-selected months. Are you sure to continue?",
                                type: "warning",
                                showCancelButton: true,
                                confirmButtonClass: "btn-danger",
                                confirmButtonText: "Continue",
                                cancelButtonText: 'Cancel',
                                closeOnConfirm: true,
                                closeOnCancel: true
                            },
                            function (isConfirm) {
                                if (isConfirm) {
                                    var month_to= $('input:radio[name=radio_month]:checked').val();
                                    var values=[];
                                    var month_totals=[];
                                    var total_detailed=0;
                                    saved_budget=false;
                                    $(".div-budget td input").each(function () {
                                        if($(this).attr('type')==='text') {
                                            if (!isNaN($(this).attr('data-month')) && $(this).attr('data-month') == month_to)
                                                values.push($(this).val());
                                        }
                                    });
                                    for(var i in data.FD){
                                        if(i !== month_to){
                                            for(var x in data.FD[i]){
                                                console.log('inside cycle');
                                                if(typeof values[x] !== 'undefined') {
                                                    $("#week_" + data.FD[i][x] + "").val(values[x]);
                                                    AutoNumeric.getAutoNumericElement('.div-budget #week_' + data.FD[i][x] + '');
                                                    AutoNumeric.set('.div-budget #week_' + data.FD[i][x] + '',  values[x]);
                                                }

                                            }
                                        }
                                    }
                                    $(".div-budget td input").each(function () {
                                        if($(this).attr('type')==='text') {
                                            if (!(typeof month_totals[$(this).attr('data-month')] !== 'undefined') && !isNaN($(this).attr('data-month')))
                                                month_totals[$(this).attr('data-month')] = 0;
                                            if (!isNaN($(this).attr('data-month')) && $(this).attr('data-month') == month_to) {
                                                values.push($(this).val());
                                            }
                                            var str = $(this).val().replace('$', '');
                                            str = str.replace(/,/g, '');
                                            if (!isNaN(parseFloat(str)))
                                                month_totals[$(this).attr('data-month')] += parseFloat(str);
                                        }
                                    });
                                    $.each(month_totals, function (index, value) {
                                        if(typeof value != 'undefined') {
                                            if (!isNaN(parseFloat(value)))
                                                total_detailed += value;
                                            $("#month_total_budget" + index + "").html(parseFloat(value).toLocaleString("en-US", {
                                                style: "currency",
                                                currency: "USD",
                                                minimumFractionDigits: 2
                                            }));
                                        }
                                    });
                                    $('.detailed-budget').html('Detailed Budget: '+ parseFloat(total_detailed).toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "USD",
                                        minimumFractionDigits: 2
                                    })
                                    );
                                }
                            });
                    });
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
    });
    $('#budget_close').on('click', function () {
        if(saved_budget == false){
            swal({
                    title: "Warning",
                    text: "The changes you made may not be saved. Are you sure to continue?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Continue",
                    cancelButtonText: 'Cancel',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm){
                        $('#mediaPlannerBudget').modal('hide');
                    }
                });
        }
        else
            $('#mediaPlannerBudget').modal('hide');
    });
    $('.budget_close_top').on('click', function () {
        if(saved_budget === false){
            swal({
                    title: "Warning",
                    text: "The changes you made may not be saved. Are you sure to continue?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Continue",
                    cancelButtonText: 'Cancel',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm){
                        $('#mediaPlannerBudget').modal('hide');
                    }
                });
        }
        else
            $('#mediaPlannerBudget').modal('hide');
    });
    $('#media_planner_budget_save').on('click', function (){
        swal({
                title: "Warning",
                text: "Are you sure to continue?",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Continue",
                cancelButtonText: 'Cancel',
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm){
                   show_overlay_loader($('#mediaPlannerBudget .modal-content'));
                   $('#budget_cam_hiden').val(MainGrid.api.getSelectedNodes()[0].data.campaign_id);
                   var url= $('#media_planner_budget_save').attr('data-url');
                   var data= $('#media_planner_budget_form').serializeArray();
                    $.ajax({
                        type: 'POST',
                        url: url,
                        data: data,
                        dataType: 'json',
                        encode: true,
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                        success: function (response) {
                            global_notification('success', 'Media Planner Budget saved');
                            hide_overlay_loader($('#mediaPlannerBudget .modal-content'));
                            $('#mediaPlannerBudget').modal('hide');
                        },
                        error: function (xhr) {
                            hide_overlay_loader($('#mediaPlannerBudget .modal-content'));
                            ajax_error();
                            debug(xhr.responseText);
                        }
                    });
                }
            });
    });

   $('.show_current_month').on('click', function () {
       var type= $(this).attr('data-type');
       main_grid_type='current_month';
       $('#range_date_div').html('Broadcast Month: '+ moment().format('MMMM  YYYY'));

       var html=' <button type="button" class="btn btn-info btn-outline" style="border: none; background-color: white; color: #41B1E1; font-size: 15px;">' +
           '                                   <i class="fa fa fa-angle-double-left"  style="font-size: 30px; color: #41B1E1; cursor: pointer; ">   </i>  Previous Month' +
           '                                   </button>';
       var html_1='  <button type="button" class="btn btn-info btn-outline" style="border: none; background-color: white; color: #41B1E1; font-size: 15px;  text-align: center;">' +
           '                                    Next Month  <i  class="fa fa fa-angle-double-right"  style="font-size: 30px; color: #41B1E1; cursor: pointer; ">  </i>' +
           '                                </button>';
       $('#previous_main_grid').html(html);
       $('#next_main_grid').html(html_1);
       $('#previous_main_grid').show();
       $('#next_main_grid').show();
       show_data(type);
   });
   $('.show_current_quarter').on('click', function () {
        var type= $(this).attr('data-type');
        main_grid_type='current_quarter';
       $('#range_date_div').html(months_quarter_div);
       var html=' <button type="button" class="btn btn-info btn-outline" style="border: none; background-color: white; color: #41B1E1; font-size: 15px;">' +
           '                                   <i class="fa fa fa-angle-double-left"  style="font-size: 30px; color: #41B1E1; cursor: pointer; ">   </i>  Previous Quarter' +
           '                                   </button>';
       var html_1='  <button type="button" class="btn btn-info btn-outline" style="border: none; background-color: white; color: #41B1E1; font-size: 15px;  text-align: center;">' +
           '                                    Next Quarter  <i  class="fa fa fa-angle-double-right"  style="font-size: 30px; color: #41B1E1; cursor: pointer; ">  </i>' +
           '                                </button>';
       $('#previous_main_grid').html(html);
       $('#next_main_grid').html(html_1);
       $('#previous_main_grid').show();
       $('#next_main_grid').show();
        show_data(type);
    });
   $('.show_current_year').on('click', function () {
        var type= $(this).attr('data-type');
        main_grid_type='current_year';
       $('#range_date_div').html('Year:   '+  moment().format('YYYY'));

       var html=' <button type="button" class="btn btn-info btn-outline" style="border: none; background-color: white; color: #41B1E1; font-size: 15px;">' +
           '                                   <i class="fa fa fa-angle-double-left"  style="font-size: 30px; color: #41B1E1; cursor: pointer; ">   </i>  Previous Year' +
           '                                   </button>';
       var html_1='  <button type="button" class="btn btn-info btn-outline" style="border: none; background-color: white; color: #41B1E1; font-size: 15px;  text-align: center;">' +
           '                                    Next Year  <i  class="fa fa fa-angle-double-right"  style="font-size: 30px; color: #41B1E1; cursor: pointer; ">  </i>' +
           '                                </button>';
       $('#previous_main_grid').html(html);
       $('#next_main_grid').html(html_1);
       $('#previous_main_grid').show();
       $('#next_main_grid').show();
       show_data(type);
    });
    var addAEvent=  function (){
        $('hide-column a').unbind();
        $('.hide-column a').bind('click', function (e) {
            if ($(this).hasClass('hidden-column')) {
                MainGrid.columnApi.setColumnVisible($(this).attr('data-col'), true);
                $(this).removeClass('hidden-column');
                if(typeof hidden_columns_main_grid[$(this).attr('data-col')] !== 'undefined')
                    hidden_columns_main_grid[$(this).attr('data-col')] = 1;
            } else {
                MainGrid.columnApi.setColumnVisible($(this).attr('data-col'), false);
                $(this).addClass('hidden-column');
                if(typeof hidden_columns_main_grid[$(this).attr('data-col')] !== 'undefined')
                    hidden_columns_main_grid[$(this).attr('data-col')] = 0;
            }
            e.stopPropagation();
        });

    }

   $('.show_custom').on('click', function () {
        var zIndexModal=  $('#customDateRange').css('z-index');
        var input = $("#search_fd");

        if (input.data('daterangepicker')) {
            input.data('daterangepicker').remove();
        }

        input.daterangepicker({
            "showWeekNumbers": true,
            "autoApply": true,
            'z-index': zIndexModal + 1,
            "linkedCalendars": false,
            "dateLimit": {
                "weeks": 53
            },
            "locale": {
                "format": "MM/DD/YYYY",
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "#",
                "daysOfWeek": [
                    "U",
                    "M",
                    "T",
                    "W",
                    "R",
                    "F",
                    "S"
                ],
                "firstDay": 1
            }
        }).val('');
        $('#customDateRange').modal('show');
    });

   function show_data(type) {
       show_loader();
       $.ajax({
           type: 'GET',
           url: '/planner/show/data/time/' + type,
           dataType: 'json',
           encode: true,
           success: function (data) {
               broadcast_month_weeks= data.broadcast_week;
               broadcast_week= data.broadcast_week;
               campaign_hiatus=data.hiatus;
               campaigns_finally=data.campaign_finally;
               months_quarter=data.months;
               if(type=='current_year')
                   reloadAnualMainGrid(moment().year());
               else
                   reloadMainGrid();
               var html_hide='';
               if(hidden_columns_main_grid.advertiser_name == 1)
                   html_hide+= '<li><a  data-col="advertiser_name">Advertiser</a></li>';
               else
                   html_hide += '<li><a  data-col="advertiser_name" class="hidden-column" >Advertiser</a></li>';
               if(hidden_columns_main_grid.fd_start == 1)
                   html_hide += '<li><a  data-col="fd_start">Start</a></li>';
               else
                   html_hide += '<li><a  data-col="fd_start" class="hidden-column">Start</a></li>';
               if(hidden_columns_main_grid.fd_end == 1)
                   html_hide += '<li><a  data-col="fd_end">End</a></li>';
               else
                   html_hide += '<li><a  data-col="fd_end" class="hidden-column">End</a></li>';
               if(hidden_columns_main_grid.budget == 1)
                   html_hide +=' <li><a  data-col="budget">Budget</a></li>';
               else
                   html_hide +=' <li><a  data-col="budget" class="hidden-column">Budget</a></li>';
               if(hidden_columns_main_grid.percent == 1)
                   html_hide += '<li><a  data-col="percent">Completed %</a></li>';
               else
                   html_hide += '<li><a  data-col="percent" class="hidden-column">Completed %</a></li>';

                // html_hide= '<li><a  data-col="advertiser_name">Advertiser</a></li>' +
                //    '                                        <li><a  data-col="fd_start">Start</a></li>' +
                //    '                                        <li><a  data-col="fd_end">End</a></li>' +
                //    '                                        <li><a  data-col="budget">Budget</a></li>' +
                //    '                                        <li><a  data-col="percent">Completed %</a></li>';
               for(var month in broadcast_week){
                   for(var week in broadcast_week[month]) {
                       var name= moment(broadcast_week[month][week]).format('MMMM')+'/';
                       var str= name+ moment(broadcast_week[month][week]).format('DD');
                       html_hide += '<li><a class="hide_a" data-col="week_'+broadcast_week[month][week]+'">'+str+'</a></li>'
                   }
               }
               $('#hide_columns').html(html_hide);
               addAEvent();
               hide_loader();
           },
           error: function (xhr) {
               hide_loader();
               ajax_error();
               debug(xhr.responseText);
           }
       });
   };
   function reloadMainGrid() {
       $('#keywordsFIlter').val('');
       $('#keywords').val('');
       $('#reset_filters').hide();
        mainColumnDefTotals=[{
           campaign_id: '',
           fd_start: '',
           fd_end: '',
           campaign_total: '',
       }];
        mainColumnDef = [
           {
               headerName: '',
               headerTooltip: '',
               groupId: 'row_he',
               headerClass: 'campaign_header',
               children: [
                   {
                       headerName: '',
                       headerTooltip: '',
                       groupId: 'row_he_he',
                       headerClass: 'campaign_header',
                       children: [
                           {
                               headerName: '',
                               headerTooltip: '',
                               field: 'row_select',
                               pinned: 'left',
                               width: 50,
                               editable: false,
                               cellRenderer: 'agGroupCellRenderer',
                               checkboxSelection: true,
                               cellRendererParams: {
                                   //checkbox: true
                               },
                               suppressFilter: true,
                               suppressMovable: true,
                               suppressResize: true,
                               suppressNavigable: true,
                               suppressSorting: true,
                               required: true,
                               headerClass: 'weeks',
                               // cellClass:'cells',
                               cellStyle: changeRowColor,
                           }
                       ],
                   },
               ]
           },
           {
               headerName: '',
               headerTooltip: '',
               groupId: 'campaign_data',
               headerClass: 'campaign_header',
               children: [
                   {
                       headerName: '',
                       headerTooltip: '',
                       groupId: 'campaign_data_data',
                       headerClass: 'campaign_header',
                       children: [ {
                           headerName: "Campaign",
                           field: 'campaign_name',
                           pinned: 'left',
                           suppressMovable: true,
                           minWidth: 50,
                           width:162,
                           editable: true,
                           filter: 'set',
                           required: true,
                           //  cellStyle: {'text-align': "left", 'font-size':'14px', 'border-right': "1px solid black", 'border-rop': "1px solid black"},
                           headerClass: 'weeks',
                           cellClass:'cells',
                           cellStyle: changeRowColor,
                           //cellRenderer:'agGroupCellRenderer'
                       },
                           {
                               headerName: "Advertiser",
                               field: 'advertiser_name',
                               pinned: 'left',
                               suppressMovable: true,
                               minWidth: 50,
                               width:162,
                               filter: 'set',
                               cellStyle: changeRowColor,
                               //cellRenderer:'agGroupCellRenderer'
                               pinned: 'left',
                               headerClass: 'weeks',
                               hide: (hidden_columns_main_grid.advertiser_name == 1) ? false : true,

                           },
                           {
                               headerName: "",
                               field: 'campaign_id',
                               width: 100,
                               pinned: 'left',
                               //cellStyle: {'text-align': "right"},
                               headerClass: 'weeks',
                               hide:true,
                               cellStyle: changeRowColor,
                               suppressMovable: true,
                           },
                           {
                               headerName: "Start",
                               field: 'fd_start',
                               width: 100,
                               pinned: 'left',
                               suppressMovable: true,
                               cellStyle: changeRowColor,
                               headerClass: 'weeks',
                               hide: (hidden_columns_main_grid.fd_start == 1) ? false : true,
                           },
                           {
                               headerName: "End",
                               field: 'fd_end',
                               width: 100,
                               cellStyle: {'text-align': "right"},
                               pinned: 'left',
                               headerClass: 'weeks',
                               suppressMovable: true,
                               cellStyle: changeRowColor,
                               hide: (hidden_columns_main_grid.fd_end == 1) ? false : true,
                           },
                           {
                               headerName: "Budget",
                               field: 'budget',
                               width: 80,
                               cellStyle: {'text-align': "right"},
                               pinned: 'left',
                               headerClass: 'weeks',
                               suppressMovable: true,
                               cellStyle: changeRowColor,
                               hide: (hidden_columns_main_grid.budget == 1) ? false : true,
                           },
                           {
                               headerName: "Completed %",
                               field: 'percent',
                               width: 100,
                               cellStyle: {'text-align': "right"},
                               pinned: 'left',
                               headerClass: 'weeks',
                               suppressMovable: true,
                               cellStyle: changeRowColor,
                               hide: (hidden_columns_main_grid.percent == 1) ? false : true,
                           },
                       ],
                   },
               ],
           },
       ];
        weeks_array=[];
        months_header = {
           headerName: 'Quarter',
           headerTooltip: 'Quarter',
           groupId: 'quarters',
           children: [],
           headerClass: 'quarters',
       }
       for (var month in broadcast_week) {
           var month_y = $.extend({}, ws_global_column_definitions.group_months);
           month_y.group_id = month;
           month_y.headerName = moment('2019-' + month + '-01').format('MMMM');
           month_y.headerTooltip += moment('2019-' + month + '-01').format('MMMM');
           if (broadcast_week[month].length == 4)
               month_y.width = '400';
           if (broadcast_week[month].length == 5)
               month_y.width = '500';
           month_y.headerClass= 'months';
           month_y.children=[];
           for (var xx in broadcast_week[month]) {
               var week_y = $.extend({}, ws_global_column_definitions.week);
               week_y.headerName = moment( broadcast_week[month][xx]).format('DD');
               week_y.headerTooltip += moment( broadcast_week[month][xx]).format('YYYY-MM-DD');
               week_y.field ='week_'+ moment( broadcast_week[month][xx]).format('YYYY-MM-DD');
               weeks_array.push('week_'+ moment( broadcast_week[month][xx]).format('YYYY-MM-DD'));
               weeks_broadcast_month['week_'+ moment( broadcast_week[month][xx]).format('YYYY-MM-DD')]=month;
               week_y.headerClass= 'weeks';
               week_y.cellStyle= changeRowColor;
               week_y.cellClassRules= {
                   'hover-week-change': function(params) {
                       if (params.node.rowPinned != 'top' && (typeof params.data.campaign_id !== 'undefined')) {
                           var camp = params.data.campaign_id;
                           var field = params.colDef.headerTooltip;
                           if (typeof campaigns_finally[camp] !== "undefined" && campaigns_finally[camp]['weeks'].length > 0) {
                               if (campaigns_finally[camp]['weeks'].indexOf(field) !== -1) {
                                   return true;
                               }
                           }
                       }
                       return false;
                   }
               },
               week_y.suppressMovable= true;
               month_y.children.push(week_y);
           }
           months_header.children.push(month_y);
       }
       for (var s in weeks_array)
           mainColumnDefTotals[0][weeks_array[s]] = '';
        mainColumnDefTotals=[{
           campaign_id: '',
           fd_start: '',
           fd_end: '',
       }];
       mainColumnDef.push(months_header);
       mainColumnDef.push(
           {
               headerName: '',
               headerTooltip: '',
               groupId: 'campaign_data_total',
               headerClass: 'campaign_header',
               children: [
                   {
                       headerName: '',
                       headerTooltip: '',
                       groupId: 'campaign_data_data_total',
                       headerClass: 'campaign_header',
                       children: [

                           {
                               headerName: "Total",
                               field: 'campaign_total',
                               pinned: 'right',
                               suppressMovable: true,
                               minWidth: 50,
                               width: 120,
                               editable: false,
                               filter: 'set',
                               required: true,
                               //  cellStyle: {'text-align': "left", 'font-size':'14px', 'border-right': "1px solid black", 'border-rop': "1px solid black"},
                               headerClass: 'weeks',
                               cellClass:'cells',
                               cellStyle: changeRowColor,
                               valueGetter: function getTtotal(params) {
                                   var tot = 0;
                                   $.each(params.data, function (index, value) {
                                       if(typeof index !== 'undefined' && index.indexOf('week_') > -1){
                                           var val = (typeof value.split("$")[1] !== 'undefined') ? value.split("$")[1] : "0";
                                           tot += parseFloat(val.replace(",",""));
                                       }else{
                                       }
                                   });
                                   return parseFloat(tot).toLocaleString("en-US", {
                                       style: "currency",
                                       currency: "USD",
                                       minimumFractionDigits: 2
                                   });
                               },
                               //cellRenderer:'agGroupCellRenderer'
                           },
                       ],
                   },
               ],
           }
       );
       MainGrid = {
           enableFilter: true,
           enableSorting: true,
           columnDefs: mainColumnDef,
           defaultColDef: {
               suppressToolPanel: true
           },
           toolPanelSuppressValues: true,defaultToolPanel: '',
           pinnedTopRowData: mainColumnDefTotals,
           headerHeight: 20,
           rowHeight: 20,
           stopEditingWhenGridLosesFocus: true,
           suppressRowClickSelection: true,
           defaultColDef: {
               suppressToolPanel: true
           },
           groupColumnDef: {
               cellRenderer: 'agGroupCellRenderer',
               headerName: 'Campaign',
               cellRendererParams: {
                   suppressCount: true,
                   suppressFilter: true,
               },
               width: 150,
               max_width: 300,
               pinned: 'left',
               suppressFilter: true,
           },
           enableColResize: true,
           marryChildren: true,
           suppressAggFuncInHeader: true,
           enableFilter: true,
           enableSorting: true,
           animateRows: true,
           rowSelection: 'single',
           //  suppressRowClickSelection: false,
           icons: {
               groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
               groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
               menu: '<i class="fa fa-bars fa-lg"/>',
               sortAscending: '<i class="fa fa-caret-down"/>',
               sortDescending: '<i class="fa fa-caret-up"/>',
               columnMoveMove: '<i class="fa fa-arrows"></i>',
               columnMovePin: '<i class="fa fa-thumb-tack"></i>',
               columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
               columnMoveRight: '<i class="fa fa-arrow-right"></i>',
               columnMoveHide: '<i class="fa fa-remove"/>'
           },
           //  getContextMenuItems: getContextMenuItemsInvoice,
           onGridReady: function (e){
           },
           onSelectionChanged: function (e) {
           },
           onCellClicked: function (e) {
               if(e.node.rowPinned !== 'top') {
                    array_to_allocate = {
                       tv: {total: 0, grp: 0},
                       radio: {total: 0, grp: 0},
                       print: {total: 0, grp: 0},
                       digital: {total: 0, grp: 0},
                       mail: {total: 0, grp: 0},
                       ooh: {total: 0, grp: 0},
                       other: {total: 0, grp: 0},
                       ott: {total: 0, grp: 0},
                   };
                   $('#tv_dp_refresh_grp').hide();
                   $('#radio_dp_refresh_grp').hide();
                   $('#print_refresh_grp').hide();
                   $('#digital_refresh_grp').hide();
                   $('#mail_refresh_grp').hide();
                   $('#ooh_refresh_grp').hide();
                   $('#other_refresh_grp').hide();
                   $('#ott_refresh_grp').hide();
                   var w = e.colDef.field.split('week_');
                   if (typeof w[1] !== 'undefined' && campaigns_finally[e.data.campaign_id]['weeks'].indexOf(e.colDef.headerTooltip) !== -1)
                       showCampPlanner(e.data.campaign_id, e.colDef.headerTooltip, weeks_broadcast_month[e.colDef.field], e.colDef.field, e)
               }
           },
           onCellValueChanged: function (e) {
               if(e.node.rowPinned !== 'top') {
                   var floating_top_row = MainGrid.api.pinnedRowModel.pinnedTopRows[0];
                   var xx = e.colDef.field;
                   var total = 0;
                   MainGrid.api.forEachNodeAfterFilterAndSort(function (node) {
                       var spl = node.data[xx].split('$');
                       if (typeof spl[1] !== 'undefined')
                           total += parseFloat(spl[1].replace(",", ""));
                       else {
                           if (typeof node.data[xx] !== 'undefined' && node.data[xx] !== '') {
                               if (!isNaN(node.data[xx]))
                                   total += parseFloat(node.data[xx].replace(",", ""))
                           }
                       }
                   });
                   floating_top_row.data[xx] = parseFloat(total).toLocaleString("en-US", {
                       style: "currency",
                       currency: "USD",
                       minimumFractionDigits: 2
                   });
                   var tot = 0;
                   $.each(e.data, function (index, value) {
                       if (typeof index !== 'undefined' && index.indexOf('week_') > -1) {
                           var val = (typeof value.split("$")[1] !== 'undefined') ? value.split("$")[1] : "0";
                           tot += parseFloat(val.replace(",", ""));
                       }
                   });
                   e.data['campaign_total'] = parseFloat(tot).toLocaleString("en-US", {
                       style: "currency",
                       currency: "USD",
                       minimumFractionDigits: 2
                   });
                   //MainGrid.api.refreshCells([floating_top_row, e.node]);
                   MainGrid.api.refreshCells({rowNodes: [floating_top_row, e.node], columns: [e.colDef.field, 'campaign_total'], force: true});
                   // MainGrid.api.pinnedRowModel.pinnedTopRows[0].setDataValue(xx, total);
               }
           },
           onItemsAdded: function (e) {
           },
           onCellFocused: function (e) {
           },
           onCellEditingStarted: function (e) {
           },
           onRowSelected: function (e) {
           },
           onCellEditingStopped: function (e) {
           },
           onCellMouseOver: function (e) {
               // if(e.node.rowPinned !== 'top') {
               //     console.log('********************************** get in to onCellMouseOver reloadMainGrid');
               //     var w = e.colDef.field.split('week_');
               //     if (typeof w[1] !== 'undefined' && campaigns_finally[e.data.campaign_id]['weeks'].indexOf(e.colDef.headerTooltip) !== -1) {
               //         e.colDef.cellStyle = {backgroundColor: '#F0B27A', cursor: 'pointer'};
               //         MainGrid.api.refreshCells([e.node], [e.colDef.field]);
               //     }
               // }
           },
           onCellMouseOut: function (e) {
               // if(e.node.rowPinned !== 'top') {
               //     var w = e.colDef.field.split('week_');
               //     if (typeof w[1] !== 'undefined' && campaigns_finally[e.data.campaign_id]['weeks'].indexOf(e.colDef.headerTooltip) !== -1) {
               //         e.colDef.cellStyle = changeRowColor;
               //         MainGrid.api.refreshCells([e.node], [e.colDef.field]);
               //     }
               // }
           },
           onFilterChanged: function (e) {
               if (this.api.isAnyFilterPresent())
                   $('#reset_filters').show();
               else
                   $('#reset_filters').hide();
               var floating_top_row = MainGrid.api.pinnedRowModel.pinnedTopRows[0];
               var total_maingrid={};

               for(var month in broadcast_week){
                   for(var week in broadcast_week[month])
                       total_maingrid['week_'+broadcast_week[month][week]]=0;
               }
               var columns=[];
               for(var column in total_maingrid) {
                   MainGrid.api.forEachNodeAfterFilterAndSort(function (node) {
                       var expl= node.data[column].split('$');
                       if(typeof(expl[1] !== 'undefined') && !isNaN(parseFloat(expl[1]))) {
                           var com= expl[1].replace(",","")
                           total_maingrid[column] += parseFloat((com));
                       }
                   });
                   floating_top_row.data[column]= parseFloat(total_maingrid[column]).toLocaleString("en-US", {
                       style: "currency",
                       currency: "USD",
                       minimumFractionDigits: 2
                   });
                   columns.push(column);
               }
               columns.push(column);
              // MainGrid.api.refreshCells([floating_top_row]);
               MainGrid.api.refreshCells({rowNodes: [floating_top_row], columns: columns, force: true});
           }
       };

       MainGrid.rowData = [];
       var totals_array=[];
       for (var m in weeks_array)
           totals_array[weeks_array[m]] = 0;
       for (var camp_id in campaigns_finally) {
           var bud= parseFloat(campaigns_finally[camp_id].budget).toLocaleString("en-US", {
               style: "currency",
               currency: "USD",
               minimumFractionDigits: 2
           });
           var values = {
               int_id: camp_id,
               campaign_id: camp_id,
               campaign_name: campaigns_finally[camp_id].name.toUpperCase(),
               advertiser_name: campaigns_finally[camp_id].advertiser,
               fd_start: moment(campaigns_finally[camp_id].start).format('MM/DD/YYYY'),
               fd_end: moment(campaigns_finally[camp_id].end).format('MM/DD/YYYY'),
               //   market_id: $('#campaign_market option:selected').val(),
               budget: bud ,
               percent: parseFloat(campaigns_finally[camp_id].percent).toFixed(1),
           };
           for (var y in weeks_array) {
               values[weeks_array[y]] = '';
               var ww = weeks_array[y].split('week_');
               if( typeof campaigns_finally[camp_id]['planner'][ww[1]] !== 'undefined') {
                   values[weeks_array[y]] = parseFloat(campaigns_finally[camp_id]['planner'][ww[1]]).toLocaleString("en-US", {
                       style: "currency",
                       currency: "USD",
                       minimumFractionDigits: 2
                   });
                   totals_array[weeks_array[y]]+= campaigns_finally[camp_id]['planner'][ww[1]];
               }
               else if(campaigns_finally[camp_id]['weeks'].indexOf(ww[1]) !== -1) {
                   values[weeks_array[y]] =parseFloat(0).toLocaleString("en-US", {
                       style: "currency",
                       currency: "USD",
                       minimumFractionDigits: 2
                   });
               }
           }
           if(typeof campaign_hiatus[camp_id] !== 'undefined') {
               for (var i in weeks_array) {
                   var hiatus= weeks_array[i].split('week_');
                   if (campaign_hiatus[camp_id].indexOf(hiatus[1]) !== -1)
                       values[weeks_array[i]] = 'H';
               }
           }
           MainGrid.rowData.push(values);
       }
       $('#mainGrid').html("");
       var MainGridGrid = document.querySelector('#mainGrid');
       var g5 = new agGrid.Grid(MainGridGrid, MainGrid);
       var array=[{}];
       for(var x in totals_array) {
           array[0][x] = parseFloat(totals_array[x]).toLocaleString("en-US", {
               style: "currency",
               currency: "USD",
               minimumFractionDigits: 2
           });
       }
       MainGrid.api.setPinnedTopRowData([array[0]]);

   }
   function reloadAnualMainGrid(cu_year) {
       $('#keywordsFIlter').val('');
       $('#keywords').val('');
       $('#reset_filters').hide();
        mainColumnDefTotals=[{
           campaign_id: '',
           fd_start: '',
           fd_end: '',
           campaign_total: '',
       }];
       ws_global_column_definitions = {
           'week': {
               headerName: '',
               headerTooltip: '',
               field: 'week_',
               editable: false,
               minWidth: 35,
               width: 100,
               required: false
           },
           'group_months': {
               headerName: 'Months',
               headerTooltip: 'Months',
               groupId: 'month_',
               children: [],
               headerClass: 'quarters'
           },
            'group_quarters': {
                headerName: 'Quarters',
                headerTooltip: 'Quarter',
                groupId: 'quarters_',
                children: [],
                headerClass: 'quarters2',
            }
       }
       months_header = {
           headerName: '',
           headerTooltip: '',
           groupId: 'year',
           children: [],
           headerClass: 'year',
       }
       var curr_year= cu_year;
       mainColumnDef = [
           {
               headerName: '',
               headerTooltip: '',
               groupId: 'row_he',
               headerClass: 'campaign_header',
               children: [
                   {
                       headerName: '',
                       headerTooltip: '',
                       groupId: 'row_he_he',
                       headerClass: 'campaign_header',
                       children: [
                           {
                               headerName: '',
                               headerTooltip: '',
                               groupId: 'row_he_he',
                               headerClass: 'campaign_header',
                               children: [
                                   {
                                       headerName: '',
                                       headerTooltip: '',
                                       field: 'row_select',
                                       pinned: 'left',
                                       width: 50,
                                       editable: false,
                                       cellRenderer: 'agGroupCellRenderer',
                                       checkboxSelection: true,
                                       cellRendererParams: {
                                           //checkbox: true
                                       },
                                       suppressFilter: true,
                                       suppressMovable: true,
                                       suppressResize: true,
                                       suppressNavigable: true,
                                       suppressSorting: true,
                                       required: true,
                                       headerClass: 'weeks',
                                       // cellClass:'cells',
                                       cellStyle: changeRowColor,
                                   }
                               ],
                           },
                       ],
                   },
               ]
           },
           {
               headerName: '',
               headerTooltip: '',
               groupId: 'campaign_data',
               headerClass: 'campaign_header',
               children: [
                   {
                       headerName: '',
                       headerTooltip: '',
                       groupId: 'campaign_data',
                       headerClass: 'campaign_header',
                       children: [
                           {
                               headerName: '',
                               headerTooltip: '',
                               groupId: 'campaign_data_data',
                               headerClass: 'campaign_header',
                               children: [ {
                                   headerName: "Campaign",
                                   field: 'campaign_name',
                                   pinned: 'left',
                                   suppressMovable: true,
                                   minWidth: 50,
                                   width:162,
                                   editable: true,
                                   filter: 'set',
                                   required: true,
                                   //  cellStyle: {'text-align': "left", 'font-size':'14px', 'border-right': "1px solid black", 'border-rop': "1px solid black"},
                                   headerClass: 'weeks',
                                   cellClass:'cells',
                                   cellStyle: changeRowColor,
                                   //cellRenderer:'agGroupCellRenderer'
                               },
                                   {
                                       headerName: "Advertiser",
                                       field: 'advertiser_name',
                                       pinned: 'left',
                                       suppressMovable: true,
                                       minWidth: 50,
                                       width:162,
                                       filter: 'set',
                                       cellStyle: changeRowColor,
                                       //cellRenderer:'agGroupCellRenderer'
                                       pinned: 'left',
                                       headerClass: 'weeks',
                                       cellStyle: changeRowColor,
                                       hide: (hidden_columns_main_grid.advertiser_name == 1) ? false : true,

                                   },
                                   {
                                       headerName: "",
                                       field: 'campaign_id',
                                       width: 100,
                                       pinned: 'left',
                                       //cellStyle: {'text-align': "right"},
                                       headerClass: 'weeks',
                                       suppressMovable: true,
                                       hide:true,
                                       cellStyle: changeRowColor,
                                   },
                                   {
                                       headerName: "Start",
                                       field: 'fd_start',
                                       width: 100,
                                       pinned: 'left',
                                       cellStyle: changeRowColor,
                                       suppressMovable: true,
                                       headerClass: 'weeks',
                                       suppressMovable: true,
                                       hide: (hidden_columns_main_grid.fd_start == 1) ? false : true,
                                   },
                                   {
                                       headerName: "End",
                                       field: 'fd_end',
                                       width: 100,
                                       cellStyle: {'text-align': "right"},
                                       pinned: 'left',
                                       headerClass: 'weeks',
                                       cellStyle: changeRowColor,
                                       suppressMovable: true,
                                       hide: (hidden_columns_main_grid.fd_end == 1) ? false : true,
                                   },
                                   {
                                       headerName: "Budget",
                                       field: 'budget',
                                       width: 80,
                                       cellStyle: {'text-align': "right"},
                                       pinned: 'left',
                                       headerClass: 'weeks',
                                       cellStyle: changeRowColor,
                                       suppressMovable: true,
                                       hide: (hidden_columns_main_grid.budget == 1) ? false : true,
                                   },
                                   {
                                       headerName: "Completed %",
                                       field: 'percent',
                                       width: 100,
                                       cellStyle: {'text-align': "right"},
                                       pinned: 'left',
                                       headerClass: 'weeks',
                                       cellStyle: changeRowColor,
                                       suppressMovable: true,
                                       hide: (hidden_columns_main_grid.percent == 1) ? false : true,
                                   },
                               ],
                           },
                       ],
                   },
               ],
           },
       ];

       var array=[1,2,3];
       var array_to=[];
       array_to.push([1,2,3,4]);
       array_to.push([5,6,7,8]);
       array_to.push([9,10,11,12]);
       weeks_array=[];
       for(var xxx in array) {
           var quarter_y = $.extend({}, ws_global_column_definitions.group_quarters);
           var val= parseInt(xxx ) + 1 ;
           quarter_y.group_id = xxx;
           quarter_y.headerName = 'Quarter ' + val + '/' + curr_year;
           quarter_y.headerTooltip += 'Quarter ' + val + '/' + curr_year;
           quarter_y.headerClass = 'quarters2';
           quarter_y.children = [];
           for (var month in broadcast_week) {
               if((xxx == 0 && (month == 1 || month == 2 || month == 3 || month == 4) ) || (xxx == 1 && (month == 5 || month == 6 || month ==7 || month == 8)) || (xxx == 2 && (month == 9 || month == 10 || month == 11 || month == 12)) ) {
                   var month_y = $.extend({}, ws_global_column_definitions.group_months);
                   month_y.group_id = month;
                   month_y.headerName = moment('2019-' + month + '-01').format('MMMM');
                   month_y.headerTooltip += moment('2019-' + month + '-01').format('MMMM');
                   if (broadcast_week[month].length == 4)
                       month_y.width = '400';
                   if (broadcast_week[month].length == 5)
                       month_y.width = '500';
                   month_y.headerClass = 'months';
                   month_y.children = [];
                   quarter_y.children.push(month_y);
                   for (var xx in broadcast_week[month]) {
                       var week_y = $.extend({}, ws_global_column_definitions.week);
                       week_y.headerName = moment(broadcast_week[month][xx]).format('DD');
                       week_y.headerTooltip += moment(broadcast_week[month][xx]).format('YYYY-MM-DD');
                       week_y.field = 'week_' + moment(broadcast_week[month][xx]).format('YYYY-MM-DD');
                       weeks_array.push('week_' + moment(broadcast_week[month][xx]).format('YYYY-MM-DD'));
                       weeks_broadcast_month['week_' + moment(broadcast_week[month][xx]).format('YYYY-MM-DD')] = month;
                       week_y.headerClass = 'weeks';
                       week_y.suppressMovable= true;
                       week_y.cellStyle = changeRowColor;
                       week_y.cellClassRules= {
                           'hover-week-change': function(params) {
                               if (params.node.rowPinned != 'top' && (typeof params.data.campaign_id !== 'undefined')) {
                                   var camp = params.data.campaign_id;
                                   var field = params.colDef.headerTooltip;
                                   if (typeof campaigns_finally[camp] !== "undefined" && campaigns_finally[camp]['weeks'].length > 0) {
                                       if (campaigns_finally[camp]['weeks'].indexOf(field) !== -1) {
                                           return true;
                                       }
                                   }
                               }
                               return false;
                           }
                       },
                       month_y.children.push(week_y);
                   }
               }
           }
           months_header.children.push(quarter_y);
       }
       for (var s in weeks_array)
           mainColumnDefTotals[0][weeks_array[s]] = '';
       mainColumnDefTotals=[{
           campaign_id: '',
           fd_start: '',
           fd_end: '',
       }];
       mainColumnDef.push(months_header);
       mainColumnDef.push(
           {
               headerName: '',
               headerTooltip: '',
               groupId: 'campaign_data_total',
               headerClass: 'campaign_header',
               children: [
                   {
                       headerName: '',
                       headerTooltip: '',
                       groupId: 'campaign_data_data_total',
                       headerClass: 'campaign_header',
                       children: [
                           {
                               headerName: '',
                               headerTooltip: '',
                               groupId: 'campaign_data__data_data_total',
                               headerClass: 'campaign_header',
                               children: [
                                   {
                                       headerName: "Total",
                                       field: 'campaign_total',
                                       pinned: 'right',
                                       suppressMovable: true,
                                       minWidth: 50,
                                       width: 120,
                                       editable: false,
                                       filter: 'set',
                                       required: true,
                                       //  cellStyle: {'text-align': "left", 'font-size':'14px', 'border-right': "1px solid black", 'border-rop': "1px solid black"},
                                       headerClass: 'weeks',
                                       cellClass: 'cells',
                                       cellStyle: changeRowColor,
                                       valueGetter: function getTtotal(params) {
                                           var tot = 0;
                                           $.each(params.data, function (index, value) {
                                               if (typeof index !== 'undefined' && index.indexOf('week_') > -1) {
                                                   var val = (typeof value.split("$")[1] !== 'undefined') ? value.split("$")[1] : "0";
                                                   tot += parseFloat(val.replace(",", ""));
                                               } else {
                                               }
                                           });
                                           return parseFloat(tot).toLocaleString("en-US", {
                                               style: "currency",
                                               currency: "USD",
                                               minimumFractionDigits: 2
                                           });
                                       },
                                       //cellRenderer:'agGroupCellRenderer'
                                   },
                               ],
                           },
                       ],
                   },
               ],
           }
       );
       MainGrid = {
           enableFilter: true,
           enableSorting: true,
           columnDefs: mainColumnDef,
           defaultColDef: {
               suppressToolPanel: true
           },
           toolPanelSuppressValues: true,defaultToolPanel: '',
           pinnedTopRowData: mainColumnDefTotals,
           headerHeight: 20,
           rowHeight: 20,
           stopEditingWhenGridLosesFocus: true,
           suppressRowClickSelection: true,
           defaultColDef: {
               suppressToolPanel: true
           },
           groupColumnDef: {
               cellRenderer: 'agGroupCellRenderer',
               headerName: 'Campaign',
               cellRendererParams: {
                   suppressCount: true,
                   suppressFilter: true,
               },
               width: 150,
               max_width: 300,
               pinned: 'left',
               suppressFilter: true,
           },
           enableColResize: true,
           marryChildren: true,
           suppressAggFuncInHeader: true,
           enableFilter: true,
           enableSorting: true,
           animateRows: true,
           rowSelection: 'single',
           //  suppressRowClickSelection: false,
           icons: {
               groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
               groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
               menu: '<i class="fa fa-bars fa-lg"/>',
               sortAscending: '<i class="fa fa-caret-down"/>',
               sortDescending: '<i class="fa fa-caret-up"/>',
               columnMoveMove: '<i class="fa fa-arrows"></i>',
               columnMovePin: '<i class="fa fa-thumb-tack"></i>',
               columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
               columnMoveRight: '<i class="fa fa-arrow-right"></i>',
               columnMoveHide: '<i class="fa fa-remove"/>'
           },
           //  getContextMenuItems: getContextMenuItemsInvoice,
           onGridReady: function (e){
           },
           onSelectionChanged: function (e) {
           },
           onCellClicked: function (e) {
               if(e.node.rowPinned !== 'top') {
                   array_to_allocate = {
                       tv: {total: 0, grp: 0},
                       radio: {total: 0, grp: 0},
                       print: {total: 0, grp: 0},
                       digital: {total: 0, grp: 0},
                       mail: {total: 0, grp: 0},
                       ooh: {total: 0, grp: 0},
                       other: {total: 0, grp: 0},
                       ott: {total: 0, grp: 0},
                   };
                   $('#tv_dp_refresh_grp').hide();
                   $('#radio_dp_refresh_grp').hide();
                   $('#print_refresh_grp').hide();
                   $('#digital_refresh_grp').hide();
                   $('#mail_refresh_grp').hide();
                   $('#ooh_refresh_grp').hide();
                   $('#other_refresh_grp').hide();
                   $('#ott_refresh_grp').hide();
                   var w = e.colDef.field.split('week_');
                   if (typeof w[1] !== 'undefined' && campaigns_finally[e.data.campaign_id]['weeks'].indexOf(e.colDef.headerTooltip) !== -1)
                       showCampPlanner(e.data.campaign_id, e.colDef.headerTooltip, weeks_broadcast_month[e.colDef.field], e.colDef.field, e)
               }
           },
           onCellValueChanged: function (e) {
               if(e.node.rowPinned !== 'top') {
                   var floating_top_row = MainGrid.api.pinnedRowModel.pinnedTopRows[0];
                   var xx = e.colDef.field;
                   var total = 0;
                   MainGrid.api.forEachNodeAfterFilterAndSort(function (node) {
                       var spl = node.data[xx].split('$');
                       if (typeof spl[1] !== 'undefined')
                           total += parseFloat(spl[1].replace(",", ""));
                       else {
                           if (typeof node.data[xx] !== 'undefined' && node.data[xx] !== '') {
                               if (!isNaN(node.data[xx]))
                                   total += parseFloat(node.data[xx].replace(",", ""))
                           }
                       }
                   });
                   floating_top_row.data[xx] = parseFloat(total).toLocaleString("en-US", {
                       style: "currency",
                       currency: "USD",
                       minimumFractionDigits: 2
                   });
                   var tot = 0;
                   $.each(e.data, function (index, value) {
                       if (typeof index !== 'undefined' && index.indexOf('week_') > -1) {
                           var val = (typeof value.split("$")[1] !== 'undefined') ? value.split("$")[1] : "0";
                           tot += parseFloat(val.replace(",", ""));
                       }
                   });
                   e.data['campaign_total'] = parseFloat(tot).toLocaleString("en-US", {
                       style: "currency",
                       currency: "USD",
                       minimumFractionDigits: 2
                   });
                   //MainGrid.api.refreshCells([floating_top_row, e.node]);
                   MainGrid.api.refreshCells({rowNodes: [floating_top_row, e.node], columns: [e.colDef.field, 'campaign_total'], force: true});
                   // MainGrid.api.pinnedRowModel.pinnedTopRows[0].setDataValue(xx, total);
               }
           },
           onItemsAdded: function (e) {
           },
           onCellFocused: function (e) {
           },
           onCellEditingStarted: function (e) {
           },
           onRowSelected: function (e) {
           },
           onCellEditingStopped: function (e) {
           },
           onCellMouseOver: function (e) {
               // if(e.node.rowPinned !== 'top') {
               //     console.log('********************************** get in to reloadAnualMainGrid ');
               //     var w = e.colDef.field.split('week_');
               //     if (typeof w[1] !== 'undefined' && campaigns_finally[e.data.campaign_id]['weeks'].indexOf(e.colDef.headerTooltip) !== -1) {
               //         e.colDef.cellStyle = {backgroundColor: '#F0B27A', cursor: 'pointer'};
               //         MainGrid.api.refreshCells([e.node], [e.colDef.field]);
               //     }
               // }
           },
           onCellMouseOut: function (e) {
               // if(e.node.rowPinned !== 'top') {
               //     var w = e.colDef.field.split('week_');
               //     if (typeof w[1] !== 'undefined' && campaigns_finally[e.data.campaign_id]['weeks'].indexOf(e.colDef.headerTooltip) !== -1) {
               //         e.colDef.cellStyle = changeRowColor;
               //         MainGrid.api.refreshCells([e.node], [e.colDef.field]);
               //     }
               // }
           },
           onFilterChanged: function (e) {
               if (this.api.isAnyFilterPresent())
                   $('#reset_filters').show();
               else
                   $('#reset_filters').hide();
               var floating_top_row = MainGrid.api.pinnedRowModel.pinnedTopRows[0];
               var total_maingrid={};

               for(var month in broadcast_week){
                   for(var week in broadcast_week[month])
                       total_maingrid['week_'+broadcast_week[month][week]]=0;
               }
               var columns=[];
               for(var column in total_maingrid) {
                   MainGrid.api.forEachNodeAfterFilterAndSort(function (node) {
                       var expl= node.data[column].split('$');
                       if(typeof(expl[1] !== 'undefined') && !isNaN(parseFloat(expl[1]))) {
                           var com= expl[1].replace(",","")
                           total_maingrid[column] += parseFloat((com));
                       }
                   });
                   floating_top_row.data[column]= parseFloat(total_maingrid[column]).toLocaleString("en-US", {
                       style: "currency",
                       currency: "USD",
                       minimumFractionDigits: 2
                   });
                   columns.push(column);
               }
               columns.push('campaign_total')
               MainGrid.api.refreshCells({rowNodes: [floating_top_row], columns: columns, force: true});
           }
       };

       MainGrid.rowData = [];
       var totals_array=[];
       for (var m in weeks_array)
           totals_array[weeks_array[m]] = 0;
       for (var camp_id in campaigns_finally) {
           var bud= parseFloat(campaigns_finally[camp_id].budget).toLocaleString("en-US", {
               style: "currency",
               currency: "USD",
               minimumFractionDigits: 2
           });
           var values = {
               int_id: camp_id,
               campaign_id: camp_id,
               campaign_name: campaigns_finally[camp_id].name.toUpperCase(),
               advertiser_name: campaigns_finally[camp_id].advertiser,
               fd_start: moment(campaigns_finally[camp_id].start).format('MM/DD/YYYY'),
               fd_end: moment(campaigns_finally[camp_id].end).format('MM/DD/YYYY'),
               //   market_id: $('#campaign_market option:selected').val(),
               budget: bud ,
               percent: parseFloat(campaigns_finally[camp_id].percent).toFixed(1),
           };
           for (var y in weeks_array) {
               values[weeks_array[y]] = '';
               var ww = weeks_array[y].split('week_');
               if( typeof campaigns_finally[camp_id]['planner'][ww[1]] !== 'undefined') {
                   values[weeks_array[y]] = parseFloat(campaigns_finally[camp_id]['planner'][ww[1]]).toLocaleString("en-US", {
                       style: "currency",
                       currency: "USD",
                       minimumFractionDigits: 2
                   });
                   totals_array[weeks_array[y]]+= campaigns_finally[camp_id]['planner'][ww[1]];
               }
               else if(campaigns_finally[camp_id]['weeks'].indexOf(ww[1]) !== -1) {
                   values[weeks_array[y]] =parseFloat(0).toLocaleString("en-US", {
                       style: "currency",
                       currency: "USD",
                       minimumFractionDigits: 2
                   });
               }
           }
           if(typeof campaign_hiatus[camp_id] !== 'undefined') {
               for (var i in weeks_array) {
                   var hiatus= weeks_array[i].split('week_');
                   if (campaign_hiatus[camp_id].indexOf(hiatus[1]) !== -1)
                       values[weeks_array[i]] = 'H';
               }
           }
           MainGrid.rowData.push(values);
       }
       $('#mainGrid').html("");
       var MainGridGrid = document.querySelector('#mainGrid');
       var g5 = new agGrid.Grid(MainGridGrid, MainGrid);
       var array=[{}];
       for(var x in totals_array) {
           array[0][x] = parseFloat(totals_array[x]).toLocaleString("en-US", {
               style: "currency",
               currency: "USD",
               minimumFractionDigits: 2
           });
       }
       MainGrid.api.setPinnedTopRowData([array[0]]);

   }
   $('#media_planner_search_submit').on('click', function(){
       if($('#search_fd').val() == '')
           global_notification('warning', 'Please select a date range');
       else{
           show_loader();
           $('#range_date_div').html($('#search_fd').val());
           main_grid_type='current_month';
           var url= $(this).attr('data-url');
           var data= $('#app-planner-search-form').serializeArray();
           $.ajax({
               type: 'POST',
               url: url,
               data: data,
               dataType: 'json',
               encode: true,
               headers: {
                   'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
               },
               success: function (data) {
                   broadcast_month_weeks= data.broadcast_week;
                   broadcast_week= data.broadcast_week;
                   campaign_hiatus=data.hiatus;
                   campaigns_finally=data.campaign_finally;
                   months_quarter=data.months;
                   reloadCustomMainGrid();
                   var html_hide= '';
                   // var html_hide= '<li><a  data-col="advertiser_name">Advertiser</a></li>' +
                   //     '                                        <li><a  data-col="fd_start">Start</a></li>' +
                   //     '                                        <li><a  data-col="fd_end">End</a></li>' +
                   //     '                                        <li><a  data-col="budget">Budget</a></li>' +
                   //     '                                        <li><a  data-col="percent">Completed %</a></li>';
                   if(hidden_columns_main_grid.advertiser_name == 1)
                       html_hide+= '<li><a  data-col="advertiser_name">Advertiser</a></li>';
                   else
                       html_hide += '<li><a  data-col="advertiser_name" class="hidden-column" >Advertiser</a></li>';
                   if(hidden_columns_main_grid.fd_start == 1)
                       html_hide += '<li><a  data-col="fd_start">Start</a></li>';
                   else
                       html_hide += '<li><a  data-col="fd_start" class="hidden-column">Start</a></li>';
                   if(hidden_columns_main_grid.fd_end == 1)
                       html_hide += '<li><a  data-col="fd_end">End</a></li>';
                   else
                       html_hide += '<li><a  data-col="fd_end" class="hidden-column">End</a></li>';
                   if(hidden_columns_main_grid.budget == 1)
                       html_hide +=' <li><a  data-col="budget">Budget</a></li>';
                   else
                       html_hide +=' <li><a  data-col="budget" class="hidden-column">Budget</a></li>';
                   if(hidden_columns_main_grid.percent == 1)
                       html_hide += '<li><a  data-col="percent">Completed %</a></li>';
                   else
                       html_hide += '<li><a  data-col="percent" class="hidden-column">Completed %</a></li>';
                   for(var month in broadcast_week){
                       for(var week in broadcast_week[month]) {
                           var name= moment(broadcast_week[month][week]).format('MMMM')+'/';
                           var str= name+ moment(broadcast_week[month][week]).format('DD');
                           html_hide += '<li><a class="hide_a" data-col="week_'+broadcast_week[month][week]+'">'+str+'</a></li>'
                       }
                   }
                   $('#hide_columns').html(html_hide);
                   $('#customDateRange').modal('hide');
                   $('#previous_main_grid').hide();
                   $('#next_main_grid').hide();
                   addAEvent();
                   hide_loader();
               },
               error: function (xhr) {
                   hide_loader();
                   ajax_error();
                   debug(xhr.responseText);
               }
           });
       }
   });
   function reloadCustomMainGrid(){
       $('#keywordsFIlter').val('');
       $('#keywords').val('');
       $('#reset_filters').hide();
        mainColumnDefTotals=[{
            campaign_id: '',
            fd_start: '',
            fd_end: '',
            campaign_total: '',
        }];
        mainColumnDef = [
            {
                headerName: '',
                headerTooltip: '',
                groupId: 'row_he',
                headerClass: 'campaign_header',
                children: [
                    {
                        headerName: '',
                        headerTooltip: '',
                        groupId: 'row_he_he',
                        headerClass: 'campaign_header',
                        children: [
                            {
                                headerName: '',
                                headerTooltip: '',
                                field: 'row_select',
                                pinned: 'left',
                                width: 50,
                                editable: false,
                                cellRenderer: 'agGroupCellRenderer',
                                checkboxSelection: true,
                                cellRendererParams: {
                                    //checkbox: true
                                },
                                suppressFilter: true,
                                suppressMovable: true,
                                suppressResize: true,
                                suppressNavigable: true,
                                suppressSorting: true,
                                required: true,
                                headerClass: 'weeks',
                                // cellClass:'cells',
                                cellStyle: changeRowColor,
                            }
                        ],
                    },
                ]
            },
            {
                headerName: '',
                headerTooltip: '',
                groupId: 'campaign_data',
                headerClass: 'campaign_header',
                children: [
                    {
                        headerName: '',
                        headerTooltip: '',
                        groupId: 'campaign_data_data',
                        headerClass: 'campaign_header',
                        children: [ {
                            headerName: "Campaign",
                            field: 'campaign_name',
                            pinned: 'left',
                            suppressMovable: true,
                            minWidth: 50,
                            width:162,
                            editable: true,
                            filter: 'set',
                            required: true,
                            //  cellStyle: {'text-align': "left", 'font-size':'14px', 'border-right': "1px solid black", 'border-rop': "1px solid black"},
                            headerClass: 'weeks',
                            cellClass:'cells',
                            cellStyle: changeRowColor,
                            //cellRenderer:'agGroupCellRenderer'
                        },
                            {
                                headerName: "Advertiser",
                                field: 'advertiser_name',
                                pinned: 'left',
                                suppressMovable: true,
                                minWidth: 50,
                                width:162,
                                filter: 'set',
                                cellStyle: changeRowColor,
                                //cellRenderer:'agGroupCellRenderer'
                                pinned: 'left',
                                headerClass: 'weeks',
                                hide: (hidden_columns_main_grid.advertiser_name == 1) ? false : true,

                            },
                            {
                                headerName: "",
                                field: 'campaign_id',
                                width: 100,
                                pinned: 'left',
                                //cellStyle: {'text-align': "right"},
                                headerClass: 'weeks',
                                hide:true,
                                suppressMovable: true,
                                cellStyle: changeRowColor
                            },
                            {
                                headerName: "Start",
                                field: 'fd_start',
                                width: 100,
                                pinned: 'left',
                                suppressMovable: true,
                                cellStyle: changeRowColor,
                                headerClass: 'weeks',
                                hide: (hidden_columns_main_grid.fd_start == 1) ? false : true,
                            },
                            {
                                headerName: "End",
                                field: 'fd_end',
                                width: 100,
                                cellStyle: {'text-align': "right"},
                                pinned: 'left',
                                headerClass: 'weeks',
                                suppressMovable: true,
                                cellStyle: changeRowColor,
                                hide: (hidden_columns_main_grid.fd_end == 1) ? false : true,
                            },
                            {
                                headerName: "Budget",
                                field: 'budget',
                                width: 80,
                                cellStyle: {'text-align': "right"},
                                pinned: 'left',
                                headerClass: 'weeks',
                                suppressMovable: true,
                                cellStyle: changeRowColor,
                                hide: (hidden_columns_main_grid.budget == 1) ? false : true,
                            },
                            {
                                headerName: "Completed %",
                                field: 'percent',
                                width: 100,
                                cellStyle: {'text-align': "right"},
                                pinned: 'left',
                                headerClass: 'weeks',
                                suppressMovable: true,
                                cellStyle: changeRowColor,
                                hide: (hidden_columns_main_grid.percent == 1) ? false : true,
                            },
                        ],
                    },
                ],
            },
        ];

        months_header = {
            headerName: '',
            headerTooltip: '',
            groupId: 'quarters',
            children: [],
            headerClass: 'quarters',
        }
        weeks_array=[];
        console.log('broadcast_week, broadcast_week ', broadcast_week);
        for (var month in broadcast_week) {
            var month_y = $.extend({}, ws_global_column_definitions.group_months);
            console.log('month_y ', month_y);
            console.log('month ', month);
            var year = '';
            if(typeof broadcast_week[month][1] !== 'undefined')
                year = moment(broadcast_week[month][1]).format('YYYY');
            else
                year = moment(broadcast_week[month][0]).format('YYYY');
            console.log('year ', year);
            month_y.group_id = month;
            month_y.headerName = moment(year +'-' + month + '-01').format('MMMM')+'   '+year;
            month_y.headerTooltip += moment(year+'-' + month + '-01').format('MMMM');
            if (broadcast_week[month].length == 4)
                month_y.width = '400';
            if (broadcast_week[month].length == 5)
                month_y.width = '500';
            month_y.headerClass= 'months';
            month_y.children=[];
            for (var xx in broadcast_week[month]) {
                var week_y = $.extend({}, ws_global_column_definitions.week);
                week_y.headerName = moment( broadcast_week[month][xx]).format('DD');
                week_y.headerTooltip += moment( broadcast_week[month][xx]).format('YYYY-MM-DD');
                week_y.field ='week_'+ moment( broadcast_week[month][xx]).format('YYYY-MM-DD');
                weeks_array.push('week_'+ moment( broadcast_week[month][xx]).format('YYYY-MM-DD'));
                weeks_broadcast_month['week_'+ moment( broadcast_week[month][xx]).format('YYYY-MM-DD')]=month;
                week_y.headerClass= 'weeks';
                week_y.suppressMovable= true;
                week_y.cellStyle= changeRowColor;
                week_y.cellClassRules= {
                    'hover-week-change': function(params) {
                        if (params.node.rowPinned != 'top' && (typeof params.data.campaign_id !== 'undefined')) {
                            var camp = params.data.campaign_id;
                            var field = params.colDef.headerTooltip;
                            if (typeof campaigns_finally[camp] !== "undefined" && campaigns_finally[camp]['weeks'].length > 0) {
                                if (campaigns_finally[camp]['weeks'].indexOf(field) !== -1) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    }
                },
                month_y.children.push(week_y);
            }
            months_header.children.push(month_y);
        }
        for (var s in weeks_array)
            mainColumnDefTotals[0][weeks_array[s]] = '';
        mainColumnDefTotals=[{
            campaign_id: '',
            fd_start: '',
            fd_end: '',
        }];
        mainColumnDef.push(months_header);
       mainColumnDef.push(
           {
               headerName: '',
               headerTooltip: '',
               groupId: 'campaign_data_total',
               headerClass: 'campaign_header',
               children: [
                   {
                       headerName: '',
                       headerTooltip: '',
                       groupId: 'campaign_data_data_total',
                       headerClass: 'campaign_header',
                       children: [

                           {
                               headerName: "Total",
                               field: 'campaign_total',
                               pinned: 'right',
                               suppressMovable: true,
                               minWidth: 50,
                               width: 120,
                               editable: false,
                               filter: 'set',
                               required: true,
                               //  cellStyle: {'text-align': "left", 'font-size':'14px', 'border-right': "1px solid black", 'border-rop': "1px solid black"},
                               headerClass: 'weeks',
                               cellClass:'cells',
                               cellStyle: changeRowColor,
                               valueGetter: function getTtotal(params) {
                                   var tot = 0;
                                   $.each(params.data, function (index, value) {
                                       if(typeof index !== 'undefined' && index.indexOf('week_') > -1){
                                           var val = (typeof value.split("$")[1] !== 'undefined') ? value.split("$")[1] : "0";
                                           tot += parseFloat(val.replace(",",""));
                                       }else{

                                       }
                                   });
                                   return parseFloat(tot).toLocaleString("en-US", {
                                       style: "currency",
                                       currency: "USD",
                                       minimumFractionDigits: 2
                                   });
                               },
                               //cellRenderer:'agGroupCellRenderer'
                           },
                       ],
                   },
               ],
           }
       );
        MainGrid = {
            enableFilter: true,
            enableSorting: true,
            columnDefs: mainColumnDef,
            defaultColDef: {
                suppressToolPanel: true
            },
            toolPanelSuppressValues: true,defaultToolPanel: '',
            pinnedTopRowData: mainColumnDefTotals,
            headerHeight: 20,
            rowHeight: 20,
            stopEditingWhenGridLosesFocus: true,
            suppressRowClickSelection: true,
            defaultColDef: {
                suppressToolPanel: true
            },
            groupColumnDef: {
                cellRenderer: 'agGroupCellRenderer',
                headerName: 'Campaign',
                cellRendererParams: {
                    suppressCount: true,
                    suppressFilter: true,
                },
                width: 150,
                max_width: 300,
                pinned: 'left',
                suppressFilter: true,
            },
            enableColResize: true,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            rowSelection: 'single',
            //  suppressRowClickSelection: false,
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            //  getContextMenuItems: getContextMenuItemsInvoice,
            onGridReady: function (e){
            },
            onSelectionChanged: function (e) {
            },
            onCellClicked: function (e) {
                if(e.node.rowPinned !== 'top') {
                    array_to_allocate = {
                        tv: {total: 0, grp: 0},
                        radio: {total: 0, grp: 0},
                        print: {total: 0, grp: 0},
                        digital: {total: 0, grp: 0},
                        mail: {total: 0, grp: 0},
                        ooh: {total: 0, grp: 0},
                        other: {total: 0, grp: 0},
                        ott: {total: 0, grp: 0},
                    };
                    $('#tv_dp_refresh_grp').hide();
                    $('#radio_dp_refresh_grp').hide();
                    $('#print_refresh_grp').hide();
                    $('#digital_refresh_grp').hide();
                    $('#mail_refresh_grp').hide();
                    $('#ooh_refresh_grp').hide();
                    $('#other_refresh_grp').hide();
                    $('#ott_refresh_grp').hide();
                    var w = e.colDef.field.split('week_');
                    if (typeof w[1] !== 'undefined' && campaigns_finally[e.data.campaign_id]['weeks'].indexOf(e.colDef.headerTooltip) !== -1)
                        showCampPlanner(e.data.campaign_id, e.colDef.headerTooltip, weeks_broadcast_month[e.colDef.field], e.colDef.field, e)
                }
            },
            onCellValueChanged: function (e) {
                if(e.node.rowPinned !== 'top') {
                    var floating_top_row = MainGrid.api.pinnedRowModel.pinnedTopRows[0];
                    var xx = e.colDef.field;
                    var total = 0;
                    MainGrid.api.forEachNodeAfterFilterAndSort(function (node) {
                        var spl = node.data[xx].split('$');
                        if (typeof spl[1] !== 'undefined')
                            total += parseFloat(spl[1].replace(",", ""));
                        else {
                            if (typeof node.data[xx] !== 'undefined' && node.data[xx] !== '') {
                                if (!isNaN(node.data[xx]))
                                    total += parseFloat(node.data[xx].replace(",", ""))
                            }
                        }
                    });
                    floating_top_row.data[xx] = parseFloat(total).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    var tot = 0;
                    $.each(e.data, function (index, value) {
                        if (typeof index !== 'undefined' && index.indexOf('week_') > -1) {
                            var val = (typeof value.split("$")[1] !== 'undefined') ? value.split("$")[1] : "0";
                            tot += parseFloat(val.replace(",", ""));
                        }
                    });
                    e.data['campaign_total'] = parseFloat(tot).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    MainGrid.api.refreshCells({rowNodes: [floating_top_row, e.node], columns: [e.colDef.field, 'campaign_total'], force: true});
                    // MainGrid.api.pinnedRowModel.pinnedTopRows[0].setDataValue(xx, total);
                }
            },
            onItemsAdded: function (e) {
            },
            onCellFocused: function (e) {
            },
            onCellEditingStarted: function (e) {
            },
            onRowSelected: function (e) {
            },
            onCellEditingStopped: function (e) {
            },
            onCellMouseOver: function (e) {
                // if(e.node.rowPinned !== 'top') {
                //     console.log('********************************** get in to reloadCustomMainGrid ');
                //     var w = e.colDef.field.split('week_');
                //     if (typeof w[1] !== 'undefined' && campaigns_finally[e.data.campaign_id]['weeks'].indexOf(e.colDef.headerTooltip) !== -1) {
                //         e.colDef.cellStyle = {backgroundColor: '#F0B27A', cursor: 'pointer'};
                //         MainGrid.api.refreshCells([e.node], [e.colDef.field]);
                //     }
                // }
            },
            onCellMouseOut: function (e) {
                // if(e.node.rowPinned !== 'top') {
                //     var w = e.colDef.field.split('week_');
                //     if (typeof w[1] !== 'undefined' && campaigns_finally[e.data.campaign_id]['weeks'].indexOf(e.colDef.headerTooltip) !== -1) {
                //         e.colDef.cellStyle = changeRowColor;
                //         MainGrid.api.refreshCells([e.node], [e.colDef.field]);
                //     }
                // }
            },
            onFilterChanged: function (e) {
                if (this.api.isAnyFilterPresent())
                  $('#reset_filters').show();
                else
                    $('#reset_filters').hide();
                var floating_top_row = MainGrid.api.pinnedRowModel.pinnedTopRows[0];
                var total_maingrid={};

                for(var month in broadcast_week){
                    for(var week in broadcast_week[month])
                        total_maingrid['week_'+broadcast_week[month][week]]=0;
                }
                var columns=[];
                for(var column in total_maingrid) {
                    MainGrid.api.forEachNodeAfterFilterAndSort(function (node) {
                        var expl= node.data[column].split('$');
                        if(typeof(expl[1] !== 'undefined') && !isNaN(parseFloat(expl[1]))) {
                            var com= expl[1].replace(",","")
                            total_maingrid[column] += parseFloat((com));
                        }
                    });
                    floating_top_row.data[column]= parseFloat(total_maingrid[column]).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    columns.push(column);
                }
                columns.push('campaign_total')
                MainGrid.api.refreshCells({rowNodes: [floating_top_row], columns: columns, force: true});
            }
        };

        MainGrid.rowData = [];
        var totals_array=[];
        for (var m in weeks_array)
            totals_array[weeks_array[m]] = 0;
        for (var camp_id in campaigns_finally) {
            var bud= parseFloat(campaigns_finally[camp_id].budget).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            var values = {
                int_id: camp_id,
                campaign_id: camp_id,
                campaign_name: campaigns_finally[camp_id].name.toUpperCase(),
                advertiser_name: campaigns_finally[camp_id].advertiser,
                fd_start: moment(campaigns_finally[camp_id].start).format('MM/DD/YYYY'),
                fd_end: moment(campaigns_finally[camp_id].end).format('MM/DD/YYYY'),
                //   market_id: $('#campaign_market option:selected').val(),
                budget: bud ,
                percent: parseFloat(campaigns_finally[camp_id].percent).toFixed(1),
            };
            for (var y in weeks_array) {
                values[weeks_array[y]] = '';
                var ww = weeks_array[y].split('week_');
                if( typeof campaigns_finally[camp_id]['planner'][ww[1]] !== 'undefined') {
                    values[weeks_array[y]] = parseFloat(campaigns_finally[camp_id]['planner'][ww[1]]).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    totals_array[weeks_array[y]]+= parseFloat(campaigns_finally[camp_id]['planner'][ww[1]]);
                }
                else if(campaigns_finally[camp_id]['weeks'].indexOf(ww[1]) !== -1) {
                    values[weeks_array[y]] =parseFloat(0).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                }
            }
            if(typeof campaign_hiatus[camp_id] !== 'undefined') {
                for (var i in weeks_array) {
                    var hiatus= weeks_array[i].split('week_');
                    if (campaign_hiatus[camp_id].indexOf(hiatus[1]) !== -1)
                        values[weeks_array[i]] = 'H';
                }
            }
            MainGrid.rowData.push(values);
        }
        $('#mainGrid').html("");
        var MainGridGrid = document.querySelector('#mainGrid');
        var g5 = new agGrid.Grid(MainGridGrid, MainGrid);
        var array=[{}];
        for(var x in totals_array) {
            array[0][x] = parseFloat(totals_array[x]).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
        }
        MainGrid.api.setPinnedTopRowData([array[0]]);
   }


    $('#tab_get_markets').on( 'click', function(){
        if($('#selected_campaigns').val().length > 0) {
            show_overlay_loader($('#mediaPlannerReportTwo .modal-content'));
            var sel_markets=  [];
            $('#selected_markets1 option:selected').each(function(){
                sel_markets.push(parseInt($(this).val()));
            });
            var cm = $('#selected_campaigns').val();
            var params = {
                campaigns: cm,
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/planner/report/media-plan/getCamMarkets',
                dataType: "json",
                contentType: "application/json",
                success: function (data) {
                    var arr = [];
                    var html = '';
                    for (var i in data.markets) {
                        if (arr.indexOf(data.markets[i].id) == -1) {
                            arr.push(data.markets[i].id);
                            var sel='';
                            if(sel_markets.indexOf(data.markets[i].id) !== -1)
                                 sel='selected';
                            if (data.markets[i].type != '')
                                html += '<option value="' + data.markets[i].id + '" '+sel+'>' + data.markets[i].type.toUpperCase() + '- ' + data.markets[i].name + '</option>';
                            else
                                html += '<option value="' + data.markets[i].id + '" '+sel+'>Custom - ' + data.markets[i].name + '</option>';
                        }
                    }
                    $('#selected_markets1').html(html).multiSelect('refresh');

                    var html='';
                    var html_1='';

                   var  start_selected = $('#start_date_comp option:selected').val();
                   var  end_selected = $('#end_date_comp option:selected').val();
                   console.log('end_selected ', end_selected );

                   var added = [];

                    for(var x in data.flight_dates) {
                        if (added.indexOf(moment(data.flight_dates[x].start).format('MM/DD/YYYY')) === -1) {
                            added.push(moment(data.flight_dates[x].start).format('MM/DD/YYYY'));
                            if (start_selected == moment(data.flight_dates[x].start).format('MM/DD/YYYY'))
                                selected = 'selected';
                            else
                                selected = '';
                            html += '<option value="' + moment(data.flight_dates[x].start).format('MM/DD/YYYY') + '">' + moment(data.flight_dates[x].start).format('MM/DD/YYYY') + '</option>';

                            if(typeof end_selected === 'undefined' || end_selected == 'undefined' || end_selected == ""){
                                console.log('last position', data.flight_dates.length)
                                console.log('flight_dates', data.flight_dates)
                                console.log('last value', moment(data.flight_dates[data.flight_dates.length - 1].end).format('MM/DD/YYYY'))
                                console.log('current value', moment(data.flight_dates[x].end).format('MM/DD/YYYY'))

                                if(moment(data.flight_dates[data.flight_dates.length - 1].end).format('MM/DD/YYYY') === moment(data.flight_dates[x].end).format('MM/DD/YYYY'))
                                    selected = 'selected';
                                else
                                    selected = '';
                            }
                            else {
                                if (end_selected == moment(data.flight_dates[x].end).format('MM/DD/YYYY'))
                                    selected = 'selected';
                                else
                                    selected = '';
                            }
                            html_1 += '<option value="' + moment(data.flight_dates[x].end).format('MM/DD/YYYY') + '" ' + selected + '>' + moment(data.flight_dates[x].end).format('MM/DD/YYYY') + '</option>';
                        }
                    }
                    $('#start_date_comp').html(html);
                    $('#end_date_comp').html(html_1);

                    fligth_dates = data.flight_dates;

                    hide_overlay_loader($('#mediaPlannerReportTwo .modal-content'));
                    $('#select_all_market1').on('click', function(e){
                        $('#selected_markets1').multiSelect('select_all');
                    });
                    $('#deselect_all_market1').on('click', function(e){
                        $('#selected_markets1').multiSelect('deselect_all');
                    });
                },
                error: function (xhr) {
                    hide_loader();
                    debug(xhr.responseText);
                    hide_overlay_loader($('#mediaPlannerReportTwo .modal-content'));
                }
            });
        }
        else {
            $('#selected_markets1').html('').multiSelect('refresh');
            $('#start_date_comp').html('');
            $('#end_date_comp').html('');
            $('#start_date_comp').val('');
            $('#end_date_comp').val('');
        }
    });

   $('#media_plan_report').on('click', function(){
       show_loader();
        $.ajax({
            type: 'GET',
            url: '/planner/report/media-plan/getAgencyData' ,
            dataType: 'json',
            encode: true,
            success: function (data) {
                $('#selected_medias1').multiSelect({
                   selectableHeader: "<div class='' style='height: 38px;'></div>",
                    selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm ' id='select_all_media1' ><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='deselect_all_media1'><i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                    afterInit: function(ms){
                    //     var that = this,
                    //         $selectableSearch = that.$selectableUl.prev(),
                    //         selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';
                    //
                    //     that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    //         .on('keydown', function(e){
                    //             if (e.which === 40){
                    //                 that.$selectableUl.focus();
                    //                 return false;
                    //             }
                    //         });
                    },
                    afterSelect: function(values){
                        this.qs1.cache();
                    },
                    afterDeselect: function(values){
                        this.qs1.cache();
                    }
                });

                $('#selected_markets1').multiSelect({
                    selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                    selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm select_all_market1' id='select_all_market1'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='deselect_all_market1'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                    afterInit: function(ms){
                        var that = this,
                            $selectableSearch = that.$selectableUl.prev(),
                            selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                            .on('keydown', function(e){
                                if (e.which === 40){
                                    that.$selectableUl.focus();
                                    return false;
                                }
                            });
                    },
                    afterSelect: function(values){
                        this.qs1.cache();
                    },
                    afterDeselect: function(values){
                        this.qs1.cache();
                    }
                });
                var html='';
                // for(var i in data.markets)
                //     html+='<option value="'+data.markets[i].id+'">'+ data.markets[i].type.toUpperCase()+'- '+data.markets[i].name+'</option>';
                // $('#selected_markets1').html(html).multiSelect('refresh');

                $('#selected_campaigns').multiSelect({
                    selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                    selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm select_all_camp' id='select_all_camp'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='deselect_all_camp'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                    afterInit: function(ms){
                        var that = this,
                            $selectableSearch = that.$selectableUl.prev(),
                            selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                            .on('keydown', function(e){
                                if (e.which === 40){
                                    that.$selectableUl.focus();
                                    return false;
                                }
                            });
                    },
                    afterSelect: function(values){
                        this.qs1.cache();
                    },
                    afterDeselect: function(values){
                        this.qs1.cache();
                    }
                });
                var html='';
                for(var i in data.campaigns)
                    html+='<option value="'+data.campaigns[i].id+'" title="FD: '+moment(data.campaigns[i].start).format('MM/DD/YYYY')+' - '+moment(data.campaigns[i].end).format('MM/DD/YYYY')+'">'+data.campaigns[i].name+'</option>';

                $('#selected_campaigns').html(html).multiSelect('refresh');

                $('#start_date_comp').select2({
                    minimumResultsForSearch: 10,
                    placeholder: 'Select one....',
                });
                $('#end_date_comp').select2({
                    minimumResultsForSearch: 10,
                    placeholder: 'Select one....',
                });


                hide_loader();

                $('#mediaPlannerReportTwo').modal('show');
                $('#select_all_media1').on('click', function(e){
                    $('#selected_medias1').multiSelect('select_all');
                });
                $('#deselect_all_media1').on('click', function(e){
                    $('#selected_medias1').multiSelect('deselect_all');
                });
                $('.div_markets1 .select_all_market1').on('click', function(e){
                    $('#selected_markets1').multiSelect('select_all');
                });
                $('#deselect_all_market1').on('click', function(e){
                    $('#selected_markets1').multiSelect('deselect_all');
                });
                $('#select_all_camp').on('click', function(e){
                    $('#selected_campaigns').multiSelect('select_all');
                });
                $('#deselect_all_camp').on('click', function(e){
                    $('#selected_campaigns').multiSelect('deselect_all');
                });
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                debug(xhr.responseText);
            }
        });
    });
   $('#media-plan-report-submit').on('click', function(){
        var campaigns =$('#selected_campaigns').val();
        var media_types =$('#selected_medias1').val();
        var markets =$('#selected_markets1').val();
        var start =  $('#start_date_comp option:selected').val();
        var end =  $('#end_date_comp option:selected').val();
        if(campaigns.length ==0)
            global_notification('warning', 'Please select at least one campaign.');
        else if(media_types.length ==0)
            global_notification('warning', 'Please select at least one media type.');
        else if(markets.length ==0)
            global_notification('warning', 'Please select at least one markets.');
        else if(typeof start === 'undefined' || typeof end === 'undefined' || start == 'undefined' || end == 'undefined' || start == "" || end == "")
            global_notification('warning', 'Please select a Date Range');
        else{
            show_overlay_loader($('#mediaPlannerReportTwo .modal-content'));
            var params = {
                campaigns: campaigns,
                media_types: media_types,
                markets: markets,
                start: start,
                end: end,
            };
            media_report_request=params;
            var url= $(this).attr('data-url');
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: url,
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    var months_date=response.months;
                    var mediaPlannerColumnDef = [
                        {
                            headerName: 'Campaign',
                            headerTooltip: '',
                            field: 'campaign_name',
                            editable: false,
                            minWidth: 35,
                            width: 200,
                            required: false,
                            pinned: 'left',
                            suppressMovable: true,
                            suppressResize: false,
                        },
                        {
                            headerName: 'Market',
                            headerTooltip: '',
                            field: 'market_name',
                            editable: false,
                            minWidth: 35,
                            width: 200,
                            required: false,
                            filter: 'set',
                            suppressMovable: false,
                            suppressResize: false,
                            pinned: 'left',
                        },
                        {
                            headerName: 'Media Type',
                            headerTooltip: '',
                            field: 'media_type',
                            editable: false,
                            minWidth: 35,
                            width: 100,
                            required: false,
                            pinned: 'left',
                            filter: 'set',
                            suppressMovable: false,
                            suppressResize: false,
                        },
                    ];
                    var col_array=['campaign', 'media_type', 'total'];
                    var months=[];
                    for(var i in response.months){
                        var month=response.months[i];
                        months.push(month);
                        col_array.push('month_'+month);
                        mediaPlannerColumnDef.push({
                            headerName: response.months_year[i],
                            field:'month_'+month,
                            width: 100,
                            cellStyle: {'text-align': "center"},
                            suppressMovable: false,
                            suppressResize: false,
                        });
                    }
                    mediaPlannerColumnDef.push({
                        headerName: ' MARKET TOTAL',
                        field: 'total',
                        width: 110,
                        pinned: 'right',
                        cellStyle: {'text-align': "right"},
                        suppressMovable: true,
                        suppressResize: false,
                    });

                    var MediaPlannerColumnDefTotals=[{
                        market_id: '',
                        market_name: '',
                        market_type: '',
                    }];
                    for(var m in response.month_totals) {
                        MediaPlannerColumnDefTotals[0]['month_'+m] = parseFloat( response.month_totals[m]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    var colDraggedTo;
                    var colDraggedId;
                    var colMovingCellPosition;
                    var colMovingCell;

                    MediaPlannerGrid = {
                        suppressDragLeaveHidesColumns: true,
                        enableFilter: true,
                        enableSorting: true,
                        columnDefs: mediaPlannerColumnDef,
                        defaultColDef: {
                            suppressToolPanel: true
                        },
                        toolPanelSuppressValues: true,defaultToolPanel: '',
                        headerHeight: 20,
                        rowHeight: 20,
                        stopEditingWhenGridLosesFocus: true,
                        rowSelection: 'multiple',
                        suppressRowClickSelection: true,
                        suppressFilter: false,
                        pinnedTopRowData: MediaPlannerColumnDefTotals,
                        //  pinnedBottomRowData: tvDpColumnDefBottom,
                        defaultColDef: {
                            suppressToolPanel: true
                        },
                        enableColResize: true,
                        icons: {
                            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                            menu: '<i class="fa fa-bars fa-lg"/>',
                            sortAscending: '<i class="fa fa-caret-down"/>',
                            sortDescending: '<i class="fa fa-caret-up"/>',
                            columnMoveMove: '<i class="fa fa-arrows"></i>',
                            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                            columnMoveHide: '<i class="fa fa-remove"/>'
                        },
                        onFilterChanged: function () {
                            var floating_top_row = this.api.pinnedRowModel.pinnedTopRows[0];
                            var total_maingrid={};
                            var total=0;
                            total_maingrid['total']=0;
                            for(var i in months_date){
                                var column='month_'+months_date[i];
                                total_maingrid[column]=0;
                                this.api.forEachNodeAfterFilterAndSort(function (node) {
                                    var expl= node.data[column].split('$');
                                    if(typeof(expl[1] !== 'undefined') && !isNaN(parseFloat(expl[1]))) {
                                        var com= expl[1].replace(",","")
                                        total_maingrid[column] += parseFloat((com));
                                        total_maingrid['total'] += parseFloat((com));
                                        total+=parseFloat(com);
                                    }
                                });
                                floating_top_row.data[column]= parseFloat(total_maingrid[column]).toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                    minimumFractionDigits: 2
                                });
                            }
                            floating_top_row.data['total']= parseFloat(total_maingrid['total']).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            });

                            this.api.refreshCells({rowNodes: [floating_top_row], columns: [], force: true});
                        },
                        onColumnMoved: function (e) {
                            // Track the start and end of a column drag.
                            colMovingCell = $('.ag-header-cell-moving');
                            if (colMovingCell.closest('.ag-pinned-left-header').length) {
                                colMovingCellPosition = 'left';
                            } else if (colMovingCell.closest('.ag-pinned-right-header').length) {
                                colMovingCellPosition = 'right';
                            } else {
                                colMovingCellPosition = 'body';
                            }

                            colDraggedTo = e.toIndex;
                            colDraggedId = e.column.colId;
                        },
                        onDragStopped: function () {
                            console.log('onDragStopped: ', this)
                            // If the column is dragged beyond immovable columns, do not allow the column to be moved.
                            var ws_unmovable_cols_left = 0;
                            var ws_unmovable_cols_right = 0;
                            var ws_total_cols = 0;
                            var left_limit = '';
                            var right_limit = '';

                            // Build two arrays of the immovabled left and right columns.
                            $.each(this.columnDefs, function (index, value) {
                                if (typeof value.children == 'undefined') {
                                    if (((value.pinned == 'left') || (value.pinned == 'right')) && (value.suppressMovable == true)) {
                                        if (value.pinned == 'left') {
                                            ws_unmovable_cols_left++;
                                            left_limit = value.headerName;
                                        } else {
                                            if (right_limit == '') {
                                                right_limit = value.headerName
                                            }
                                            ws_unmovable_cols_right++;
                                        }
                                    }
                                    ws_total_cols++;
                                } else {
                                    $.each(value.children, function (index, value) {
                                        if (((value.pinned == 'left') || (value.pinned == 'right')) && (value.suppressMovable == true)) {
                                            if (value.pinned == 'left') {
                                                ws_unmovable_cols_left++;
                                                left_limit = value.headerName;
                                            } else {
                                                ws_unmovable_cols_right++;
                                                if (right_limit == '') {
                                                    right_limit = value.headerName
                                                }
                                            }
                                        }
                                        ws_total_cols++;
                                    });
                                }
                            });

                            // if (colMovingCellPosition == 'left') {
                            //     if (colDraggedTo < ws_unmovable_cols_left) {
                            //         // Column moved too far left, snap to left most valid position.
                            //         this.columnApi.moveColumn(colDraggedId, ws_unmovable_cols_left + 1);
                            //         global_notification('warning', 'Sorry, you may not move columns to the left of '
                            //             + left_limit + '.', undefined, 'ws_col_move_left');
                            //     }
                            // } else if (colMovingCellPosition == 'right') {
                            //     if ((colDraggedTo !== 0) && (colDraggedTo >= (ws_total_cols - ws_unmovable_cols_right))) {
                            //         // Column moved too far right, snap to right most valid position.
                            //         this.columnApi.moveColumn(colDraggedId, (ws_total_cols - ws_unmovable_cols_right) - 1);
                            //         global_notification('warning', 'Sorry, you may not move columns to the right of '
                            //             + right_limit + '.', undefined, 'ws_col_move_right');
                            //     }
                            // }

                            // Reset value so it is properly logged on next drag.
                            colDraggedTo = undefined;

                            var current_width = parseInt($('#mediaGrid .ag-header-viewport').css('width').replace("px", ""))
                            console.log("CURRENT MEDIUM PANEL WIDTH: ", current_width)
                            if (current_width < 200) {
                                var settingsPinned = [];
                                for (var pos in mediaPlannerColumnDef) {
                                    console.log('mediaPlannerColumnDef', mediaPlannerColumnDef[pos]);
                                    if (mediaPlannerColumnDef[pos]['pinned'] == "left" || mediaPlannerColumnDef[pos]['pinned'] == "right") {
                                        settingsPinned.push(mediaPlannerColumnDef[pos]['field'])
                                    }
                                }
                                console.log('settingsPinned',settingsPinned);
                                var gridOptions = MediaPlannerGrid;
                                $.each(this.columnDefs, function (index, value) {
                                    //console.log("DATA FROM CURRENT COLUMNS: ", value)
                                    if (typeof value.children !== "undefined") {
                                        for (var pos in value.children) {
                                            if (settingsPinned.indexOf(value.children[pos]['field']) === -1) {
                                                //console.log("COLUMN CHANGED: ", value.children[pos]['field'])
                                                gridOptions.columnApi.setColumnPinned(value.children[pos]['field'], null);
                                            }
                                        }
                                    } else {
                                        if (settingsPinned.indexOf(value['field']) === -1) {
                                            //console.log("COLUMN CHANGED: ", value['field'])
                                            gridOptions.columnApi.setColumnPinned(value['field'], null);
                                        }
                                    }
                                })
                                swal({
                                        title: "Warning",
                                        text: "Column positions were reset because there are too many pinned columns.",
                                        type: "warning",
                                        showCancelButton: false,
                                        confirmButtonClass: "btn-danger",
                                        confirmButtonText: "OK",
                                        //cancelButtonText: 'No',
                                        closeOnConfirm: true,
                                        closeOnCancel: true
                                    },
                                    function (isConfirm) {
                                        if (isConfirm) {}

                                    });
                               // global_notification("warning", "Columns position were reset because there are to many pinned columns.")
                            }
                        },
                    };

                    MediaPlannerGrid.rowData = [];
                    var total_total=0;
                    for(var market_id in response.results){
                        var market_array= response.results[market_id];
                        var market_name= market_array.name;
                        for(var media in market_array.media_type){
                            for(var camp_id in market_array.media_type[media]){
                                var total=0;
                                var values = {
                                    market_name: market_name,
                                    campaign_name: market_array.media_type[media][camp_id]['campaign_name'],
                                    media_type:media,
                                };
                                for(var month in market_array.media_type[media][camp_id]['months']){
                                    values['month_'+month]='';
                                    total+= parseFloat(market_array.media_type[media][camp_id]['months'][month]);
                                    total_total+= parseFloat(market_array.media_type[media][camp_id]['months'][month]);
                                    values['month_'+month]=  parseFloat(market_array.media_type[media][camp_id]['months'][month]).toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "USD",
                                        minimumFractionDigits: 2
                                    });
                                }
                                values['total']=parseFloat(total).toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                    minimumFractionDigits: 2
                                });
                                MediaPlannerGrid.rowData.push(values);
                            }
                        }
                    }
                    MediaPlannerColumnDefTotals[0]['total'] = parseFloat(total_total).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });

                    $('#mediaGrid').html("");
                    var mediaGridGrid = document.querySelector('#mediaGrid');
                    var g5 = new agGrid.Grid(mediaGridGrid, MediaPlannerGrid);


                   // $('#mediaPlannerReportTwo').modal('hide');
                    $('#showMediaPlannerReportGrid').modal('show');
                    hide_overlay_loader($('#mediaPlannerReportTwo .modal-content'));
                   // exportToExcel(response);
                },
                error: function (xhr) {
                    ajax_error();
                    hide_overlay_loader($('#mediaPlannerReportTwo .modal-content'));
                    debug(xhr.responseText);
                }
            });
        }
    });

   function exportGridMedia() {
       var url= $('#media_report_excel').attr('data-url');
       params= media_report_request;

       show_overlay_loader($('#showMediaPlannerReportGrid .modal-content'));
       $.ajax({
           type: 'POST',
           headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
           data: JSON.stringify(params),
           url: url,
           dataType: "json",
           contentType: "application/json",
           success: function (response) {
               hide_overlay_loader($('#showMediaPlannerReportGrid .modal-content'));
               var url='data:application/vnd.ms-excel,' + encodeURIComponent(response);
               location.href=url;
               return false;
           },
           error: function (xhr) {
               ajax_error();
               hide_overlay_loader($('#showMediaPlannerReportGrid .modal-content'));
               debug(xhr.responseText);
           }
       });

   }
   $('#media_report_pdf').on('click', function () {
       var url= $(this).attr('data-url');
       params= media_report_request;
       show_overlay_loader($('#showMediaPlannerReportGrid .modal-content'));
       $.ajax({
           type: 'POST',
           headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
           data: JSON.stringify(params),
           url: url,
           dataType: "json",
           contentType: "application/json",
           success: function (response) {
               window.open(response.new_tab_target);
               hide_overlay_loader($('#showMediaPlannerReportGrid .modal-content'));

           },
           error: function (xhr) {
               ajax_error();
               hide_overlay_loader($('#showMediaPlannerReportGrid .modal-content'));
               debug(xhr.responseText);
           }
       });

   });

   $('#previous_main_grid').on('click', function () {
       show_loader();
       var url=$(this).attr('data-url');
       var params ={
           type: main_grid_type,
           date_range:  $('#range_date_div').text(),
           broadcast_week: broadcast_week,
       };
       $.ajax({
           type: 'POST',
           headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
           data: JSON.stringify(params),
           url: url,
           dataType: "json",
           contentType: "application/json",
           success: function (data) {
               broadcast_month_weeks= data.broadcast_week;
               broadcast_week= data.broadcast_week;
               campaign_hiatus=data.hiatus;
               campaigns_finally=data.campaign_finally;
               months_quarter=data.months;
               if(main_grid_type=='current_year')
                   reloadAnualMainGrid(data.current_year);
               else
                   reloadMainGrid();
               var html_hide = '';
               if(hidden_columns_main_grid.advertiser_name == 1)
                   html_hide+= '<li><a  data-col="advertiser_name">Advertiser</a></li>';
               else
                   html_hide += '<li><a  data-col="advertiser_name" class="hidden-column" >Advertiser</a></li>';
               if(hidden_columns_main_grid.fd_start == 1)
                   html_hide += '<li><a  data-col="fd_start">Start</a></li>';
               else
                   html_hide += '<li><a  data-col="fd_start" class="hidden-column">Start</a></li>';
               if(hidden_columns_main_grid.fd_end == 1)
                   html_hide += '<li><a  data-col="fd_end">End</a></li>';
               else
                   html_hide += '<li><a  data-col="fd_end" class="hidden-column">End</a></li>';
               if(hidden_columns_main_grid.budget == 1)
                   html_hide +=' <li><a  data-col="budget">Budget</a></li>';
               else
                   html_hide +=' <li><a  data-col="budget" class="hidden-column">Budget</a></li>';
               if(hidden_columns_main_grid.percent == 1)
                   html_hide += '<li><a  data-col="percent">Completed %</a></li>';
               else
                   html_hide += '<li><a  data-col="percent" class="hidden-column">Completed %</a></li>';
               // var html_hide= '<li><a  data-col="advertiser_name">Advertiser</a></li>' +
               //     '                                        <li><a  data-col="fd_start">Start</a></li>' +
               //     '                                        <li><a  data-col="fd_end">End</a></li>' +
               //     '                                        <li><a  data-col="budget">Budget</a></li>' +
               //     '                                        <li><a  data-col="percent">Completed %</a></li>';
               for(var month in broadcast_week){
                   for(var week in broadcast_week[month]) {
                       var name= moment(broadcast_week[month][week]).format('MMMM')+'/';
                       var str= name+ moment(broadcast_week[month][week]).format('DD');
                       html_hide += '<li><a  data-col="week_'+broadcast_week[month][week]+'">'+str+'</a></li>'
                   }
               }
               $('#range_date_div').html(data.months_q)
               $('#hide_columns').html(html_hide);
               addAEvent();
               hide_loader();
           },
           error: function (xhr) {
               ajax_error();
               hide_loader();
               debug(xhr.responseText);
           }
       });

   });
   $('#next_main_grid').on('click', function () {
        show_loader();
        var url=$(this).attr('data-url');
        var params ={
            type: main_grid_type,
            date_range:  $('#range_date_div').text(),
            broadcast_week: broadcast_week,
        };
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: url,
            dataType: "json",
            contentType: "application/json",
            success: function (data) {
                broadcast_month_weeks= data.broadcast_week;
                broadcast_week= data.broadcast_week;
                campaign_hiatus=data.hiatus;
                campaigns_finally=data.campaign_finally;
                months_quarter=data.months;
                if(main_grid_type=='current_year')
                    reloadAnualMainGrid(data.current_year);
                else
                    reloadMainGrid();
                var html_hide='';
                if(hidden_columns_main_grid.advertiser_name == 1)
                    html_hide+= '<li><a  data-col="advertiser_name">Advertiser</a></li>';
                else
                    html_hide += '<li><a  data-col="advertiser_name" class="hidden-column" >Advertiser</a></li>';
                if(hidden_columns_main_grid.fd_start == 1)
                    html_hide += '<li><a  data-col="fd_start">Start</a></li>';
                else
                    html_hide += '<li><a  data-col="fd_start" class="hidden-column">Start</a></li>';
                if(hidden_columns_main_grid.fd_end == 1)
                    html_hide += '<li><a  data-col="fd_end">End</a></li>';
                else
                    html_hide += '<li><a  data-col="fd_end" class="hidden-column">End</a></li>';
                if(hidden_columns_main_grid.budget == 1)
                    html_hide +=' <li><a  data-col="budget">Budget</a></li>';
                else
                    html_hide +=' <li><a  data-col="budget" class="hidden-column">Budget</a></li>';
                if(hidden_columns_main_grid.percent == 1)
                    html_hide += '<li><a  data-col="percent">Completed %</a></li>';
                else
                    html_hide += '<li><a  data-col="percent" class="hidden-column">Completed %</a></li>';
                // var html_hide= '<li><a  data-col="advertiser_name">Advertiser</a></li>' +
                //     '                                        <li><a  data-col="fd_start">Start</a></li>' +
                //     '                                        <li><a  data-col="fd_end">End</a></li>' +
                //     '                                        <li><a  data-col="budget">Budget</a></li>' +
                //     '                                        <li><a  data-col="percent">Completed %</a></li>';
                for(var month in broadcast_week){
                    for(var week in broadcast_week[month]) {
                        var name= moment(broadcast_week[month][week]).format('MMMM')+'/';
                        var str= name+ moment(broadcast_week[month][week]).format('DD');
                        html_hide += '<li><a  data-col="week_'+broadcast_week[month][week]+'">'+str+'</a></li>'
                    }
                }
                $('#range_date_div').html(data.months_q)
                $('#hide_columns').html(html_hide);
                addAEvent();
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                debug(xhr.responseText);
            }
        });

    });

   $('#save_items_all').on('click', function () {
       var y = 0;
       var show_new = '';
       if(array_to_allocate ['tv']['total'] == 1 && array_to_allocate ['tv']['grp'] == 1 ){
           if(y == 0)
               show_new += 'Television';
           else
               show_new += ', Television';
           y++;
       }
       if(array_to_allocate ['radio']['total'] == 1 && array_to_allocate ['radio']['grp'] == 1 ){
           if(y == 0)
               show_new += 'Radio';
           else
               show_new += ', Radio';
           y++;
       }
       if(array_to_allocate ['digital']['total'] == 1 && array_to_allocate ['digital']['grp'] == 1 ){
           if(y == 0)
               show_new += 'Digital';
           else
               show_new += ', Digital';
           y++;
       }
       if(array_to_allocate ['print']['total'] == 1 && array_to_allocate ['print']['grp'] == 1 ){
           if(y == 0)
               show_new += 'Print';
           else
               show_new += ', Print';
           y++;
       }
       if(array_to_allocate ['mail']['total'] == 1 && array_to_allocate ['mail']['grp'] == 1 ){
           if(y == 0)
               show_new += 'Mail';
           else
               show_new += ', Mail';
           y++;
       }
       if(array_to_allocate ['ooh']['total'] == 1 && array_to_allocate ['ooh']['grp'] == 1 ){
           if(y == 0)
               show_new += 'OOH';
           else
               show_new += ', OOH';
           y++;
       }
       if(array_to_allocate ['other']['total'] == 1 && array_to_allocate ['other']['grp'] == 1 ){
           if(y == 0)
               show_new += 'Other';
           else
               show_new += ', Other';
           y++;
       }
       if(array_to_allocate ['ott']['total'] == 1 && array_to_allocate ['ott']['grp'] == 1 ){
           if(y == 0)
               show_new += 'OTT';
           else
               show_new += ', OTT';
           y++;
       }

       if(y > 0){
           swal({
                   title: "Warning!",
                   text: "Please Allocate GRP/GRI before save for the fallowing media type(s):\n "+ show_new+".\n If you continue the GRP/GRI percent changes will be lost. \n Do you want to continue anyway? ",
                   type: "warning",
                   showCancelButton: true,
                   confirmButtonClass: "btn-danger",
                   confirmButtonText: "Continue",
                   closeOnConfirm: true,
                   closeOnCancel: true
               },
               function (isConfirm) {
                   if (isConfirm) {
                       show_overlay_loader($("#newPlannerModal .modal-content"));
                       var params = {
                           campaign_id: camapaign_selected,
                           week: week_selected,
                           broadcast_month: broadcast_month_selected,
                           market_id: $('#campaign_market option:selected').val(),
                           types: selected_cam_media_types,
                           lines_tv: [],
                           deleted_tv: [],
                           lines_radio: [],
                           deleted_radio: [],
                           lines_print: [],
                           deleted_print: [],
                           lines_digital: [],
                           deleted_digital: [],
                           lines_ooh: [],
                           deleted_ooh: [],
                           lines_other: [],
                           deleted_other: [],
                           lines_mail: [],
                           deleted_mail: [],
                           lines_ott: [],
                           deleted_ott: [],
                       };
                       for(var media in selected_cam_media_types) {
                           if(selected_cam_media_types[media] == 'tv') {
                               TvDPGrid.api.forEachNode(function (node) {
                                   if (node.data.market_cost === "")
                                       node.data.market_cost = 0
                                   if (node.data.grp === "")
                                       node.data.grp = 0
                                   if (node.data.daypart !== "" && node.data.daypart !== 'undefined') {
                                       params.lines_tv.push(node.data);
                                   }
                               });
                               params.deleted_tv=deletedItemsDPTV;
                           }
                           if(selected_cam_media_types[media] == 'radio') {
                               RadioDPGrid.api.forEachNode(function (node) {
                                   if (node.data.market_cost === "")
                                       node.data.market_cost = 0
                                   if (node.data.grp === "")
                                       node.data.grp = 0
                                   if (node.data.daypart !== "" && node.data.daypart !== 'undefined') {
                                       params.lines_radio.push(node.data);
                                   }
                               });
                               params.deleted_radio=deletedItemsDPRadio;
                           }
                           if(selected_cam_media_types[media] == 'digital') {
                               DigitalGrid.api.forEachNode(function (node) {
                                   if (node.data.market_cost === "")
                                       node.data.market_cost = 0
                                   if (node.data.grp === "")
                                       node.data.grp = 0
                                   if (node.data.length !== "" && node.data.length !== 'undefined') {
                                       params.lines_digital.push(node.data);
                                   }
                               });
                               params.deleted_digital=deletedItemsDigital;
                           }
                           if(selected_cam_media_types[media] == 'print') {
                               PrintGrid.api.forEachNode(function (node) {
                                   if (node.data.market_cost === "")
                                       node.data.market_cost = 0
                                   if (node.data.grp === "")
                                       node.data.grp = 0
                                   if (node.data.length !== "" && node.data.length !== 'undefined') {
                                       params.lines_print.push(node.data);
                                   }
                               });
                               params.deleted_print=deletedItemsPrint;
                           }
                           if(selected_cam_media_types[media] == 'mail') {
                               MailGrid.api.forEachNode(function (node) {
                                   if (node.data.market_cost === "")
                                       node.data.market_cost = 0
                                   if (node.data.grp === "")
                                       node.data.grp = 0
                                   if (node.data.length !== "" && node.data.length !== 'undefined') {
                                       params.lines_mail.push(node.data);
                                   }
                               });
                               params.deleted_mail=deletedItemsMail;
                           }
                           if(selected_cam_media_types[media] == 'ooh') {
                               OOHGrid.api.forEachNode(function (node) {
                                   if (node.data.market_cost === "")
                                       node.data.market_cost = 0
                                   if (node.data.grp === "")
                                       node.data.grp = 0
                                   if (node.data.length !== "" && node.data.length !== 'undefined') {
                                       params.lines_ooh.push(node.data);
                                   }
                               });
                               params.deleted_ooh=deletedItemsOOH;
                           }
                           if(selected_cam_media_types[media] == 'other') {
                               OtherGrid.api.forEachNode(function (node) {
                                   if (node.data.market_cost === "")
                                       node.data.market_cost = 0
                                   if (node.data.grp === "")
                                       node.data.grp = 0
                                   if (node.data.length !== "" && node.data.length !== 'undefined') {
                                       params.lines_other.push(node.data);
                                   }
                               });
                               params.deleted_other=deletedItemsOther;
                           }
                           if(selected_cam_media_types[media] == 'ott') {
                               OTTGrid.api.forEachNode(function (node) {
                                   if (node.data.market_cost === "")
                                       node.data.market_cost = 0
                                   if (node.data.grp === "")
                                       node.data.grp = 0
                                   if (node.data.length !== "" && node.data.length !== 'undefined') {
                                       params.lines_print.push(node.data);
                                   }
                               });
                               params.deleted_print=deletedItemsPrint;
                           }
                       }
                       $.ajax({
                           type: 'POST',
                           headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                           url: '/planner/all-grid/save-lines',
                           data: JSON.stringify(params),
                           contentType: "application/json",
                           dataType: 'json',
                           encode: true,
                           success: function (data) {
                               for(var i in selected_cam_media_types){

                                   $('#tv_apply_div').show();
                                   $('#radio_apply_div').show();
                                   $('#other_apply_div').show();
                                   $('#print_apply_div').show();
                                   $('#mail_apply_div').show();
                                   $('#digital_apply_div').show();
                                   $('#ooh_apply_div').show();
                                   $('#ott_apply_div').show();

                                   if(cam_mark_count == true) {
                                       $('#tv_dp_apply_market').show();
                                       $('#radio_dp_apply_market').show();
                                       $('#digital_apply_market').show();
                                       $('#ooh_apply_market').show();
                                       $('#print_apply_market').show();
                                       $('#mail_apply_market').show();
                                       $('#other_apply_market').show();
                                       $('#ott_apply_market').show();
                                   }

                                   saved_all[0]['radio_dp'] = 1;
                                   deletedItemsDPRadio=[];
                                   saved_all[0]['tv_dp'] = 1;
                                   deletedItemsDPTV=[];
                                   saved_all[0]['print'] = 1;
                                   deletedItemsPrint=[];
                                   saved_all[0]['digital'] = 1;
                                   deletedItemsDigital=[];
                                   saved_all[0]['ooh'] = 1;
                                   deletedItemsOOH=[];
                                   saved_all[0]['mail'] = 1;
                                   deletedItemsMail=[];
                                   saved_all[0]['other'] = 1;
                                   deletedItemsOther=[];
                                   saved_all[0]['ott'] = 1;
                                   deletedItemsOTT=[];
                                   if( data.news.length > 0) {
                                       var media= selected_cam_media_types[i];
                                       if(media == 'tv') {
                                           // $('#tv_dp_apply').show();
                                           $('#tv_apply_div').show();
                                           if(cam_mark_count == true)
                                               $('#tv_dp_apply_market').show();
                                           var x = 0;
                                           if (typeof data.news.television !== 'undefined' &&  data.news.television.length > 0) {
                                               TvDPGrid.api.forEachNode(function (node) {
                                                   if (node.data['int_id'] == '-') {
                                                       node.data['int_id'] = data.news.televison[x];
                                                       //TvDPGrid.api.refreshCells([node], ['int_id']);
                                                       TvDPGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                                       x++;
                                                   }
                                               });
                                           }
                                       }
                                       if(media == 'radio') {
                                           //  $('#radio_dp_apply').show();
                                           $('#radio_apply_div').show();
                                           if(cam_mark_count == true)
                                               $('#radio_dp_apply_market').show();
                                           var x = 0;
                                           if (typeof data.news.radio !== 'undefined' && data.news.radio.length > 0) {
                                               RadioDPGrid.api.forEachNode(function (node) {
                                                   if (node.data['int_id'] == '-') {
                                                       node.data['int_id'] = data.news.radio[x];
                                                       //RadioDPGrid.api.refreshCells([node], ['int_id']);
                                                       RadioDPGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                                       x++;
                                                   }
                                               });
                                           }
                                       }
                                       if(media == 'print') {
                                           //    $('#print_apply').show();
                                           $('#print_apply_div').show();
                                           if(cam_mark_count == true)
                                               $('#print_apply_market').show();
                                           var x = 0;
                                           if (typeof data.news.print !== 'undefined' && data.news.print.length > 0) {
                                               PrintGrid.api.forEachNode(function (node) {
                                                   if (node.data['int_id'] == '-') {
                                                       node.data['int_id'] = data.news.print[x];
                                                       PrintGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                                       x++;
                                                   }
                                               });
                                           }
                                       }
                                       if(media == 'digital') {
                                           //$('#digital_apply').show();
                                           $('#digital_apply_div').show();
                                           if(cam_mark_count == true)
                                               $('#digital_apply_market').show();
                                           var x = 0;
                                           if (typeof data.news.digital !== 'undefined' && data.news.digital.length > 0) {
                                               DigitalGrid.api.forEachNode(function (node) {
                                                   if (node.data['int_id'] == '-') {
                                                       node.data['int_id'] = data.news.digital[x];
                                                       DigitalGrid.api.refreshCells({rowNodes: [node], columns: ['int_id'], force: true});
                                                       x++;
                                                   }
                                               });
                                           }
                                       }
                                       if(media == 'ooh') {
                                           //$('#ooh_apply').show();
                                           $('#ooh_apply_div').show();
                                           if(cam_mark_count == true)
                                               $('#ooh_apply_market').show();
                                           var x = 0;
                                           if (typeof data.news.ooh !== 'undefined' && data.news.ooh.length > 0) {
                                               OOHGrid.api.forEachNode(function (node) {
                                                   if (node.data['int_id'] == '-') {
                                                       node.data['int_id'] = data.news.ooh[x];
                                                       OOHGrid.api.refreshCells([node], ['int_id']);
                                                       x++;
                                                   }
                                               });
                                           }
                                       }
                                       if(media == 'mail') {
                                           // $('#mail_apply').show();
                                           $('#mail_apply_div').show();
                                           if(cam_mark_count == true)
                                               $('#mail_apply_market').show();
                                           var x = 0;
                                           if (typeof data.news.mail !== 'undefined' && data.news.mail.length > 0) {
                                               MailGrid.api.forEachNode(function (node) {
                                                   if (node.data['int_id'] == '-') {
                                                       node.data['int_id'] = data.news.mail[x];
                                                       MailGrid.api.refreshCells([node], ['int_id']);
                                                       x++;
                                                   }
                                               });
                                           }
                                       }
                                       if(media == 'other') {
                                           //  $('#ooh_apply').show();
                                           $('#other_apply_div').show();
                                           if(cam_mark_count == true)
                                               $('#other_apply_market').show();
                                           var x = 0;
                                           if (typeof data.news.other !== 'undefined' && data.news.other.length > 0) {
                                               OtherGrid.api.forEachNode(function (node) {
                                                   if (node.data['int_id'] == '-') {
                                                       node.data['int_id'] = data.news.other[x];
                                                       OtherGrid.api.refreshCells([node], ['int_id']);
                                                       x++;
                                                   }
                                               });
                                           }
                                       }
                                       if(media == 'ott') {
                                           $('#ott_apply_div').show();
                                           if(cam_mark_count == true)
                                               $('#ott_apply_market').show();
                                           var x = 0;
                                           if (typeof data.news.ott !== 'undefined' && data.news.ott.length > 0) {
                                               OtherGrid.api.forEachNode(function (node) {
                                                   if (node.data['int_id'] == '-') {
                                                       node.data['int_id'] = data.news.ott[x];
                                                       OTTGrid.api.refreshCells([node], ['int_id']);
                                                       x++;
                                                   }
                                               });
                                           }
                                       }
                                   }
                               }
                               getValueMainGrid(selected_row,column_week, selected_week, broadcast_month_selected_number, camapaign_selected );
                               $('#newPlannerModal').modal('hide');
                               hide_overlay_loader($('#newPlannerModal .modal-content'))
                               global_notification("success", "Items saved...");
                           },
                           error: function (xhr) {
                               hide_overlay_loader($('#newPlannerModal .modal-content'))
                               debug(xhr.responseText);
                           }
                       });
                   }

               });
       }
       else {
           show_overlay_loader($("#newPlannerModal .modal-content"));
           var params = {
               campaign_id: camapaign_selected,
               week: week_selected,
               broadcast_month: broadcast_month_selected,
               market_id: $('#campaign_market option:selected').val(),
               types: selected_cam_media_types,
               lines_tv: [],
               deleted_tv: [],
               lines_radio: [],
               deleted_radio: [],
               lines_print: [],
               deleted_print: [],
               lines_digital: [],
               deleted_digital: [],
               lines_ooh: [],
               deleted_ooh: [],
               lines_other: [],
               deleted_other: [],
               lines_mail: [],
               deleted_mail: [],
               lines_ott: [],
               deleted_ott: [],
           };
           for (var media in selected_cam_media_types) {
               if (selected_cam_media_types[media] == 'tv') {
                   TvDPGrid.api.forEachNode(function (node) {
                       if (node.data.market_cost === "")
                           node.data.market_cost = 0
                       if (node.data.grp === "")
                           node.data.grp = 0
                       if (node.data.daypart !== "" && node.data.daypart !== 'undefined') {
                           params.lines_tv.push(node.data);
                       }
                   });
                   params.deleted_tv = deletedItemsDPTV;
               }
               if (selected_cam_media_types[media] == 'radio') {
                   RadioDPGrid.api.forEachNode(function (node) {
                       if (node.data.market_cost === "")
                           node.data.market_cost = 0
                       if (node.data.grp === "")
                           node.data.grp = 0
                       if (node.data.daypart !== "" && node.data.daypart !== 'undefined') {
                           params.lines_radio.push(node.data);
                       }
                   });
                   params.deleted_radio = deletedItemsDPRadio;
               }
               if (selected_cam_media_types[media] == 'digital') {
                   DigitalGrid.api.forEachNode(function (node) {
                       if (node.data.market_cost === "")
                           node.data.market_cost = 0
                       if (node.data.grp === "")
                           node.data.grp = 0
                       if (node.data.length !== "" && node.data.length !== 'undefined') {
                           params.lines_digital.push(node.data);
                       }
                   });
                   params.deleted_digital = deletedItemsDigital;
               }
               if (selected_cam_media_types[media] == 'print') {
                   PrintGrid.api.forEachNode(function (node) {
                       if (node.data.market_cost === "")
                           node.data.market_cost = 0
                       if (node.data.grp === "")
                           node.data.grp = 0
                       if (node.data.length !== "" && node.data.length !== 'undefined') {
                           params.lines_print.push(node.data);
                       }
                   });
                   params.deleted_print = deletedItemsPrint;
               }
               if (selected_cam_media_types[media] == 'mail') {
                   MailGrid.api.forEachNode(function (node) {
                       if (node.data.market_cost === "")
                           node.data.market_cost = 0
                       if (node.data.grp === "")
                           node.data.grp = 0
                       if (node.data.length !== "" && node.data.length !== 'undefined') {
                           params.lines_mail.push(node.data);
                       }
                   });
                   params.deleted_mail = deletedItemsMail;
               }
               if (selected_cam_media_types[media] == 'ooh') {
                   OOHGrid.api.forEachNode(function (node) {
                       if (node.data.market_cost === "")
                           node.data.market_cost = 0
                       if (node.data.grp === "")
                           node.data.grp = 0
                       if (node.data.length !== "" && node.data.length !== 'undefined') {
                           params.lines_ooh.push(node.data);
                       }
                   });
                   params.deleted_ooh = deletedItemsOOH;
               }
               if (selected_cam_media_types[media] == 'other') {
                   OtherGrid.api.forEachNode(function (node) {
                       if (node.data.market_cost === "")
                           node.data.market_cost = 0
                       if (node.data.grp === "")
                           node.data.grp = 0
                       if (node.data.length !== "" && node.data.length !== 'undefined') {
                           params.lines_other.push(node.data);
                       }
                   });
                   params.deleted_other = deletedItemsOther;
               }
               if (selected_cam_media_types[media] == 'ott') {
                   OTTGrid.api.forEachNode(function (node) {
                       if (node.data.market_cost === "")
                           node.data.market_cost = 0
                       if (node.data.grp === "")
                           node.data.grp = 0
                       if (node.data.length !== "" && node.data.length !== 'undefined') {
                           params.lines_ott.push(node.data);
                       }
                   });
                   params.deleted_ott = deletedItemsOther;
               }
           }
           $.ajax({
               type: 'POST',
               headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
               url: '/planner/all-grid/save-lines',
               data: JSON.stringify(params),
               contentType: "application/json",
               dataType: 'json',
               encode: true,
               success: function (data) {
                   for (var i in selected_cam_media_types) {

                       $('#tv_apply_div').show();
                       $('#radio_apply_div').show();
                       $('#other_apply_div').show();
                       $('#print_apply_div').show();
                       $('#mail_apply_div').show();
                       $('#digital_apply_div').show();
                       $('#ooh_apply_div').show();
                       $('#ott_apply_div').show();

                       if (cam_mark_count == true) {
                           $('#tv_dp_apply_market').show();
                           $('#radio_dp_apply_market').show();
                           $('#digital_apply_market').show();
                           $('#ooh_apply_market').show();
                           $('#print_apply_market').show();
                           $('#mail_apply_market').show();
                           $('#other_apply_market').show();
                           $('#ott_apply_market').show();
                       }

                       saved_all[0]['radio_dp'] = 1;
                       deletedItemsDPRadio = [];
                       saved_all[0]['tv_dp'] = 1;
                       deletedItemsDPTV = [];
                       saved_all[0]['print'] = 1;
                       deletedItemsPrint = [];
                       saved_all[0]['digital'] = 1;
                       deletedItemsDigital = [];
                       saved_all[0]['ooh'] = 1;
                       deletedItemsOOH = [];
                       saved_all[0]['mail'] = 1;
                       deletedItemsMail = [];
                       saved_all[0]['other'] = 1;
                       deletedItemsOther = [];
                       saved_all[0]['ott'] = 1;
                       deletedItemsOTT = [];

                       if (data.news.length > 0) {
                           var media = selected_cam_media_types[i];
                           if (media == 'tv') {
                               // $('#tv_dp_apply').show();
                               $('#tv_apply_div').show();
                               if (cam_mark_count == true)
                                   $('#tv_dp_apply_market').show();
                               var x = 0;
                               if (typeof data.news.television !== 'undefined' && data.news.television.length > 0) {
                                   TvDPGrid.api.forEachNode(function (node) {
                                       if (node.data['int_id'] == '-') {
                                           node.data['int_id'] = data.news.televison[x];
                                           //TvDPGrid.api.refreshCells([node], ['int_id']);
                                           TvDPGrid.api.refreshCells({
                                               rowNodes: [node],
                                               columns: ['int_id'],
                                               force: true
                                           });
                                           x++;
                                       }
                                   });
                               }
                           }
                           if (media == 'radio') {
                               //  $('#radio_dp_apply').show();
                               $('#radio_apply_div').show();
                               if (cam_mark_count == true)
                                   $('#radio_dp_apply_market').show();
                               var x = 0;
                               if (typeof data.news.radio !== 'undefined' && data.news.radio.length > 0) {
                                   RadioDPGrid.api.forEachNode(function (node) {
                                       if (node.data['int_id'] == '-') {
                                           node.data['int_id'] = data.news.radio[x];
                                           //RadioDPGrid.api.refreshCells([node], ['int_id']);
                                           RadioDPGrid.api.refreshCells({
                                               rowNodes: [node],
                                               columns: ['int_id'],
                                               force: true
                                           });
                                           x++;
                                       }
                                   });
                               }
                           }
                           if (media == 'print') {
                               //    $('#print_apply').show();
                               $('#print_apply_div').show();
                               if (cam_mark_count == true)
                                   $('#print_apply_market').show();
                               var x = 0;
                               if (typeof data.news.print !== 'undefined' && data.news.print.length > 0) {
                                   PrintGrid.api.forEachNode(function (node) {
                                       if (node.data['int_id'] == '-') {
                                           node.data['int_id'] = data.news.print[x];
                                           PrintGrid.api.refreshCells({
                                               rowNodes: [node],
                                               columns: ['int_id'],
                                               force: true
                                           });
                                           x++;
                                       }
                                   });
                               }
                           }
                           if (media == 'digital') {
                               //$('#digital_apply').show();
                               $('#digital_apply_div').show();
                               if (cam_mark_count == true)
                                   $('#digital_apply_market').show();
                               var x = 0;
                               if (typeof data.news.digital !== 'undefined' && data.news.digital.length > 0) {
                                   DigitalGrid.api.forEachNode(function (node) {
                                       if (node.data['int_id'] == '-') {
                                           node.data['int_id'] = data.news.digital[x];
                                           DigitalGrid.api.refreshCells({
                                               rowNodes: [node],
                                               columns: ['int_id'],
                                               force: true
                                           });
                                           x++;
                                       }
                                   });
                               }
                           }
                           if (media == 'ooh') {
                               //$('#ooh_apply').show();
                               $('#ooh_apply_div').show();
                               if (cam_mark_count == true)
                                   $('#ooh_apply_market').show();
                               var x = 0;
                               if (typeof data.news.ooh !== 'undefined' && data.news.ooh.length > 0) {
                                   OOHGrid.api.forEachNode(function (node) {
                                       if (node.data['int_id'] == '-') {
                                           node.data['int_id'] = data.news.ooh[x];
                                           OOHGrid.api.refreshCells([node], ['int_id']);
                                           x++;
                                       }
                                   });
                               }
                           }
                           if (media == 'mail') {
                               // $('#mail_apply').show();
                               $('#mail_apply_div').show();
                               if (cam_mark_count == true)
                                   $('#mail_apply_market').show();
                               var x = 0;
                               if (typeof data.news.mail !== 'undefined' && data.news.mail.length > 0) {
                                   MailGrid.api.forEachNode(function (node) {
                                       if (node.data['int_id'] == '-') {
                                           node.data['int_id'] = data.news.mail[x];
                                           MailGrid.api.refreshCells([node], ['int_id']);
                                           x++;
                                       }
                                   });
                               }
                           }
                           if (media == 'other') {
                               //  $('#ooh_apply').show();
                               $('#other_apply_div').show();
                               if (cam_mark_count == true)
                                   $('#other_apply_market').show();
                               var x = 0;
                               if (typeof data.news.other !== 'undefined' && data.news.other.length > 0) {
                                   OtherGrid.api.forEachNode(function (node) {
                                       if (node.data['int_id'] == '-') {
                                           node.data['int_id'] = data.news.other[x];
                                           OtherGrid.api.refreshCells([node], ['int_id']);
                                           x++;
                                       }
                                   });
                               }
                           }
                           if (media == 'ott') {
                               $('#ott_apply_div').show();
                               if (cam_mark_count == true)
                                   $('#ott_apply_market').show();
                               var x = 0;
                               if (typeof data.news.ott !== 'undefined' && data.news.ott.length > 0) {
                                   OTTGrid.api.forEachNode(function (node) {
                                       if (node.data['int_id'] == '-') {
                                           node.data['int_id'] = data.news.ott[x];
                                           OTTGrid.api.refreshCells([node], ['int_id']);
                                           x++;
                                       }
                                   });
                               }
                           }
                       }
                   }

                   getValueMainGrid(selected_row, column_week, selected_week, broadcast_month_selected_number, camapaign_selected);
                   $('#newPlannerModal').modal('hide');
                   hide_overlay_loader($('#newPlannerModal .modal-content'))
                   global_notification("success", "Items saved...");
               },
               error: function (xhr) {
                   hide_overlay_loader($('#newPlannerModal .modal-content'))
                   debug(xhr.responseText);
               }
           });
       }
   });

   $('#campaign_goal').on('click', function(){
       if (MainGrid.api.getSelectedNodes().length == 0) {
           swal({
                   title: "Warning",
                   text: "Please select a campaign first.",
                   type: "warning",
                   showCancelButton: false,
                   confirmButtonClass: "btn-danger",
                   confirmButtonText: "OK",
                   //cancelButtonText: 'No',
                   closeOnConfirm: true,
                   closeOnCancel: true
               },
               function (isConfirm) {
                   if (isConfirm) {}

               });
       }
       else {
           show_loader();
           var camp_id= MainGrid.api.getSelectedNodes()[0].data.campaign_id;
           $.ajax({
               type: 'GET',
               url: '/planner/report/campaign/datas/' + camp_id ,
               dataType: 'json',
               encode: true,
               success: function (data) {
                   $('#selected_medias2').multiSelect({
                       selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                       selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm ' id='select_all_media2' ><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='deselect_all_media2'><i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                       afterInit: function(ms){
                           var that = this,
                               $selectableSearch = that.$selectableUl.prev(),
                               selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                           that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                               .on('keydown', function(e){
                                   if (e.which === 40){
                                       that.$selectableUl.focus();
                                       return false;
                                   }
                               });
                       },
                       afterSelect: function(values){
                           this.qs1.cache();
                       },
                       afterDeselect: function(values){
                           this.qs1.cache();
                       }
                   });
                   $('#selected_medias2').html('').multiSelect('refresh');
                   var html='';
                   for(var i in data.media_types){
                       var option='';
                       var disabled='disabled';
                       if(data.media_types[i]== 'tv') {
                           option = 'Television';
                           disabled = '';
                       }
                       if(data.media_types[i]== 'radio') {
                           option = 'Radio';
                           disabled = '';
                       }
                       console.log('%%%%%%%%%%%%%%%%%%%%%%%%%%%%%');
                       console.log(data.media_types[i]);
                       console.log(disabled);
                       if(data.media_types[i]== 'digital')
                           option='Digital';
                       if(data.media_types[i]== 'print')
                           option='Print';
                       if(data.media_types[i]== 'ooh')
                           option='OOH';
                       if(data.media_types[i]== 'mail')
                           option='Mail';
                       if(data.media_types[i]== 'other')
                           option='Other';
                       if(data.media_types[i]== 'ott')
                           option='OTT JamLoop';

                       html+='<option value="'+data.media_types[i]+'">'+option+'</option>';
                   }
                   $('#selected_medias2').html(html).multiSelect('refresh');
                   $('#start_date2').select2({
                       minimumResultsForSearch: 10,
                       placeholder: 'Select one....',
                   });
                   $('#end_date2').select2({
                       minimumResultsForSearch: 10,
                       placeholder: 'Select one....',
                   });
                   var html='';
                   var html_1='';
                   fligth_dates=data.flightDates;
                   for(var x in data.FD)
                       html+='<option value="'+moment(data.FD[x]).format('MM/DD/YYYY')+'">'+moment(data.FD[x]).format('MM/DD/YYYY')+'</option>';
                   for(var x in data.FDE) {
                       if(x == (data.FDE.length - 1))
                           selected='selected';
                       else
                           selected = '';
                       html_1 += '<option value="' + moment(data.FDE[x]).format('MM/DD/YYYY') + '" '+selected+'>' + moment(data.FDE[x]).format('MM/DD/YYYY') + '</option>';
                   }
                   $('#start_date2').html(html);
                   $('#end_date2').html(html_1);

                   $('#selected_markets2').multiSelect({
                       selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                       selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm select_all_market' id='select_all_market2'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='deselect_all_market2'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                       afterInit: function(ms){
                           var that = this,
                               $selectableSearch = that.$selectableUl.prev(),
                               selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                           that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                               .on('keydown', function(e){
                                   if (e.which === 40){
                                       that.$selectableUl.focus();
                                       return false;
                                   }
                               });
                       },
                       afterSelect: function(values){
                           this.qs1.cache();
                       },
                       afterDeselect: function(values){
                           this.qs1.cache();
                       }
                   });
                   var html='';
                   for(var i in data.markets)
                       html+='<option value="'+data.markets[i].id+'">'+ data.markets[i].type.toUpperCase()+'- '+data.markets[i].name+'</option>';
                   $('#selected_markets2').html(html).multiSelect('refresh');

                   var header_options_mm= $('#header_options_sc2').html();
                   $('#div_logo_option_mm2').hide();
                   $('#header_options_sc2').multiSelect({
                       selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                       selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm ' id='select_all_header2'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='deselect_all_header2'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                       afterInit: function(ms){
                           var that = this,
                               $selectableSearch = that.$selectableUl.prev(),
                               selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                           that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                               .on('keydown', function(e){
                                   if (e.which === 40){
                                       that.$selectableUl.focus();
                                       return false;
                                   }
                               });
                       },
                       afterSelect: function(values){
                           if(values == 'Agency Logo')
                               $('#div_logo_option_mm2').show();
                           this.qs1.cache();
                       },
                       afterDeselect: function(values){
                           if(values == 'Agency Logo')
                               $('#div_logo_option_mm2').hide();
                           this.qs1.cache();
                       }
                   });
                   $("#header_options_sc2").html('');
                   $("#header_options_sc2").multiSelect('refresh');
                   $('#header_options_sc2').html(header_options_mm);
                   $("#header_options_sc2").multiSelect('refresh');
                   $('#logo_option_mm2').select2({
                       minimumResultsForSearch: 10,
                   });

                   hide_loader();
                   $('#GoalReportModal').modal('show');
                   $('#select_all_media2').on('click', function(e){
                       $('#selected_medias2').multiSelect('select_all');
                   });
                   $('#deselect_all_media2').on('click', function(e){
                       $('#selected_medias2').multiSelect('deselect_all');
                   });
                   $('#select_all_market2').on('click', function(e){
                       $('#selected_markets2').multiSelect('select_all');
                   });
                   $('#deselect_all_market2').on('click', function(e){
                       $('#selected_markets2').multiSelect('deselect_all');
                   });
                   $('#select_all_header2').on('click', function(e){
                       $('#header_options_sc2').multiSelect('select_all');
                       $('#div_logo_option_mm2').show();
                   });
                   $('#deselect_all_header2').on('click', function(e){
                       $('#header_options_sc2').multiSelect('deselect_all');
                       $('#div_logo_option_mm2').hide();
                   });
               },
               error: function (xhr) {
                   hide_loader();
                   debug(xhr.responseText);
               }
           });
       }
    });
   $('#goal-report-preview').on('click', function(){
        submit_goalReport('preview', $(this).attr('data-url'));
   });
   $('#goal-report-download').on('click', function(){
        submit_goalReport('download', $(this).attr('data-url'));
   });

   var submit_goalReport= function(type, url){
        $('#campaign_id_mm2').val(MainGrid.api.getSelectedNodes()[0].data.campaign_id);
        $('#version_sc').val(type);
        if($('#selected_medias2').val().length ==0)
            global_notification('warning', 'Please select at least one media type');
        else if($('#selected_markets2').val().length ==0)
            global_notification('warning', 'Please select at least one market');
        else {
            show_overlay_loader($('#GoalReportModal .modal-content'));
            var more_options=[];
            $('.options_check2 input[type=checkbox]').each(function(){
                if (this.checked)
                    more_options.push( $(this).val());
            });
            var params ={
                media_types: $('#selected_medias2').val(),
                header_options: $('#header_options_sc2').val(),
                markets: $('#selected_markets2').val(),
                logo_option: $('#logo_option_mm2 option:selected').val(),
                more_options: more_options,
                campaign_id: $('#campaign_id_mm2').val(),
                start: $('#start_date2 option:selected').val(),
                end: $('#end_date2 option:selected').val(),
                type: type,
                logo_option: $('#logo_option_mm2 option:selected').val()
            };
            console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^');
            console.log(params);
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: url,
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    hide_overlay_loader($('#GoalReportModal .modal-content'));
                    if(type=='download')
                        exportToExcel(response, 'Campaign_Goal_Report_' + moment().format("Y-MM-d_H:m:s"));
                    else
                        var win = window.open("", "Planner Report", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1100,height=1000,top=100,left=100");
                    win.document.body.innerHTML = response;
                },
                error: function (xhr) {
                    ajax_error();
                    hide_overlay_loader($('#GoalReportModal .modal-content'));
                    debug(xhr.responseText);
                }
            });

        }
    }







   function onFilterTextBoxChanged() {
        MainGrid.api.setQuickFilter(document.getElementById('keywordsFIlter').value);
    }

    // window.addEventListener("DOMContentLoaded", function(e) {
    //     var global= 0;
    //     var array_count= 0;
    //
    //     var myHilitor = new Hilitor2("mainGrid");
    //     myHilitor.setMatchType("opend");
    //     //  myyHilitor.setMatchType("mainGrid");
    //
    //     var matchIndex = -1;
    //     var matches = 0;
    //
    //
    //     var container = document.getElementById("text");
    //     var searchEl  = document.getElementById("keywords");
    //     var counterEl = document.getElementById("counter");
    //     var navEl     = document.getElementById("navigate");
    //     var navPre    = document.getElementById("prev");
    //     var navNext   = document.getElementById("next");
    //     var navCancel = document.getElementById("cancel");
    //     var regexEl   = document.getElementById("regex")
    //
    //     $('#keywords').on('keydown', function(evt) {
    //         if(evt.key === 'Enter'){
    //             if(array_count > 0){
    //                 if(global == array_count)
    //                     global=0;
    //
    //                 myHilitor.gotoMatch(global);
    //                 global++;
    //                 console.log(global);
    //                 evt.preventDefault();
    //             }
    //         }
    //     });
    //
    //     var searchTrigger = function(e) {
    //         matches = myHilitor.apply(searchEl.value);
    //         regexEl.innerHTML = "Regex: " + myHilitor.getRegex();
    //         displayNavigation();
    //     };
    //     searchEl.addEventListener("keyup", searchTrigger, false);
    //
    //     navPre.addEventListener("click", function(e) {
    //         doNav(-1);
    //         e.preventDefault();
    //     }, false);
    //
    //     navNext.addEventListener("click", function(e) {
    //         doNav(1);
    //         e.preventDefault();
    //     }, false);
    //
    //     navCancel.addEventListener("click", function(e) {
    //         searchEl.value = "";
    //         searchTrigger();
    //         regexEl.innerHTML = counterEl.innerHTML = "";
    //         container.scrollTop = 0;
    //         e.preventDefault();
    //     }, false);
    //
    //
    //     var displayNavigation = function()
    //     {
    //         matchIndex = -1;
    //         array_count=matches;
    //         counterEl.innerHTML = matches + ((matches == 1) ? " match" : " matches");
    //         // if(matches > 0) {
    //         //     navEl.style.display = "inline";
    //         //     navPre.disabled = true;
    //         //     navNext.disabled = false;
    //         // } else {
    //         //     navEl.style.display = "none";
    //         // }
    //     };
    //
    //     var doNav = function(offset)
    //     {
    //         matchIndex += offset;
    //         matchIndex = matchIndex % matches;
    //         console.log(matchIndex);
    //
    //         myHilitor.gotoMatch(matchIndex);
    //
    //         navPre.disabled = (matchIndex <= 0);
    //         navNext.disabled = (matchIndex >= matches - 1);
    //
    //         if(matchIndex >= matches - 1)
    //             global = -1;
    //         else
    //             global = 1;
    //     };
    //
    // }, false);

    $('#reset_filters').on('click', function () {
        $.each(MainGrid.api.getFilterModel(), function (index, value) {
            MainGrid.api.destroyFilter(index);
        });

        $('#keywordsFIlter').val('');
        MainGrid.api.setQuickFilter('');

        $('#keywords').val('');
        var searchEl= $('#keywords');
        var myHilitor = new Hilitor2("mainGrid");
        searchEl.value = "";
        myHilitor.apply(searchEl.value);
        $('#mainGrid').scrollTop = 0;

    });
    $('.media-totals-toggle-planning').on('click', function () {
        if (!$(this).hasClass('expanded')) {
          //  $('#analysisWs').css('height', '35vh');
            $('.media-totals-wrapper').css('height', '10vh').show();
            $(this).addClass('expanded');
            $(this).find('i').removeClass('fa-angle-double-up').addClass('fa-angle-double-down');
        } else {
           // $('#analysisWs').css('height', '70vh');
            $('.media-totals-wrapper').css('height', '0').hide();
            $(this).removeClass('expanded');
            $(this).find('i').removeClass('fa-angle-double-down').addClass('fa-angle-double-up');
        }
    });

    var update_week_totals = function(market_cost_total, market_grp_total, market_total_total, budget, to_mcost, to_mgrp, to_mtotal){
        grp_total= parseFloat(to_mgrp) + parseFloat(market_grp_total)
        console.log(grp_total);
        var per= 0;
        if(parseFloat(budget) > 0)
            per= (parseFloat(market_total_total) * 100)/ budget;

        var per1= 0;
        if(parseFloat(budget) > 0)
            per1= ((parseFloat(to_mtotal) + parseFloat(market_total_total)) * 100)/ budget;
        var html='';
        html += '<div class="table-wrapper" style="margin-top: 1%"><table class="table table-bordered table-striped table-condensed" >';
        html += '<tr  style="background-color: #CEE3F6"><td style="background-color: #CEE3F6"></td>';
        html += '<td  style="background-color: #CEE3F6"> Cost </td>';
        html += '<td  style="background-color: #CEE3F6"> GRP Goal </td>';
        html += '<td  style="background-color: #CEE3F6"> Total Cost </td>';
        html += '<td  style="background-color: #CEE3F6"> Budget </td>';
        html += '<td  style="background-color: #CEE3F6"> % Spend </td>';
        html += '</tr>';
        html += '<tbody>';
        html += '<tr id="market_week_totals" style=" height: 20px;"><td>Market Week Totals</td>';
        html += '<td >'+parseFloat(market_cost_total).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        }),+'</td>';
        html += '<td>'+parseFloat(market_grp_total).toLocaleString("en-US", {
            style: "decimal",
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
        });+'</td>';
        html += '<td>'+parseFloat(market_total_total).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        }),+'</td>';
        html += '<td>'+parseFloat(budget).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        }),+'</td>';
        html += '<td>'+parseFloat(per).toLocaleString("en-US", {
            style: "percent",
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
        });+'%</td>';
        html += '</tr>';

        html += '<tr id="market_week_totals" style=" height: 20px;"><td>Campaign Week Totals</td>';
        html += '<td >'+parseFloat(parseFloat(to_mcost) + parseFloat(market_cost_total) ).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        }),+'</td>';
        html += '<td>'+ parseFloat(grp_total).toLocaleString("en-US", {
            style: "decimal",
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
        }); +'</td>';
        html += '<td>'+parseFloat(parseFloat(to_mtotal) + parseFloat(market_total_total)).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        }),+'</td>';
        html += '<td>'+parseFloat(budget).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        }),+'</td>';
        html += '<td>'+parseFloat(per1).toLocaleString("en-US", {
            style: "percent",
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
        });+'%</td>';
        html += '</tr>';
        html += '</tbody></table></div>';
        $("#vndDemoSummary").html(html);
    };

    $('#campaign_graphs').on('click', function(){
        if (MainGrid.api.getSelectedNodes().length == 0) {
            swal({
                    title: "Warning",
                    text: "Please select a campaign first.",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {}

                });
        }
        else {
            show_loader();
            var camp_id = MainGrid.api.getSelectedNodes()[0].data.campaign_id;

            $.ajax({
                type: 'GET',
                url: '/planner/report/campaign/datas/' + camp_id ,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    $('#graphs_medias').multiSelect({
                        selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                        selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm ' id='select_all_media_gr' ><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='deselect_all_media_gr'><i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                        afterInit: function (ms) {
                            var that = this,
                                $selectableSearch = that.$selectableUl.prev(),
                                selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                                .on('keydown', function (e) {
                                    if (e.which === 40) {
                                        that.$selectableUl.focus();
                                        return false;
                                    }
                                });
                        },
                        afterSelect: function (values) {
                            this.qs1.cache();
                        },
                        afterDeselect: function (values) {
                            this.qs1.cache();
                        }
                    });
                    $('#graphs_medias').html('').multiSelect('refresh');
                    var html = '';
                    for (var i in data.media_types) {
                        var option = '';
                        var disabled = 'disabled';
                        if (data.media_types[i] == 'tv') {
                            option = 'Television';
                            disabled = '';
                        }
                        if (data.media_types[i] == 'radio') {
                            option = 'Radio';
                            disabled = '';
                        }
                        if (data.media_types[i] == 'digital')
                            option = 'Digital';
                        if (data.media_types[i] == 'print')
                            option = 'Print';
                        if (data.media_types[i] == 'ooh')
                            option = 'OOH';
                        if (data.media_types[i] == 'mail')
                            option = 'Mail';
                        if (data.media_types[i] == 'other')
                            option = 'Other';
                        if (data.media_types[i] == 'ott')
                            option = 'OTT JamLoop';

                        html += '<option value="' + data.media_types[i] + '">' + option + '</option>';
                    }
                    $('#graphs_medias').html(html).multiSelect('refresh');

                    $('#graphs_markets').multiSelect({
                        selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                        selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm select_all_market' id='select_all_market_gr'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='deselect_all_market_gr'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
                        afterInit: function (ms) {
                            var that = this,
                                $selectableSearch = that.$selectableUl.prev(),
                                selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                                .on('keydown', function (e) {
                                    if (e.which === 40) {
                                        that.$selectableUl.focus();
                                        return false;
                                    }
                                });
                        },
                        afterSelect: function (values) {
                            this.qs1.cache();
                        },
                        afterDeselect: function (values) {
                            this.qs1.cache();
                        }
                    });
                    var html = '';
                    for (var i in data.markets)
                        html += '<option value="' + data.markets[i].id + '">' + data.markets[i].type.toUpperCase() + '- ' + data.markets[i].name + '</option>';
                    $('#graphs_markets').html(html).multiSelect('refresh');

                    $('#graphs_type').select2({
                        minimumResultsForSearch: 5
                    });
                    $('#graphs_format').select2({
                        minimumResultsForSearch: 5
                    });


                    $('.gr-campaign').html('<b>Campaign: </b>  ' +data.campaign.name);
                    $('.gr-budget').html('<b>Budget: </b>  ' + MainGrid.api.getSelectedNodes()[0].data.budget);

                    $('#camp_selected_graph').val(data.campaign.id);

                    $('#graphsOptionsModal').modal({backdrop: 'static', keyboard: false})
                    $('#graphsOptionsModal').modal('show');

                    hide_loader();
                    $('#select_all_media_gr').on('click', function (e) {
                        $('#graphs_medias').multiSelect('select_all');
                    });
                    $('#deselect_all_media_gr').on('click', function (e) {
                        $('#graphs_medias').multiSelect('deselect_all');
                    });
                    $('#select_all_market_gr').on('click', function (e) {
                        $('#graphs_markets').multiSelect('select_all');
                    });
                    $('#deselect_all_market_gr').on('click', function (e) {
                        $('#graphs_markets').multiSelect('deselect_all');
                    });
                },
                error: function (xhr) {
                    hide_loader();
                    debug(xhr.responseText);
                }
            });
        }
    });

    $('#submit_graphs').on('click', function () {
        var options = [];
        $('.div_graphs_options input[type=checkbox]').each(function () {
            if (this.checked)
                options.push($(this).val())
        });
       if($('#graphs_markets').val().length == 0){
            swal({
                    title: "Warning",
                    text: "Please select at least one Market.",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    //cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {}

                });
        }
       else if($('#graphs_medias').val().length == 0){
            swal({
                    title: "Warning",
                    text: "Please select at least one Media Type.",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    //cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {}

                });
        }
       else if(options.length ==0){
           swal({
                   title: "Warning",
                   text: "Please select at least one Print Option.",
                   type: "warning",
                   showCancelButton: false,
                   confirmButtonClass: "btn-danger",
                   confirmButtonText: "OK",
                   //cancelButtonText: 'No',
                   closeOnConfirm: true,
                   closeOnCancel: true
               },
               function (isConfirm) {
                   if (isConfirm) {}

               });
       }
       else {
            show_overlay_loader($('#graphsOptionsModal .modal-content'));
            var options = [];
            $('.div_graphs_options input[type=checkbox]').each(function () {
                if (this.checked)
                     options.push($(this).val())
            });
            var params = {
                campaign_id: $('#camp_selected_graph').val(),
                graphs_type: $('#graphs_type option:selected').val(),
                graphs_medias: $('#graphs_medias').val(),
                graphs_markets: $('#graphs_markets').val(),
                options: options,
                graphs_format: $('#graphs_format option:selected').val(),
            };
            var url = $(this).attr('data-url');
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: url,
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    var html='';
                    html+='                          <div class="col-md-12 new-graphs-modal-container">' +
                        '                                    <ul class="nav nav-tabs " role="tablist" style="">';
                    var html_content='';
                    var cont=1;
                    for(var market in response.results){
                       var active='';
                       var  expanded=false;
                        if(cont == 1) {
                            active = 'active';
                            expanded= true;
                        }

                        if(response.each == 1 && market !== 'totals'){
                             html+='<li id="media_'+cont+'" role="presentation" class="'+active+' nav-item">' +
                                 '<a href="#tab_gr_'+cont+'" class="nav-link" aria-controls="tab_gr_'+cont+'" role="tab" data-toggle="tab" aria-expanded="'+expanded+'">' +
                                 ' <span class="hidden-xs">'+market+'</span></a></li>';
                             html_content+=' <div role="tabpanel" class="tab-pane '+active+'" id="tab_gr_'+cont+'">';
                             html_content += '<div class="row"><div class="col-md-12">' +
                               '                                <div id="container_'+cont+'" style="min-width: 310px; height: 400px; margin: 0 auto"></div>' +
                               '                            </div></div>';
                             html_content+='</div>';
                            cont++;
                        }
                        if(response.totals == 1 && market === 'totals'){
                            html+='<li id="media_'+cont+'" role="presentation" class="'+active+' nav-item"><a href="#tab_gr_'+cont+'" class="nav-link" aria-controls="tab_gr_'+cont+'" role="tab" data-toggle="tab" aria-expanded="'+expanded+'"> <span class="hidden-xs">Combined Markets</span></a></li>';
                            html_content+=' <div role="tabpanel" class="tab-pane '+active+'" id="tab_gr_'+cont+'">';
                            html_content += '<div class="row"> <div class="col-md-12">' +
                                '                                <div id="container_'+cont+'" style="min-width: 310px; height: 400px; margin: 0 auto"></div>' +
                                '                            </div></div>';
                            html_content+='</div>';
                            cont++;
                        }
                    }
                    html+='</ul>'
                    //content tabs
                    html+='<div class="tab-content gr" style="width: 100%">'
                    html+=html_content;
                    html+='</div>';
                    //close all div
                    html+= '</div>';
                    $('.container-graphs-div').html(html);

                   if(response.graph_type == 'column' || response.graph_type == 'bar') {
                       var cont = 1;
                       for (var market in response.results) {
                           if (response.each == 1 && market !== 'totals') {
                               var data = [];
                               var data2 = [];
                               var xx=0;
                               for (var media in response.results[market]) {
                                   var cost = response.results[market][media]['cost'];
                                   data.push({
                                       //color: response.colors_two[xx],
                                       name: media,
                                       y: cost,
                                       drilldown: media,
                                   });
                                   var array = [];
                                   for (var month in response.results[market][media]['months'])
                                       array.push([moment(month + '-01').format('MMM, YYYY'), response.results[market][media]['months'][month]])
                                   data2.push({
                                       name: media,
                                       id: media,
                                       data: array,
                                   });
                                   xx++;
                               }

                               Highcharts.theme = {
                                   colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                               }
                               Highcharts.setOptions(Highcharts.theme);
                               Highcharts.chart('container_' + cont + '', {
                                   chart: {
                                       type: response.graph_type,
                                   },
                                   title: {
                                       text: market + '   Planning'
                                   },
                                   subtitle: {
                                       text: 'Click the columns to view planning by month.'
                                   },
                                   xAxis: {
                                       type: 'category',
                                   },
                                   yAxis: {
                                       title: {
                                           text: 'Budget'

                                       },
                                       min: 0,
                                       max: response.budgets[0],
                                       tickInterval: response.budgets[0] * 0.20,
                                       labels: {
                                           formatter: function () {
                                               // if(response.graphs_format == 'percent'){
                                               //     return this.value.toLocaleString("en-US", {
                                               //         minimumFractionDigits: 1
                                               //     })+ '%';
                                               // }
                                               // else {
                                                   return this.value.toLocaleString("en-US", {
                                                       style: "currency",
                                                       currency: "USD",
                                                       minimumFractionDigits: 2
                                                   });
                                               //}
                                           }
                                       },
                                   },
                                   legend: {
                                       enabled: false
                                   },
                                   credits: {
                                       text: 'GaleForce Digital, Inc.',
                                       //  href: 'http://www.galeforcedigital.com'
                                   },
                                   plotOptions: {
                                       series: {
                                           borderWidth: 0,
                                           // dataLabels: {
                                           //     enabled: true,
                                           //     format: '${point.y:.2f}'
                                           // }
                                       }
                                   },
                                   tooltip: {
                                       headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
                                       pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>${point.y:.2f}</b> <br/>'
                                   },

                                   series: [
                                       {
                                           name: "Media Types",
                                           colorByPoint: true,
                                         //  color: response.colors_two,
                                           data: data
                                       }
                                   ],
                                   drilldown: {
                                       series: data2
                                   }

                               });
                               cont++;
                           }
                           if (response.totals == 1 && market === 'totals') {
                               var data = [];
                               var data2 = [];
                               var xx=0;
                               for (var media in response.results[market]) {
                                   var cost = response.results[market][media]['cost'];
                                   data.push({
                                      // color: response.colors_two[xx],
                                       name: media,
                                       y: cost,
                                       drilldown: media,
                                   });

                                   var array = [];
                                   for (var month in response.results[market][media]['months'])
                                       array.push([moment(month + '-01').format('MMM, YYYY'), response.results[market][media]['months'][month]])
                                   data2.push({
                                       name: media,
                                       id: media,
                                       data: array,
                                   });
                                   xx++;
                               }

                               Highcharts.theme = {
                                   colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                               }
                               Highcharts.setOptions(Highcharts.theme);
                               Highcharts.chart('container_' + cont + '', {
                                   chart: {
                                       type: response.graph_type
                                   },
                                 //  colors: response.colors_two,
                                   title: {
                                       text: 'Combined Markets Planning'
                                   },
                                   subtitle: {
                                       text: 'Click the columns to view planning by month.'
                                   },
                                   xAxis: {
                                       type: 'category',
                                   },
                                   yAxis: {
                                       title: {
                                           text: 'Budget'

                                       },
                                       min: 0,
                                       max: response.budgets[0],
                                       tickInterval: response.budgets[0] * 0.20,
                                       labels: {
                                           formatter: function () {
                                               return this.value.toLocaleString("en-US", {
                                                   style: "currency",
                                                   currency: "USD",
                                                   minimumFractionDigits: 2
                                               });
                                           }
                                       },
                                   },
                                   legend: {
                                       enabled: false
                                   },
                                   credits: {
                                       text: 'GaleForce Digital, Inc.',
                                       //  href: 'http://www.galeforcedigital.com'
                                   },
                                   plotOptions: {
                                       series: {
                                           borderWidth: 0,
                                           // dataLabels: {
                                           //     enabled: true,
                                           //     format: '${point.y:.2f}',
                                           // },
                                       }
                                   },
                                   tooltip: {
                                       headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
                                       pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>${point.y:.2f}</b> <br/>'
                                   },

                                   series: [
                                       {
                                           name: "Media Types",
                                           colorByPoint: true,
                                           //color: response.colors_two,
                                           data: data
                                       }
                                   ],
                                   drilldown: {
                                       series: data2
                                   }

                               });
                               cont++;
                           }
                       }
                   }
                   else{
                       var cont = 1;
                       for (var market in response.results) {
                           if (response.each == 1 && market !== 'totals') {
                               var data = [];
                               var data2 = [];
                               var xx=0;
                               for (var media in response.results[market]) {
                                   var cost = response.results[market][media]['cost'];
                                   data.push({
                                       name: media,
                                       y: cost,
                                       drilldown: media,
                                   });
                                   var array = [];
                                   for (var month in response.results[market][media]['months'])
                                       array.push([moment(month + '-01').format('MMM, YYYY'), response.results[market][media]['months'][month]])
                                   data2.push({
                                       name: media,
                                       id: media,
                                       data: array,
                                   });
                                   xx++;
                               }
                               Highcharts.theme = {
                                   colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                               }
                               Highcharts.setOptions(Highcharts.theme);
                               Highcharts.chart('container_' + cont + '', {
                                   chart: {

                                       type: 'pie'
                                   },
                                   title: {
                                       text: market + '   Planning'
                                   },
                                   subtitle: {
                                       text: 'Click the slices to view planning by month.'
                                   },
                                   credits: {
                                       text: 'GaleForce Digital, Inc.',
                                       //  href: 'http://www.galeforcedigital.com'
                                   },
                                   plotOptions: {
                                       series: {
                                           dataLabels: {
                                               enabled: true,
                                               format: '${point.y:.2f}'
                                           },
                                           showInLegend: true,
                                           //colors: response.colors_two,
                                       }
                                   },
                                   tooltip: {
                                       headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                                       pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>${point.y:.2f}</b> <br/>'
                                   },

                                   series: [
                                       {
                                           name: "Media Types",
                                           colorByPoint: true,
                                           data: data
                                       }
                                   ],
                                   drilldown: {
                                       series: data2
                                   }
                               });
                               cont++;
                           }
                           if (response.totals == 1 && market === 'totals') {
                               var data = [];
                               var data2 = [];
                               var xx=0;
                               for (var media in response.results['totals']) {
                                   var cost = response.results['totals'][media]['cost'];
                                   data.push({
                                      // color: response.colors_two[xx],
                                       name: media,
                                       y: cost,
                                       drilldown: media,
                                   });

                                   var array = [];
                                   for (var month in response.results[market][media]['months'])
                                       array.push([moment(month + '-01').format('MMM, YYYY'), response.results[market][media]['months'][month]])
                                   data2.push({
                                       name: media,
                                       id: media,
                                       data: array,
                                   });
                                   xx++;
                               }
                               console.log('data', data);
                               Highcharts.theme = {
                                colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                               }
                               Highcharts.setOptions(Highcharts.theme);

                               Highcharts.chart('container_' + cont + '', {
                                   chart: {
                                       type: 'pie'
                                   },
                                   title: {
                                       text: 'Combined Markets Planning'
                                   },
                                   subtitle: {
                                       text: 'Click the slices to view planning by month.'
                                   },
                                   credits: {
                                       text: 'GaleForce Digital, Inc.',
                                     //  href: 'http://www.galeforcedigital.com'
                                   },
                                   plotOptions: {
                                       series: {
                                           dataLabels: {
                                               enabled: true,
                                               format: '${point.y:.2f}'
                                           },
                                           showInLegend: true,
                                           //colors: response.colors_two,
                                       }
                                   },
                                   tooltip: {
                                       headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                                       pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>${point.y:.2f}</b> <br/>'
                                   },

                                   series: [
                                       {
                                           name: "Media Types",
                                           colorByPoint: true,
                                          // colors: response.colors_two,
                                          // color: response.colors_two,
                                           data: data
                                       }
                                   ],
                                   drilldown: {
                                       series: data2
                                   }

                               });
                               cont++;
                           }
                       }
                   }

                    $('#GraphsModal').modal('show');
                    hide_overlay_loader($('#graphsOptionsModal .modal-content'));
                },
                error: function (xhr) {
                    ajax_error();
                    hide_overlay_loader($('#graphsOptionsModal .modal-content'));
                    debug(xhr.responseText);
                }
            });
        }

    });

}
